import React, { Component, useCallback, useRef, useState, useEffect, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { Logo, TextField, Button, Checkbox, Tooltip, ButtonCircle, NavigationBar, Select, Table, DialogContent, Icon, Dialog, EditableText, withClickOutside, TextFieldWithIcon, DatesPicker } from 'factor';
import get from 'lodash/get';
import { Redirect, withRouter, HashRouter, Switch, Route } from 'react-router-dom';
import ReactDOM, { createPortal } from 'react-dom';
import debounce from 'lodash/debounce';
import moment from 'moment';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import isFunction from 'lodash/isFunction';
import moment$1 from 'moment-timezone';
import isObject from 'lodash/isObject';
import times from 'lodash/times';
import throttle from 'lodash/throttle';
import first from 'lodash/first';
import last from 'lodash/last';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports);

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});
var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;
var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf;
});
var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;
var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var DOCUMENT_TITLE = 'Report Builder | IQM Corporation';
var USER_ADVERTISER = 1;
var FULL_DAY_FORMAT = 'YYYY-MM-DD HH:mm:ss';
var AM_PM_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var BASE_INFO_NAME = 'authorizedUser';

var Auth = function Auth() {
  var _this = this;

  classCallCheck(this, Auth);
  defineProperty(this, "authorize", /*#__PURE__*/function () {
    var _ref = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(credentials, rememberMe) {
      var user, profile, userData;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              user = credentials;

              if (!credentials.email) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return ApiService.authenticate(credentials);

            case 5:
              user = _context.sent;

            case 6:
              _context.next = 8;
              return ApiService.fetchUserProfile(user);

            case 8:
              profile = _context.sent;
              userData = _objectSpread({}, user, {}, profile);
              _this._user = userData;
              _this._rememberMe = rememberMe;

              if (rememberMe) {
                localStorage.setItem(BASE_INFO_NAME, JSON.stringify(userData));
              } else {
                localStorage.removeItem(BASE_INFO_NAME);
              }

              return _context.abrupt("return", userData);

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  defineProperty(this, "updateUser", function (data) {
    _this._user = _objectSpread({}, _this._user, {}, data);
    localStorage.setItem(BASE_INFO_NAME, JSON.stringify(_this._user));
  });
  defineProperty(this, "getToken", function () {
    return _this._user && _this._user.apiToken;
  });
  defineProperty(this, "getAvatar", /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var avatar;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (_this._user) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", null);

          case 2:
            _context2.prev = 2;

            if (!_this._user.avatar) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", _this._user.avatar);

          case 7:
            _context2.next = 9;
            return ApiService.fetchUserAvatar();

          case 9:
            avatar = _context2.sent;

            _this.updateUser({
              avatar: avatar
            });

            return _context2.abrupt("return", avatar);

          case 12:
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](2);
            throw _context2.t0;

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 14]]);
  })));
  defineProperty(this, "getUserApps", /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
    var apps;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (!_this._userApps) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", _this._userApps);

          case 5:
            _context3.next = 7;
            return ApiService.fetchUserApps();

          case 7:
            apps = _context3.sent;
            _this._userApps = apps;
            return _context3.abrupt("return", apps);

          case 10:
            _context3.next = 15;
            break;

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](0);
            throw _context3.t0;

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 12]]);
  })));
  defineProperty(this, "getUser", function () {
    return _this._user;
  });
  defineProperty(this, "isAuthenticated", function () {
    return !!_this._user;
  });
  defineProperty(this, "unauthorize", function () {
    localStorage.removeItem(BASE_INFO_NAME);
    _this._user = null;
  });
  this._user = JSON.parse(localStorage.getItem(BASE_INFO_NAME));
};

var AuthService = new Auth();

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

var isNativeFunction = _isNativeFunction;
var construct = createCommonjsModule(function (module) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
      module.exports = _construct = Reflect.construct;
    } else {
      module.exports = _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  module.exports = _construct;
});
var wrapNativeSuper = createCommonjsModule(function (module) {
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return construct(Class, arguments, getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  module.exports = _wrapNativeSuper;
});

var ServerError = /*#__PURE__*/function (_Error) {
  inherits(ServerError, _Error);

  function ServerError(props) {
    var _this;

    classCallCheck(this, ServerError);
    _this = possibleConstructorReturn(this, getPrototypeOf(ServerError).call(this, props));
    _this.name = 'ServerError';

    if (props.response) {
      var _props$response$data = props.response.data,
          responseObject = _props$response$data.responseObject,
          statusCode = _props$response$data.statusCode,
          message = _props$response$data.message;
      _this.errorMessage = (_typeof_1(responseObject) === 'object' ? responseObject.errorMsg : responseObject) || message;
      _this.status = statusCode || props.response.status;

      if (props.response.status === 401) {
        if (AuthService.logout) {
          AuthService.logout();
        } else {
          window.localStorage.removeItem(BASE_INFO_NAME);
          window.location.reload();
        }
      }
    } else {
      _this.message = 'Endpoint is not available';
    }

    return _this;
  }

  return ServerError;
}( /*#__PURE__*/wrapNativeSuper(Error));

var userAuth = function userAuth(data) {
  return {
    userType: data.userType,
    domainURL: data.domainURL,
    apiToken: data.apiToken
  };
};

var userProfile = function userProfile(data) {
  return {
    firstName: data.firstName,
    lastName: data.lastName,
    dspId: data.dsp_id,
    userId: data.user_id,
    userType: data.user_type_id,
    companyName: data.company_name,
    email: data.email,
    timezoneId: data.timezone || data.user_timezone_id,
    timezoneName: data.timezone_country_name,
    address: data.address,
    zipCode: data.zip_code,
    phone: data.phone,
    websiteUrl: data.website
  };
};

var isProd = process.env.REACT_APP_ENVIRONMENT === 'production';
var LOGIN_URL = isProd ? 'https://reporting-gateway.iqm.com/api/v2/login' : 'https://reporting.admin1.stage.iqm.com/api/v2/login';
var ADVERTISER_PROFILE_URL = isProd ? 'https://app.iqm.com/api/manage/profile' : 'https://app1.stage.iqm.com/api/manage/profile';
var ADMIN_PROFILE_URL = isProd ? 'https://admin.iqm.com/api/manage/profile' : 'https://admin1.stage.iqm.com/api/manage/profile';
var USER_AVATAR_URL = isProd ? 'https://avatar-service.iqm.com/avatar' : 'https://avatar-service.stage.iqm.com/avatar';
var VALIDATE_TOKEN_URL = isProd ? 'https://reporting-gateway.iqm.com/api/v2/auth/validate-token' : 'https://api-gateway.stage.iqm.com/api/v2/auth/validate-token';
var CSV_DOWNLOAD_URL = isProd ? 'https://export-service.iqm.com/csv' : 'https://export-service.stage.iqm.com/csv';
var XLSX_DOWNLOAD_URL = isProd ? 'https://export-service.iqm.com/xlsx' : 'https://export-service.stage.iqm.com/xlsx';
var TIMEZONES_LIST = isProd ? 'https://app.iqm.com/api/timezones' : 'https://app1.stage.iqm.com/api/timezones';

var getConfig = function getConfig() {
  return {
    LOGIN_URL: LOGIN_URL,
    ADVERTISER_PROFILE_URL: ADVERTISER_PROFILE_URL,
    ADMIN_PROFILE_URL: ADMIN_PROFILE_URL,
    USER_AVATAR_URL: USER_AVATAR_URL,
    VALIDATE_TOKEN_URL: VALIDATE_TOKEN_URL,
    CSV_DOWNLOAD_URL: CSV_DOWNLOAD_URL,
    XLSX_DOWNLOAD_URL: XLSX_DOWNLOAD_URL,
    TIMEZONES_LIST: TIMEZONES_LIST
  };
};

var config = getConfig();

var Api = /*#__PURE__*/function () {
  function Api() {
    classCallCheck(this, Api);
  }

  createClass(Api, [{
    key: "validateToken",
    value: function () {
      var _validateToken = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(token) {
        var response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios({
                  method: 'POST',
                  url: config.VALIDATE_TOKEN_URL,
                  data: "api_token=".concat(token),
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                });

              case 3:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw new ServerError(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function validateToken(_x) {
        return _validateToken.apply(this, arguments);
      }

      return validateToken;
    }()
  }, {
    key: "authenticate",
    value: function () {
      var _authenticate = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(_ref) {
        var email, password, response, user;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                email = _ref.email, password = _ref.password;
                _context2.prev = 1;
                _context2.next = 4;
                return axios.post(config.LOGIN_URL, {
                  email: email,
                  password: password
                });

              case 4:
                response = _context2.sent;
                user = userAuth(response.data.responseObject);
                return _context2.abrupt("return", user);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                throw new ServerError(_context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }));

      function authenticate(_x2) {
        return _authenticate.apply(this, arguments);
      }

      return authenticate;
    }()
  }, {
    key: "fetchUserProfile",
    value: function () {
      var _fetchUserProfile = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(_ref2) {
        var userType, apiToken, response, profile;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                userType = _ref2.userType, apiToken = _ref2.apiToken;
                _context3.prev = 1;
                _context3.next = 4;
                return axios({
                  url: userType === USER_ADVERTISER ? config.ADVERTISER_PROFILE_URL : config.ADMIN_PROFILE_URL,
                  headers: {
                    'x-iaa-api-token': apiToken
                  }
                });

              case 4:
                response = _context3.sent;
                profile = userProfile(response.data);
                return _context3.abrupt("return", profile);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                throw new ServerError(_context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      function fetchUserProfile(_x3) {
        return _fetchUserProfile.apply(this, arguments);
      }

      return fetchUserProfile;
    }()
  }, {
    key: "uploadUserAvatar",
    value: function () {
      var _uploadUserAvatar = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(base64, ext) {
        var user, response, avatar;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", null);

              case 4:
                _context4.next = 6;
                return axios.put("".concat(config.USER_AVATAR_URL, "/").concat(ext), base64, {
                  headers: {
                    'x-iaa-api-token': user.apiToken,
                    'Authorization': 'Basic YWRtaW46VHJFMnVNb1A=',
                    'Base-Url': user.domainURL,
                    'Content-Type': 'text/plain'
                  }
                });

              case 6:
                response = _context4.sent;
                avatar = response.data.avatar;
                return _context4.abrupt("return", avatar);

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);
                throw new ServerError(_context4.t0);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 11]]);
      }));

      function uploadUserAvatar(_x4, _x5) {
        return _uploadUserAvatar.apply(this, arguments);
      }

      return uploadUserAvatar;
    }()
  }, {
    key: "fetchUserAvatar",
    value: function () {
      var _fetchUserAvatar = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        var user, response, avatar;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", null);

              case 4:
                _context5.next = 6;
                return axios({
                  url: config.USER_AVATAR_URL,
                  headers: {
                    'x-iaa-api-token': user.apiToken,
                    'Authorization': 'Basic YWRtaW46VHJFMnVNb1A=',
                    'Base-Url': user.domainURL
                  }
                });

              case 6:
                response = _context5.sent;
                avatar = response.data.avatar;
                return _context5.abrupt("return", avatar);

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                throw new ServerError(_context5.t0);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 11]]);
      }));

      function fetchUserAvatar() {
        return _fetchUserAvatar.apply(this, arguments);
      }

      return fetchUserAvatar;
    }()
  }, {
    key: "fetchUserApps",
    value: function () {
      var _fetchUserApps = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
        var user, response, apps;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return", null);

              case 4:
                _context6.next = 6;
                return axios({
                  url: "https://".concat(user.domainURL, "/api/v2/adv/static/apps/list"),
                  headers: {
                    'x-iaa-api-token': user.apiToken
                  },
                  params: {
                    dspId: user.dspId,
                    advertiserId: user.userType === USER_ADVERTISER ? user.userId : null
                  }
                });

              case 6:
                response = _context6.sent;
                apps = response.data.responseObject.filter(function (a) {
                  return a;
                });
                return _context6.abrupt("return", apps);

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);
                throw new ServerError(_context6.t0);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 11]]);
      }));

      function fetchUserApps() {
        return _fetchUserApps.apply(this, arguments);
      }

      return fetchUserApps;
    }()
  }, {
    key: "fetchTimezones",
    value: function () {
      var _fetchTimezones = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7() {
        var result, user, path, response, serverTimezones, mapTimezone, UTCTimezoneOption, USTimezoneOptions, otherTimezoneOptions, currentUserTimezone;
        return regenerator.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                result = {
                  defaultUserTimezone: {
                    value: 'UTC',
                    label: 'UTC'
                  },
                  timezoneOptions: []
                };
                _context7.prev = 1;
                user = AuthService.getUser();
                path = 'api/v2/adv/static/timezone/list';
                _context7.next = 6;
                return axios({
                  url: "https://".concat(user.domainURL, "/").concat(path),
                  headers: {
                    'x-iaa-api-token': user.apiToken
                  }
                });

              case 6:
                response = _context7.sent;

                if (!(response && isEmpty(response.data))) {
                  _context7.next = 9;
                  break;
                }

                return _context7.abrupt("return", result);

              case 9:
                serverTimezones = response.data.responseObject;

                mapTimezone = function mapTimezone(timezone) {
                  return {
                    label: timezone.label,
                    value: timezone.name,
                    id: timezone.id
                  };
                };

                UTCTimezoneOption = [];
                USTimezoneOptions = [];
                otherTimezoneOptions = [];
                serverTimezones.forEach(function (serverTimezone) {
                  var timezone = mapTimezone(serverTimezone);

                  if (timezone.id === user.timezoneId) {
                    currentUserTimezone = timezone;
                  }

                  if (timezone.label.startsWith('US/')) {
                    USTimezoneOptions.push(timezone);
                  } else if (timezone.value === 'UTC') {
                    UTCTimezoneOption.push(timezone);
                  } else {
                    otherTimezoneOptions.push(timezone);
                  }
                });
                result.timezoneOptions = [].concat(USTimezoneOptions, UTCTimezoneOption, otherTimezoneOptions);
                result.defaultUserTimezone = currentUserTimezone;
                return _context7.abrupt("return", result);

              case 20:
                _context7.prev = 20;
                _context7.t0 = _context7["catch"](1);
                console.error(_context7.t0);
                return _context7.abrupt("return", result);

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 20]]);
      }));

      function fetchTimezones() {
        return _fetchTimezones.apply(this, arguments);
      }

      return fetchTimezones;
    }()
  }]);
  return Api;
}();

var ApiService = new Api();

var isValid = function isValid(name, value) {
  switch (name) {
    case 'email':
      return validateEmail(value);

    default:
      return true;
  }
};

var validateEmail = function validateEmail(value) {
  var reg = EMAIL_REGEX;
  return !!(value && reg.test(value));
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".login-form__warning {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.21429em; }\n\n.title-main {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 3rem;\n  text-transform: capitalize;\n  color: #787878; }\n\n.title-main-subtitle {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 2.25rem;\n  text-transform: uppercase;\n  color: #ff5859; }\n\n.title-form {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 1.25rem;\n  text-transform: uppercase;\n  color: #3fd4ad; }\n\n.title-form-subtitle {\n  font-family: 'Lato Light', sans-serif;\n  font-weight: 400;\n  font-size: 2rem;\n  color: #000000; }\n\n.title-card {\n  font-family: 'Lato Medium', sans-serif;\n  font-weight: 400;\n  font-size: 1.5rem;\n  line-height: 1.375em;\n  color: #000000; }\n\n.title-card-subtitle {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  color: #787878; }\n\n.paragraph {\n  margin-bottom: 1.5rem;\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.78947em;\n  color: #787878; }\n  .paragraph_large {\n    font-size: 1.5rem; }\n\n.login-form {\n  display: flex;\n  align-items: stretch;\n  position: relative;\n  flex-direction: column;\n  max-width: 25rem;\n  padding: 1.875rem 2.8125rem 2.125rem;\n  border-radius: .25rem;\n  box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.125); }\n  .login-form-main {\n    display: flex; }\n  .login-form .login-form__logo {\n    align-self: center;\n    margin-bottom: 0.8125rem;\n    font-size: 0.61806rem; }\n  .login-form__subtitle {\n    margin-bottom: 1.25rem;\n    margin-top: 0;\n    color: #787878;\n    font-size: 0.875rem;\n    text-align: center;\n    font-family: Lato Light,sans-serif;\n    font-weight: 400; }\n  .login-form__erorrs {\n    color: #ff5859;\n    margin: 0;\n    font-family: Lato Light,sans-serif;\n    font-weight: 400; }\n  .login-form__row {\n    display: flex; }\n    .login-form__row:not(:last-child) {\n      margin-bottom: 1.75rem; }\n    .login-form__row._jc-sb {\n      justify-content: space-between; }\n    .login-form__row._ai-c {\n      align-items: center; }\n    .login-form__row._fd-column {\n      flex-direction: column; }\n  .login-form__controls {\n    display: flex;\n    justify-content: space-between; }\n  .login-form__btn-flat {\n    font-family: Lato Medium,sans-serif;\n    font-weight: 400;\n    color: #787878;\n    text-decoration: none;\n    font-size: 1rem; }\n    .login-form__btn-flat:hover {\n      color: black; }\n  .login-form .text-field__help-text {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    margin-top: .125rem; }\n  .login-form__warning {\n    margin: 1.3125rem 0 0;\n    color: #ffa300; }\n";
styleInject(css);

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var numbersOfError = function numbersOfError(errors) {
  return Object.values(errors).reduce(function (count, err) {
    if (err) count++;
    return count;
  }, 0);
};

var LoginForm = /*#__PURE__*/function (_Component) {
  inherits(LoginForm, _Component);

  function LoginForm() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, LoginForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(LoginForm)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      email: '',
      password: '',
      rememberMe: false,
      apiError: '',
      isSubmitting: false,
      errors: {
        email: false,
        password: false
      }
    });
    defineProperty(assertThisInitialized(_this), "checkCapsLock", function (e) {
      var isCapsLock = e.getModifierState && event.getModifierState('CapsLock');
      _this.state.isCapsLock !== isCapsLock && _this.setState({
        isCapsLock: isCapsLock
      });
    });
    defineProperty(assertThisInitialized(_this), "handleSubmitForm", /*#__PURE__*/function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(event) {
        var _this$state, email, password, rememberMe, errors, userData;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                _this$state = _this.state, email = _this$state.email, password = _this$state.password, rememberMe = _this$state.rememberMe, errors = _this$state.errors;

                if (!numbersOfError(errors)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this.setState({
                  apiError: '',
                  isSubmitting: true
                });

                rememberMe = true; // temporary to keep user session

                _context.prev = 6;
                _context.next = 9;
                return AuthService.authorize({
                  email: email,
                  password: password
                }, rememberMe);

              case 9:
                userData = _context.sent;
                _this.props.onSuccess && _this.props.onSuccess(userData, rememberMe);
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                _this.props.onError && _this.props.onError(_context.t0);

                _this.setState({
                  apiError: _context.t0.errorMessage,
                  isSubmitting: false
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    defineProperty(assertThisInitialized(_this), "handleChange", function (_ref2) {
      var _this$setState;

      var target = _ref2.target;
      var value = target.type === 'checkbox' ? target.checked : target.value;

      _this.setState((_this$setState = {}, defineProperty(_this$setState, target.name, value), defineProperty(_this$setState, "errors", _objectSpread$1({}, _this.state.errors, defineProperty({}, target.name, !isValid(target.name, value)))), _this$setState));
    });
    return _this;
  }

  createClass(LoginForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.checkCapsLock);
      window.addEventListener('keyup', this.checkCapsLock);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var countErrors = numbersOfError(this.state.errors);
      var docTitle = this.props.docTitle || DOCUMENT_TITLE;

      if (countErrors) {
        document.title = "(".concat(countErrors, " error").concat(countErrors > 1 ? 's' : '', ")").concat(docTitle);
      } else {
        document.title = docTitle;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          rememberMe = _this$state2.rememberMe,
          apiError = _this$state2.apiError,
          isSubmitting = _this$state2.isSubmitting,
          isCapsLock = _this$state2.isCapsLock;
      return React.createElement("main", {
        className: "login-form-main _centered _no-header"
      }, React.createElement("form", {
        className: "login-form",
        ref: this.form,
        onChange: this.handleChange,
        onSubmit: this.handleSubmitForm
      }, React.createElement(Logo, {
        className: "login-form__logo"
      }), React.createElement("p", {
        className: "login-form__subtitle"
      }, "Powering campaigns with artificial intelligence"), apiError && React.createElement("p", {
        className: "login-form__erorrs"
      }, apiError), React.createElement("div", {
        className: "login-form__row"
      }, React.createElement(TextField, {
        name: "email",
        label: "Email address",
        type: "text",
        value: this.state.email,
        validationRules: [{
          func: validateEmail,
          error: function error(name, rule) {
            return "".concat(rule.title, " must be a valid email address!");
          },
          title: 'Email'
        }]
      })), React.createElement("div", {
        className: "login-form__row _fd-column"
      }, React.createElement(TextField, {
        name: "password",
        label: "Password",
        type: "password",
        value: this.state.password
      }), isCapsLock && React.createElement("p", {
        className: "login-form__warning"
      }, "Caps lock is ON")), React.createElement("div", {
        className: "login-form__controls login-form__row"
      }, React.createElement(Button, {
        className: "btn-square _filled _conflower-blue login-form__btn",
        type: "submit",
        value: "Enter",
        disabled: isSubmitting
      }, "Log In")), React.createElement("div", {
        className: "login-form__row _jc-sb _ai-c"
      }, React.createElement("div", {
        className: "checkbox-wrapper"
      }, React.createElement(Checkbox, {
        checked: rememberMe,
        label: "Remember me",
        name: "rememberMe",
        onChange: function onChange(v) {
          return _this2.setState({
            rememberMe: v
          });
        }
      })), React.createElement("a", {
        href: "/#",
        className: "login-form__btn-flat"
      }, "Forgot password?"))));
    }
  }]);
  return LoginForm;
}(Component);

LoginForm.propTypes = {
  docTitle: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
};
var build_umd = createCommonjsModule(function (module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    return (
      /******/
      function (modules) {
        // webpackBootstrap

        /******/
        // The module cache

        /******/
        var installedModules = {};
        /******/

        /******/
        // The require function

        /******/

        function __webpack_require__(moduleId) {
          /******/

          /******/
          // Check if module is in cache

          /******/
          if (installedModules[moduleId]) {
            /******/
            return installedModules[moduleId].exports;
            /******/
          }
          /******/
          // Create a new module (and put it into the cache)

          /******/


          var module = installedModules[moduleId] = {
            /******/
            i: moduleId,

            /******/
            l: false,

            /******/
            exports: {}
            /******/

          };
          /******/

          /******/
          // Execute the module function

          /******/

          modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
          /******/

          /******/
          // Flag the module as loaded

          /******/

          module.l = true;
          /******/

          /******/
          // Return the exports of the module

          /******/

          return module.exports;
          /******/
        }
        /******/

        /******/

        /******/
        // expose the modules object (__webpack_modules__)

        /******/


        __webpack_require__.m = modules;
        /******/

        /******/
        // expose the module cache

        /******/

        __webpack_require__.c = installedModules;
        /******/

        /******/
        // define getter function for harmony exports

        /******/

        __webpack_require__.d = function (exports, name, getter) {
          /******/
          if (!__webpack_require__.o(exports, name)) {
            /******/
            Object.defineProperty(exports, name, {
              enumerable: true,
              get: getter
            });
            /******/
          }
          /******/

        };
        /******/

        /******/
        // define __esModule on exports

        /******/


        __webpack_require__.r = function (exports) {
          /******/
          if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            /******/
            Object.defineProperty(exports, Symbol.toStringTag, {
              value: 'Module'
            });
            /******/
          }
          /******/


          Object.defineProperty(exports, '__esModule', {
            value: true
          });
          /******/
        };
        /******/

        /******/
        // create a fake namespace object

        /******/
        // mode & 1: value is a module id, require it

        /******/
        // mode & 2: merge all properties of value into the ns

        /******/
        // mode & 4: return value when already ns object

        /******/
        // mode & 8|1: behave like require

        /******/


        __webpack_require__.t = function (value, mode) {
          /******/
          if (mode & 1) value = __webpack_require__(value);
          /******/

          if (mode & 8) return value;
          /******/

          if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
          /******/

          var ns = Object.create(null);
          /******/

          __webpack_require__.r(ns);
          /******/


          Object.defineProperty(ns, 'default', {
            enumerable: true,
            value: value
          });
          /******/

          if (mode & 2 && typeof value != 'string') for (var key in value) {
            __webpack_require__.d(ns, key, function (key) {
              return value[key];
            }.bind(null, key));
          }
          /******/

          return ns;
          /******/
        };
        /******/

        /******/
        // getDefaultExport function for compatibility with non-harmony modules

        /******/


        __webpack_require__.n = function (module) {
          /******/
          var getter = module && module.__esModule ?
          /******/
          function getDefault() {
            return module['default'];
          } :
          /******/
          function getModuleExports() {
            return module;
          };
          /******/

          __webpack_require__.d(getter, 'a', getter);
          /******/


          return getter;
          /******/
        };
        /******/

        /******/
        // Object.prototype.hasOwnProperty.call

        /******/


        __webpack_require__.o = function (object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/

        /******/
        // __webpack_public_path__

        /******/


        __webpack_require__.p = "";
        /******/

        /******/

        /******/
        // Load entry module and return exports

        /******/

        return __webpack_require__(__webpack_require__.s = 8);
        /******/
      }(
      /************************************************************************/

      /******/
      [
      /* 0 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = mapValues;

        function mapValues(obj, f) {
          if (obj == null) {
            return {};
          }

          var res = {};
          Object.keys(obj).forEach(function (key) {
            res[key] = f(obj[key]);
          });
          return res;
        }
        /***/

      },
      /* 1 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.setActive = setActive;
        exports.default = registerXHR;

        var _mapValues = __webpack_require__(0);

        var _mapValues2 = _interopRequireDefault(_mapValues);

        var _enhanceFunc = __webpack_require__(2);

        var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var isActive = true;

        function setActive(shouldBeActive) {
          isActive = shouldBeActive;
        }

        var currentXHRId = 0;

        function registerXHR(_ref) {
          var addRequest = _ref.addRequest,
              addResponse = _ref.addResponse,
              _ref$shouldCloneRespo = _ref.shouldCloneResponse,
              shouldCloneResponse = _ref$shouldCloneRespo === undefined ? false : _ref$shouldCloneRespo;
          var _XHR = XMLHttpRequest;
          var xhrMap = new WeakMap();
          var unsubscribedFromXhr = false;
          var LOGROCKET_XHR_LABEL = 'xhr-';
          window._lrXMLHttpRequest = XMLHttpRequest; // eslint-disable-next-line no-native-reassign

          XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
            var xhrObject = new _XHR(mozAnon, mozSystem);

            if (!isActive) {
              return xhrObject;
            }

            xhrMap.set(xhrObject, {
              xhrId: ++currentXHRId,
              headers: {}
            }); // ..., 'open', (method, url, async, username, password) => {

            (0, _enhanceFunc2.default)(xhrObject, 'open', function (method, url) {
              if (unsubscribedFromXhr) return;
              var currentXHR = xhrMap.get(xhrObject);
              currentXHR.method = method;
              currentXHR.url = url;
            });
            (0, _enhanceFunc2.default)(xhrObject, 'send', function (data) {
              if (unsubscribedFromXhr) return;
              var currentXHR = xhrMap.get(xhrObject);
              if (!currentXHR) return;
              var request = {
                url: currentXHR.url,
                method: currentXHR.method && currentXHR.method.toUpperCase(),
                headers: (0, _mapValues2.default)(currentXHR.headers || {}, function (headerValues) {
                  return headerValues.join(', ');
                }),
                body: data
              };
              addRequest('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, request);
            });
            (0, _enhanceFunc2.default)(xhrObject, 'setRequestHeader', function (header, value) {
              if (unsubscribedFromXhr) return;
              var currentXHR = xhrMap.get(xhrObject);
              if (!currentXHR) return;
              currentXHR.headers = currentXHR.headers || {};
              currentXHR.headers[header] = currentXHR.headers[header] || [];
              currentXHR.headers[header].push(value);
            });
            var xhrListeners = {
              readystatechange: function readystatechange() {
                if (unsubscribedFromXhr) return;

                if (xhrObject.readyState === 4) {
                  var currentXHR = xhrMap.get(xhrObject);
                  if (!currentXHR) return;
                  var headerString = xhrObject.getAllResponseHeaders();
                  var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
                    var next = previous;
                    var headerParts = current.split(': ');

                    if (headerParts.length > 0) {
                      var key = headerParts.shift(); // first index of the array

                      var value = headerParts.join(': '); // rest of the array repaired

                      if (previous[key]) {
                        next[key] += ', ' + value;
                      } else {
                        next[key] = value;
                      }
                    }

                    return next;
                  }, {});
                  var body = void 0; // IE 11 sometimes throws when trying to access large responses

                  try {
                    switch (xhrObject.responseType) {
                      case 'json':
                        body = shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                        break;

                      case 'arraybuffer':
                      case 'blob':
                        {
                          body = xhrObject.response;
                          break;
                        }

                      case 'document':
                        {
                          body = xhrObject.responseXML;
                          break;
                        }

                      case 'text':
                      case '':
                        {
                          body = xhrObject.responseText;
                          break;
                        }

                      default:
                        {
                          body = '';
                        }
                    }
                  } catch (err) {
                    body = 'LogRocket: Error accessing response.';
                  }

                  var response = {
                    url: currentXHR.url,
                    status: xhrObject.status,
                    headers: headers,
                    body: body,
                    method: (currentXHR.method || '').toUpperCase()
                  };
                  addResponse('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, response);
                }
              } // // Unused Event Listeners
              // loadstart: () => {},
              // progress: () => {},
              // abort: () => {},
              // error: () => {},
              // load: () => {},
              // timeout: () => {},
              // loadend: () => {},

            };
            Object.keys(xhrListeners).forEach(function (key) {
              xhrObject.addEventListener(key, xhrListeners[key]);
            });
            return xhrObject;
          }; // this allows "instanceof XMLHttpRequest" to work


          XMLHttpRequest.prototype = _XHR.prototype; // Persist the static variables.

          ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
            XMLHttpRequest[variable] = _XHR[variable];
          });
          return function () {
            unsubscribedFromXhr = true; // eslint-disable-next-line no-native-reassign

            XMLHttpRequest = _XHR;
          };
        }
        /***/

      },
      /* 2 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = enhanceFunc;
        /* eslint no-param-reassign: ["error", { "props": false }] */

        function enhanceFunc(obj, method, handler) {
          var original = obj[method];

          function shim() {
            var res = void 0;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            if (original) {
              res = original.apply(this, args);
            }

            handler.apply(this, args);
            return res;
          }

          obj[method] = shim;
          return function () {
            obj[method] = original;
          };
        }
        /***/

      },
      /* 3 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.Capture = exports.registerExceptions = undefined;

        var _registerExceptions = __webpack_require__(16);

        var _registerExceptions2 = _interopRequireDefault(_registerExceptions);

        var _Capture = __webpack_require__(6);

        var Capture = _interopRequireWildcard(_Capture);

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj.default = obj;
            return newObj;
          }
        }

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.registerExceptions = _registerExceptions2.default;
        exports.Capture = Capture;
        /***/
      },
      /* 4 */

      /***/
      function (module, exports) {
        var g; // This works in non-strict mode

        g = function () {
          return this;
        }();

        try {
          // This works if eval is allowed (see CSP)
          g = g || Function("return this")() || (1, eval)("this");
        } catch (e) {
          // This works if the window reference is available
          if (typeof window === "object") g = window;
        } // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}


        module.exports = g;
        /***/
      },
      /* 5 */

      /***/
      function (module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /* eslint-disable */

          /*
           TraceKit - Cross brower stack traces - github.com/occ/TraceKit
          
           This was originally forked from github.com/occ/TraceKit, but has since been
           largely re-written and is now maintained as part of raven-js.  Tests for
           this are in test/vendor.
          
           MIT license
          */
          var TraceKit = {
            collectWindowErrors: true,
            debug: false
          }; // This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)

          var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}; // global reference to slice


          var _slice = [].slice;
          var UNKNOWN_FUNCTION = '?'; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types

          var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;

          function getLocationHref() {
            if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
            return document.location.href;
          }
          /**
           * TraceKit.report: cross-browser processing of unhandled exceptions
           *
           * Syntax:
           *   TraceKit.report.subscribe(function(stackInfo) { ... })
           *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
           *   TraceKit.report(exception)
           *   try { ...code... } catch(ex) { TraceKit.report(ex); }
           *
           * Supports:
           *   - Firefox: full stack trace with line numbers, plus column number
           *              on top frame; column number is not guaranteed
           *   - Opera:   full stack trace with line and column numbers
           *   - Chrome:  full stack trace with line and column numbers
           *   - Safari:  line and column number for the top frame only; some frames
           *              may be missing, and column number is not guaranteed
           *   - IE:      line and column number for the top frame only; some frames
           *              may be missing, and column number is not guaranteed
           *
           * In theory, TraceKit should work on all of the following versions:
           *   - IE5.5+ (only 8.0 tested)
           *   - Firefox 0.9+ (only 3.5+ tested)
           *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
           *     Exceptions Have Stacktrace to be enabled in opera:config)
           *   - Safari 3+ (only 4+ tested)
           *   - Chrome 1+ (only 5+ tested)
           *   - Konqueror 3.5+ (untested)
           *
           * Requires TraceKit.computeStackTrace.
           *
           * Tries to catch all unhandled exceptions and report them to the
           * subscribed handlers. Please note that TraceKit.report will rethrow the
           * exception. This is REQUIRED in order to get a useful stack trace in IE.
           * If the exception does not reach the top of the browser, you will only
           * get a stack trace from the point where TraceKit.report was called.
           *
           * Handlers receive a stackInfo object as described in the
           * TraceKit.computeStackTrace docs.
           */


          TraceKit.report = function reportModuleWrapper() {
            var handlers = [],
                lastArgs = null,
                lastException = null,
                lastExceptionStack = null;
            /**
             * Add a crash handler.
             * @param {Function} handler
             */

            function subscribe(handler) {
              installGlobalHandler();
              handlers.push(handler);
            }
            /**
             * Remove a crash handler.
             * @param {Function} handler
             */


            function unsubscribe(handler) {
              for (var i = handlers.length - 1; i >= 0; --i) {
                if (handlers[i] === handler) {
                  handlers.splice(i, 1);
                }
              }
            }
            /**
             * Remove all crash handlers.
             */


            function unsubscribeAll() {
              uninstallGlobalHandler();
              handlers = [];
            }
            /**
             * Dispatch stack information to all handlers.
             * @param {Object.<string, *>} stack
             */


            function notifyHandlers(stack, isWindowError) {
              var exception = null;

              if (isWindowError && !TraceKit.collectWindowErrors) {
                return;
              }

              for (var i in handlers) {
                if (handlers.hasOwnProperty(i)) {
                  try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                  } catch (inner) {
                    exception = inner;
                  }
                }
              }

              if (exception) {
                throw exception;
              }
            }

            var _oldOnerrorHandler, _onErrorHandlerInstalled;
            /**
             * Ensures all global unhandled exceptions are recorded.
             * Supported by Gecko and IE.
             * @param {string} message Error message.
             * @param {string} url URL of script that generated the exception.
             * @param {(number|string)} lineNo The line number at which the error
             * occurred.
             * @param {?(number|string)} colNo The column number at which the error
             * occurred.
             * @param {?Error} ex The actual Error object.
             */


            function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
              var stack = null;

              if (lastExceptionStack) {
                TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                processLastException();
              } else if (ex) {
                // New chrome and blink send along a real error object
                // Let's just report that like a normal error.
                // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
                stack = TraceKit.computeStackTrace(ex);
                notifyHandlers(stack, true);
              } else {
                var location = {
                  'url': url,
                  'line': lineNo,
                  'column': colNo
                };
                var name = undefined;
                var msg = message; // must be new var or will modify original `arguments`

                var groups;

                if ({}.toString.call(message) === '[object String]') {
                  var groups = message.match(ERROR_TYPES_RE);

                  if (groups) {
                    name = groups[1];
                    msg = groups[2];
                  }
                }

                location.func = UNKNOWN_FUNCTION;
                stack = {
                  'name': name,
                  'message': msg,
                  'url': getLocationHref(),
                  'stack': [location]
                };
                notifyHandlers(stack, true);
              }

              if (_oldOnerrorHandler) {
                return _oldOnerrorHandler.apply(this, arguments);
              }

              return false;
            }

            function installGlobalHandler() {
              if (_onErrorHandlerInstalled) {
                return;
              }

              _oldOnerrorHandler = _window.onerror;
              _window.onerror = traceKitWindowOnError;
              _onErrorHandlerInstalled = true;
            }

            function uninstallGlobalHandler() {
              if (!_onErrorHandlerInstalled) {
                return;
              }

              _window.onerror = _oldOnerrorHandler;
              _onErrorHandlerInstalled = false;
              _oldOnerrorHandler = undefined;
            }

            function processLastException() {
              var _lastExceptionStack = lastExceptionStack,
                  _lastArgs = lastArgs;
              lastArgs = null;
              lastExceptionStack = null;
              lastException = null;
              notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
            }
            /**
             * Reports an unhandled Error to TraceKit.
             * @param {Error} ex
             * @param {?boolean} rethrow If false, do not re-throw the exception.
             * Only used for window.onerror to not cause an infinite loop of
             * rethrowing.
             */


            function report(ex, rethrow) {
              var args = _slice.call(arguments, 1);

              if (lastExceptionStack) {
                if (lastException === ex) {
                  return; // already caught by an inner catch block, ignore
                } else {
                  processLastException();
                }
              }

              var stack = TraceKit.computeStackTrace(ex);
              lastExceptionStack = stack;
              lastException = ex;
              lastArgs = args; // If the stack trace is incomplete, wait for 2 seconds for
              // slow slow IE to see if onerror occurs or not before reporting
              // this exception; otherwise, we will end up with an incomplete
              // stack trace

              setTimeout(function () {
                if (lastException === ex) {
                  processLastException();
                }
              }, stack.incomplete ? 2000 : 0);

              if (rethrow !== false) {
                throw ex; // re-throw to propagate to the top level (and cause window.onerror)
              }
            }

            report.subscribe = subscribe;
            report.unsubscribe = unsubscribe;
            report.uninstall = unsubscribeAll;
            return report;
          }();
          /**
           * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
           *
           * Syntax:
           *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
           * Returns:
           *   s.name              - exception name
           *   s.message           - exception message
           *   s.stack[i].url      - JavaScript or HTML file URL
           *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
           *   s.stack[i].args     - arguments passed to the function, if known
           *   s.stack[i].line     - line number, if known
           *   s.stack[i].column   - column number, if known
           *
           * Supports:
           *   - Firefox:  full stack trace with line numbers and unreliable column
           *               number on top frame
           *   - Opera 10: full stack trace with line and column numbers
           *   - Opera 9-: full stack trace with line numbers
           *   - Chrome:   full stack trace with line and column numbers
           *   - Safari:   line and column number for the topmost stacktrace element
           *               only
           *   - IE:       no line numbers whatsoever
           *
           * Tries to guess names of anonymous functions by looking for assignments
           * in the source code. In IE and Safari, we have to guess source file names
           * by searching for function bodies inside all page scripts. This will not
           * work for scripts that are loaded cross-domain.
           * Here be dragons: some function names may be guessed incorrectly, and
           * duplicate functions may be mismatched.
           *
           * TraceKit.computeStackTrace should only be used for tracing purposes.
           * Logging of unhandled exceptions should be done with TraceKit.report,
           * which builds on top of TraceKit.computeStackTrace and provides better
           * IE support by utilizing the window.onerror event to retrieve information
           * about the top of the stack.
           *
           * Note: In IE and Safari, no stack trace is recorded on the Error object,
           * so computeStackTrace instead walks its *own* chain of callers.
           * This means that:
           *  * in Safari, some methods may be missing from the stack trace;
           *  * in IE, the topmost function in the stack trace will always be the
           *    caller of computeStackTrace.
           *
           * This is okay for tracing (because you are likely to be calling
           * computeStackTrace from the function you want to be the topmost element
           * of the stack trace anyway), but not okay for logging unhandled
           * exceptions (because your catch block will likely be far away from the
           * inner function that actually caused the exception).
           *
           */


          TraceKit.computeStackTrace = function computeStackTraceWrapper() {
            // Contents of Exception in various browsers.
            //
            // SAFARI:
            // ex.message = Can't find variable: qq
            // ex.line = 59
            // ex.sourceId = 580238192
            // ex.sourceURL = http://...
            // ex.expressionBeginOffset = 96
            // ex.expressionCaretOffset = 98
            // ex.expressionEndOffset = 98
            // ex.name = ReferenceError
            //
            // FIREFOX:
            // ex.message = qq is not defined
            // ex.fileName = http://...
            // ex.lineNumber = 59
            // ex.columnNumber = 69
            // ex.stack = ...stack trace... (see the example below)
            // ex.name = ReferenceError
            //
            // CHROME:
            // ex.message = qq is not defined
            // ex.name = ReferenceError
            // ex.type = not_defined
            // ex.arguments = ['aa']
            // ex.stack = ...stack trace...
            //
            // INTERNET EXPLORER:
            // ex.message = ...
            // ex.name = ReferenceError
            //
            // OPERA:
            // ex.message = ...message... (see the example below)
            // ex.name = ReferenceError
            // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
            // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

            /**
             * Computes stack trace information from the stack property.
             * Chrome and Gecko use this property.
             * @param {Error} ex
             * @return {?Object.<string, *>} Stack trace information.
             */
            function computeStackTraceFromStackProp(ex) {
              if (typeof ex.stack === 'undefined' || !ex.stack) return;
              var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
                  gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
                  winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
                  lines = ex.stack.split('\n'),
                  stack = [],
                  parts,
                  element,
                  reference = /^(.*) is undefined$/.exec(ex.message);

              for (var i = 0, j = lines.length; i < j; ++i) {
                if (parts = chrome.exec(lines[i])) {
                  var isNative = parts[2] && parts[2].indexOf('native') !== -1;
                  element = {
                    'url': !isNative ? parts[2] : null,
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': isNative ? [parts[2]] : [],
                    'line': parts[3] ? +parts[3] : null,
                    'column': parts[4] ? +parts[4] : null
                  };
                } else if (parts = winjs.exec(lines[i])) {
                  element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': [],
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                  };
                } else if (parts = gecko.exec(lines[i])) {
                  element = {
                    'url': parts[3],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': parts[2] ? parts[2].split(',') : [],
                    'line': parts[4] ? +parts[4] : null,
                    'column': parts[5] ? +parts[5] : null
                  };
                } else {
                  continue;
                }

                if (!element.func && element.line) {
                  element.func = UNKNOWN_FUNCTION;
                }

                stack.push(element);
              }

              if (!stack.length) {
                return null;
              }

              if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                stack[0].column = ex.columnNumber + 1;
              }

              return {
                'name': ex.name,
                'message': ex.message,
                'url': getLocationHref(),
                'stack': stack
              };
            }
            /**
             * Adds information about the first frame to incomplete stack traces.
             * Safari and IE require this to get complete data on the first frame.
             * @param {Object.<string, *>} stackInfo Stack trace information from
             * one of the compute* methods.
             * @param {string} url The URL of the script that caused an error.
             * @param {(number|string)} lineNo The line number of the script that
             * caused an error.
             * @param {string=} message The error generated by the browser, which
             * hopefully contains the name of the object that caused the error.
             * @return {boolean} Whether or not the stack information was
             * augmented.
             */


            function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
              var initial = {
                'url': url,
                'line': lineNo
              };

              if (initial.url && initial.line) {
                stackInfo.incomplete = false;

                if (!initial.func) {
                  initial.func = UNKNOWN_FUNCTION;
                }

                if (stackInfo.stack.length > 0) {
                  if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                      return false; // already in stack trace
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                      stackInfo.stack[0].line = initial.line;
                      return false;
                    }
                  }
                }

                stackInfo.stack.unshift(initial);
                stackInfo.partial = true;
                return true;
              } else {
                stackInfo.incomplete = true;
              }

              return false;
            }
            /**
             * Computes stack trace information by walking the arguments.caller
             * chain at the time the exception occurred. This will cause earlier
             * frames to be missed but is the only way to get any stack trace in
             * Safari and IE. The top frame is restored by
             * {@link augmentStackTraceWithInitialElement}.
             * @param {Error} ex
             * @return {?Object.<string, *>} Stack trace information.
             */


            function computeStackTraceByWalkingCallerChain(ex, depth) {
              var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
                  stack = [],
                  funcs = {},
                  recursion = false,
                  parts,
                  item;

              for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
                if (curr === computeStackTrace || curr === TraceKit.report) {
                  // console.log('skipping internal function');
                  continue;
                }

                item = {
                  'url': null,
                  'func': UNKNOWN_FUNCTION,
                  'line': null,
                  'column': null
                };

                if (curr.name) {
                  item.func = curr.name;
                } else if (parts = functionName.exec(curr.toString())) {
                  item.func = parts[1];
                }

                if (typeof item.func === 'undefined') {
                  try {
                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
                  } catch (e) {}
                }

                if (funcs['' + curr]) {
                  recursion = true;
                } else {
                  funcs['' + curr] = true;
                }

                stack.push(item);
              }

              if (depth) {
                // console.log('depth is ' + depth);
                // console.log('stack is ' + stack.length);
                stack.splice(0, depth);
              }

              var result = {
                'name': ex.name,
                'message': ex.message,
                'url': getLocationHref(),
                'stack': stack
              };
              augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
              return result;
            }
            /**
             * Computes a stack trace for an exception.
             * @param {Error} ex
             * @param {(string|number)=} depth
             */


            function computeStackTrace(ex, depth) {
              var stack = null;
              depth = depth == null ? 0 : +depth;

              try {
                stack = computeStackTraceFromStackProp(ex);

                if (stack) {
                  return stack;
                }
              } catch (e) {
                if (TraceKit.debug) {
                  throw e;
                }
              }

              try {
                stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);

                if (stack) {
                  return stack;
                }
              } catch (e) {
                if (TraceKit.debug) {
                  throw e;
                }
              }

              return {
                'name': ex.name,
                'message': ex.message,
                'url': getLocationHref()
              };
            }

            computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
            computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
            return computeStackTrace;
          }();

          module.exports = TraceKit;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(4));
        /***/
      },
      /* 6 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        /* eslint-disable no-param-reassign */


        exports.captureMessage = captureMessage;
        exports.captureException = captureException;

        var _TraceKit = __webpack_require__(5);

        var _TraceKit2 = _interopRequireDefault(_TraceKit);

        var _stackTraceFromError = __webpack_require__(18);

        var _stackTraceFromError2 = _interopRequireDefault(_stackTraceFromError);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function isScalar(value) {
          return /boolean|number|string/.test(typeof value === 'undefined' ? 'undefined' : _typeof(value));
        }

        function scrub(data, options) {
          if (options) {
            var optionalScalars = [// Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
            // and 'debug'. Defaults to 'error'.
            'level', 'logger'];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = optionalScalars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var field = _step.value;
                var value = options[field];

                if (isScalar(value)) {
                  data[field] = value.toString();
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var optionalMaps = ['tags', 'extra'];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = optionalMaps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _field = _step2.value;
                var dirty = options[_field] || {};
                var scrubbed = {};
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = Object.keys(dirty)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var key = _step3.value;
                    var _value = dirty[key];

                    if (isScalar(_value)) {
                      scrubbed[key.toString()] = _value.toString();
                    }
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }

                data[_field] = scrubbed;
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }

        function captureMessage(logger, message) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var isConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          var data = {
            exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
            message: message,
            browserHref: window.location.href
          };
          scrub(data, options);
          logger.addEvent('lr.core.Exception', function () {
            return data;
          });
        }

        function captureException(logger, exception) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

          var trace = preppedTrace || _TraceKit2.default.computeStackTrace(exception);

          var data = {
            exceptionType: 'WINDOW',
            errorType: trace.name,
            message: trace.message,
            browserHref: window.location.href
          };
          scrub(data, options);
          var addEventOptions = {
            _stackTrace: (0, _stackTraceFromError2.default)(trace)
          };
          logger.addEvent('lr.core.Exception', function () {
            return data;
          }, addEventOptions);
        }
        /***/

      },
      /* 7 */

      /***/
      function (module, exports) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var dateNow = Date.now.bind(Date);
        var loadTime = dateNow();
        exports.default = typeof performance !== 'undefined' && performance.now ? performance.now.bind(performance) : function () {
          return dateNow() - loadTime;
        };
        module.exports = exports['default'];
        /***/
      },
      /* 8 */

      /***/
      function (module, exports, __webpack_require__) {
        module.exports = __webpack_require__(9);
        /***/
      },
      /* 9 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _setup = __webpack_require__(10);

        var _setup2 = _interopRequireDefault(_setup);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var instance = (0, _setup2.default)();
        exports.default = instance;
        module.exports = exports['default'];
        /***/
      },
      /* 10 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = setup;

        var _makeLogRocket = __webpack_require__(11);

        var _makeLogRocket2 = _interopRequireDefault(_makeLogRocket);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        var CDN_SERVER_MAP = {
          'cdn.logrocket.io': 'https://r.logrocket.io',
          'cdn.lr-ingest.io': 'https://r.lr-ingest.io',
          'cdn-staging.logrocket.io': 'https://staging-i.logrocket.io',
          'cdn-staging.lr-ingest.io': 'https://staging-i.lr-ingest.io'
        };

        function setup() {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var enterpriseServer = _ref.enterpriseServer,
              _ref$sdkVersion = _ref.sdkVersion,
              sdkVersion = _ref$sdkVersion === undefined ? "1.0.6" : _ref$sdkVersion,
              opts = _objectWithoutProperties(_ref, ['enterpriseServer', 'sdkVersion']);

          var scriptOrigin = 'https://cdn.logrocket.io';
          var scriptIngest = void 0;

          if (sdkVersion === 'script') {
            try {
              var scriptTag = document.currentScript;
              var matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
              var scriptHostname = matches && matches[2];

              if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) {
                scriptOrigin = matches && matches[1];
                scriptIngest = CDN_SERVER_MAP[scriptHostname];
              }
            } catch (_) {
              /* no-op */
            }
          } else {
            // NPM
            scriptOrigin = 'https://cdn.lr-ingest.io';
            scriptIngest = 'https://r.lr-ingest.io';
          }

          var sdkServer = opts.sdkServer || enterpriseServer;
          var ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
          var instance = (0, _makeLogRocket2.default)(function () {
            var script = document.createElement('script');

            if (ingestServer) {
              if (typeof window.__SDKCONFIG__ === 'undefined') {
                window.__SDKCONFIG__ = {};
              }

              window.__SDKCONFIG__.serverURL = ingestServer + '/i';
              window.__SDKCONFIG__.statsURL = ingestServer + '/s';
            }

            if (sdkServer) {
              script.src = sdkServer + '/logger.min.js';
            } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
              script.src = window.__SDKCONFIG__.loggerURL;
            } else if (window._lrAsyncScript) {
              script.src = window._lrAsyncScript;
            } else {
              script.src = scriptOrigin + '/logger.min.js';
            }

            script.async = true;
            document.head.appendChild(script);

            script.onload = function () {
              // Brave browser: Advertises its user-agent as Chrome ##.##... then
              // loads logger.min.js, but blocks the execution of the script
              // causing _LRlogger to be undefined.  Let's make sure its there first.
              if (typeof window._LRLogger === 'function') {
                instance.onLogger(new window._LRLogger({
                  sdkVersion: sdkVersion
                }));
              } else {
                console.warn('LogRocket: script execution has been blocked by a product or service.');
                instance.uninstall();
              }
            };

            script.onerror = function () {
              console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
              instance.uninstall();
            };
          });
          return instance;
        }

        module.exports = exports['default'];
        /***/
      },
      /* 11 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = makeLogRocket;

        var _LogRocket = __webpack_require__(12);

        var _LogRocket2 = _interopRequireDefault(_LogRocket);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var REACT_NATIVE_NOTICE = 'LogRocket does not yet support React Native.';

        var makeNoopPolyfill = function makeNoopPolyfill() {
          return {
            init: function init() {},
            uninstall: function uninstall() {},
            log: function log() {},
            info: function info() {},
            warn: function warn() {},
            error: function error() {},
            debug: function debug() {},
            addEvent: function addEvent() {},
            identify: function identify() {},
            start: function start() {},

            get threadID() {
              return null;
            },

            get recordingID() {
              return null;
            },

            get recordingURL() {
              return null;
            },

            reduxEnhancer: function reduxEnhancer() {
              return function (store) {
                return function () {
                  return store.apply(undefined, arguments);
                };
              };
            },
            reduxMiddleware: function reduxMiddleware() {
              return function () {
                return function (next) {
                  return function (action) {
                    return next(action);
                  };
                };
              };
            },
            track: function track() {},
            getSessionURL: function getSessionURL() {},
            getVersion: function getVersion() {},
            startNewSession: function startNewSession() {},
            onLogger: function onLogger() {},
            setClock: function setClock() {},
            captureMessage: function captureMessage() {},
            captureException: function captureException() {}
          };
        };

        function makeLogRocket() {
          var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

          if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
            throw new Error(REACT_NATIVE_NOTICE);
          }

          if (typeof window !== 'undefined') {
            if (window._disableLogRocket) {
              return makeNoopPolyfill();
            }

            if (window.MutationObserver && window.WeakMap) {
              // Save window globals that we rely on.
              window._lrMutationObserver = window.MutationObserver;
              var instance = new _LogRocket2.default();
              getLogger(instance);
              return instance;
            }
          }

          return makeNoopPolyfill();
        }

        module.exports = exports['default'];
        /***/
      },
      /* 12 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.MAX_QUEUE_SIZE = undefined;

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _logrocketNetwork = __webpack_require__(13);

        var _logrocketNetwork2 = _interopRequireDefault(_logrocketNetwork);

        var _logrocketExceptions = __webpack_require__(3);

        var _logrocketConsole = __webpack_require__(19);

        var _logrocketConsole2 = _interopRequireDefault(_logrocketConsole);

        var _logrocketRedux = __webpack_require__(21);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        var MAX_QUEUE_SIZE = exports.MAX_QUEUE_SIZE = 1000;

        var considerIngestServerOption = function considerIngestServerOption() {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var ingestServer = _ref.ingestServer,
              options = _objectWithoutProperties(_ref, ['ingestServer']);

          if (ingestServer) {
            return _extends({
              serverURL: ingestServer + '/i',
              statsURL: ingestServer + '/s'
            }, options);
          }

          return options;
        };

        var LogRocket = function () {
          function LogRocket() {
            var _this = this;

            _classCallCheck(this, LogRocket);

            this._buffer = []; // TODO: tests for these exposed methods.

            ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
              _this[method] = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                _this.addEvent('lr.core.LogEvent', function () {
                  var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                  if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
                    _logrocketExceptions.Capture.captureMessage(_this, args[0], {}, true);
                  }

                  return {
                    logLevel: method.toUpperCase(),
                    args: args
                  };
                }, {
                  shouldCaptureStackTrace: true
                });
              };
            });
            this._isInitialized = false;
            this._installed = [];
          }

          _createClass(LogRocket, [{
            key: 'addEvent',
            value: function addEvent(type, getMessage) {
              var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var time = Date.now();

              this._run(function (logger) {
                logger.addEvent(type, getMessage, _extends({}, opts, {
                  timeOverride: time
                }));
              });
            }
          }, {
            key: 'onLogger',
            value: function onLogger(logger) {
              this._logger = logger;

              while (this._buffer.length > 0) {
                var f = this._buffer.shift();

                f(this._logger);
              }
            }
          }, {
            key: '_run',
            value: function _run(f) {
              if (this._isDisabled) {
                return;
              }

              if (this._logger) {
                f(this._logger);
              } else {
                if (this._buffer.length >= MAX_QUEUE_SIZE) {
                  this._isDisabled = true;
                  console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
                  this.uninstall();
                  return;
                }

                this._buffer.push(f.bind(this));
              }
            }
          }, {
            key: 'init',
            value: function init(appID, opts) {
              if (!this._isInitialized) {
                this._installed.push((0, _logrocketExceptions.registerExceptions)(this));

                this._installed.push((0, _logrocketNetwork2.default)(this));

                this._installed.push((0, _logrocketConsole2.default)(this));

                this._isInitialized = true;

                this._run(function (logger) {
                  logger.init(appID, considerIngestServerOption(opts));
                });
              }
            }
          }, {
            key: 'start',
            value: function start() {
              this._run(function (logger) {
                logger.start();
              });
            }
          }, {
            key: 'uninstall',
            value: function uninstall() {
              this._installed.forEach(function (f) {
                return f();
              });

              this._buffer = [];

              this._run(function (logger) {
                logger.uninstall();
              });
            }
          }, {
            key: 'identify',
            value: function identify(id, opts) {
              this._run(function (logger) {
                logger.identify(id, opts);
              });
            }
          }, {
            key: 'startNewSession',
            value: function startNewSession() {
              this._run(function (logger) {
                logger.startNewSession();
              });
            }
          }, {
            key: 'track',
            value: function track(customEventName) {
              this._run(function (logger) {
                logger.track(customEventName);
              });
            }
          }, {
            key: 'getSessionURL',
            value: function getSessionURL(cb) {
              if (typeof cb !== 'function') {
                throw new Error('LogRocket: must pass callback to getSessionURL()');
              }

              this._run(function (logger) {
                if (logger.getSessionURL) {
                  logger.getSessionURL(cb);
                } else {
                  cb(logger.recordingURL);
                }
              });
            }
          }, {
            key: 'getVersion',
            value: function getVersion(cb) {
              this._run(function (logger) {
                cb(logger.version);
              });
            }
          }, {
            key: 'captureMessage',
            value: function captureMessage(message) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              _logrocketExceptions.Capture.captureMessage(this, message, options);
            }
          }, {
            key: 'captureException',
            value: function captureException(exception) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              _logrocketExceptions.Capture.captureException(this, exception, options);
            }
          }, {
            key: 'reduxEnhancer',
            value: function reduxEnhancer() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return (0, _logrocketRedux.createEnhancer)(this, options);
            }
          }, {
            key: 'reduxMiddleware',
            value: function reduxMiddleware() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return (0, _logrocketRedux.createMiddleware)(this, options);
            }
          }, {
            key: 'version',
            get: function get() {
              return this._logger && this._logger.version;
            }
          }, {
            key: 'sessionURL',
            get: function get() {
              return this._logger && this._logger.recordingURL;
            }
          }, {
            key: 'recordingURL',
            get: function get() {
              return this._logger && this._logger.recordingURL;
            }
          }, {
            key: 'recordingID',
            get: function get() {
              return this._logger && this._logger.recordingID;
            }
          }, {
            key: 'threadID',
            get: function get() {
              return this._logger && this._logger.threadID;
            }
          }, {
            key: 'tabID',
            get: function get() {
              return this._logger && this._logger.tabID;
            }
          }]);

          return LogRocket;
        }();

        exports.default = LogRocket;
        /***/
      },
      /* 13 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }; // import registerWebSocket from './registerWebSocket';


        exports.default = registerNetwork;

        var _registerFetch = __webpack_require__(14);

        var _registerFetch2 = _interopRequireDefault(_registerFetch);

        var _registerXHR = __webpack_require__(1);

        var _registerXHR2 = _interopRequireDefault(_registerXHR);

        var _mapValues = __webpack_require__(0);

        var _mapValues2 = _interopRequireDefault(_mapValues);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function registerNetwork(logger) {
          var ignoredNetwork = {}; // truncate if > 4MB in size

          var truncate = function truncate(data) {
            var limit = 1024 * 1000 * 4;
            var str = data;

            if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null) {
              var proto = Object.getPrototypeOf(data);

              if (proto === Object.prototype || proto === null) {
                // plain object - jsonify for the size check
                str = JSON.stringify(data);
              }
            }

            if (str && str.length && str.length > limit && typeof str === 'string') {
              var beginning = str.substring(0, 1000);
              return beginning + ' ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference#network';
            }

            return data;
          };

          var addRequest = function addRequest(reqId, request) {
            var method = request.method;
            logger.addEvent('lr.network.RequestEvent', function () {
              var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                  _ref$isEnabled = _ref.isEnabled,
                  isEnabled = _ref$isEnabled === undefined ? true : _ref$isEnabled,
                  _ref$requestSanitizer = _ref.requestSanitizer,
                  requestSanitizer = _ref$requestSanitizer === undefined ? function (f) {
                return f;
              } : _ref$requestSanitizer;

              if (!isEnabled) {
                return null;
              }

              var sanitized = null;

              try {
                // only try catch user defined functions
                sanitized = requestSanitizer(request);
              } catch (err) {
                console.error(err);
              }

              if (sanitized) {
                // Writing and then reading from an a tag turns a relative
                // url into an absolute one.
                var a = document.createElement('a');
                a.href = sanitized.url;
                return {
                  reqId: reqId,
                  // default
                  url: a.href,
                  // sanitized
                  headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
                    // sanitized
                    return '' + headerValue;
                  }),
                  body: truncate(sanitized.body),
                  // sanitized
                  method: method,
                  // default
                  referrer: sanitized.referrer || undefined,
                  // sanitized
                  mode: sanitized.mode || undefined,
                  // sanitized
                  credentials: sanitized.credentials || undefined // sanitized

                };
              }

              ignoredNetwork[reqId] = true;
              return null;
            });
          };

          var addResponse = function addResponse(reqId, response) {
            var method = response.method,
                status = response.status;
            logger.addEvent('lr.network.ResponseEvent', function () {
              var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                  _ref2$isEnabled = _ref2.isEnabled,
                  isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled,
                  _ref2$responseSanitiz = _ref2.responseSanitizer,
                  responseSanitizer = _ref2$responseSanitiz === undefined ? function (f) {
                return f;
              } : _ref2$responseSanitiz;

              if (!isEnabled) {
                return null;
              } else if (ignoredNetwork[reqId]) {
                delete ignoredNetwork[reqId];
                return null;
              }

              var sanitized = null;

              try {
                // only try catch user defined functions
                sanitized = responseSanitizer(response);
              } catch (err) {
                console.error(err); // fall through to redacted log
              }

              if (sanitized) {
                return {
                  reqId: reqId,
                  // default
                  status: sanitized.status,
                  // sanitized
                  headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
                    // sanitized
                    return '' + headerValue;
                  }),
                  body: truncate(sanitized.body),
                  // sanitized
                  method: method // default

                };
              }

              return {
                reqId: reqId,
                // default
                status: status,
                // default
                headers: {},
                // redacted
                body: null,
                // redacted
                method: method // default

              };
            });
          };

          var unsubFetch = (0, _registerFetch2.default)({
            addRequest: addRequest,
            addResponse: addResponse
          });
          var unsubXHR = (0, _registerXHR2.default)({
            addRequest: addRequest,
            addResponse: addResponse,
            shouldCloneResponse: logger._shouldCloneResponse
          }); // const unsubWebSocket = registerWebSocket(logger);

          return function () {
            unsubFetch();
            unsubXHR(); // unsubWebSocket();
          };
        }
        /***/

      },
      /* 14 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        exports.default = registerFetch;

        var _mapValues = __webpack_require__(0);

        var _mapValues2 = _interopRequireDefault(_mapValues);

        var _fetchIntercept = __webpack_require__(15);

        var _fetchIntercept2 = _interopRequireDefault(_fetchIntercept);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function makeObjectFromHeaders(headers) {
          // If using real fetch, we must stringify the Headers object.
          if (headers == null || typeof headers.forEach !== 'function') {
            return headers;
          }

          var result = {};
          headers.forEach(function (value, key) {
            if (result[key]) {
              result[key] = result[key] + ',' + value;
            } else {
              result[key] = '' + value;
            }
          });
          return result;
        } // XHR specification is unclear of what types to allow in value so using toString method for now


        var stringifyHeaders = function stringifyHeaders(headers) {
          return (0, _mapValues2.default)(makeObjectFromHeaders(headers), function (value) {
            return '' + value;
          });
        };

        function pluckFetchFields() {
          var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return {
            url: arg.url,
            headers: stringifyHeaders(arg.headers),
            method: arg.method && arg.method.toUpperCase(),
            referrer: arg.referrer || undefined,
            mode: arg.mode || undefined,
            credentials: arg.credentials || undefined
          };
        }

        function registerFetch(_ref) {
          var addRequest = _ref.addRequest,
              addResponse = _ref.addResponse;
          var LOGROCKET_FETCH_LABEL = 'fetch-';
          var fetchMethodMap = {};

          var unregister = _fetchIntercept2.default.register({
            request: function request(fetchId) {
              for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              var p = void 0;

              if (typeof Request !== 'undefined' && args[0] instanceof Request) {
                var clonedText = void 0; // Request.clone() and Request.text() may throw in Safari (e.g., when
                // request body contains FormData)

                try {
                  clonedText = args[0].clone().text();
                } catch (err) {
                  clonedText = Promise.resolve('LogRocket fetch error: ' + err.message);
                }

                p = clonedText.then(function (body) {
                  return _extends({}, pluckFetchFields(args[0]), {
                    body: body
                  });
                }, function (err) {
                  return _extends({}, pluckFetchFields(args[0]), {
                    body: 'LogRocket fetch error: ' + err.message
                  });
                });
              } else {
                p = Promise.resolve(_extends({}, pluckFetchFields(args[1]), {
                  url: '' + args[0],
                  body: (args[1] || {}).body
                }));
              }

              return p.then(function (req) {
                fetchMethodMap[fetchId] = req.method;
                addRequest('' + LOGROCKET_FETCH_LABEL + fetchId, req);
                return args;
              });
            },
            requestError: function requestError(fetchId, error) {
              return Promise.reject(error);
            },
            response: function response(fetchId, _response) {
              var clonedText = void 0;

              try {
                // TODO: enhance function on original response and future clones for:
                // text(), json(), blob(), formdata(), arraybuffer()
                clonedText = _response.clone().text();
              } catch (err) {
                // safari has a bug where cloning can fail
                clonedText = Promise.resolve('LogRocket fetch error: ' + err.message);
              }

              return clonedText.then(function (data) {
                var responseHash = {
                  url: _response.url,
                  status: _response.status,
                  headers: stringifyHeaders(_response.headers),
                  body: data,
                  method: fetchMethodMap[fetchId]
                };
                delete fetchMethodMap[fetchId];
                addResponse('' + LOGROCKET_FETCH_LABEL + fetchId, responseHash);
                return _response;
              });
            },
            responseError: function responseError(fetchId, error) {
              var response = {
                url: undefined,
                status: 0,
                headers: {},
                body: '' + error
              };
              addResponse('' + LOGROCKET_FETCH_LABEL + fetchId, response);
              return Promise.reject(error);
            }
          });

          return unregister;
        }
        /***/

      },
      /* 15 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _registerXHR = __webpack_require__(1);

        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          } else {
            return Array.from(arr);
          }
        }

        var interceptors = [];

        function makeInterceptor(fetch, fetchId) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
            return [interceptor].concat(array);
          }, []);
          var promise = Promise.resolve(args); // Register request interceptors

          reversedInterceptors.forEach(function (_ref) {
            var request = _ref.request,
                requestError = _ref.requestError;

            if (request || requestError) {
              promise = promise.then(function (args) {
                return request.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
              }, function (args) {
                return requestError.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
              });
            }
          });
          promise = promise.then(function (args) {
            (0, _registerXHR.setActive)(false);
            var res = void 0;
            var err = void 0;

            try {
              res = fetch.apply(undefined, _toConsumableArray(args));
            } catch (_err) {
              err = _err;
            }

            (0, _registerXHR.setActive)(true);

            if (err) {
              throw err;
            }

            return res;
          });
          reversedInterceptors.forEach(function (_ref2) {
            var response = _ref2.response,
                responseError = _ref2.responseError;

            if (response || responseError) {
              promise = promise.then(function (res) {
                return response(fetchId, res);
              }, function (err) {
                return responseError && responseError(fetchId, err);
              });
            }
          });
          return promise;
        }

        function attach(env) {
          if (!env.fetch || !env.Promise) {
            // Make sure fetch is available in the given environment. If it's not, then
            // default to using XHR intercept.
            return;
          }

          var isPolyfill = env.fetch.polyfill; // eslint-disable-next-line no-param-reassign

          env.fetch = function (fetch) {
            var fetchId = 0;
            return function () {
              for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              return makeInterceptor.apply(undefined, [fetch, fetchId++].concat(args));
            };
          }(env.fetch); // Forward the polyfill properly from fetch (set by github/whatwg-fetch).


          if (isPolyfill) {
            // eslint-disable-next-line no-param-reassign
            env.fetch.polyfill = isPolyfill;
          }
        } // TODO: React Native
        //   attach(global);


        var didAttach = false;
        exports.default = {
          register: function register(interceptor) {
            if (!didAttach) {
              didAttach = true;
              attach(window);
            }

            interceptors.push(interceptor);
            return function () {
              var index = interceptors.indexOf(interceptor);

              if (index >= 0) {
                interceptors.splice(index, 1);
              }
            };
          },
          clear: function clear() {
            interceptors = [];
          }
        };
        /***/
      },
      /* 16 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = registerCore;

        var _raven = __webpack_require__(17);

        var _raven2 = _interopRequireDefault(_raven);

        var _Capture = __webpack_require__(6);

        var Capture = _interopRequireWildcard(_Capture);

        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};

            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }

            newObj.default = obj;
            return newObj;
          }
        }

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function registerCore(logger) {
          var raven = new _raven2.default({
            captureException: function captureException(errorReport) {
              Capture.captureException(logger, null, null, errorReport);
            }
          });

          var rejectionHandler = function rejectionHandler(evt) {
            // http://2ality.com/2016/04/unhandled-rejections.html
            logger.addEvent('lr.core.Exception', function () {
              return {
                exceptionType: 'UNHANDLED_REJECTION',
                message: evt.reason || 'Unhandled Promise rejection'
              };
            });
          };

          window.addEventListener('unhandledrejection', rejectionHandler);
          return function () {
            window.removeEventListener('unhandledrejection', rejectionHandler);
            raven.uninstall();
          };
        }
        /***/

      },
      /* 17 */

      /***/
      function (module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          Object.defineProperty(exports, "__esModule", {
            value: true
          });

          var _createClass = function () {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }

            return function (Constructor, protoProps, staticProps) {
              if (protoProps) defineProperties(Constructor.prototype, protoProps);
              if (staticProps) defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          /* eslint-disable */

          /*
          Some contents of this file were originaly from raven-js, BSD-2 Clause
          
          Copyright (c) 2018 Sentry (https://sentry.io) and individual contributors.
          All rights reserved.
          
          Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
          
          * Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
          * Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
          
          THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          */


          var _TraceKit = __webpack_require__(5);

          var _TraceKit2 = _interopRequireDefault(_TraceKit);

          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }

          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }

          var objectPrototype = Object.prototype;

          function isUndefined(what) {
            return what === void 0;
          }

          function isFunction(what) {
            return typeof what === 'function';
          }
          /**
           * hasKey, a better form of hasOwnProperty
           * Example: hasKey(MainHostObject, property) === true/false
           *
           * @param {Object} host object to check property
           * @param {string} key to check
           */


          function hasKey(object, key) {
            return objectPrototype.hasOwnProperty.call(object, key);
          }
          /**
           * Polyfill a method
           * @param obj object e.g. `document`
           * @param name method name present on object e.g. `addEventListener`
           * @param replacement replacement function
           * @param track {optional} record instrumentation to an array
           */


          function fill(obj, name, replacement, track) {
            var orig = obj[name];
            obj[name] = replacement(orig);

            if (track) {
              track.push([obj, name, orig]);
            }
          }

          var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

          var _document = _window.document;

          var Handler = function () {
            function Handler(_ref) {
              var captureException = _ref.captureException;

              _classCallCheck(this, Handler);

              this._errorHandler = this._errorHandler.bind(this);
              this._ignoreOnError = 0;
              this._wrappedBuiltIns = [];
              this.captureException = captureException;

              _TraceKit2.default.report.subscribe(this._errorHandler);

              this._instrumentTryCatch();
            }

            _createClass(Handler, [{
              key: 'uninstall',
              value: function uninstall() {
                _TraceKit2.default.report.unsubscribe(this._errorHandler); // restore any wrapped builtins


                var builtin;

                while (this._wrappedBuiltIns.length) {
                  builtin = this._wrappedBuiltIns.shift();
                  var obj = builtin[0],
                      name = builtin[1],
                      orig = builtin[2];
                  obj[name] = orig;
                }
              }
            }, {
              key: '_errorHandler',
              value: function _errorHandler(report) {
                if (!this._ignoreOnError) {
                  this.captureException(report);
                }
              }
            }, {
              key: '_ignoreNextOnError',
              value: function _ignoreNextOnError() {
                var _this = this;

                this._ignoreOnError += 1;
                setTimeout(function () {
                  // onerror should trigger before setTimeout
                  _this._ignoreOnError -= 1;
                });
              }
              /*
               * Wrap code within a context so Handler can capture errors
               * reliably across domains that is executed immediately.
               *
               * @param {object} options A specific set of options for this context [optional]
               * @param {function} func The callback to be immediately executed within the context
               * @param {array} args An array of arguments to be called with the callback [optional]
               */

            }, {
              key: 'context',
              value: function context(options, func, args) {
                if (isFunction(options)) {
                  args = func || [];
                  func = options;
                  options = undefined;
                }

                return this.wrap(options, func).apply(this, args);
              }
            }, {
              key: 'wrap',

              /*
               * Wrap code within a context and returns back a new function to be executed
               *
               * @param {object} options A specific set of options for this context [optional]
               * @param {function} func The function to be wrapped in a new context
               * @param {function} func A function to call before the try/catch wrapper [optional, private]
               * @return {function} The newly wrapped functions with a context
               */
              value: function wrap(options, func, _before) {
                var self = this; // 1 argument has been passed, and it's not a function
                // so just return it

                if (isUndefined(func) && !isFunction(options)) {
                  return options;
                } // options is optional


                if (isFunction(options)) {
                  func = options;
                  options = undefined;
                } // At this point, we've passed along 2 arguments, and the second one
                // is not a function either, so we'll just return the second argument.


                if (!isFunction(func)) {
                  return func;
                } // We don't wanna wrap it twice!


                try {
                  if (func.__lr__) {
                    return func;
                  } // If this has already been wrapped in the past, return that


                  if (func.__lr_wrapper__) {
                    return func.__lr_wrapper__;
                  }
                } catch (e) {
                  // Just accessing custom props in some Selenium environments
                  // can cause a "Permission denied" exception (see lr-js#495).
                  // Bail on wrapping and return the function as-is (defers to window.onerror).
                  return func;
                }

                function wrapped() {
                  var args = [],
                      i = arguments.length,
                      deep = !options || options && options.deep !== false;

                  if (_before && isFunction(_before)) {
                    _before.apply(this, arguments);
                  } // Recursively wrap all of a function's arguments that are
                  // functions themselves.


                  while (i--) {
                    args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
                  }

                  try {
                    // Attempt to invoke user-land function. This is part of the LogRocket SDK.
                    // If you're seeing this frame in a stack trace, it means that LogRocket caught
                    // an unhandled error thrown by your application code, reported it, then bubbled
                    // it up. This is expected behavior and is not a bug with LogRocket.
                    return func.apply(this, args);
                  } catch (e) {
                    self._ignoreNextOnError();

                    self.captureException(_TraceKit2.default.computeStackTrace(e), options);
                    throw e;
                  }
                } // copy over properties of the old function


                for (var property in func) {
                  if (hasKey(func, property)) {
                    wrapped[property] = func[property];
                  }
                }

                wrapped.prototype = func.prototype;
                func.__lr_wrapper__ = wrapped; // Signal that this function has been wrapped already
                // for both debugging and to prevent it to being wrapped twice

                wrapped.__lr__ = true;
                wrapped.__inner__ = func;
                return wrapped;
              }
            }, {
              key: '_instrumentTryCatch',

              /**
               * Install any queued plugins
               */
              value: function _instrumentTryCatch() {
                var self = this;
                var wrappedBuiltIns = self._wrappedBuiltIns;

                function wrapTimeFn(orig) {
                  return function (fn, t) {
                    // preserve arity
                    // Make a copy of the arguments to prevent deoptimization
                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                    var args = new Array(arguments.length);

                    for (var i = 0; i < args.length; ++i) {
                      args[i] = arguments[i];
                    }

                    var originalCallback = args[0];

                    if (isFunction(originalCallback)) {
                      args[0] = self.wrap(originalCallback);
                    } // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                    // also supports only two arguments and doesn't care what this is, so we
                    // can just call the original function directly.


                    if (orig.apply) {
                      return orig.apply(this, args);
                    } else {
                      return orig(args[0], args[1]);
                    }
                  };
                }

                function wrapEventTarget(global) {
                  var proto = _window[global] && _window[global].prototype;

                  if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
                    fill(proto, 'addEventListener', function (orig) {
                      return function (evtName, fn, capture, secure) {
                        // preserve arity
                        try {
                          if (fn && fn.handleEvent) {
                            fn.handleEvent = self.wrap(fn.handleEvent);
                          }
                        } catch (err) {} // can sometimes get 'Permission denied to access property "handle Event'
                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                        // so that we don't have more than one wrapper function


                        var before;
                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
                      };
                    }, wrappedBuiltIns);
                    fill(proto, 'removeEventListener', function (orig) {
                      return function (evt, fn, capture, secure) {
                        try {
                          fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
                        } catch (e) {// ignore, accessing __lr_wrapper__ will throw in some Selenium environments
                        }

                        return orig.call(this, evt, fn, capture, secure);
                      };
                    }, wrappedBuiltIns);
                  }
                }

                fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
                fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);

                if (_window.requestAnimationFrame) {
                  fill(_window, 'requestAnimationFrame', function (orig) {
                    return function (cb) {
                      return orig(self.wrap(cb));
                    };
                  }, wrappedBuiltIns);
                } // event targets borrowed from bugsnag-js:
                // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666


                var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];

                for (var i = 0; i < eventTargets.length; i++) {
                  wrapEventTarget(eventTargets[i]);
                }

                var $ = _window.jQuery || _window.$;

                if ($ && $.fn && $.fn.ready) {
                  fill($.fn, 'ready', function (orig) {
                    return function (fn) {
                      return orig.call(this, self.wrap(fn));
                    };
                  }, wrappedBuiltIns);
                }
              }
            }]);

            return Handler;
          }();

          exports.default = Handler;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(4));
        /***/
      },
      /* 18 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = stackTraceFromError;

        function stackTraceFromError(errorReport) {
          function makeNotNull(val) {
            return val === null ? undefined : val;
          }

          return errorReport.stack ? errorReport.stack.map(function (frame) {
            return {
              lineNumber: makeNotNull(frame.line),
              columnNumber: makeNotNull(frame.column),
              fileName: makeNotNull(frame.url),
              functionName: makeNotNull(frame.func)
            };
          }) : undefined;
        }
        /***/

      },
      /* 19 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _registerConsole = __webpack_require__(20);

        var _registerConsole2 = _interopRequireDefault(_registerConsole);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = _registerConsole2.default;
        /***/
      },
      /* 20 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        exports.default = registerConsole;

        var _enhanceFunc = __webpack_require__(2);

        var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);

        var _logrocketExceptions = __webpack_require__(3);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function registerConsole(logger) {
          var unsubFunctions = [];
          var methods = ['log', 'warn', 'info', 'error', 'debug'];
          methods.forEach(function (method) {
            unsubFunctions.push((0, _enhanceFunc2.default)(console, method, function () {
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              logger.addEvent('lr.core.LogEvent', function () {
                var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var isEnabled = consoleOptions.isEnabled;

                if ((typeof isEnabled === 'undefined' ? 'undefined' : _typeof(isEnabled)) === 'object' && isEnabled[method] === false || isEnabled === false) {
                  return null;
                }

                if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
                  _logrocketExceptions.Capture.captureMessage(logger, args[0], {}, true);
                }

                return {
                  logLevel: method.toUpperCase(),
                  args: args
                };
              });
            }));
          });
          return function () {
            unsubFunctions.forEach(function (unsubFunction) {
              return unsubFunction();
            });
          };
        }
        /***/

      },
      /* 21 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.createEnhancer = exports.createMiddleware = undefined;

        var _createEnhancer = __webpack_require__(22);

        var _createEnhancer2 = _interopRequireDefault(_createEnhancer);

        var _createMiddleware = __webpack_require__(23);

        var _createMiddleware2 = _interopRequireDefault(_createMiddleware);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.createMiddleware = _createMiddleware2.default;
        exports.createEnhancer = _createEnhancer2.default;
        /***/
      },
      /* 22 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        exports.default = createEnhancer;

        var _now = __webpack_require__(7);

        var _now2 = _interopRequireDefault(_now);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var storeIdCounter = 0;

        function createEnhancer(logger) {
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              _ref$stateSanitizer = _ref.stateSanitizer,
              stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
            return f;
          } : _ref$stateSanitizer,
              _ref$actionSanitizer = _ref.actionSanitizer,
              actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
            return f;
          } : _ref$actionSanitizer; // an enhancer is a function that returns a Store


          return function (createStore) {
            return function (reducer, initialState, enhancer) {
              var store = createStore(reducer, initialState, enhancer);
              var originalDispatch = store.dispatch;
              var storeId = storeIdCounter++;
              logger.addEvent('lr.redux.InitialState', function () {
                var sanitizedState = void 0;

                try {
                  // only try catch user defined functions
                  sanitizedState = stateSanitizer(store.getState());
                } catch (err) {
                  console.error(err.toString());
                }

                return {
                  state: sanitizedState,
                  storeId: storeId
                };
              });

              var dispatch = function dispatch(action) {
                var start = (0, _now2.default)();
                var err = void 0;
                var res = void 0;

                try {
                  res = originalDispatch(action);
                } catch (_err) {
                  err = _err;
                } finally {
                  var duration = (0, _now2.default)() - start;
                  logger.addEvent('lr.redux.ReduxAction', function () {
                    var sanitizedState = null;
                    var sanitizedAction = null;

                    try {
                      // only try catch user defined functions
                      sanitizedState = stateSanitizer(store.getState());
                      sanitizedAction = actionSanitizer(action);
                    } catch (err) {
                      console.error(err.toString());
                    }

                    if (sanitizedState && sanitizedAction) {
                      return {
                        storeId: storeId,
                        action: sanitizedAction,
                        duration: duration,
                        stateDelta: sanitizedState
                      };
                    }

                    return null;
                  });
                }

                if (err) {
                  throw err;
                }

                return res;
              };

              return _extends({}, store, {
                dispatch: dispatch
              });
            };
          };
        }
        /***/

      },
      /* 23 */

      /***/
      function (module, exports, __webpack_require__) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = createMiddleware;

        var _now = __webpack_require__(7);

        var _now2 = _interopRequireDefault(_now);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var storeIdCounter = 0;

        function createMiddleware(logger) {
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              _ref$stateSanitizer = _ref.stateSanitizer,
              stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
            return f;
          } : _ref$stateSanitizer,
              _ref$actionSanitizer = _ref.actionSanitizer,
              actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
            return f;
          } : _ref$actionSanitizer;

          return function (store) {
            var storeId = storeIdCounter++;
            logger.addEvent('lr.redux.InitialState', function () {
              var sanitizedState = void 0;

              try {
                // only try catch user defined functions
                sanitizedState = stateSanitizer(store.getState());
              } catch (err) {
                console.error(err.toString());
              }

              return {
                state: sanitizedState,
                storeId: storeId
              };
            });
            return function (next) {
              return function (action) {
                var start = (0, _now2.default)();
                var err = void 0;
                var res = void 0;

                try {
                  res = next(action);
                } catch (_err) {
                  err = _err;
                } finally {
                  var duration = (0, _now2.default)() - start;
                  logger.addEvent('lr.redux.ReduxAction', function () {
                    var sanitizedState = null;
                    var sanitizedAction = null;

                    try {
                      // only try catch user defined functions
                      sanitizedState = stateSanitizer(store.getState());
                      sanitizedAction = actionSanitizer(action);
                    } catch (err) {
                      console.error(err.toString());
                    }

                    if (sanitizedState && sanitizedAction) {
                      return {
                        storeId: storeId,
                        action: sanitizedAction,
                        duration: duration,
                        stateDelta: sanitizedState
                      };
                    }

                    return null;
                  });
                }

                if (err) {
                  throw err;
                }

                return res;
              };
            };
          };
        }
        /***/

      }
      /******/
      ])
    );
  });
});
var LogRocket = unwrapExports(build_umd);
var APPS_ID = {
  'report-builder': '2orf07/iqm-report-builder',
  'dashboard': '2orf07/advertiser-dashboard'
};

function enableLogRocket(app) {
  var id = APPS_ID[app];

  if (id) {
    LogRocket.init(id);
  }
}

function identifyLogRocket() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  LogRocket.identify(user.apiToken, {
    name: "".concat(user.firstName ? user.firstName + ' ' + user.lastName : user.companyName),
    email: user.email
  });
}

var LoginRoute = /*#__PURE__*/function (_Component) {
  inherits(LoginRoute, _Component);

  function LoginRoute() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, LoginRoute);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(LoginRoute)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      isOneClickLogin: true
    });
    defineProperty(assertThisInitialized(_this), "onSuccess", function (userData, rememberMe) {
      _this.props.onSuccess && _this.props.onSuccess(userData, rememberMe);
      identifyLogRocket(userData);
    });
    return _this;
  }

  createClass(LoginRoute, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkAuth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        this.checkAuth();
      }
    }
  }, {
    key: "checkAuth",
    value: function () {
      var _checkAuth = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _this$props$match$par, token, baseUrl, _ref, responseObject, rememberMe, userData;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props$match$par = this.props.match.params, token = _this$props$match$par.token, baseUrl = _this$props$match$par.base_url;

                if (token && baseUrl) {
                  _context.next = 4;
                  break;
                }

                this.setState({
                  isOneClickLogin: false
                });
                return _context.abrupt("return");

              case 4:
                token = atob(token);
                baseUrl = atob(baseUrl);
                _context.next = 8;
                return ApiService.validateToken(token);

              case 8:
                _ref = _context.sent;
                responseObject = _ref.responseObject;

                if (!responseObject.isValid) {
                  _context.next = 17;
                  break;
                }

                rememberMe = true;
                _context.next = 14;
                return AuthService.authorize({
                  apiToken: token,
                  userType: USER_ADVERTISER,
                  domainURL: baseUrl
                }, rememberMe);

              case 14:
                userData = _context.sent;
                this.onSuccess(userData, rememberMe);
                this.props.redirectPath && this.props.history.push(this.props.redirectPath);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkAuth() {
        return _checkAuth.apply(this, arguments);
      }

      return checkAuth;
    }()
  }, {
    key: "render",
    value: function render() {
      if (this.state.isOneClickLogin) return null;
      return React.createElement("div", {
        className: "main _centered"
      }, React.createElement(LoginForm, {
        onSuccess: this.onSuccess,
        docTitle: this.props.docTitle
      }));
    }
  }]);
  return LoginRoute;
}(Component);

LoginRoute.propTypes = {
  docTitle: PropTypes.string,
  onSuccess: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  redirectPath: PropTypes.string
};

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

var LoginFormContainer = /*#__PURE__*/function (_React$Component) {
  inherits(LoginFormContainer, _React$Component);
  createClass(LoginFormContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkAuth();
    }
  }]);

  function LoginFormContainer(props) {
    var _this;

    classCallCheck(this, LoginFormContainer);
    _this = possibleConstructorReturn(this, getPrototypeOf(LoginFormContainer).call(this, props));
    defineProperty(assertThisInitialized(_this), "state", {
      isOneClickLogin: true
    });
    defineProperty(assertThisInitialized(_this), "onSuccessLogin", function (userData, rememberMe) {
      var search = _this.props.location.search;
      AuthService.updateUser(userData);
      identifyLogRocket(userData);
      _this.props.successLoginRedirectPath && _this.props.history.push(_this.props.successLoginRedirectPath + search);
    });
    var params = get(props, 'match.params');
    _this.state = {
      isOneClickLogin: params.token && params.baseUrl
    };
    return _this;
  }

  createClass(LoginFormContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        this.checkAuth();
      }
    }
  }, {
    key: "checkAuth",
    value: function () {
      var _checkAuth = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _this$props$match$par, base64Token, base64BaseUrl, search, token, baseUrl, _ref, responseObject;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props$match$par = this.props.match.params, base64Token = _this$props$match$par.base64Token, base64BaseUrl = _this$props$match$par.base64BaseUrl;
                search = this.props.location.search;

                if (base64Token && base64BaseUrl) {
                  _context.next = 5;
                  break;
                }

                if (this.state.isOneClickLogin) {
                  this.setState({
                    isOneClickLogin: false
                  });
                }

                return _context.abrupt("return");

              case 5:
                token = atob(base64Token);
                baseUrl = atob(base64BaseUrl);
                _context.next = 9;
                return ApiService.validateToken(token);

              case 9:
                _ref = _context.sent;
                responseObject = _ref.responseObject;

                if (!responseObject.isValid) {
                  _context.next = 15;
                  break;
                }

                _context.next = 14;
                return AuthService.authorize({
                  apiToken: token,
                  domainURL: baseUrl,
                  userType: USER_ADVERTISER
                }, true);

              case 14:
                this.props.successLoginRedirectPath && this.props.history.push(this.props.successLoginRedirectPath + search);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkAuth() {
        return _checkAuth.apply(this, arguments);
      }

      return checkAuth;
    }()
  }, {
    key: "render",
    value: function render() {
      var search = this.props.location.search;

      if (this.state.isOneClickLogin) {
        return null;
      }

      if (AuthService.getToken()) {
        return React.createElement(Redirect, {
          to: this.props.successLoginRedirectPath + search
        });
      }

      return React.createElement("div", {
        className: "main _centered"
      }, React.createElement(LoginForm, {
        onSuccess: this.onSuccessLogin,
        docTitle: this.props.documentTitle
      }));
    }
  }]);
  return LoginFormContainer;
}(React.Component);

LoginFormContainer.propTypes = {
  documentTitle: PropTypes.string,
  successLoginRedirectPath: PropTypes.string,
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object
};

var PrivateRoutesContainer = /*#__PURE__*/function (_React$Component) {
  inherits(PrivateRoutesContainer, _React$Component);

  function PrivateRoutesContainer() {
    classCallCheck(this, PrivateRoutesContainer);
    return possibleConstructorReturn(this, getPrototypeOf(PrivateRoutesContainer).apply(this, arguments));
  }

  createClass(PrivateRoutesContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      var authorizedUser = AuthService.getUser();

      if (!authorizedUser) {
        return this.props.history.push('/login');
      }

      AuthService.logout = function () {
        AuthService.unauthorize();

        _this.props.onLogout();

        _this.props.history.push('/login');
      };

      this.props.onSuccessLogin(authorizedUser, this.props.history);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return PrivateRoutesContainer;
}(React.Component);

PrivateRoutesContainer.propTypes = {
  onSuccessLogin: PropTypes.func,
  onLogout: PropTypes.func,
  history: PropTypes.object
};
var PrivateRoutesContainer$1 = withRouter(PrivateRoutesContainer);

var IQMRouter = /*#__PURE__*/function (_Component) {
  inherits(IQMRouter, _Component);

  function IQMRouter() {
    classCallCheck(this, IQMRouter);
    return possibleConstructorReturn(this, getPrototypeOf(IQMRouter).apply(this, arguments));
  }

  createClass(IQMRouter, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(HashRouter, {
        basename: "/"
      }, React.createElement(Switch, null, React.createElement(Route, {
        path: "/login/:base64Token?/:base64BaseUrl?",
        component: function component(props) {
          return React.createElement(LoginFormContainer, _extends_1({}, props, {
            documentTitle: _this.props.documentTitle,
            onSuccessLogin: _this.props.onSuccessLogin,
            successLoginRedirectPath: _this.props.successLoginRedirectPath
          }));
        }
      }), React.createElement(PrivateRoutesContainer$1, {
        onSuccessLogin: this.props.onSuccessLogin,
        successLoginRedirectPath: this.props.successLoginRedirectPath,
        onLogout: this.props.onLogout
      }, this.props.children), React.createElement(Redirect, {
        to: this.props.successLoginRedirectPath
      })));
    }
  }]);
  return IQMRouter;
}(Component);

IQMRouter.propTypes = {
  documentTitle: PropTypes.string,
  successLoginRedirectPath: PropTypes.string,
  onSuccessLogin: PropTypes.func,
  onLogout: PropTypes.func
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#5A4146",
  d: "M85.7 36.2v1.3c0 1.6.3 3.3.8 4.8l3 9.1h5.7v-21h-3.8c-3.1.1-5.7 2.6-5.7 5.8z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#694B4B",
  d: "M111.8 40.2l-3.2 11.3-15.2-13.4c-2.1 0-3.8-1.7-3.8-3.8 0-3.2 2.6-5.7 5.7-5.7h13.3c2.1 0 3.8 1.7 3.8 3.8V36c0 1.4-.2 2.8-.6 4.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AF78",
  d: "M93.4 57.2h11.4v8.4H93.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D29B6E",
  d: "M93.4 60.7c1.8.7 3.7 1.1 5.7 1.1s3.9-.4 5.7-1.1v-3.5H93.4v3.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5DCED",
  d: "M114 64.4l-9.2-2.6-5.7 3.8-5.7-3.8-9.2 2.6c-2.5.7-4.1 2.9-4.1 5.5v13.9c0 1.1.9 1.9 1.9 1.9h34.3c1.1 0 1.9-.9 1.9-1.9V69.9c-.1-2.6-1.8-4.8-4.2-5.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#AFB9D2",
  d: "M101 85.7h-3.8l.9-20.1h1.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0C087",
  d: "M99.1 59.1c-6.3 0-11.4-5.1-11.4-11.4v-2.2c0-1 .4-2 1.1-2.7l3.5-3.5c.7-.7 1.7-1.2 2.8-1.1 6.1.2 11.5 1.5 14.4 4.4.7.7 1.1 1.7 1.1 2.7v2.4c-.1 6.2-5.2 11.4-11.5 11.4z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AF78",
  d: "M93.4 45.9c0-2.2 1.8-3.9 4-3.8 3.8.2 9.6.9 13.1 2.6-.1-.8-.5-1.6-1-2.1-2.9-2.9-8.3-4.2-14.4-4.4-1 0-2 .4-2.8 1.1l-3.5 3.5c-.7.7-1.1 1.7-1.1 2.7v2.2c0 5.2 3.5 9.6 8.3 11-1.6-2-2.5-4.4-2.5-7.2l-.1-5.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CFE2",
  d: "M110.5 75.6c0-1.5.6-3 1.7-4l4.9-4.9c.7.9 1 2.1 1 3.3v13.9c0 1.1-.9 1.9-1.9 1.9h-5.7V75.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#959CB5",
  d: "M100 69.4h-1.9c-.5 0-1-.4-1-1v-2.9h3.8v2.9c.1.6-.3 1-.9 1z"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  fill: "#C7CFE2"
}, React.createElement("path", {
  d: "M99.1 65.6L95.8 68c-.6.4-1.4.3-1.7-.4l-2.9-5.3 1.2-1.8c.3-.4.8-.5 1.2-.1l5.5 5.2zM99.1 65.6l3.2 2.5c.6.4 1.4.3 1.7-.4l2.9-5.3-1.2-1.8c-.3-.4-.8-.5-1.2-.1l-5.4 5.1z"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#5A4146",
  d: "M34.1 58.3c-1.6-4.3-2.9-11.7-3.2-15.6-.5-7.3-6.1-13.3-13.6-13.3s-13 6-13.6 13.3C3.5 46.5 2.2 54 .6 58.3c-.4 1 .1 2 1 2.4 1.7.8 5.5 2.3 10 2.9h11.6c4.5-.6 8.2-2.2 10-2.9.8-.4 1.3-1.5.9-2.4z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#694B4B",
  d: "M33.1 60.7c.9-.4 1.4-1.5 1-2.4-1.6-4.3-2.9-11.7-3.2-15.6-.5-7.3-6.1-13.3-13.6-13.3h-.1c-5.7 0-7.8 7.9-2.8 10.8.3.2.5.3.5.3l4.3 23.3h3.9c4.5-.8 8.3-2.3 10-3.1z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AF78",
  d: "M31.1 67.5L25 64.4c-1.3-.6-2.1-2-2.1-3.4v-5.7H11.4V61c0 1.4-.8 2.8-2.1 3.4l-6.2 3.1c-1.9 1-3.2 2.9-3.2 5.1v11.3c0 1.1.9 1.9 1.9 1.9h30.5c1.1 0 1.9-.9 1.9-1.9V72.6c.1-2.2-1.1-4.2-3.1-5.1z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#D29B6E",
  d: "M17.1 62.9c2.1 0 4-.4 5.8-1.2 0-.2-.1-.5-.1-.7v-5.7H11.4V61c0 .3-.1.5-.1.7 1.8.7 3.8 1.2 5.8 1.2z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5DCED",
  d: "M31.1 67.5l-4.4-2.2c-2 3.1-5.6 5.2-9.6 5.2s-7.6-2.1-9.6-5.2l-4.4 2.2c-1.9 1-3.2 2.9-3.2 5.1v11.3c0 1.1.9 1.9 1.9 1.9h30.5c1.1 0 1.9-.9 1.9-1.9V72.6c.1-2.2-1.1-4.2-3.1-5.1z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0C087",
  d: "M17.1 59.1c-5.8 0-10.6-4.3-11.3-10-.1-.8.3-1.6 1-2 .9-.4 2.2-1.2 3.4-2.3 1.4-1.2 2.2-2.5 2.6-3.4.4-.8 1.3-1.3 2.1-1 6.7 1.7 11.3 5.2 12.9 6.6.4.4.7.9.7 1.5-.4 5.9-5.3 10.6-11.4 10.6z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AF78",
  d: "M27.9 47c-1.7-1.4-6.2-4.9-12.9-6.6-.9-.2-1.8.2-2.1 1-.3.7-.9 1.6-1.7 2.5-.3.3-.5.6-.9.9-1.2 1.1-2.5 1.8-3.4 2.3-.7.4-1.1 1.2-1 2 .7 5 4.6 9.1 9.6 9.8-2.3-1.6-4-3.7-4-7.5v-2.7c.4-.3.9-.6 1.3-1 1.1-.9 2-2 2.7-3.2 5.1 1.6 8.6 4.3 9.9 5.4.4.3 1.3 1.1 2.3 2.1.5-1.1.7-2.3.8-3.5.1-.5-.2-1.1-.6-1.5z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CFE2",
  d: "M1.2 69.1c-.7 1-1.2 2.2-1.2 3.4v11.3c0 1.1.9 1.9 1.9 1.9h5.7v-9.6c0-1.2-.5-2.3-1.4-3l-5-4z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M86.4 64.9l-15.9-5.8-11.4 3.8-11.4-3.8-15.9 5.8c-3 1.1-5 4-5 7.2v11.8c0 1.1.9 1.9 1.9 1.9h61c1.1 0 1.9-.9 1.9-1.9V72c-.1-3.2-2.2-6-5.2-7.1z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5859",
  d: "M57 65.8l-1.9 19.9H63l-1.9-19.9z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5859",
  d: "M61.1 69.3h-4c-.7 0-1.3-.6-1.3-1.3v-5.1h6.7V68c-.1.7-.7 1.3-1.4 1.3z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#39C9A0",
  d: "M89.4 66.8c1.3 1.4 2.1 3.2 2.1 5.2v11.8c0 1.1-.9 1.9-1.9 1.9H80v-6.4c0-2 .8-4 2.2-5.4l7.2-7.1z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#5A4146",
  d: "M80 19.8v-16C80 1.7 78.3 0 76.2 0H53.3c-8.4 0-15.2 6.8-15.2 15.2v4.5c0 2 .3 4.1 1 6l.6 1.9c.2.6.3 1.2.3 1.8v1h38.1v-1c0-.6.1-1.2.3-1.8l.6-1.9c.7-1.8 1-3.9 1-5.9z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#694B4B",
  d: "M47.6 7.7c0 4.3 3.5 7.7 7.7 7.7h1.1l.5 15h21.2v-1c0-.6.1-1.2.3-1.8l.6-1.9c.6-1.9 1-4 1-6v-16c0-2-1.7-3.7-3.8-3.7H55.4c-4.3 0-7.8 3.5-7.8 7.7z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AF78",
  d: "M47.6 45.7h22.9v17.1H47.6z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#D29B6E",
  d: "M47.6 52.2c3.4 1.9 7.3 3.1 11.4 3.1s8.1-1.1 11.4-3.1v-6.4H47.6v6.4z"
});

var _ref28 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFA300"
}, React.createElement("path", {
  d: "M59.1 62.9l-6.1 6c-.8.8-2.2.7-2.9-.2l-6.3-8.3 1.6-3.5c.5-1 1.8-1.4 2.7-.8l11 6.8z"
}), React.createElement("path", {
  d: "M59.1 62.9l6.1 6.1c.8.8 2.2.7 2.9-.2l6.3-8.3-1.7-3.5c-.5-1-1.8-1.4-2.7-.8l-10.9 6.7z"
}));

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0C087",
  d: "M59.1 51.4c-10.6 0-19.1-8.5-19.1-19v-2.2c0-1 .4-2 1.1-2.7l1.6-1.6c.7-.7 1.1-1.7 1.1-2.7v-4.6c0-.9.6-1.6 1.5-1.9 4.5-1.1 18.5-3.6 28.1 3.4.6.5 1 1.2 1 2v1c0 1 .4 2 1.1 2.7l1.6 1.6c.7.7 1.1 1.7 1.1 2.7v2.2c-.1 10.6-8.6 19.1-19.1 19.1z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AF78",
  d: "M73.3 20.2c-6.7-4.9-15.6-5.1-21.9-4.5-2.6.3-4.8.7-6.2 1-.9.2-1.5 1-1.5 1.9v4.6c0 1-.4 2-1.1 2.7L41 27.5c-.7.7-1.1 1.7-1.1 2.7v2.2c0 9.7 7.3 17.8 16.8 18.9-3.3-3.4-5.3-8.1-5.3-13.2V24.2c0-1.9 1.4-3.5 3.4-3.8 4.6-.6 12.9-.9 19.5 2.8v-1c0-.8-.3-1.5-1-2z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#39C9A0",
  d: "M28.7 66.8c-1.3 1.4-2.1 3.2-2.1 5.2v11.8c0 1.1.9 1.9 1.9 1.9H38v-6.4c0-2-.8-4-2.2-5.4l-7.1-7.1z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 118.1 85.7"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var _ref$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#F29F5C",
  d: "M101.3 35.7l-3.1-25.6-5.9.7-11.5-6.4c-1.2-.7-2.6-1-4-.9L58.7 5.2c-2.2.2-4.2 1.5-5.3 3.4L40.7 30.5c-.9 1.6-.2 3.7 1.5 4.4l.5.2c1 .4 2 .6 3.1.7l-1.6 1.4-3.3 2.8-9.2 7.8c-1.6 1.4-1.8 3.9-.4 5.5l.9 1.1c1.8 2.1 5 2.3 7.1.5l3.5 4c1.1 1.3 2.8 1.9 4.4 1.7 1-.1 1.9-.5 2.7-1.2l3.5 4c1.1 1.3 2.8 1.9 4.4 1.7 1-.1 1.9-.5 2.7-1.2l1.9 1.6c1.8 2.1 5 2.3 7.1.5l2.6-2.3 21.8-17h8.6l-1.2-11z"
});

var _ref2$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#D37D42",
  d: "M92 40.2l-21.8 17-2.6 2.3c-2.1 1.8-5.3 1.6-7.1-.5l-1.9-1.6c-.8.7-1.7 1.1-2.7 1.2-1.6.2-3.3-.4-4.4-1.7l-3.5-4c-.8.7-1.7 1.1-2.7 1.2-1.6.2-3.3-.4-4.4-1.7l-3.5-4c-1.8 1.6-4.4 1.6-6.2.3-1 1.4-.9 3.4.3 4.7l.9 1.1c1.8 2.1 5 2.3 7.1.5l3.5 4c1.1 1.3 2.8 1.9 4.4 1.7 1-.1 1.9-.5 2.7-1.2l3.5 4c1.1 1.3 2.8 1.9 4.4 1.7 1-.1 1.9-.5 2.7-1.2l1.9 1.6c1.8 2.1 5 2.3 7.1.5l2.6-2.3 21.8-17h8.6l-1-7.7-9.7 1.1z"
});

var _ref3$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0C087",
  d: "M95.9 51.3L84.3 41.2 81 38.4l-2.3-2-10-8.6 1.2-9.8c.4-3.3-1.7-6.4-4.9-7.3l-21.8-6c-2.3-.6-4.7.4-5.8 2.6l-2.7 5.3-11.7-.8-3 25.6-1.3 11.1 11.3.8 23.9 20.6 2.6 2.2c2.1 1.8 5.3 1.6 7.1-.5l3.5-4c.8.7 1.7 1.1 2.7 1.2 1.6.2 3.3-.4 4.4-1.7l3.5-4c.8.7 1.7 1.1 2.7 1.2 1.6.2 3.3-.4 4.4-1.7l3.5-4c2.1 1.8 5.3 1.6 7.1-.5l.9-1.1c1.5-1.8 1.3-4.3-.4-5.7z"
});

var _ref4$1 = /*#__PURE__*/React.createElement("g", {
  fill: "#D6A269"
}, React.createElement("path", {
  d: "M95.9 51.3l-3.6-3.1c1.2 1.5 1.1 3.7-.2 5.2l-1 1.1c-1.9 2.2-5.3 2.5-7.5.6L80 59.4c-1.2 1.4-3 2-4.7 1.8-1-.1-2-.5-2.9-1.3l-3.7 4.3c-1.2 1.4-3 2-4.7 1.8-1-.1-2-.5-2.9-1.3L57.4 69c-.7.8-1.6 1.4-2.5 1.6l1.6 1.4c2.1 1.8 5.3 1.6 7.1-.5l3.5-4c.8.7 1.7 1.1 2.7 1.2 1.6.2 3.3-.4 4.4-1.7l3.5-4c.8.7 1.7 1.1 2.7 1.2 1.6.2 3.3-.4 4.4-1.7l3.5-4c2.1 1.8 5.3 1.6 7.1-.5l.9-1.1c1.5-1.7 1.3-4.2-.4-5.6z"
}), React.createElement("path", {
  d: "M89.5 57.1l-6.4-5.5c-.8-.7-1.9-.6-2.6.2-.7.8-.6 1.9.2 2.6l6.4 5.5 1.2-1.4c.5.4 1 .7 1.6.9.4-.8.3-1.8-.4-2.3zM79.3 63.9c.4-.7.3-1.7-.4-2.3l-5.7-5c-.8-.7-1.9-.6-2.6.2-.7.8-.6 1.9.2 2.6l5.7 5 1.2-1.4c.5.4 1 .7 1.6.9z"
}));

var _ref5$1 = /*#__PURE__*/React.createElement("g", {
  fill: "#F29F5C"
}, React.createElement("path", {
  d: "M30.6 49.2L29.2 51c-1.5 2-1.1 4.8.9 6.3s4.8 1.1 6.3-.9l1.4-1.8c1.5-2 1.1-4.8-.9-6.3-2-1.4-4.8-1-6.3.9zM39 53.1l-2.6 3.4c-1.5 2-1.1 4.8.9 6.3s4.8 1.1 6.3-.9l2.6-3.4c1.5-2 1.1-4.8-.9-6.3-1.9-1.5-4.8-1.1-6.3.9zM47.2 57.3L43.6 62c-1.5 2-1.1 4.8.9 6.3s4.8 1.1 6.3-.9l3.6-4.7c1.5-2 1.1-4.8-.9-6.3s-4.8-1.1-6.3.9zM54.6 62.5l-3.8 5c-1.5 2-1.1 4.8.9 6.3s4.8 1.1 6.3-.9l3.8-5c1.5-2 1.1-4.8-.9-6.3s-4.8-1.1-6.3.9zM92.2 10.8L80.8 4.4c-1.2-.7-2.6-1-4-.9L58.7 5.2c-2.2.2-4.2 1.5-5.3 3.4L40.7 30.5c-.9 1.6-.2 3.7 1.5 4.4l.5.2c4.7 1.8 9.9.3 13-3.7l4.9-6.4s11.7 13.6 24.6-2.3"
}));

var _ref6$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M124 50.2l-6-48.6c-.1-.5-.3-.9-.7-1.2-.4-.3-.8-.4-1.3-.4l-14 1.7c-3.6.4-6.2 3.8-5.8 7.4l4.8 39c.4 3.4 3.3 5.8 6.6 5.8.3 0 .5 0 .8-.1l14-1.7c1 0 1.7-.9 1.6-1.9z"
});

var _ref7$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#39C9A0",
  d: "M124 50.2l-.7-5.3c-.3.4-.8.7-1.3.8l-14.7 1.8c-.3 0-.6.1-.9.1-2.5 0-4.7-1.3-5.9-3.4l.5 4c.4 3.4 3.3 5.8 6.6 5.8.3 0 .5 0 .8-.1l14-1.7c1-.1 1.7-1 1.6-2z"
});

var _ref8$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFA300",
  d: "M22 1.7L8 0c-.5 0-.9.1-1.3.4-.4.3-.6.7-.7 1.2L0 50.2c-.1 1 .6 1.9 1.6 2l14 1.7c.3 0 .5.1.8.1 3.3 0 6.2-2.5 6.6-5.8l4.8-39c.4-3.7-2.1-7-5.8-7.5z"
});

var _ref9$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#ED9406",
  d: "M0 50.2l.7-5.3c.3.4.7.7 1.3.8l14.7 1.8c.3 0 .6.1.9.1 2.5 0 4.7-1.3 5.9-3.4l-.5 4c-.4 3.4-3.3 5.8-6.6 5.8-.3 0-.5 0-.8-.1l-14-1.7c-1-.1-1.7-1-1.6-2z"
});

var _ref10$1 = /*#__PURE__*/React.createElement("g", {
  fill: "#EBEEF2"
}, React.createElement("circle", {
  cx: 112.4,
  cy: 42.4,
  r: 3.5
}), React.createElement("circle", {
  cx: 11.4,
  cy: 42.4,
  r: 3.5
}));

var SvgComponent$1 = function SvgComponent(props) {
  return React.createElement("svg", _extends$1({
    viewBox: "0 0 124 74.7"
  }, props), _ref$1, _ref2$1, _ref3$1, _ref4$1, _ref5$1, _ref6$1, _ref7$1, _ref8$1, _ref9$1, _ref10$1);
};

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

var _ref$2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "b"
}, React.createElement("stop", {
  stopColor: "#00245F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#004B98",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "e"
}, React.createElement("stop", {
  stopOpacity: 0.372,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#919191",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("path", {
  d: "M18.571 0a40.638 40.638 0 01-5.25.321C11.5.321 9.714.214 8.071 0 4.25 3.25 0 8.679 0 13.607 0 21.357 5.964 25 13.321 25c7.358 0 13.322-3.643 13.322-11.393 0-4.964-4.25-10.357-8.072-13.607z",
  id: "a"
}), React.createElement("path", {
  d: "M18.571 0a40.638 40.638 0 01-5.25.321C11.5.321 9.714.214 8.071 0 4.25 3.25 0 8.679 0 13.607 0 21.357 5.964 25 13.321 25c7.358 0 13.322-3.643 13.322-11.393 0-4.964-4.25-10.357-8.072-13.607z",
  id: "d"
}));

var _ref2$2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.571 8.929a40.638 40.638 0 01-5.25.321c-1.821 0-3.607-.107-5.25-.321C4.25 12.179 0 17.607 0 22.536c0 7.75 5.964 11.393 13.321 11.393 7.358 0 13.322-3.643 13.322-11.393 0-4.965-4.25-10.357-8.072-13.607z",
  fill: "#E90000",
  fillRule: "nonzero"
});

var _ref3$2 = /*#__PURE__*/React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
}));

var _ref4$2 = /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#d"
}));

var _ref5$2 = /*#__PURE__*/React.createElement("path", {
  fill: "#846C64",
  fillRule: "nonzero",
  d: "M8.321 6.679l9.858.178.428 2.28-5.143.204-5.424-.204z"
});

var _ref6$2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.321 7.143c1.715 0 3.358-.107 4.858-.286 1-2.143 1.892-4.321 1.892-5.286 0-1.428-1.821-2.178-2.892-.642-1.429 2-2.072-.929-3.715-.929-1.643 0-2.5 2.714-3.785.893C8.5-.75 6.536.25 6.536 1.536c0 1.25.821 3.357 1.75 5.321 1.535.179 3.25.286 5.035.286z",
  fill: "#E90000",
  fillRule: "nonzero"
});

var _ref7$2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.561 28.661v1.957c0 .191-.143.382-.382.382h-1.91a.376.376 0 01-.381-.382v-1.91c-1.91-.142-3.485-1.622-3.675-3.531 0-.191.19-.382.381-.382h1.91c.19 0 .334.095.382.286.095.573.668 1.003 1.24 1.003h1.671c1.003 0 1.91-.716 2.005-1.671.143-1.146-.764-2.1-1.862-2.1H12.7c-2.34 0-4.44-1.719-4.678-4.105-.24-2.482 1.527-4.583 3.914-4.917v-1.91c0-.19.19-.381.382-.381h1.909c.19 0 .382.143.382.382v1.91c1.909.142 3.484 1.622 3.675 3.531 0 .191-.143.382-.382.382h-1.909c-.143 0-.334-.095-.382-.286a1.332 1.332 0 00-1.289-1.003h-1.67c-1.003 0-1.862.716-2.005 1.671-.096 1.146.764 2.1 1.861 2.1h1.432c2.673 0 4.774 2.244 4.487 4.965-.19 2.1-1.861 3.675-3.866 4.01z",
  fill: "#FFF",
  fillRule: "nonzero"
});

var SvgComponent$2 = function SvgComponent(props) {
  return React.createElement("svg", _extends$2({
    width: 27,
    height: 34,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref$2, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2$2, React.createElement("g", {
    transform: "translate(0 8.929)"
  }, _ref3$2, React.createElement("path", {
    d: "M7.694-4.742L11.98-2.6c1.175-4.805 2.493-6.546 3.955-5.222 1.112 1.007 7.323 6.72 11.42 9.428.744.492.212 5.981-1.817 5.981-1.278 0-2.812.146-4.603.438-6.347.387-10.144.387-11.391 0C3.112 6.034 1.67.876.302-.492c-1.764-1.764.7-3.181 7.392-4.25z",
    fill: "url(#b)",
    fillRule: "nonzero",
    opacity: 0.556,
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#c)"
  })), React.createElement("g", {
    transform: "translate(0 8.929)"
  }, _ref4$2, React.createElement("path", {
    d: "M17.234 26.124h-.349l7.77-3.517 4.08-3.91C22.553 11.97 18.95 8.22 17.926 7.449c-3.7-2.793-6.443-.315-7.156 0-2.5 1.102 1.998 4.497.938 3.924-1.45-.784-.202-.414 3.744 1.11.832 1.405 1.093 2.35.784 2.832a63.112 63.112 0 01-1.547 2.249l-2.98 1.133 5.526 7.427z",
    fill: "url(#e)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#f)"
  })), _ref5$2, _ref6$2, _ref7$2));
};

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

var _ref$3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, React.createElement("g", {
  id: "Product-Icons-12-Copy-17",
  transform: "translate(-129 -38)"
}, React.createElement("g", {
  id: "Dashboard",
  transform: "translate(129 38)"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("g", {
  id: "Advertiser-Dashboard-Prodict-Icon"
}, React.createElement("g", {
  id: "Group-7"
}, React.createElement("path", {
  id: "Rectangle-Copy",
  d: "M0 30V2C0 .9.9 0 2 0h33.1c1.1 0 2 .9 2 2v28c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#007aff"
}), React.createElement("path", {
  id: "Rectangle",
  d: "M1.9 31h34.9c-.3.3-.5.6-.8.8-.4.2-1.2.2-1.4.2H1.9c-.5-.1-.9-.2-1.2-.5-.2-.1-.4-.4-.4-.5 0-.1 0 0 .1 0h1.5z",
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#1a87b9"
}))), React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 21.447,
  y1: 14.481,
  x2: 24.689,
  y2: 32.865
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#2e1b38"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#004b98",
  stopOpacity: 0
})), React.createElement("path", {
  opacity: 0.33,
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#SVGID_1_)",
  d: "M36.4 30.8H10.7L9.1 20.2l15.6-6.3L37 25.3z"
}), React.createElement("g", {
  id: "Rectangle-Copy-4"
}, React.createElement("g", {
  transform: "rotate(-90 16.5 27.5)"
}, React.createElement("path", {
  id: "path-3",
  transform: "rotate(-90 16.5 27.045)",
  className: "st3",
  d: "M15.5 25h2v4h-2z"
})), React.createElement("path", {
  transform: "rotate(180 16.273 27.273)",
  fill: "#fff",
  className: "st4",
  d: "M15.5 25h2v4h-2z"
})), React.createElement("g", {
  id: "Rectangle-Copy-15"
}, React.createElement("g", {
  transform: "rotate(-90 21.5 28.5)"
}, React.createElement("path", {
  id: "path-5",
  transform: "rotate(-90 21.5 28.045)",
  className: "st3",
  d: "M20.5 27h2v2h-2z"
})), React.createElement("path", {
  transform: "rotate(180 21.273 28.273)",
  fill: "#fff",
  className: "st4",
  d: "M20.5 27h2v2h-2z"
})), React.createElement("g", {
  id: "Rectangle-Copy-16"
}, React.createElement("g", {
  transform: "rotate(-90 26.5 26.5)"
}, React.createElement("path", {
  id: "path-7",
  transform: "rotate(-90 26.5 26.045)",
  className: "st3",
  d: "M25.5 23h2v6h-2z"
})), React.createElement("path", {
  transform: "rotate(180 26.273 26.273)",
  fill: "#fff",
  className: "st4",
  d: "M25.5 23h2v6h-2z"
})), React.createElement("g", {
  id: "Rectangle-Copy-17"
}, React.createElement("g", {
  transform: "rotate(-90 31.5 26)"
}, React.createElement("path", {
  id: "path-9",
  transform: "rotate(-90 31.5 25.545)",
  className: "st3",
  d: "M30.5 22h2v7h-2z"
})), React.createElement("path", {
  transform: "rotate(180 31.273 25.773)",
  fill: "#fff",
  className: "st4",
  d: "M30.5 22h2v7h-2z"
})), React.createElement("path", {
  id: "Combined-Shape",
  fill: "#fff",
  className: "st4",
  d: "M16.6 3v1.9c.7.2 1.5.5 2.1.9L20 4.5l3 3-1.3 1.3c.4.7.7 1.4.9 2.1h1.9V15h-1.9c-.2.7-.5 1.5-.9 2.1l1.3 1.3-3 3-1.3-1.3c-.7.4-1.4.7-2.1.9v2h-4.1v-1.9c-.7-.2-1.5-.5-2.1-.9L9 21.5l-3-3 1.3-1.3c-.4-.7-.7-1.4-.9-2.1H4.5V11h1.9c.3-.8.6-1.6 1-2.2L6 7.4l3-3 1.3 1.3c.7-.4 1.4-.7 2.1-.9V3h4.2zm-2.1 5.7c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3z"
})))));

var SvgComponent$3 = function SvgComponent(props) {
  return React.createElement("svg", _extends$3({
    version: 1.1,
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 37.1 32",
    xmlSpace: "preserve"
  }, props), _ref$3);
};

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

var _ref$4 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M9.9 22.2h4.9c.4 0 .8.3 1 .7l3.4 11c.2.5-.1 1.1-.7 1.2h-5.2c-.4 0-.8-.3-1-.7l-3.4-11c-.2-.5.1-1.1.7-1.2h.3z"
}));

var _ref2$3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
}));

var _ref3$3 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#b)",
  fill: "#FFF",
  d: "M9.9 22.2h4.9c.4 0 .8.3 1 .7l3.4 11c.2.5-.1 1.1-.7 1.2h-5.2c-.4 0-.8-.3-1-.7l-3.4-11c-.2-.5.1-1.1.7-1.2h.3z"
});

var _ref4$3 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  fill: "#009537",
  d: "M20.5 22.2V7.1c0-.6.3-1.2.7-1.6L27 .9c1.7-1.4 4.2-1.1 5.6.6.6.7.9 1.6.9 2.5v21.3c0 2.2-1.8 4-4 4-.9 0-1.8-.3-2.5-.9l-5.8-4.6c-.4-.4-.7-.9-.7-1.6z"
}), React.createElement("defs", null, React.createElement("path", {
  id: "c",
  d: "M20.5 22.2V7.1c0-.6.3-1.2.7-1.6L27 .9c1.7-1.4 4.2-1.1 5.6.6.6.7.9 1.6.9 2.5v21.3c0 2.2-1.8 4-4 4-.9 0-1.8-.3-2.5-.9l-5.8-4.6c-.4-.4-.7-.9-.7-1.6z"
})), React.createElement("clipPath", {
  id: "d"
}, React.createElement("use", {
  xlinkHref: "#c",
  overflow: "visible"
})), React.createElement("linearGradient", {
  id: "e",
  gradientUnits: "userSpaceOnUse",
  x1: 35.221,
  y1: 18.584,
  x2: 19.995,
  y2: 19.116,
  gradientTransform: "matrix(1 0 0 -1 0 38)"
}, React.createElement("stop", {
  offset: 0,
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00245f"
})), React.createElement("path", {
  opacity: 0.5,
  clipPath: "url(#d)",
  fill: "url(#e)",
  d: "M34.8 32.2l-14.4-6.8V6.1z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#009537",
  d: "M9.9 22.2h4.9c.4 0 .8.3 1 .7l3.4 11c.2.5-.1 1.1-.7 1.2h-5.2c-.4 0-.8-.3-1-.7l-3.4-11c-.2-.5.1-1.1.7-1.2h.3z"
}), React.createElement("defs", null, React.createElement("path", {
  id: "f",
  d: "M9.9 22.2h4.9c.4 0 .8.3 1 .7l3.4 11c.2.5-.1 1.1-.7 1.2h-5.2c-.4 0-.8-.3-1-.7l-3.4-11c-.2-.5.1-1.1.7-1.2h.3z"
})), React.createElement("clipPath", {
  id: "g"
}, React.createElement("use", {
  xlinkHref: "#f",
  overflow: "visible"
})), React.createElement("linearGradient", {
  id: "h",
  gradientUnits: "userSpaceOnUse",
  x1: -1076.352,
  y1: 228.785,
  x2: -1076.352,
  y2: 229.785,
  gradientTransform: "matrix(-13.6412 3.1493 -4.9721 -21.5363 -13530.038 8349.464)"
}, React.createElement("stop", {
  offset: 0,
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00245f"
})), React.createElement("path", {
  clipPath: "url(#g)",
  fill: "url(#h)",
  d: "M21.3 28L5.5 12.1l.9 13.7.6 2.5 6.1 4.7 4.8-4.2 3.4-.6z"
})), React.createElement("g", null, React.createElement("g", {
  transform: "translate(0 7)"
}, React.createElement("path", {
  fill: "#007561",
  d: "M4-.8h17v17H4c-2.2 0-4-1.8-4-4v-9c0-2.3 1.8-4 4-4z"
}), React.createElement("linearGradient", {
  id: "i",
  gradientUnits: "userSpaceOnUse",
  x1: -932.69,
  y1: 283.898,
  x2: -931.692,
  y2: 283.898,
  gradientTransform: "rotate(45 -2645.906 20171.011) scale(16.1123 14.2072)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#3b1212"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#4c4c4c",
  stopOpacity: 0
})), React.createElement("path", {
  opacity: 0.483,
  fill: "url(#i)",
  d: "M15.9.8l9.6 10.9-10 8.6c-2.2-2-3.8-3.6-4.9-5-.6-.9-1.4-3.3-2.1-4.7-.3-.6-.8-1.2-1.3-1.8 0-1.2.4-2.1 1.3-2.7 1-.7 3.1-1.7 3.7-2.3 1.4-1.5 2.7-2.5 3.7-3z"
})), React.createElement("path", {
  fill: "#0A4A52",
  d: "M19 6.2h2v17h-2z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#FFF",
  d: "M15.964 7.796L1.468 13.099l5.728 2.616 6.576-5.727-5.798 6.505 2.616 5.728z"
}))));

var SvgComponent$4 = function SvgComponent(props) {
  return React.createElement("svg", _extends$4({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.6 35.2"
  }, props), _ref$4, _ref2$3, _ref3$3, _ref4$3);
};

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

var _ref$5 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M9.9.024C4.584.352.264 4.656.014 9.902c-.166 3.238 1.122 6.148 3.323 8.156 1.163 1.107 1.87 2.583 1.87 4.181v1.517h10.8v-1.517c0-1.557.623-3.033 1.786-4.099a10.299 10.299 0 003.406-7.705C21.157 4.45 16.049-.385 9.9.025z",
  id: "a"
}), React.createElement("path", {
  id: "d",
  d: "M0 0h9.36v2.88H0z"
}), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "b"
}, React.createElement("stop", {
  stopOpacity: 0.278,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#919191",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref2$4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.908 15.165h1.661c1.006 0 1.831.814 1.831 1.82 0 1.006-.825 1.82-1.83 1.82h-1.662a1.828 1.828 0 01-1.831-1.82c0-1.006.824-1.82 1.83-1.82zm0 2c.092 0 .169-.076.169-.18 0-.105-.077-.18-.17-.18h1.662c-.092 0-.169.075-.169.18 0 .104.077.18.17.18h-1.662zM1.83 15.165h1.662c1.007 0 1.831.814 1.831 1.82 0 1.006-.824 1.82-1.83 1.82H1.83A1.828 1.828 0 010 16.985c0-1.006.825-1.82 1.83-1.82zm0 2c.093 0 .17-.076.17-.18 0-.105-.077-.18-.17-.18h1.662c-.092 0-.169.075-.169.18 0 .104.077.18.17.18H1.83zM17.2 0c1.006 0 1.83.814 1.83 1.82v1.64c0 1.005-.824 1.819-1.83 1.819a1.828 1.828 0 01-1.83-1.82V1.82C15.37.815 16.193 0 17.2 0zm0 2c.092 0 .17-.076.17-.18v1.64c0-.105-.078-.181-.17-.181-.092 0-.17.076-.17.18V1.82c0 .105.078.181.17.181zM4.825 4.52a1.808 1.808 0 012.444.113l1.536 1.516c.73.72.73 1.852 0 2.572a1.825 1.825 0 01-1.283.534c-.478 0-.936-.19-1.284-.534L4.7 7.204a1.782 1.782 0 01-.115-2.448l.115-.123.124-.112zm1.311 1.49c.031-.073.021-.179-.03-.23l1.536 1.517a.179.179 0 00-.12-.042.179.179 0 00-.121.042c-.065.064-.065.212 0 .276L5.864 6.056c.045.045.136.055.2.027l.041-.027.031-.047zM25.718 25.137a1.808 1.808 0 012.444.112l1.537 1.517c.73.72.73 1.851 0 2.57a1.825 1.825 0 01-1.284.535c-.477 0-.935-.19-1.284-.534l-1.536-1.517a1.782 1.782 0 01-.115-2.447l.115-.124.123-.112zm1.312 1.489c.031-.073.02-.178-.03-.23l1.536 1.517a.179.179 0 00-.12-.042.179.179 0 00-.121.042c-.065.064-.065.213 0 .276l-1.537-1.516c.045.045.136.054.2.027l.041-.027.031-.047zM27.131 4.633a1.81 1.81 0 012.568 0c.73.72.73 1.852 0 2.571l-1.537 1.517a1.825 1.825 0 01-1.284.534c-.477 0-.935-.19-1.283-.534a1.782 1.782 0 01-.115-2.448l.115-.124 1.536-1.516zm-.1 2.893c.03-.073.02-.178-.032-.23a.179.179 0 00-.12-.041.179.179 0 00-.121.042l1.537-1.517c-.065.064-.065.213 0 .276.057.057.184.057.241 0L27 7.573l.031-.047zM6.192 25.297c.681-.768 1.884-.768 2.613-.048.73.72.73 1.852 0 2.571L7.27 29.337a1.825 1.825 0 01-1.284.534c-.478 0-.936-.19-1.284-.534a1.782 1.782 0 01-.115-2.448l.115-.123 1.49-1.469z",
  fill: "#FDC808",
  fillRule: "nonzero"
});

var _ref3$4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.66 6.064c-5.316.328-9.636 4.632-9.886 9.878-.166 3.238 1.122 6.148 3.323 8.156 1.163 1.107 1.87 2.583 1.87 4.181v1.517h10.8v-1.517c0-1.557.623-3.033 1.786-4.099a10.299 10.299 0 003.406-7.705c-.042-5.984-5.15-10.82-11.299-10.41z",
  fill: "#FFC800",
  fillRule: "nonzero"
});

var _ref4$4 = /*#__PURE__*/React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
}));

var _ref5$3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.487 10.153l4.403 5.241c.159.19.144.48-.034.65l-.734.701a.413.413 0 01-.609-.035l-.02-.025-.072.069-1.449-.267-3.41 4.782-6.287 2.456-.464-.536 6.671-6.2a.896.896 0 001.1-.102.981.981 0 00.071-1.35.898.898 0 00-1.3-.074.982.982 0 00-.218 1.123l-6.671 6.2-.464-.537 3.043-6.215 4.955-2.992-.097-1.523.15-.14a.482.482 0 01.093-.56l.734-.702a.413.413 0 01.609.036z",
  fill: "#FFF",
  fillRule: "nonzero"
});

var _ref6$3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#626262",
  strokeWidth: 2,
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.8 30.556h10.8v2.824H11.8z"
});

var _ref7$3 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M12.298 33.456h9.36v2.88h-9.36z",
  fill: "#626262",
  fillRule: "nonzero"
}), React.createElement("g", {
  transform: "translate(12.298 33.456)"
}, React.createElement("mask", {
  id: "e",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#d"
})), React.createElement("path", {
  fill: "#4E514E",
  fillRule: "nonzero",
  mask: "url(#e)",
  d: "M-.498 2.104h10.08v1.44H-.498z"
})));

var SvgComponent$5 = function SvgComponent(props) {
  return React.createElement("svg", _extends$5({
    width: 35,
    height: 37,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref$5, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2$4, _ref3$4, React.createElement("g", {
    transform: "translate(6.76 6.04)"
  }, _ref4$4, React.createElement("path", {
    d: "M16.915 29.44l2.578-.48 3.279-7.018 1.988-2.996c-3.99-5.108-6.496-8.048-7.52-8.82-3.7-2.794-5.117 3.176-6.64 3.54-1.016.242-3.199 1.403-6.549 3.483l12.864 12.29z",
    fill: "url(#b)",
    fillRule: "nonzero",
    opacity: 0.797,
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#c)"
  })), _ref5$3, _ref6$3, _ref7$3));
};

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

var _ref$6 = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "56.929%",
  y1: "53.176%",
  x2: "13.612%",
  y2: "32.591%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#4C4C4C",
  stopOpacity: 0,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#3F1F1F",
  stopOpacity: 0.773,
  offset: "100%"
}), React.createElement("stop", {
  stopColor: "#3B1212",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "22.389%",
  y1: "25.13%",
  x2: "55.439%",
  y2: "75.25%",
  id: "d"
}, React.createElement("stop", {
  stopColor: "#3B1212",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#4C4C4C",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "14.859%",
  y1: "25.1%",
  x2: "61.123%",
  y2: "86.489%",
  id: "e"
}, React.createElement("stop", {
  stopColor: "#3B1212",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#4C4C4C",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "1.39%",
  y1: "32.304%",
  x2: "82.072%",
  y2: "99.923%",
  id: "f"
}, React.createElement("stop", {
  stopColor: "#3B1212",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#4C4C4C",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("circle", {
  id: "b",
  cx: 16,
  cy: 16,
  r: 14
}));

var _ref2$5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M27.667 19.673l9.576 4.88c1.008.513 1.472 1.94.99 3.043l-1.028 2.016c-.514 1.008-1.94 1.471-3.043.989l-6.049-3.082-3.78-1.926 3.334-5.92z",
  fill: "#C1C1C1"
}), React.createElement("path", {
  d: "M13.6 5.9l-3 5.6-10-5.1L4.8.8z",
  transform: "translate(23.787 19.146)",
  fill: "url(#a)",
  opacity: 0.607
})), React.createElement("path", {
  d: "M16 2c7.7 0 14 6.3 14 14s-6.3 14-14 14S2 23.7 2 16 8.3 2 16 2zm0 4C10.5 6 6 10.5 6 16s4.5 10 10 10 10-4.5 10-10S21.5 6 16 6z",
  fill: "#A0A0A0",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16S0 24.8 0 16 7.2 0 16 0zm0 4C9.4 4 4 9.4 4 16s5.4 12 12 12 12-5.4 12-12S22.6 4 16 4z",
  fill: "#C1C1C1",
  fillRule: "nonzero"
}), React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#b"
})), React.createElement("g", {
  mask: "url(#c)"
}, React.createElement("path", {
  fill: "url(#d)",
  fillRule: "nonzero",
  opacity: 0.483,
  d: "M19.2.2L26.1 7l-6.9 7-2.2-2.8z",
  transform: "translate(6 12)"
}), React.createElement("path", {
  fill: "url(#e)",
  fillRule: "nonzero",
  opacity: 0.483,
  d: "M11.2 6.2l8.2 8.8-8.2 5L9 16.7z",
  transform: "translate(6 12)"
}), React.createElement("path", {
  fill: "url(#f)",
  fillRule: "nonzero",
  opacity: 0.483,
  d: "M3.2 11.2l8.2 8.8-6.3-1-4.2-1.5z",
  transform: "translate(6 12)"
}), React.createElement("g", {
  fill: "#E90000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M8.6 22.9c.9 0 1.7.8 1.7 1.7v4.7c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-4.7c0-1 .7-1.7 1.7-1.7zM16.7 17.7c.9 0 1.7.8 1.7 1.7v9.9c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-9.9c0-.9.8-1.7 1.7-1.7zM24.4 12.1c.9 0 1.7.8 1.7 1.7v15.4c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7V13.9c0-1 .8-1.8 1.7-1.8z"
}))), React.createElement("circle", {
  stroke: "#E90000",
  fill: "#FFF",
  fillRule: "nonzero",
  mask: "url(#c)",
  cx: 8.6,
  cy: 20.3,
  r: 2.6
}), React.createElement("circle", {
  stroke: "#E90000",
  fill: "#FFF",
  fillRule: "nonzero",
  mask: "url(#c)",
  cx: 16.7,
  cy: 15.1,
  r: 2.6
}), React.createElement("circle", {
  stroke: "#E90000",
  fill: "#FFF",
  fillRule: "nonzero",
  mask: "url(#c)",
  cx: 24.4,
  cy: 9.6,
  r: 2.6
}), React.createElement("path", {
  stroke: "#E90000",
  strokeLinecap: "square",
  mask: "url(#c)",
  d: "M11.4 19.2l3-2.6M19.3 13.4l2.8-2.3"
}));

var SvgComponent$6 = function SvgComponent(props) {
  return React.createElement("svg", _extends$6({
    width: 39,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref$6, _ref2$5);
};

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

var _ref$7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M127.3 8.2H24.2c-.6 0-1 .2-1.5.6-.4.4-.6.9-.6 1.5v53.6c0 .6.2 1 .6 1.5.4.4.9.6 1.5.6h103.1c.6 0 1-.2 1.4-.6.4-.4.6-.9.6-1.5V10.3c0-.6-.2-1-.6-1.5-.4-.3-.8-.6-1.4-.6z"
});

var _ref2$6 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5DCED",
  d: "M134.6 3c-2-2-4.4-3-7.3-3H24.2c-2.8 0-5.3 1-7.3 3s-3 4.4-3 7.3v70.1c0 2.8 1 5.3 3 7.3s4.4 3 7.3 3h103c2.8 0 5.3-1 7.3-3s3-4.4 3-7.3V10.3c.1-2.8-.9-5.3-2.9-7.3zm-5.2 60.9c0 .6-.2 1-.6 1.5-.4.4-.9.6-1.4.6H24.2c-.6 0-1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5V10.3c0-.6.2-1 .6-1.5.4-.4.9-.6 1.5-.6h103.1c.6 0 1 .2 1.4.6.4.4.6.9.6 1.5v53.6z"
});

var _ref3$5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CFE2",
  d: "M56.2 100.3c-.7 1.3-1 2.2-1 2.8 0 1.1.4 2.1 1.2 2.9.8.8 1.8 1.2 2.9 1.2h33c1.1 0 2.1-.4 2.9-1.2.8-.8 1.2-1.8 1.2-2.9 0-.6-.3-1.5-1-2.8-.7-1.3-1.4-2.8-2.1-4.6-.7-1.7-1-3.4-1-5h-33c0 1.6-.3 3.3-1 5-.8 1.8-1.5 3.3-2.1 4.6z"
});

var _ref4$5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5859",
  d: "M26.4 12.1h44.8v33.2H26.4z"
});

var _ref5$4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M57.9 23.1c-5 0-9.1 4.1-9.1 9.1s4.1 9.1 9.1 9.1 9.1-4.1 9.1-9.1-4.1-9.1-9.1-9.1zm-1.7 13.7l-4-4 1.3-1.3 2.7 2.7 6-6 1.3 1.3-7.3 7.3z"
});

var _ref6$4 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  fill: "#FFF",
  d: "M105.6 28.9h53.5v74h-53.5z"
}), React.createElement("path", {
  fill: "#C7CFE2",
  d: "M160.5 103.9c1.3-1.3 2-2.9 2-4.7V32.6c0-1.8-.7-3.4-2-4.7-1.3-1.3-2.9-2-4.7-2h-45.3c-1.8 0-3.4.7-4.7 2-1.3 1.3-2 2.9-2 4.7v66.7c0 1.8.7 3.4 2 4.7 1.3 1.3 2.9 2 4.7 2h45.3c1.9-.1 3.4-.8 4.7-2.1zm-48.6-10.4c-.4 0-.7-.1-.9-.4-.3-.3-.4-.6-.4-.9V32.6c0-.4.1-.7.4-.9.3-.3.6-.4.9-.4H155c.4 0 .7.1.9.4.3.3.4.6.4.9v59.6c0 .4-.1.7-.4.9-.3.3-.6.4-.9.4h-43.1zm22.4 8.5c-1.4 0-2.6-1.1-2.6-2.6 0-1.4 1.1-2.6 2.6-2.6 1.4 0 2.6 1.1 2.6 2.6-.1 1.4-1.2 2.6-2.6 2.6z"
}), React.createElement("path", {
  fill: "#FF5859",
  d: "M113.1 33.8h40.5V67h-40.5z"
}), React.createElement("path", {
  fill: "#3FD4AD",
  d: "M141.4 44.3c-5 0-9.1 4.1-9.1 9.1s4.1 9.1 9.1 9.1 9.1-4.1 9.1-9.1-4.1-9.1-9.1-9.1zM139.8 58l-4-4 1.3-1.3 2.7 2.7 6-6 1.3 1.3-7.3 7.3z"
}));

var _ref7$4 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  fill: "#FFF",
  d: "M1 46.3h33v52.6H1z"
}), React.createElement("path", {
  fill: "#C7CFE2",
  d: "M34.4 101.9c1.3-1.3 2-2.9 2-4.7V49c0-1.8-.7-3.4-2-4.7-1.3-1.3-2.9-2-4.7-2h-23c-1.8 0-3.4.7-4.7 2-1.3 1.3-2 2.9-2 4.7v-2.1V97.3c0 1.8.7 3.4 2 4.7 1.3 1.3 2.9 2 4.7 2h23c1.8-.1 3.4-.8 4.7-2.1zM4 92.8c-.4 0-.7-.1-.9-.4-.3-.3-.4-.6-.4-.9V49c0-.4.1-.7.4-.9.3-.3.6-.4.9-.4h28.3c.4 0 .7.1.9.4.3.3.4.6.4.9v42.5c0 .4-.1.7-.4.9-.3.3-.6.4-.9.4H4zm14.7 7.8c-1.4 0-2.6-1.1-2.6-2.6s1.1-2.6 2.6-2.6c1.4 0 2.6 1.1 2.6 2.6s-1.2 2.6-2.6 2.6z"
}));

var _ref8$2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5859",
  d: "M3.8 49.4h28.9v23.7H3.8z"
});

var _ref9$2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M24 56.9c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm-1.2 9.8L20 63.8l.9-.9 1.9 1.9 4.3-4.3.9.9-5.2 5.3z"
});

var SvgComponent$7 = function SvgComponent(props) {
  return React.createElement("svg", _extends$7({
    viewBox: "0 0 162.5 107.2"
  }, props), _ref$7, _ref2$6, _ref3$5, _ref4$5, _ref5$4, _ref6$4, _ref7$4, _ref8$2, _ref9$2);
};

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

var _ref$8 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M114.1 1.5h-7.4c-39.9 0-49.6 44.3-77.5 44.3h-7.4v-6.5c0-4-2.7-5.6-5.9-3.6l-13.8 14c-.6.6-1 1.1-1.3 1.6-1.4 2-.9 3.5 1.4 5.7L16 71c3.3 2 5.9.4 5.9-3.6V60.6h7.4c35.7-.1 46.2-44.3 77.4-44.3h7.4c2 0 3.7-1.7 3.7-3.7V5.2c0-2-1.7-3.7-3.7-3.7z",
  fill: "#FFA300"
}), React.createElement("g", {
  fill: "#3FD4AD"
}, React.createElement("path", {
  d: "M127.5 49.1c-.3-.3-.6-.7-1-1.1l-13.8-14c-3.3-2-5.9-.4-5.9 3.6v6.6h-7.4c-9.4 0-16.7-5-23.8-11.6-2.1 2-4.1 4.1-6.3 6.3l-1.4 1.4-2.7 2.7c9.2 8.7 19.6 15.9 34.1 16h7.4v6.6c0 4 2.7 5.6 5.9 3.6l13.8-14c2.6-2.4 2.9-3.9 1.1-6.1zM22 0h-7.4c-2 0-3.7 1.7-3.7 3.7v7.4c0 2 1.7 3.7 3.7 3.7H22c12.4 0 21.5 6.9 30.2 15.3 1.5-1.4 3-2.9 4.4-4.4 2-2 4-4.1 6.1-6-.9-.9-1.8-1.7-2.7-2.6C50.3 7.9 38.8 0 22 0z"
})));

var SvgComponent$8 = function SvgComponent(props) {
  return React.createElement("svg", _extends$8({
    viewBox: "0 0 129 72"
  }, props), _ref$8);
};

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

var _ref$9 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  fill: "#7046C9",
  d: "M.1 30V2c0-1.1.9-2 2-2h22.7l12.3 13v17c0 1.1-.9 2-2 2h-33c-1.1 0-2-.9-2-2z"
}), React.createElement("path", {
  opacity: 0.5,
  fill: "#411D8D",
  d: "M2 31h34.9c-.3.3-.5.6-.8.8-.4.2-1.2.2-1.4.2H2c-.5-.1-.9-.2-1.2-.5-.2-.1-.4-.4-.4-.5s0 0 .1 0H2z"
}), React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: -931.258,
  y1: 360.136,
  x2: -931.258,
  y2: 361.153,
  gradientTransform: "matrix(12 0 0 13 11206 -4672)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#140633"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#004b98",
  stopOpacity: 0
})), React.createElement("path", {
  opacity: 0.5,
  fill: "url(#a)",
  d: "M24.7 9.8l12.4 3V23z"
}), React.createElement("path", {
  d: "M24.9 0l12.3 13h-8.6c-2.1 0-3.9-1.8-3.9-4v-.1l.2-8.9z"
}), React.createElement("path", {
  fill: "#967BD0",
  d: "M24.9 0l12.3 13h-8.6c-2.1 0-3.9-1.8-3.9-4v-.1l.2-8.9z"
}), React.createElement("g", {
  fill: "#FFF"
}, React.createElement("path", {
  d: "M2.7 3h6v2h-6zM9.7 3h6v2h-6zM2.7 6h6v2h-6zM9.7 6h6v2h-6zM2.7 9h6v2h-6zM9.7 9h6v2h-6z"
})), React.createElement("linearGradient", {
  id: "b",
  gradientUnits: "userSpaceOnUse",
  x1: 22.386,
  y1: 15.57,
  x2: 24.958,
  y2: 0.981,
  gradientTransform: "matrix(1 0 0 -1 0 34)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#2e1b38"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#004b98",
  stopOpacity: 0
})), React.createElement("path", {
  opacity: 0.33,
  fill: "url(#b)",
  d: "M36.6 31H11.5l-1.6-8.2 15.3-4.9 11.9 8.8z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M26.4 19l-7.2-5.8c-.2-.1-.4-.2-.6-.1-.2.1-.3.3-.3.5v3c-6 1.3-9.6 5-9.6 9.8 0 .3.2.5.5.6s.6-.1.7-.4c1-3 5-4.1 8.4-4.3v2.9c0 .2.1.4.3.5s.5.1.6-.1l7.2-5.8c.1-.1.2-.3.2-.4.1-.2 0-.3-.2-.4z"
}));

var SvgComponent$9 = function SvgComponent(props) {
  return React.createElement("svg", _extends$9({
    viewBox: "0 0 37.1 32"
  }, props), _ref$9);
};

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

var _ref$a = /*#__PURE__*/React.createElement("g", {
  fill: "#3FD4AD"
}, React.createElement("path", {
  d: "M84 77.4V100c0 2-.4 3-2.5 2-1-.5-1.8.1-2.6.5-8.9 5-17.9 4.8-26.9.5-2-.9-3.7-1.7-5.9-1-2.3.7-3.4 0-3.3-2.8.2-6.3.1-12.6.1-18.9 0-4.5-1.9-6.4-6.5-6.4-1 0-1.9-.1-2.9 0-1.7.2-2.7-.3-3.6-2-1.8-3.5-5.6-5-9.2-4-3.5 1-6 4.2-5.9 7.9 0 3.7 2.5 6.8 6.1 7.7 3.6.9 7.1-.6 9.1-3.9 1.1-1.9 6.9-3 8.5-1.6.8.6.7 1.5.7 2.4 0 6.3-.1 12.6 0 18.9 0 2.1-.8 2.2-2.4 1.5-2.5-.9-4.8-2.1-6.8-3.8-.9-.7-1.6-1-2.8-.7-8.7 2.6-16.2.5-21.9-6.5-6-7.4-6.9-15.8-2.8-24.5 2.8-6 7.5-10.4 13.7-12.9 1.8-.7 2.6-1.8 3.4-3.5 3.7-8.4 10.1-13.2 19.2-14.5 2.4-.3 3.4.2 3.4 3-.3 7.6-.2 15-.2 22.5 0 4.8 1.8 6.5 6.6 6.6h8.9c2 0 3 .8 2.9 2.9-.1 1-.1 1.9 0 2.9.2 2.1-.2 3.4-2.4 4.4-3.4 1.6-4.8 5.5-3.9 9 .9 3.4 4 5.8 7.6 6 3.6.2 6.8-1.9 8-5.3 1.2-3.5.1-7.5-3.1-9.3-2.2-1.2-2.7-2.6-2.5-4.8.1-1.2.1-2.5 0-3.7-.2-3.6-2.3-5.9-6-6-3.1-.1-6.1-.1-9.2 0-2.3.1-3.3-.7-3.3-3.1.1-8.1.1-16.2 0-24.4 0-1.5.6-2.3 1.8-2.9 5.9-3.2 12.1-4.8 18.7-2.2 1.1.4 2 .3 3-.1 7.4-2.7 14.3-1.4 20.8 2.6 1.1.6 2 1.4 3.3 1.4 11.4.4 18.1 7 22.3 16.9.8 1.9 1.8 3.1 3.6 4.1 7.9 5 13.6 11.6 12.4 21.5-1.8 14.6-14.3 22.2-24.6 18.5-1.4-.5-2.1.5-2.9 1.3-3.8 3.8-8.3 6-13.6 6.8-1.8.3-2.8 0-2.8-2.2.2-5.3.1-10.5 0-15.8 0-1.8.5-2.4 2.3-2.3 3.8.1 7.6.1 11.5 0 3.7-.1 5.6-1.7 6.2-5.4.2-1.2.7-1.8 1.7-2.3 3.8-2.1 5.3-5.5 4.3-9.3-.9-3.5-4.2-6-7.8-6.1-3.6 0-6.9 2.4-7.8 6-1 3.8.5 7.3 4.2 9.4.9.5 2 .8 1.7 2.2-.4 1.4-1.5 1.6-2.7 1.6-3.7 0-7.5-.1-11.2 0-1.9.1-2.4-.6-2.4-2.5.1-7.3 0-14.5 0-21.8 0-5.7-1.6-7.2-7.4-7.3-.7 0-1.3-.1-2 0-2.3.2-4-.2-5.2-2.7-1.6-3.2-5.6-4.3-9-3.2-3.5 1.1-5.8 4.4-5.7 8.1.1 3.5 2.6 6.6 6 7.5 3.6 1 7.2-.5 9.1-3.7.6-.9.6-2.4 2.2-2.3 2.5.2 5.2-.7 7.6.6 1 .6.7 1.9.7 2.9.1 7.7.1 15.4.1 23z"
}), React.createElement("path", {
  d: "M66.6 53.6c-2.6.1-4.8-2-4.8-4.6 0-2.5 2-4.7 4.6-4.8 2.6-.1 4.8 1.9 4.8 4.6-.1 2.6-2.1 4.7-4.6 4.8zM110.6 67.8c0 2.5-2.3 4.7-4.8 4.7-2.5-.1-4.6-2.1-4.6-4.6-.1-2.6 2.1-4.8 4.7-4.8 2.5 0 4.7 2.2 4.7 4.7zM22.8 70.7c2.6 0 4.8 2.2 4.7 4.7 0 2.5-2.1 4.5-4.6 4.6-2.6.1-4.8-2-4.9-4.6 0-2.5 2.2-4.7 4.8-4.7zM66.7 83.3c0 2.6-2.1 4.7-4.7 4.7s-4.7-2.2-4.7-4.7c0-2.6 2.1-4.6 4.8-4.7 2.6 0 4.6 2 4.6 4.7z"
}));

var _ref2$7 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5DCED",
  d: "M128 71H77.8V0H128v71z"
});

var _ref3$6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5859",
  d: "M89.3 10.3h18.9V15H89.3zM89.3 19.8h22.9v4.7H89.3zM89.3 38.8h22.9v4.7H89.3zM89.3 29.2h18.9v4.7H89.3z"
});

var _ref4$6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M115.2 47c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm-1.8 15.1l-4.4-4.4 1.5-1.5 2.9 2.9 6.6-6.6 1.5 1.5-8.1 8.1z"
});

var SvgComponent$a = function SvgComponent(props) {
  return React.createElement("svg", _extends$a({
    viewBox: "0 0 131.7 106.2"
  }, props), _ref$a, _ref2$7, _ref3$6, _ref4$6);
};

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

var _ref$b = /*#__PURE__*/React.createElement("path", {
  fill: "#826C6C",
  d: "M21.8 12.1h7.8v18.8h-7.8z"
});

var _ref2$8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M20.1 0h11.3v13.4H20.1z"
});

var _ref3$7 = /*#__PURE__*/React.createElement("path", {
  fill: "#826C6C",
  d: "M40.9 12.1h7.8v18.8h-7.8z"
});

var _ref4$7 = /*#__PURE__*/React.createElement("path", {
  fill: "#694B4B",
  d: "M60.1 12.1h7.8v18.8h-7.8z"
});

var _ref5$5 = /*#__PURE__*/React.createElement("path", {
  fill: "#39C9A0",
  d: "M58.5 0h11.3v13.4H58.5z"
});

var _ref6$5 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M14.7 44.5h60.4v83H14.7z"
});

var _ref7$5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFA300",
  d: "M29.1 58.4h31.8v25.8H29.1z"
});

var _ref8$3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6243",
  d: "M7.1 27h75.7v25.3H7.1z"
});

var _ref9$3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5DCED",
  d: "M0 27h89.9v7.8H0z"
});

var _ref10$2 = /*#__PURE__*/React.createElement("path", {
  fill: "#39C9A0",
  d: "M44.9 44.5h30.3v83H44.9z"
});

var _ref11$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#694B4B",
  d: "M44.9 12.1h3.9v18.8h-3.9z"
});

var _ref12$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#ED9406",
  d: "M44.9 58.4h16v25.8h-16z"
});

var _ref13$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#E0464E",
  d: "M44.9 27h38v25.3h-38z"
});

var _ref14$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CFE2",
  d: "M44.9 27H90v7.8H44.9z"
});

var _ref15$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FD4AD",
  d: "M39.3 0h11.3v13.4H39.3z"
});

var _ref16$1 = /*#__PURE__*/React.createElement("path", {
  fill: "#39C9A0",
  d: "M44.9 0h5.7v13.4h-5.7z"
});

var SvgComponent$b = function SvgComponent(props) {
  return React.createElement("svg", _extends$b({
    viewBox: "0 0 89.9 127.5"
  }, props), _ref$b, _ref2$8, _ref3$7, _ref4$7, _ref5$5, _ref6$5, _ref7$5, _ref8$3, _ref9$3, _ref10$2, _ref11$1, _ref12$1, _ref13$1, _ref14$1, _ref15$1, _ref16$1);
};

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

var _ref$c = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "49.924%",
  y1: "-.067%",
  x2: "49.924%",
  y2: "99.783%",
  id: "b"
}, React.createElement("stop", {
  stopColor: "#00245F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#004B98",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "21.111%",
  y1: "28.17%",
  x2: "82.007%",
  y2: "84.85%",
  id: "d"
}, React.createElement("stop", {
  stopColor: "#3B1212",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#4C4C4C",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("path", {
  d: "M34 22.2C34 12.8 26.4 5 17 5S0 12.6 0 22c0 0 34 .1 34 .2z",
  id: "a"
}));

var _ref2$9 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(0 7)"
}, React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("use", {
  fill: "#003DD5",
  xlinkHref: "#a"
}), React.createElement("path", {
  d: "M11.3 4.1l5 2.5C17.7 1 19.3-1 21 .5c1.3 1.2 8.5 7.8 13.3 11 .9.6.2 7-2.1 7-1.5 0-3.3.2-5.4.5-7.4.5-11.8.5-13.3 0C6 16.7 4.3 10.6 2.7 9.1c-2-2.1.8-3.8 8.6-5z",
  fill: "url(#b)",
  opacity: 0.556,
  mask: "url(#c)"
}), React.createElement("path", {
  d: "M23.6 7.6l13.2 16.1-14.1 6.7-10.1-11.6c-.6-.1-.3-.6 1-1.5 1.5-1 4.2.9 5 0 .8-.8 3.1-2.8 3.4-3.5.2-.6-.2-2.6.4-5.1.1-.3.5-.7 1.2-1.1z",
  fill: "url(#d)",
  opacity: 0.483,
  mask: "url(#c)"
})), React.createElement("circle", {
  fill: "#003DD5",
  cx: 17,
  cy: 7,
  r: 7
}), React.createElement("path", {
  d: "M18.7 11v1.5c.6.2 1.2.4 1.7.7l1.1-1.1 2.4 2.4-1.1 1.1c.3.5.5 1.1.7 1.7H25v3.3h-1.5c-.2.6-.4 1.2-.7 1.7l1.1 1.1-2.4 2.4-1.1-1.1c-.5.3-1.1.5-1.7.7V27h-3.3v-1.5c-.6-.2-1.2-.4-1.7-.7l-1.1 1.1-2.4-2.4 1.1-1.1c-.3-.5-.5-1.1-.7-1.7H9v-3.3h1.5c.2-.6.4-1.2.7-1.7l-1.1-1.1 2.4-2.4 1.1 1.1c.5-.3 1.1-.5 1.7-.7V11h3.4zM17 15.6c-1.9 0-3.4 1.5-3.4 3.4s1.5 3.4 3.4 3.4 3.4-1.5 3.4-3.4-1.5-3.4-3.4-3.4z",
  fill: "#FFF"
}));

var SvgComponent$c = function SvgComponent(props) {
  return React.createElement("svg", _extends$c({
    width: 34,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref$c, _ref2$9);
};

function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$d.apply(this, arguments);
}

var _ref$d = /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, React.createElement("g", {
  id: "BidModel"
}, React.createElement("g", {
  id: "Rectangle-Copy-3",
  transform: "translate(0 11)"
}, React.createElement("g", {
  id: "Mask"
}, React.createElement("path", {
  id: "path-1",
  d: "M3.5.5l12 6.6c.6.4 1 1 1 1.8v15.3c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.2l-12-6.6c-.6-.4-1-1-1-1.8V2.2c0-1.1.9-2 2-2 .3 0 .7.1 1 .3z",
  fill: "#007aff"
})), React.createElement("g", {
  id: "Clipped"
}, React.createElement("defs", null, React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: -3,
  y: -5,
  width: 23,
  height: 29
}, React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: -3,
  y: -5,
  width: 23,
  height: 29,
  id: "mask-2_1_"
}, React.createElement("g", {
  filter: "url(#Adobe_OpacityMaskFilter)"
}, React.createElement("path", {
  id: "path-1_3_",
  className: "st2",
  d: "M3.5.5l12 6.6c.6.4 1 1 1 1.8v15.3c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.2l-12-6.6c-.6-.4-1-1-1-1.8V2.2c0-1.1.9-2 2-2 .3 0 .7.1 1 .3z"
}))), React.createElement("linearGradient", {
  id: "Path_2_",
  gradientUnits: "userSpaceOnUse",
  x1: -274.033,
  y1: 416.978,
  x2: -273.034,
  y2: 416.978,
  gradientTransform: "matrix(0 29 23 0 -9582 7942)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#001e3f"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#006fee",
  stopOpacity: 0
})), React.createElement("path", {
  id: "Path",
  d: "M20-4.5L17.1 24-3 16.8l1.3-21.1c-.4-.7.4-.9 2.5-.5C3.2-4.3 4 .1 5.7.1c1.6 0 5.7.3 6.6-.1.8-.3 2.3-2.7 5.3-4.6.5-.2 1.2-.2 2.4.1z",
  opacity: 0.483,
  mask: "url(#mask-2_1_)",
  fill: "url(#Path_2_)",
  enableBackground: "new"
}))), React.createElement("path", {
  id: "Rectangle",
  d: "M18.9.4l12.5 5.9c1 .5 1.4 1.7 1 2.7-.2.4-.5.7-.9.9L19 16.5c-.6.3-1.3.3-1.9 0L4.5 9.9c-1-.5-1.3-1.7-.8-2.7.2-.4.5-.7.9-.9L17.1.4c.6-.3 1.2-.3 1.8 0z",
  fill: "#003dd5"
}), React.createElement("g", {
  id: "Rectangle_1_",
  transform: "translate(18 9)"
}, React.createElement("g", {
  id: "Mask_1_",
  transform: "matrix(-1 0 0 1 17.74 2)"
}, React.createElement("path", {
  id: "path-4",
  d: "M3.4.6l12 6.6c.6.4 1 1 1 1.8v15.3c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.2l-12-6.6c-.6-.4-1-1-1-1.8V2.4c0-1.1.9-2 2-2 .3 0 .7.1 1 .2z",
  fill: "#0633a4"
})), React.createElement("g", {
  id: "Clipped_1_"
}, React.createElement("defs", null, React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter_1_",
  filterUnits: "userSpaceOnUse",
  x: 1.3,
  y: 2.5,
  width: 16.2,
  height: 25.4
}, React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 1.3,
  y: 2.5,
  width: 16.2,
  height: 25.4,
  id: "mask-5_1_"
}, React.createElement("g", {
  filter: "url(#Adobe_OpacityMaskFilter_1_)"
}, React.createElement("path", {
  id: "path-4_3_",
  className: "st2",
  d: "M17.7.3l.9 19.9c0 .1-.9 1-.9 1.1-1.1 1.5-13.3 6.8-14.4 6.8-.3 0-1.1.2-1.4 0L1.4 26c-.6-.4 0-5.6 0-6.4L.7 10C.7 8.9 17.4.1 17.7.3z"
}))), React.createElement("linearGradient", {
  id: "Path_3_",
  gradientUnits: "userSpaceOnUse",
  x1: -279.641,
  y1: 404.229,
  x2: -278.642,
  y2: 404.229,
  gradientTransform: "rotate(45 -16118.95 646.55) scale(18.4882 -27.7174)"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#3b1212"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#4c4c4c",
  stopOpacity: 0
})), React.createElement("path", {
  id: "Path_1_",
  d: "M16.9 20.9c-4.5 2.2-8 4.1-10.4 5.7s-4.1 1.7-5.1.3v-14s-.4-2.7 1-3.7C4.1 8.1 9.6 5.4 14 2.9c.1-.1 2.8-1.8 3.4 1.9.3 2 .1 7.4-.5 16.1z",
  opacity: 0.483,
  mask: "url(#mask-5_1_)",
  fill: "url(#Path_3_)",
  enableBackground: "new"
})))));

var SvgComponent$d = function SvgComponent(props) {
  return React.createElement("svg", _extends$d({
    version: 1.1,
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 36 38",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 36 38"
  }, props), _ref$d);
};

function _extends$e() {
  _extends$e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$e.apply(this, arguments);
}

var _ref$e = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#A3A3A3",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#919191",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "c"
}, React.createElement("stop", {
  stopOpacity: 0.341,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#919191",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("path", {
  d: "M14.546 8.642C12.506 4.56 9.076 1.54 4.75.071a1.68 1.68 0 00-2.04.98L0 15.43l13.757 17.7c4.905-.65 2.638 0 2.638-10.131 0-3.5.192-10.276-1.849-14.358z",
  id: "b"
}));

var _ref2$a = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M20.987 17.647l11.793 5.16.302.105c.186.057.366.088.567.088.944 0 1.787-.586 2.15-1.453a15.562 15.562 0 00.365-11.03C33.984 4.058 28.95 0 22.624 0c-.852 0-1.509.076-2.196.245l-.326.087c-.113.032-.23.067-.357.106L19.547.5l-1.034.342c-.61.25-1.066.654-1.302 1.26-.229.585-.291 1.126-.102 1.68l2.473 12.345.049.167c.249.638.718 1.172 1.356 1.353z",
  fill: "#FFC900"
}), React.createElement("path", {
  d: "M2.102 13.642c2.04-4.082 5.47-7.102 9.796-8.571a1.68 1.68 0 012.04.98l2.71 14.38 15.413 5.293c.408.163.735.49.817.898.163.408.163.816 0 1.224-1.878 4.408-5.633 7.837-10.123 9.388-1.796.571-3.592.898-5.47.898-7.265 0-13.714-4.653-16.08-11.51-1.47-4.327-1.144-8.898.897-12.98z",
  fill: "#DFAF28"
}));

var _ref3$8 = /*#__PURE__*/React.createElement("path", {
  d: "M2.102 13.642c2.04-4.082 5.47-7.102 9.796-8.571a1.68 1.68 0 012.04.98l2.71 14.38-.148 17.7C8.97 37.538 3.87 33.7 1.204 26.622c-1.57-4.17-1.143-8.897.898-12.979z",
  fill: "#FFC900",
  fillRule: "nonzero"
});

var _ref4$8 = /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#b"
}));

var _ref5$6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 21.5l-9 6v-12z",
  fill: "#FFF",
  fillRule: "nonzero"
});

var SvgComponent$e = function SvgComponent(props) {
  return React.createElement("svg", _extends$e({
    width: 37,
    height: 39,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref$e, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2$a, React.createElement("path", {
    d: "M14.613 22.979c11.217-.69 16.992-.376 17.325.943.499 1.979-.476 5.43-1.838 7.988-.376.706-4.626 6.873-6.459 5.975-1.73-.848-4.74-5.817-9.028-14.906z",
    fill: "url(#a)",
    fillRule: "nonzero",
    opacity: 0.797,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "scale(-1 1) rotate(80 .5 3.077)"
  }), _ref3$8, React.createElement("g", {
    transform: "translate(.253 5)"
  }, _ref4$8, React.createElement("path", {
    d: "M13.013 33.132L17 34l3.278-7.018 1.989-2.996c-4.484-4.132-7.237-6.583-8.26-7.356-2.467-1.862-5.054.008-8.76 5.87l7.766 10.632z",
    fill: "url(#c)",
    fillRule: "nonzero",
    opacity: 0.797,
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#d)"
  })), _ref5$6));
};

function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}

var _ref$f = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M.27.237h37.954V28.07H.271z"
}), React.createElement("path", {
  id: "c",
  d: "M.039.155h12.65v5.06H.04z"
}), React.createElement("path", {
  id: "e",
  d: "M0 33.2h49.843V.306H0z"
}));

var _ref2$b = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(3.988 .07)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  d: "M35.694 19.845c0 .172-.063.32-.189.445a.61.61 0 01-.444.188H3.434a.612.612 0 01-.446-.188.611.611 0 01-.187-.445V3.4c0-.172.062-.32.187-.446a.612.612 0 01.446-.187h31.627c.172 0 .32.063.444.187a.607.607 0 01.189.446v16.445zm1.6-18.68a3.05 3.05 0 00-2.233-.929H3.434c-.87 0-1.615.311-2.234.93A3.047 3.047 0 00.27 3.4v21.506c0 .87.31 1.615.93 2.233.62.62 1.364.93 2.234.93H35.061c.87 0 1.613-.31 2.233-.93.62-.618.93-1.363.93-2.233V3.4c0-.87-.31-1.615-.93-2.234z",
  fill: "#D5DCED",
  mask: "url(#b)"
})), React.createElement("g", {
  transform: "translate(16.871 27.984)"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#c"
})), React.createElement("path", {
  d: "M.355 3.08c-.211.396-.316.685-.316.87 0 .342.125.64.375.89s.547.375.89.375h10.12c.343 0 .64-.126.89-.376s.376-.547.376-.89c0-.17-.106-.458-.317-.86-.21-.401-.421-.87-.632-1.402a4.173 4.173 0 01-.316-1.532H1.304c0 .5-.106 1.014-.316 1.541A14.13 14.13 0 01.355 3.08",
  fill: "#C7CFE2",
  mask: "url(#d)"
})), React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#e"
})), React.createElement("path", {
  fill: "#FF5859",
  mask: "url(#f)",
  d: "M8.098 14.223h13.745V4.026H8.098z"
}), React.createElement("path", {
  d: "M17.238 11.595l-1.223-1.222.408-.408.815.815 1.834-1.834.407.408-2.241 2.241zm.51-4.203a2.777 2.777 0 100 5.554 2.777 2.777 0 000-5.554z",
  fill: "#3FD4AD",
  mask: "url(#f)"
}), React.createElement("path", {
  fill: "#FFF",
  mask: "url(#f)",
  d: "M32.4 31.87h16.42V9.17H32.4z"
}), React.createElement("path", {
  d: "M41.188 31.583a.787.787 0 110-1.573.787.787 0 010 1.573zm-6.874-2.6a.394.394 0 01-.288-.122.396.396 0 01-.12-.288V10.301c0-.111.04-.208.12-.288a.395.395 0 01.288-.121h13.208c.11 0 .206.04.287.12.08.081.122.178.122.289v18.272c0 .112-.041.207-.122.288a.393.393 0 01-.287.121H34.314zm14.93 3.198c.399-.4.6-.88.6-1.443V10.301c0-.563-.201-1.044-.6-1.445-.402-.4-.883-.6-1.445-.6H33.901c-.562 0-1.043.2-1.443.6-.4.401-.6.882-.6 1.445V30.738c0 .562.2 1.043.6 1.443.4.4.881.601 1.443.601H47.8c.562 0 1.043-.2 1.444-.6z",
  fill: "#C7CFE2",
  mask: "url(#f)"
}), React.createElement("path", {
  fill: "#FF5859",
  mask: "url(#f)",
  d: "M34.705 20.866H47.13V10.669H34.705z"
}), React.createElement("path", {
  d: "M42.877 18.098l-1.222-1.222.407-.408.815.815 1.834-1.834.408.408-2.242 2.241zm.51-4.203a2.777 2.777 0 100 5.554 2.777 2.777 0 000-5.554z",
  fill: "#3FD4AD",
  mask: "url(#f)"
}), React.createElement("path", {
  fill: "#FFF",
  mask: "url(#f)",
  d: "M.299 30.642h10.136v-16.14H.299z"
}), React.createElement("path", {
  d: "M5.721 31.152a.787.787 0 110-1.573.787.787 0 010 1.573zm-4.49-2.367a.393.393 0 01-.287-.122.393.393 0 01-.121-.287V15.333c0-.111.04-.206.121-.288a.393.393 0 01.288-.12H9.92c.111 0 .207.04.288.12.08.082.12.177.12.288v13.043c0 .111-.04.207-.12.287a.394.394 0 01-.288.122h-8.69zm9.318 2.79c.4-.4.6-.88.6-1.443V15.333c0-.562-.2-1.044-.6-1.444-.4-.4-.882-.6-1.444-.6h-7.06c-.563 0-1.044.2-1.444.6-.4.4-.6.882-.6 1.444v-.654 15.453c0 .562.2 1.043.6 1.443.4.401.881.602 1.443.602h7.061c.562 0 1.044-.201 1.444-.602z",
  fill: "#C7CFE2",
  mask: "url(#f)"
}), React.createElement("path", {
  fill: "#FF5859",
  mask: "url(#f)",
  d: "M1.16 22.733h8.875V15.45H1.16z"
}), React.createElement("path", {
  d: "M6.997 20.756l-.874-.873.292-.291.582.582 1.31-1.31.29.29-1.6 1.602zm.364-3.002a1.983 1.983 0 100 3.966 1.983 1.983 0 000-3.966z",
  fill: "#3FD4AD",
  mask: "url(#f)"
}));

var SvgComponent$f = function SvgComponent(props) {
  return React.createElement("svg", _extends$f({
    width: 50,
    height: 34,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref$f, _ref2$b);
};

function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$g.apply(this, arguments);
}

var _ref$g = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "16.726%",
  y1: "10.349%",
  x2: "67.372%",
  y2: "97.189%",
  id: "b"
}, React.createElement("stop", {
  stopColor: "#6F6F6F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#919191",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "20.595%",
  y1: "7.987%",
  x2: "65.352%",
  y2: "100%",
  id: "e"
}, React.createElement("stop", {
  stopColor: "#6F6F6F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#919191",
  stopOpacity: 0,
  offset: "100%"
})), React.createElement("path", {
  d: "M2 0h28a2 2 0 012 2v39.923a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z",
  id: "a"
}), React.createElement("path", {
  id: "d",
  d: "M0 0h5v7H0z"
}));

var _ref2$c = /*#__PURE__*/React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
}));

var _ref3$9 = /*#__PURE__*/React.createElement("use", {
  fill: "#CECECE",
  fillRule: "nonzero",
  xlinkHref: "#a"
});

var _ref4$9 = /*#__PURE__*/React.createElement("path", {
  d: "M2.77 31h41.378c-.318.347-.644.603-.98.768-.503.247-1.39.232-1.698.232H2.77c-.601-.064-1.072-.231-1.412-.5a3.51 3.51 0 01-.49-.496c-.044-.058.002 0 .061 0 .358 0 .972-.001 1.84-.004z",
  fill: "#B2B2B2",
  fillRule: "nonzero",
  opacity: 0.5
});

var _ref5$7 = /*#__PURE__*/React.createElement("path", {
  d: "M20 32h5v7h-5z",
  fill: "#BFBFBF",
  fillRule: "nonzero"
});

var _ref6$6 = /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#d"
}));

var _ref7$6 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B0",
  fillRule: "nonzero",
  d: "M20 32h5v1h-5z"
});

var _ref8$4 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  fillRule: "nonzero",
  d: "M18 41h9v-1h-9z"
});

var _ref9$4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ACACAC",
  fillRule: "nonzero",
  d: "M18 40h9v-1h-9z"
});

var _ref10$3 = /*#__PURE__*/React.createElement("g", null, React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero",
  transform: "translate(4 3)"
}, React.createElement("rect", {
  width: 37,
  height: 6,
  rx: 1
}), React.createElement("rect", {
  y: 19,
  width: 17,
  height: 6,
  rx: 1
}), React.createElement("rect", {
  y: 10,
  width: 9,
  height: 6,
  rx: 1
}), React.createElement("rect", {
  x: 14,
  y: 10,
  width: 9,
  height: 6,
  rx: 1
})), React.createElement("g", {
  strokeLinecap: "square",
  stroke: "#FFF"
}, React.createElement("path", {
  d: "M8.5 13.5l13-5M22.5 9.5v5M9 19v5"
})));

var _ref11$2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.673 11.03a6.084 6.084 0 00-2.805.875c-1.142.778-1.574 1.799-1.591 3.753l-.018 1.695-3.632 3.13c-3.824 3.286-4.533 4.168-4.239 5.31.225.934.813 1.643 1.557 1.971.9.364 1.332.364 2.128-.052.363-.172 2.059-1.971 3.788-3.977l3.132-3.65h1.678c1.92 0 2.992-.45 3.77-1.608.606-.882 1.022-2.56.848-3.303l-.155-.57-1.228 1.175c-.986.934-1.436 1.21-2.197 1.332-.9.138-1.004.104-1.782-.675-.796-.795-.83-.882-.692-1.798.121-.761.398-1.21 1.332-2.197l1.176-1.228-.57-.138c-.263-.05-.098-.026-.5-.044zm-9.844 15a.5.5 0 110 1 .5.5 0 010-1z",
  fill: "#7046C9",
  fillRule: "nonzero"
});

var SvgComponent$g = function SvgComponent(props) {
  return React.createElement("svg", _extends$g({
    width: 45,
    height: 41,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref$g, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "rotate(-90 16.27 15.73)"
  }, _ref2$c, _ref3$9, React.createElement("path", {
    d: "M-1.127 51.462c5.091-2.202 8.693-4.225 10.803-6.07 1.193-1.042 5.27-4.011 6.824-5.601 1.465-1.5-4.416-4.778-3.5-6.91-8.481-7.032-7.303-9.159-7.53-9.336-.014-.01-6.002 4.567-10.057 7.746-1.67 1.31-4.083 1.42-7.413 4.201l10.873 15.97z",
    fill: "url(#b)",
    fillRule: "nonzero",
    opacity: 0.443,
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#c)"
  })), _ref4$9, _ref5$7, React.createElement("g", {
    transform: "translate(20 32)"
  }, _ref6$6, React.createElement("path", {
    d: "M5 10.478c1.786-.84 3.54-2.02 5.265-3.54 1.724-1.519 3.446-4.297 5.165-8.335C10.342-4.987 7.705-6.854 7.52-7 7.501-7.014 4.661-4.806-1-.377l6 10.855z",
    fill: "url(#e)",
    fillRule: "nonzero",
    opacity: 0.443,
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#f)"
  })), _ref7$6, _ref8$4, _ref9$4, _ref10$3, _ref11$2));
};

var APPS_ICON = {
  'Manage Users': SvgComponent,
  'Manage Customers': SvgComponent$1,
  'Finance': SvgComponent$2,
  'Dashboard': SvgComponent$3,
  'Campaign Builder': SvgComponent$4,
  'Creative Builder': SvgComponent$5,
  'Audience Builder': SvgComponent$6,
  'Manage Publishers': SvgComponent$7,
  'Manage Exchanges': SvgComponent$8,
  'Report Builder': SvgComponent$9,
  'Voter Intelligence': SvgComponent$a,
  'Campaign Manager': SvgComponent$b,
  'Accounts': SvgComponent$c,
  'Bid Model': SvgComponent$d,
  'Inventory': SvgComponent$e,
  'Inventory Managment': SvgComponent$f,
  'Framework': SvgComponent$g
};
var APPS_WITH_ONE_CLICK_LOGIN = ['Dashboard', 'Report Builder', 'Campaign Builder', 'Inventory Managment', 'Audience Builder'];

function getAppIconComponent(name) {
  return APPS_ICON[name];
}

var NavMenuList = function NavMenuList(props) {
  var list = props.list,
      toggleMenu = props.toggleMenu;

  var makeUrl = function makeUrl(name, url) {
    if (!APPS_WITH_ONE_CLICK_LOGIN.includes(name)) return url;
    var user = AuthService.getUser();
    return "".concat(url, "/#/login/").concat(btoa(user.apiToken), "/").concat(btoa(user.domainURL));
  };

  return React.createElement("ul", {
    className: "nav-menu__list"
  }, list.map(function (app, i) {
    var AppIcon = getAppIconComponent(app.name);
    return React.createElement("li", {
      className: "nav-menu__item",
      key: i
    }, React.createElement("a", {
      href: makeUrl(app.name, app.appUrl),
      target: "_blank",
      className: "nav-menu__link",
      onClick: toggleMenu
    }, React.createElement("span", {
      className: "nav-menu__image"
    }, React.createElement(AppIcon, null)), React.createElement("span", {
      className: "nav-menu__title"
    }, app.displayName)));
  }));
};

var css$1 = ".nav-menu {\n  position: absolute;\n  top: 100%;\n  right: 1rem;\n  width: 20.125rem;\n  max-height: calc(100vh - 100rem / 16);\n  overflow: auto;\n  border-radius: 0.5rem;\n  border: 0.0625rem solid #e9e8e8;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  background: #fff;\n  transition: transform 0.3s, opacity 0.3s;\n  transform: scale(1);\n  opacity: 1; }\n  .nav-menu._hidden {\n    transform: scale(0);\n    opacity: 0; }\n  .nav-menu__list {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 1.75rem; }\n  .nav-menu__item {\n    flex: 0 1 33.333%;\n    min-width: 33.333%;\n    max-width: 33.333%;\n    height: 6.25rem;\n    padding: 0.0625rem; }\n  .nav-menu__link {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0.5rem 0.125rem;\n    padding: 0;\n    border: none;\n    background: none;\n    text-decoration: none; }\n    .nav-menu__link:hover {\n      border: 1px solid #e9e8e8;\n      border-radius: 2px;\n      margin: 7px 1px; }\n  .nav-menu__image {\n    align-self: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 0.3125rem;\n    margin-bottom: 0.5rem;\n    width: 3.375rem;\n    height: 2.875rem;\n    border-radius: 50%;\n    position: relative; }\n    .nav-menu__image img,\n    .nav-menu__image svg {\n      flex: 0 1 100%;\n      max-width: 100%;\n      max-height: 100%; }\n  .nav-menu__title {\n    display: block;\n    max-width: 100%;\n    overflow: hidden;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1.53846em;\n    color: #000;\n    text-align: center;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    .nav-menu__title._tt-u {\n      text-transform: uppercase; }\n  .nav-menu__link:hover .nav-menu__title {\n    white-space: normal; }\n";
styleInject(css$1);

var NavMenu = /*#__PURE__*/function (_Component) {
  inherits(NavMenu, _Component);

  function NavMenu() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, NavMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(NavMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      apps: []
    });
    return _this;
  }

  createClass(NavMenu, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var apps;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return AuthService.getUserApps();

              case 3:
                apps = _context.sent;
                this.setState({
                  apps: apps || []
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          toggleMenu = _this$props.toggleMenu;
      return React.createElement("div", {
        className: "nav-menu ".concat(className || '')
      }, React.createElement(NavMenuList, {
        list: this.state.apps,
        toggleMenu: toggleMenu
      }));
    }
  }]);
  return NavMenu;
}(Component);

var NavbarContent = /*#__PURE__*/function (_Component) {
  inherits(NavbarContent, _Component);

  function NavbarContent() {
    var _this;

    classCallCheck(this, NavbarContent);
    _this = possibleConstructorReturn(this, getPrototypeOf(NavbarContent).call(this));
    defineProperty(assertThisInitialized(_this), "handleClickOutside", function (e) {
      if (_this.navMenuWrapper && !_this.navMenuWrapper.contains(e.target) && _this.state.open) {
        _this.togglePopup();
      }
    });
    defineProperty(assertThisInitialized(_this), "togglePopup", function () {
      _this.setState({
        open: !_this.state.open
      });
    });
    _this.state = {
      open: false
    };
    return _this;
  }

  createClass(NavbarContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var open = this.state.open;
      var children = this.props.children;
      return React.createElement("div", {
        className: "nav-bar__wrapper"
      }, children, React.createElement("div", {
        className: "nav-bar__wrapper-right"
      }, React.createElement(Tooltip, {
        label: "Support",
        position: "bottom",
        auto: false
      }, React.createElement("a", {
        href: "https://help.iqm.com",
        target: "_blank"
      }, React.createElement(ButtonCircle, {
        iconName: "Question",
        outline: true
      }))), React.createElement("div", {
        className: "nav-menu-wrapper ".concat(children ? '' : '_ml'),
        ref: function ref(el) {
          return _this2.navMenuWrapper = el;
        }
      }, React.createElement(Tooltip, {
        label: "All your Apps",
        position: "bottom",
        auto: false
      }, React.createElement(ButtonCircle, {
        key: "nav-menu-btn",
        iconName: "Apps",
        outline: true,
        onClick: this.togglePopup,
        className: "_size-16"
      })), React.createElement(NavMenu, {
        key: "nav-menu",
        className: "".concat(open ? '' : '_hidden'),
        toggleMenu: this.togglePopup
      }))));
    }
  }]);
  return NavbarContent;
}(Component);

function _extends$h() {
  _extends$h = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$h.apply(this, arguments);
}

var _ref$h = /*#__PURE__*/React.createElement("g", {
  className: "logo__i",
  fill: "#ff5859"
}, React.createElement("path", {
  d: "M.2 11c.4.3.7.6 1.1.9C6.7 17.3 12 22.7 17.4 28c.7.7 1 1.4 1 2.4v40.3c0 1.6-.1 1.7-1.7 1.7H.2V11zM18.4.2v16.5c0 .4.2 1-.3 1.2-.5.2-.7-.4-1-.7C11.9 12 6.7 6.8 1.4 1.6L.2.4c.2-.5.6-.2 1-.2h17.2z"
}));

var _ref2$d = /*#__PURE__*/React.createElement("path", {
  fill: "#ffa300",
  d: "M103.2.2v64.7c0 .6.3 1.5-.3 1.7-.5.2-.9-.6-1.3-1-5.3-5.2-10.5-10.4-15.7-15.6-.7-.7-1-1.4-1-2.4V19.9c0-1.6 0-1.6-1.6-1.6H50.5c-1.6 0-1.6 0-1.6 1.6v32.6c0 1.7 0 1.7 1.7 1.7H78c1.1 0 1.9.3 2.6 1.1 8.3 8.3 16.6 16.6 24.9 25 .3.3.8.5.7.9-.2.5-.8.3-1.2.3H82.6c-1 0-1.7-.3-2.3-1-2.3-2.3-4.6-4.6-6.8-6.9-.8-.8-1.5-1.1-2.6-1.1H32.7c-1.9 0-1.9 0-1.9-1.9V.3C54.8.2 79 .2 103.2.2z"
});

var _ref3$a = /*#__PURE__*/React.createElement("g", {
  className: "logo__m",
  fill: "#3fd4ad"
}, React.createElement("path", {
  d: "M202.3.2v70.4c0 1.7-.1 1.8-1.9 1.8h-14.9c-1.2 0-1.5-.4-1.5-1.6V56.4 20.2v-1.5c-.7.1-.9.5-1.2.8L160 42.3c-1.1 1.1-1.1 1.1-2.2 0-13.8-13.6-27.5-27.4-41.3-41.1-.3-.3-.6-.7-.9-1H141c5.8 5.8 11.5 11.6 17.3 17.4.5.5.8.3 1.2-.1C165.2 11.7 171 5.9 176.8.2h25.5zM115.6 41.7v-29c0-.4-.2-1 .2-1.2.5-.2.7.4 1 .7 5.3 5.3 10.6 10.6 15.9 15.8.7.7 1 1.4 1 2.4v40.4c0 1.6 0 1.7-1.7 1.7h-14.9c-1.2 0-1.5-.4-1.5-1.5V41.7z"
}));

var SvgComponent$h = function SvgComponent(props) {
  return React.createElement("svg", _extends$h({
    viewBox: "0 0 202.1 81.1"
  }, props), _ref$h, _ref2$d, _ref3$a);
};

var css$2 = ".user-info-popup {\n  width: 100%;\n  border-radius: .5rem;\n  overflow: hidden;\n  background: white;\n  box-shadow: 0 0 0.5rem 0.125rem rgba(0, 0, 0, 0.15); }\n  .user-info-popup__container {\n    padding: 1rem;\n    display: flex; }\n  .user-info-popup__right {\n    padding-left: 20px;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: space-between; }\n  .user-info-popup__avatar {\n    width: 6.0625rem;\n    height: 6.0625rem;\n    border-radius: 50%;\n    background-position: center;\n    background-size: 6.0625rem;\n    background-repeat: no-repeat;\n    position: relative;\n    overflow: hidden; }\n    .user-info-popup__avatar_btn {\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: rgba(0, 0, 0, 0.3);\n      padding: 0.375rem 0 0.625rem;\n      text-align: center;\n      color: white;\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      font-size: 0.9375rem;\n      cursor: pointer; }\n      .user-info-popup__avatar_btn:hover {\n        background-color: rgba(0, 0, 0, 0.5); }\n  .user-info-popup__desc {\n    margin-bottom: 1.25rem; }\n    .user-info-popup__desc span {\n      display: block; }\n      .user-info-popup__desc span:nth-child(1) {\n        font-family: Lato Bold, sans-serif;\n        font-weight: 400;\n        margin-bottom: 0.25rem; }\n      .user-info-popup__desc span:nth-child(2) {\n        font-family: Lato Regular, sans-serif;\n        font-weight: 400; }\n  .user-info-popup .btn-square {\n    margin-left: auto;\n    padding: 0 .9375em; }\n    .user-info-popup .btn-square .btn-content {\n      font-family: Lato Regular, sans-serif;\n      font-weight: 400;\n      font-size: .875em; }\n";
styleInject(css$2);

var PopupContent = /*#__PURE__*/function (_Component) {
  inherits(PopupContent, _Component);

  function PopupContent() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, PopupContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(PopupContent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "openUploadDialog", function () {
      _this.fileInput.click();
    });
    defineProperty(assertThisInitialized(_this), "onUploadImage", /*#__PURE__*/function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(event) {
        var file, reader;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                file = event.target.files[0];
                reader = new FileReader();
                reader.onloadend = /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
                  var ext, base64, avatar;
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          ext = file.type.split('/')[1];
                          base64 = reader.result.split('base64,')[1];
                          _context.next = 4;
                          return ApiService.uploadUserAvatar(base64, ext);

                        case 4:
                          avatar = _context.sent;

                          _this.props.updateAvatar(avatar);

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                reader.readAsDataURL(file);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    defineProperty(assertThisInitialized(_this), "handleLogout", function () {
      AuthService.unauthorize();
      AuthService.logout && AuthService.logout();
      _this.props.onLogout && _this.props.onLogout();
    });
    return _this;
  }

  createClass(PopupContent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var avatar = this.props.avatar;
      var user = AuthService.getUser() || {};
      return React.createElement("div", {
        className: "user-info-popup"
      }, React.createElement("div", {
        className: "user-info-popup__container"
      }, React.createElement("div", {
        className: "user-info-popup__left"
      }, React.createElement("div", {
        className: "user-info-popup__avatar",
        style: {
          backgroundImage: "url('".concat(avatar, "')")
        },
        onClick: this.openUploadDialog
      }, React.createElement("div", {
        className: "user-info-popup__avatar_btn"
      }, "Change"), React.createElement("input", {
        type: "file",
        ref: function ref(_ref3) {
          _this2.fileInput = _ref3;
        },
        onChange: this.onUploadImage,
        hidden: true
      }))), React.createElement("div", {
        className: "user-info-popup__right"
      }, React.createElement("div", {
        className: "user-info-popup__desc"
      }, React.createElement("span", null, user.userType === USER_ADVERTISER ? "".concat(user.firstName, " ").concat(user.lastName) : "".concat(user.companyName)), React.createElement("span", null, user.email)), React.createElement(Button, {
        className: "btn-square _filled _conflower-blue",
        onClick: this.handleLogout
      }, "Log Out"))));
    }
  }]);
  return PopupContent;
}(Component);

var css$3 = ".nav-bar__logo {\n  width: 2.75rem;\n  height: 2.375rem;\n  position: relative;\n  border-radius: 50%;\n  margin-right: 1rem; }\n";
styleInject(css$3);

var getLogo = function getLogo() {
  var logo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Report Builder';
  if (typeof logo !== 'string') return logo;
  var Logo = getAppIconComponent(logo);
  return React.createElement("div", {
    className: "nav-bar__logo"
  }, React.createElement(Logo, null));
};

var Header = /*#__PURE__*/function (_Component) {
  inherits(Header, _Component);

  function Header() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      avatar: ''
    });
    defineProperty(assertThisInitialized(_this), "updateAvatar", function (avatar) {
      _this.setState({
        avatar: avatar
      });

      AuthService.updateUser({
        avatar: avatar
      });
    });
    return _this;
  }

  createClass(Header, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var avatar;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return AuthService.getAvatar();

              case 3:
                avatar = _context.sent;
                this.setState({
                  avatar: avatar
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onLogout = _this$props.onLogout,
          leftLogo = _this$props.leftLogo,
          title = _this$props.title,
          _this$props$backButto = _this$props.backButton,
          backButton = _this$props$backButto === void 0 ? false : _this$props$backButto,
          backHandler = _this$props.backHandler,
          isBeta = _this$props.isBeta,
          children = _this$props.children;
      var avatar = this.state.avatar;
      return React.createElement(NavigationBar, {
        title: title,
        leftLogo: getLogo(leftLogo),
        backButton: backButton,
        backHandler: backHandler,
        profileLogo: React.createElement("div", {
          key: "profile-logo",
          className: "nav-bar__profile-logo"
        }, React.createElement(SvgComponent$h, null)),
        profileAvatar: React.createElement("div", {
          key: "profile-avatar",
          className: "nav-bar__profile-avatar",
          style: {
            backgroundImage: "url('".concat(avatar, "')")
          }
        }),
        popupContent: React.createElement(PopupContent, {
          avatar: avatar,
          onLogout: onLogout,
          updateAvatar: this.updateAvatar
        }),
        isBeta: isBeta
      }, React.createElement(NavbarContent, null, children));
    }
  }]);
  return Header;
}(Component);

var TableWithOptionsContext = React.createContext({
  allColumns: [],
  selectedColumns: [],
  onColumnsChanged: function onColumnsChanged() {}
});

var TableBaseRoot = /*#__PURE__*/function (_React$Component) {
  inherits(TableBaseRoot, _React$Component);

  function TableBaseRoot() {
    classCallCheck(this, TableBaseRoot);
    return possibleConstructorReturn(this, getPrototypeOf(TableBaseRoot).apply(this, arguments));
  }

  createClass(TableBaseRoot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$allColumn = _this$props.allColumns,
          allColumns = _this$props$allColumn === void 0 ? [] : _this$props$allColumn,
          _this$props$selectedC = _this$props.selectedColumns,
          selectedColumns = _this$props$selectedC === void 0 ? [] : _this$props$selectedC,
          _this$props$onColumns = _this$props.onColumnsChanged,
          onColumnsChanged = _this$props$onColumns === void 0 ? function () {} : _this$props$onColumns,
          _this$props$dataReque = _this$props.dataRequest,
          dataRequest = _this$props$dataReque === void 0 ? {} : _this$props$dataReque,
          _this$props$csvDownlo = _this$props.csvDownloadRequest,
          csvDownloadRequest = _this$props$csvDownlo === void 0 ? {} : _this$props$csvDownlo,
          _this$props$transform = _this$props.transformCSVDownloadRequest,
          transformCSVDownloadRequest = _this$props$transform === void 0 ? null : _this$props$transform,
          children = _this$props.children;
      return React.createElement(TableWithOptionsContext.Provider, {
        value: {
          allColumns: allColumns,
          selectedColumns: selectedColumns,
          onColumnsChanged: onColumnsChanged,
          dataRequest: dataRequest,
          csvDownloadRequest: csvDownloadRequest,
          transformCSVDownloadRequest: transformCSVDownloadRequest
        }
      }, children);
    }
  }]);
  return TableBaseRoot;
}(React.Component);

TableBaseRoot.propTypes = {
  allColumns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.required,
    value: PropTypes.string.required
  })),
  selectedColumns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.required,
    value: PropTypes.string.required
  })),
  onColumnsChanged: PropTypes.func,
  dataRequest: PropTypes.shape({
    url: PropTypes.string.isRequired,
    method: PropTypes.oneOf(['get', 'post']),
    data: PropTypes.object,
    params: PropTypes.object,
    headers: PropTypes.object
  }).isRequired,
  transformCSVDownloadRequest: PropTypes.func,
  csvDownloadRequest: PropTypes.shape({
    url: PropTypes.string.isRequired,
    method: PropTypes.oneOf(['get', 'post']),
    data: PropTypes.object,
    params: PropTypes.object,
    headers: PropTypes.object
  })
};
var css$4 = ".table__columns.select {\n  width: 130px; }\n  .table__columns.select._opened {\n    width: auto;\n    min-width: 13.125rem; }\n";
styleInject(css$4);

var TableSortedOptions = /*#__PURE__*/function (_React$Component) {
  inherits(TableSortedOptions, _React$Component);

  function TableSortedOptions() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TableSortedOptions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TableSortedOptions)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "handleChange", function (value) {
      _this.context.onColumnsChanged && _this.context.onColumnsChanged(value);
    });
    return _this;
  }

  createClass(TableSortedOptions, [{
    key: "render",
    value: function render() {
      var _this$context = this.context,
          allColumns = _this$context.allColumns,
          selectedColumns = _this$context.selectedColumns;
      var _this$props = this.props,
          label = _this$props.label,
          _this$props$selectPro = _this$props.selectProps,
          selectProps = _this$props$selectPro === void 0 ? {} : _this$props$selectPro;
      var className = "table__columns ".concat(selectProps.className || '');
      return React.createElement(Select, _extends_1({
        onChange: this.handleChange,
        options: allColumns,
        value: selectedColumns,
        isMulti: true,
        label: label || 'Columns',
        allSelectable: true,
        hideCrossIfClosed: true,
        hideValueOnFocus: true,
        showControlLabel: true,
        dnd: true,
        allSelectedText: 'All Selected',
        tooltipParams: {
          label: 'Select and order the columns to include in the table',
          auto: false,
          position: 'left'
        }
      }, selectProps, {
        className: className
      }));
    }
  }]);
  return TableSortedOptions;
}(React.Component);

defineProperty(TableSortedOptions, "contextType", TableWithOptionsContext);
var ColumnOptions = {
  ColumnId: {
    value: 'id',
    label: 'ID',
    alwaysEnabled: true,
    draggableGroup: 1
  },
  ColumnCheckbox: {
    value: 'checkbox',
    label: '',
    alwaysEnabled: true,
    draggableGroup: 1
  },
  ColumnCampaignName: {
    value: 'campaignName',
    label: 'Campaign Name',
    alwaysEnabled: true,
    draggableGroup: 1
  },
  ColumnMaxBid: {
    value: 'maxBid',
    label: 'Max Bid($)'
  },
  ColumnBudget: {
    value: 'budget',
    label: 'Budget($)'
  },
  ColumnDailyBudget: {
    value: 'budgetDay',
    label: 'Daily Budget($)'
  },
  ColumnTotalBudget: {
    value: 'budgetTotal',
    label: 'Total Budget($)'
  },
  ColumnTotalSpent: {
    value: 'spent',
    label: 'Total Spent($)'
  },
  ColumnStartDate: {
    value: 'startTime',
    label: 'Start date'
  },
  ColumnEndDate: {
    value: 'endTime',
    label: 'End date'
  },
  ColumnImpressions: {
    value: 'impressions',
    label: 'Impressions'
  },
  ColumnUniqueReach: {
    value: 'uniqueReach',
    label: 'Unique Reach'
  },
  ColumnCreated: {
    value: 'created',
    label: 'Created'
  },
  ColumnModified: {
    value: 'modified',
    label: 'Modified'
  },
  ColumnGoal: {
    value: 'campaignType',
    label: 'Goal'
  },
  // previously 'Type'
  ColumnEcpm: {
    value: 'eCPM',
    label: 'eCPM($)'
  },
  ColumnEcpc: {
    value: 'eCPC',
    label: 'eCPC($)'
  },
  ColumnClicks: {
    value: 'clicks',
    label: 'Clicks'
  },
  ColumnWinrate: {
    value: 'winRate',
    label: 'WinRate(%)'
  },
  ColumnCtr: {
    value: 'CTR',
    label: 'CTR(%)'
  },
  ColumnDataCost: {
    value: 'dataCost',
    label: 'Data Cost($)'
  },
  ColumnMediaSpent: {
    value: 'mediaSpent',
    label: 'Media Spent($)'
  },
  ColumnTotalSpentPercent: {
    value: 'percentageOfTotalSpent',
    label: 'Total Spent(%)'
  },
  ColumnVcr: {
    value: 'VCR',
    label: 'VCR(%)'
  },
  ColumnStartCount: {
    value: 'startCount',
    label: 'Video Start'
  },
  ColumnFirstCount: {
    value: 'firstCount',
    label: 'Video 25%'
  },
  ColumnMidCount: {
    value: 'midCount',
    label: 'Video 50%'
  },
  ColumnThirdCount: {
    value: 'thirdCount',
    label: 'Video 75%'
  },
  ColumnCompleteCount: {
    value: 'completeCount',
    label: 'Video 100%'
  },
  ColumnCpcv: {
    value: 'eCPCV',
    label: 'CPCV($)'
  },
  ColumnAge: {
    label: 'Age Group',
    value: 'age'
  },
  ColumnGender: {
    label: 'Gender',
    value: 'gender'
  },
  ColumnIncomeGroup: {
    label: 'Income Range',
    value: 'incomeRange'
  },
  ColumnEthnicity: {
    label: 'Ethnicity',
    value: 'ethnicity'
  },
  ColumnLanguage: {
    label: 'Language',
    value: 'language'
  },
  ColumnCampaignGroupName: {
    label: 'Camapign Group Name',
    value: 'campaignGroupName'
  }
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;
var css$5 = ".skeleton-block, .skeleton-row__item {\n  display: block;\n  height: 1.75rem;\n  border-radius: 0.3125rem;\n  background-image: linear-gradient(90deg, #f4f4f4 0px, #e9e8e8 2rem, #f4f4f4 4rem);\n  background-size: 200%;\n  background-position: 100%;\n  animation: skeleton 1.5s infinite linear; }\n\n.skeleton-row {\n  display: flex;\n  width: 100%; }\n  .skeleton-row__item {\n    flex: 1 1 auto; }\n    .skeleton-row__item:not(:last-child) {\n      margin-right: 0.625rem; }\n\n@keyframes skeleton {\n  0% {\n    background-position: 100%; }\n  100% {\n    background-position: -100%; } }\n\n@keyframes skeleton-3-times-slower {\n  0%,\n  22.222% {\n    background-position: 100%; }\n  55.556%,\n  100% {\n    background-position: -100%; } }\n";
styleInject(css$5);

var SkeletonBlock = function SkeletonBlock(props) {
  var style = props.style,
      tag = props.tag;
  return tag ? React.createElement(tag, {
    className: 'skeleton-block',
    style: style
  }, null) : React.createElement("div", {
    className: "skeleton-block",
    style: style
  });
};

var Skeleton = function Skeleton(_ref) {
  var _ref$colN = _ref.colN,
      colN = _ref$colN === void 0 ? 10 : _ref$colN,
      _ref$rowN = _ref.rowN,
      rowN = _ref$rowN === void 0 ? 10 : _ref$rowN,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? [] : _ref$classes,
      theadRowHeight = _ref.theadRowHeight,
      tbodyRowHeight = _ref.tbodyRowHeight;
  var table = {};
  var colArr = toConsumableArray(new Array(colN));
  var rowArr = toConsumableArray(new Array(rowN));
  var skeleton = React.createElement(SkeletonBlock, {
    style: {
      width: '100%',
      height: "".concat(17 / 16, "rem")
    }
  });
  table.header = colArr.map(function (value, index) {
    return {
      label: skeleton,
      className: classes[index] || ''
    };
  });
  table.body = colArr.map(function (item, index) {
    return {
      key: index,
      className: classes[index] || ''
    };
  });
  table.data = rowArr.map(function () {
    return colArr.reduce(function (acc, item, i) {
      acc[i] = skeleton;
      return acc;
    }, {});
  });
  return React.createElement("div", {
    className: "no-interaction",
    style: {
      width: '100%'
    }
  }, React.createElement(Table, {
    className: "_skeleton",
    header: table.header,
    body: table.body,
    data: table.data,
    fixedHeader: false,
    rowKeyExtractor: function rowKeyExtractor(data, rowIndex) {
      return "".concat(data.id, "_").concat(rowIndex);
    },
    enableContextMenu: false,
    theadRowHeight: theadRowHeight,
    tbodyRowHeight: tbodyRowHeight
  }));
};

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var config$1 = getConfig();

var TableApi = /*#__PURE__*/function () {
  function TableApi() {
    classCallCheck(this, TableApi);
  }

  createClass(TableApi, [{
    key: "fetchData",
    value: function fetchData(_ref) {
      var url = _ref.url,
          _ref$method = _ref.method,
          method = _ref$method === void 0 ? 'post' : _ref$method,
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {} : _ref$params,
          _ref$data = _ref.data,
          data = _ref$data === void 0 ? {} : _ref$data,
          _ref$headers = _ref.headers,
          headers = _ref$headers === void 0 ? {} : _ref$headers;

      try {
        var user = AuthService.getUser();
        if (!user) return null;
        var source = axios.CancelToken.source();
        var request = axios({
          url: url,
          headers: _objectSpread$2({
            'x-iaa-api-token': user.apiToken,
            'Base-Url': user.domainURL
          }, headers),
          data: data,
          params: params,
          method: method,
          cancelToken: source.token
        });
        return {
          promise: request,
          source: source
        };
      } catch (e) {
        throw new ServerError(e);
      }
    }
  }, {
    key: "downloadCSV",
    value: function () {
      var _downloadCSV = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(data) {
        var user, response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", null);

              case 4:
                _context.next = 6;
                return axios({
                  url: config$1.CSV_DOWNLOAD_URL,
                  method: 'post',
                  headers: {
                    'x-iaa-api-token': user.apiToken,
                    'Base-Url': user.domainURL
                  },
                  data: _objectSpread$2({}, data, {
                    token: user.apiToken
                  })
                });

              case 6:
                response = _context.sent;
                return _context.abrupt("return", response.request.responseURL);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                throw new SyntaxError(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      function downloadCSV(_x) {
        return _downloadCSV.apply(this, arguments);
      }

      return downloadCSV;
    }()
  }, {
    key: "downloadXLSX",
    value: function () {
      var _downloadXLSX = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(data) {
        var user, response;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", null);

              case 4:
                _context2.next = 6;
                return axios({
                  url: config$1.XLSX_DOWNLOAD_URL,
                  method: 'post',
                  headers: {
                    'x-iaa-api-token': user.apiToken,
                    'Base-Url': user.domainURL
                  },
                  responseType: 'blob',
                  data: _objectSpread$2({}, data, {
                    token: user.apiToken
                  })
                });

              case 6:
                response = _context2.sent;
                return _context2.abrupt("return", response.request.responseURL);

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                throw new SyntaxError(_context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }));

      function downloadXLSX(_x2) {
        return _downloadXLSX.apply(this, arguments);
      }

      return downloadXLSX;
    }()
  }, {
    key: "updateCampaignName",
    value: function () {
      var _updateCampaignName = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(id, value) {
        var user;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                user = AuthService.getUser();

                if (!(!user || !id)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", null);

              case 4:
                _context3.next = 6;
                return axios.patch("https://".concat(user.domainURL, "/api/campaign/").concat(id), {
                  campaign_name: value
                }, {
                  headers: {
                    'x-iaa-api-token': user.apiToken
                  }
                });

              case 6:
                return _context3.abrupt("return", true);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                throw new ServerError(_context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      function updateCampaignName(_x3, _x4) {
        return _updateCampaignName.apply(this, arguments);
      }

      return updateCampaignName;
    }()
  }]);
  return TableApi;
}();

var TableApiService = new TableApi();
var CurrencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
var NumberFormat = new Intl.NumberFormat('en-US');
var DateTimeFormat = 'MM/DD/YYYY hh:mm A';
var DateFormat = 'MM/DD/YYYY';

var percentFormat = function percentFormat(value) {
  return "".concat((value || 0).toFixed(2), "%");
};

var displayCurrency = function displayCurrency() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return data !== null ? CurrencyFormat.format(data) : '—';
};

var displayNumber = function displayNumber() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return data !== null ? NumberFormat.format(data) : '—';
};

var displayPercent = function displayPercent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return data !== null ? percentFormat(+data) : '—';
};

var TableHeaderMapping = {
  id: {
    label: 'ID',
    tooltip: 'Unique system-generated number assigned to each campaign',
    sortingKey: 'campaignId',
    className: 'w-120-120',
    draggableGroup: 'group1'
  },
  checkbox: {
    label: '',
    className: '_checkbox',
    draggable: false
  },
  campaignName: {
    label: 'Campaign Name',
    tooltip: 'Campaign Name',
    sortingKey: 'campaignName',
    className: 'w-250-650',
    draggableGroup: 'group1'
  },
  campaignGroupId: {
    label: 'Campaign Group ID',
    tooltip: 'Unique system-generated number assigned to each Campaign Group',
    sortingKey: 'campaignGroupId',
    className: 'w-150-200',
    draggableGroup: 'group1'
  },
  campaignGroupName: {
    label: 'Campaign Group',
    tooltip: 'Campaign Group',
    sortingKey: 'campaignGroupName',
    className: 'w-250-650',
    draggableGroup: 'group1'
  },
  budget: {
    label: 'Budget',
    tooltip: 'Budget',
    sortingKey: 'budget',
    className: 'w-100-200'
  },
  budgetDay: {
    label: 'Daily Budget',
    tooltip: 'Amount up to which you allow us to spend on average each day',
    sortingKey: 'budgetDay',
    className: 'w-100-200'
  },
  budgetTotal: {
    label: 'Total Budget',
    tooltip: 'Amount up to which you allow us to spend',
    sortingKey: 'budgetTotal',
    className: 'w-100-200'
  },
  uniqueReach: {
    label: 'Unique Reach',
    tooltip: 'Unique Reach',
    sortingKey: 'uniqueReach',
    className: 'w-100-200'
  },
  created: {
    label: 'Created',
    tooltip: 'Created',
    sortingKey: 'created',
    className: 'w-100-200'
  },
  modified: {
    label: 'Modified',
    tooltip: 'Modified',
    sortingKey: 'lastModified',
    className: 'w-100-200'
  },
  campaignType: {
    label: 'Goal',
    tooltip: 'Campaign Goal, cpm - Impressions, cpc - Clicks',
    sortingKey: 'campaignType',
    className: 'w-60-60'
  },
  eCPM: {
    label: 'eCPM',
    tooltip: 'Effective Cost Per Mile is the amount you pay per one thousand Impressions',
    sortingKey: 'eCPM',
    className: 'w-70-200'
  },
  eCPC: {
    label: 'eCPC',
    tooltip: 'Effective Cost Per Click is the amount spent divided by the number of clicks',
    sortingKey: 'eCPC',
    className: 'w-70-200'
  },
  dataCost: {
    label: 'Data Spent',
    tooltip: 'Amount spent to serve Impressions to Audience you matched or purchased',
    sortingKey: 'dataCost',
    className: 'w-90-90'
  },
  spent: {
    label: 'Total Spent',
    tooltip: 'Sum of the Media Spent and Data Spent',
    sortingKey: 'spent',
    className: 'w-100-200'
  },
  mediaSpent: {
    label: 'Media Spent',
    tooltip: 'Amount spent to win Impressions',
    sortingKey: 'mediaSpent',
    className: 'w-100-200'
  },
  percentageOfTotalSpent: {
    label: 'Budget vs Spent',
    tooltip: 'Percentage of the Total Budget that was Spent',
    sortingKey: 'percentageOfTotalSpent',
    className: 'w-100-200'
  },
  creativeId: {
    label: 'Creative ID',
    tooltip: 'Unique system-generated number assigned to each Creative',
    sortingKey: 'creative_id',
    className: 'w-100-100',
    draggableGroup: 'group1'
  },
  campaignId: {
    label: 'Campaign ID',
    tooltip: 'Unique system-generated number assigned to each Campaign',
    sortingKey: 'campaignId',
    className: 'w-100-100',
    draggableGroup: 'group1'
  },
  creativeName: {
    label: 'Creative Name',
    tooltip: 'Creative Name',
    sortingKey: 'creativeName',
    className: 'w-250-650',
    draggableGroup: 'group1'
  },
  creativeType: {
    label: 'Creative Type',
    tooltip: 'Creative Type',
    sortingKey: 'creativeTypeName',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  devOs: {
    label: 'OS',
    tooltip: 'OS',
    sortingKey: 'devOs',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  startTime: {
    label: 'Start Date',
    tooltip: 'Campaign Start Date',
    sortingKey: 'startTime',
    className: 'w-90-90',
    draggableGroup: 'group1'
  },
  endTime: {
    label: 'End Date',
    tooltip: 'Campaign End Date',
    sortingKey: 'endTime',
    className: 'w-90-90',
    draggableGroup: 'group1'
  },
  date: {
    label: 'Date',
    tooltip: 'Date',
    sortingKey: 'date',
    className: 'w-100-200',
    draggableGroup: 'group1'
  },
  winRate: {
    label: 'Win Rate',
    tooltip: 'Percentage of Impressions won per the Bids made',
    sortingKey: 'winRate',
    className: 'w-90-90'
  },
  clicks: {
    label: 'Clicks',
    tooltip: 'Number of times someone clicks your ad',
    sortingKey: 'clicks',
    className: 'w-60-60'
  },
  CTR: {
    label: 'CTR',
    tooltip: 'Click-through rate is the percentage of Clicks received per the Impressions served',
    sortingKey: 'CTR',
    className: 'w-60-60'
  },
  impressions: {
    label: 'Impressions',
    tooltip: 'Number of times ad displayed on the someone\'s screen',
    sortingKey: 'impressions',
    className: 'w-90-90'
  },
  maxBid: {
    label: 'Max Bid',
    tooltip: 'Amount up to which you allow us to Bid',
    sortingKey: 'maxBid',
    className: 'w-80-80'
  },
  deviceType: {
    label: 'Device Type',
    tooltip: 'Device Type',
    sortingKey: 'deviceType',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  trafficType: {
    label: 'Channel',
    tooltip: 'Environment for the Creative delivery, App (in-app) or Web',
    sortingKey: 'trafficType',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  manufacturerName: {
    label: 'Manufacturer',
    tooltip: 'Manufacturer',
    sortingKey: 'manufacturerName',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  exchName: {
    label: 'Exchange',
    tooltip: 'Exchange',
    sortingKey: 'exchName',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  VCR: {
    label: 'VCR',
    tooltip: 'Video Completion Rate is the percentage of video ads that play through to completion',
    sortingKey: 'VCR',
    className: 'w-65-65'
  },
  startCount: {
    label: 'Video Start',
    tooltip: 'Number of video ads that start to play',
    sortingKey: 'startCount',
    className: 'w-90-90'
  },
  firstCount: {
    label: 'Video 25%',
    tooltip: 'Number of video ads that play through 25% of their duration',
    sortingKey: 'firstCount',
    className: 'w-90-90'
  },
  midCount: {
    label: 'Video 50%',
    tooltip: 'Number of video ads that play through 50% of their duration',
    sortingKey: 'midCount',
    className: 'w-90-90'
  },
  thirdCount: {
    label: 'Video 75%',
    tooltip: 'Number of video ads that play through 75% of their duration',
    sortingKey: 'thirdCount',
    className: 'w-90-90'
  },
  completeCount: {
    label: 'Video 100%',
    tooltip: 'Number of video ads that play through to completion',
    sortingKey: 'completeCount',
    className: 'w-100-200'
  },
  eCPCV: {
    label: 'CPCV',
    tooltip: 'Cost Per Completed View is the amount spent divided by video ads that play through to completion',
    sortingKey: 'eCPCV',
    className: 'w-70-200'
  },
  age: {
    label: 'Age Group',
    tooltip: 'Age Group',
    sortingKey: 'age',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  gender: {
    label: 'Gender',
    tooltip: 'Gender',
    sortingKey: 'gender',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  incomeGroup: {
    label: 'Income Range',
    tooltip: 'Income Range',
    sortingKey: 'incomeGroup',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  ethnicity: {
    label: 'Ethnicity',
    tooltip: 'Ethnicity',
    sortingKey: 'ethnicity',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  language: {
    label: 'Language',
    tooltip: 'Language',
    sortingKey: 'language',
    className: 'w-150-300',
    draggableGroup: 'group1'
  }
};
var TableBodyMapping = {
  id: {
    key: 'campaignId',
    className: '_id w-100-100 _right'
  },
  budget: {
    key: function key(data) {
      return displayCurrency(data.budget);
    },
    className: '_right w-100-200'
  },
  budgetDay: {
    key: function key(data) {
      return displayCurrency(data.budgetDay);
    },
    className: '_right w-100-200'
  },
  budgetTotal: {
    key: function key(data) {
      return displayCurrency(data.budgetTotal);
    },
    className: '_right w-100-200'
  },
  spent: {
    key: function key(data) {
      return displayCurrency(data.spent);
    },
    className: 'w-100-200 _right'
  },
  startTime: {
    key: function key(data) {
      return data.startTime ? data.campaignTimezone ? moment.unix(data.startTime).tz(data.campaignTimezone).format(DateFormat) : moment.unix(data.startTime).format(DateFormat) : '—';
    },
    className: '_start-date w-90-90'
  },
  endTime: {
    key: function key(data) {
      return data.endTime ? data.campaignTimezone ? moment.unix(data.endTime).tz(data.campaignTimezone).format(DateFormat) : moment.unix(data.endTime).format(DateFormat) : '—';
    },
    className: '_end-date w-90-90'
  },
  uniqueReach: {
    key: function key(data) {
      return displayNumber(data.uniqueReach);
    },
    className: 'w-100-200 _right'
  },
  created: {
    key: function key(data) {
      return data.created ? moment.unix(data.created).format(DateTimeFormat) : '—';
    },
    className: '_start-date w-100-200'
  },
  modified: {
    key: function key(data) {
      return data.lastModified ? moment.unix(data.lastModified).format(DateTimeFormat) : '—';
    },
    className: '_end-date w-100-200'
  },
  campaignType: {
    key: function key(data) {
      return data.campaignType ? data.campaignType : '—';
    },
    className: 'w-100 w-60-60'
  },
  eCPM: {
    key: function key(data) {
      return displayCurrency(data.eCPM);
    },
    className: '_right w-70-200'
  },
  eCPC: {
    key: function key(data) {
      return displayCurrency(data.eCPC);
    },
    className: '_right w-70-200'
  },
  dataCost: {
    key: function key(data) {
      return displayCurrency(data.dataCost);
    },
    className: '_right w-90-90'
  },
  mediaSpent: {
    key: function key(data) {
      return displayCurrency(data.mediaSpent);
    },
    className: '_right w-100-200'
  },
  percentageOfTotalSpent: {
    key: function key(data) {
      return displayPercent(data.percentageOfTotalSpent);
    },
    className: '_right w-100-200'
  },
  campaignGroupId: {
    key: 'campaignGroupId',
    className: 'w-150-200'
  },
  campaignGroupName: {
    key: 'campaignGroupName',
    className: 'w-250-650'
  },
  creativeId: {
    key: 'creativeId',
    className: 'w-100-100 _right'
  },
  campaignId: {
    key: 'campaignId',
    className: 'w-100-100 _right'
  },
  campaignName: {
    key: 'campaignName',
    className: 'w-250-650'
  },
  creativeName: {
    key: 'creativeName',
    className: 'w-250-650'
  },
  creativeType: {
    key: 'creativeTypeName',
    className: 'w-150-300'
  },
  deviceType: {
    key: 'deviceType',
    className: 'w-150-300'
  },
  manufacturerName: {
    key: 'manufacturerName',
    className: 'w-150-300'
  },
  trafficType: {
    key: 'trafficType',
    className: 'w-150-300'
  },
  exchName: {
    key: 'exchName',
    className: 'w-150-300'
  },
  age: {
    key: 'age',
    className: 'w-150-300'
  },
  gender: {
    key: 'gender',
    className: 'w-150-300'
  },
  incomeGroup: {
    key: 'incomeGroup',
    className: 'w-150-300'
  },
  ethnicity: {
    key: 'ethnicity',
    className: 'w-150-300'
  },
  language: {
    key: 'language',
    className: 'w-150-300'
  },
  date: {
    key: function key(data) {
      if (!data.date) {
        return '';
      }

      var momentDate = moment(data.date);
      return momentDate.isValid() ? momentDate.format(DateFormat) : data.date;
    },
    className: 'w-100-200'
  },
  impressions: {
    key: function key(data) {
      return displayNumber(data.impressions);
    },
    className: 'w-90-90 _right'
  },
  devOs: {
    key: 'devOs',
    className: 'w-150-300'
  },
  winRate: {
    key: function key(data) {
      return displayPercent(data.winRate);
    },
    className: '_right w-90-90'
  },
  clicks: {
    key: function key(data) {
      return displayNumber(data.clicks);
    },
    className: '_right w-60-60'
  },
  maxBid: {
    key: function key(data) {
      return displayCurrency(data.maxBid);
    },
    className: '_right w-80-80'
  },
  CTR: {
    key: function key(data) {
      return displayPercent(data.CTR);
    },
    className: '_right w-60-60'
  },
  VCR: {
    key: function key(data) {
      return displayPercent(data.VCR);
    },
    className: '_right w-65-65'
  },
  startCount: {
    key: function key(data) {
      return displayNumber(data.startCount);
    },
    className: '_right w-90-90'
  },
  firstCount: {
    key: function key(data) {
      return displayNumber(data.firstCount);
    },
    className: '_right w-90-90'
  },
  midCount: {
    key: function key(data) {
      return displayNumber(data.midCount);
    },
    className: '_right w-90-90'
  },
  thirdCount: {
    key: function key(data) {
      return displayNumber(data.thirdCount);
    },
    className: '_right w-90-90'
  },
  completeCount: {
    key: function key(data) {
      return displayNumber(data.completeCount);
    },
    className: '_right w-100-200'
  },
  eCPCV: {
    key: function key(data) {
      return displayCurrency(data.eCPCV);
    },
    className: '_right w-70-200'
  }
};
var css$6 = ".table table td {\n  min-width: 150px;\n  max-width: 200px;\n  width: 200px; }\n  .table table td._right .td-content-inner {\n    margin-left: auto; }\n  .table table td.w-60-60 {\n    min-width: 60px;\n    max-width: 60px;\n    width: 60px; }\n  .table table td.w-65-65 {\n    min-width: 65px;\n    max-width: 65px;\n    width: 65px; }\n  .table table td.w-60-80 {\n    min-width: 60px;\n    max-width: 80px;\n    width: 80px; }\n  .table table td.w-80-80 {\n    min-width: 80px;\n    max-width: 80px;\n    width: 80px; }\n  .table table td.w-90-90 {\n    min-width: 90px;\n    max-width: 90px;\n    width: 90px; }\n  .table table td.w-100-100 {\n    min-width: 100px;\n    max-width: 100px;\n    width: 100px; }\n  .table table td.w-100-200 {\n    min-width: 100px;\n    max-width: 200px;\n    width: 200px; }\n  .table table td.w-70-200 {\n    min-width: 70px;\n    max-width: 200px;\n    width: 200px; }\n  .table table td.w-120-120 {\n    min-width: 120px;\n    max-width: 120px;\n    width: 120px; }\n  .table table td.w-135-135 {\n    min-width: 135px;\n    max-width: 135px;\n    width: 135px; }\n  .table table td.w-150-200 {\n    min-width: 150px;\n    max-width: 200px;\n    width: 200px; }\n  .table table td.w-150-300 {\n    min-width: 150px;\n    max-width: 300px;\n    width: 300px; }\n  .table table td.w-250-650 {\n    min-width: 250px;\n    max-width: 650px;\n    width: 650px; }\n  .table table td.w-450-650 {\n    min-width: 450px;\n    max-width: 650px;\n    width: 650px; }\n\n.skeleton-block, .skeleton-row__item {\n  display: block;\n  height: 1.75rem;\n  border-radius: 0.3125rem;\n  background-image: linear-gradient(90deg, #f4f4f4 0px, #e9e8e8 2rem, #f4f4f4 4rem);\n  background-size: 200%;\n  background-position: 100%;\n  animation: skeleton 1.5s infinite linear; }\n\n.skeleton-row {\n  display: flex;\n  width: 100%; }\n  .skeleton-row__item {\n    flex: 1 1 auto; }\n    .skeleton-row__item:not(:last-child) {\n      margin-right: 0.625rem; }\n\n@keyframes skeleton {\n  0% {\n    background-position: 100%; }\n  100% {\n    background-position: -100%; } }\n\n@keyframes skeleton-3-times-slower {\n  0%,\n  22.222% {\n    background-position: 100%; }\n  55.556%,\n  100% {\n    background-position: -100%; } }\n\n.editable-text {\n  width: 100%;\n  position: relative; }\n  .editable-text .text-field__input {\n    font-size: 0.875rem;\n    height: 100%;\n    padding: 0;\n    padding-right: 24px; }\n  .editable-text .text-field__base {\n    margin-top: 0; }\n    .editable-text .text-field__base:after, .editable-text .text-field__base:before {\n      bottom: -0.25rem; }\n    .editable-text .text-field__base:after {\n      border-color: #4d5ecc; }\n  .editable-text .svg-icon {\n    position: absolute;\n    right: 0;\n    width: 20px;\n    height: 20px;\n    fill: #4d5ecc; }\n  .editable-text._right .text-field__input {\n    text-align: right;\n    padding-right: 0;\n    padding-left: 24px; }\n  .editable-text._right .svg-icon {\n    left: 0;\n    right: auto; }\n\n.table-wrapper .table._skeleton {\n  display: none; }\n  .table-wrapper .table._skeleton .td-content-inner {\n    width: 100%; }\n\n.table-wrapper._show-skeleton .table {\n  display: none; }\n\n.table-wrapper._show-skeleton .table._skeleton {\n  display: block; }\n\n.table-wrapper .no-data-placeholder {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center; }\n  .table-wrapper .no-data-placeholder .svg-icon {\n    width: 200px;\n    height: 200px;\n    fill: #dddddd; }\n  .table-wrapper .no-data-placeholder__subtitle {\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 1.3125rem;\n    color: #a2a2a2; }\n";
styleInject(css$6);

var LoadAllDialogContent = function LoadAllDialogContent(_ref) {
  var onClose = _ref.onClose,
      onLoad = _ref.onLoad,
      campaignCount = _ref.campaignCount;
  return React.createElement(DialogContent, null, React.createElement("h3", {
    className: "title-card mb-4"
  }, "Load All Campaigns?"), React.createElement("h5", {
    className: "title-card-subtitle mb-4"
  }, "To make selection we need to load all", ' ', React.createElement("span", {
    className: "_black"
  }, campaignCount), ' ', "campaigns"), React.createElement("div", {
    className: "d-flex justify-content-end align-items-center"
  }, React.createElement(Button, {
    className: "btn-square _conflower-blue mr-2",
    onClick: onClose
  }, "Cancel"), React.createElement(Button, {
    className: "btn-square _conflower-blue _filled",
    onClick: onLoad
  }, "Load")));
};

var props = {
  onClose: PropTypes.func,
  onLoad: PropTypes.func,
  campaignCount: PropTypes.number
};
LoadAllDialogContent.propTypes = props;

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var SELECTED_CLASS_NAME = '_selected';
var defaultSorting = {
  direction: null,
  field: null
};
var STORAGE_NAME = 'changeCampaignName';

var moveItem = function moveItem(a, from, to) {
  if (from === to || to === null) return a;
  var clone = toConsumableArray(a);
  clone.splice(to, 0, clone.splice(from, 1)[0]);
  return clone;
};

var TableComp = /*#__PURE__*/function (_React$Component) {
  inherits(TableComp, _React$Component);

  function TableComp(props) {
    var _this;

    classCallCheck(this, TableComp);
    _this = possibleConstructorReturn(this, getPrototypeOf(TableComp).call(this, props));
    defineProperty(assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (!isEqual(prevProps.dataRequest, _this.props.dataRequest)) {
        _this.setState({
          isNewArray: true,
          selected: [],
          sorting: _this.props.defaultSorting || _this.defaultSorting,
          loading: true
        }, function () {
          _this.props.onLoading && _this.props.onLoading(_this.state.loading);

          _this.getData();
        });
      } else if (!isEqual(prevProps.defaultSorting, _this.props.defaultSorting)) {
        _this.setState({
          sorting: _this.props.defaultSorting || _this.defaultSorting
        });
      }

      if (_this.state.loading !== prevState.loading) {
        if (_this.props.onLoading) {
          _this.props.onLoading(_this.state.loading);
        }
      }

      if (_this.state.loadingData !== prevState.loadingData) {
        if (_this.props.onDataLoading) {
          _this.props.onDataLoading(_this.state.loadingData);
        }
      } else if (!prevState.loadingData && _this.props.data !== prevProps.data) {
        _this.setState({
          data: _this.props.data || []
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "_mounted", false);
    defineProperty(assertThisInitialized(_this), "componentDidMount", function () {
      _this._mounted = true;

      if (_this.state.loading) {
        _this.getData();
      }
    });
    defineProperty(assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._mounted = false;

      if (_this.prevSourceRequest) {
        _this.prevSourceRequest.cancel();
      }
    });
    defineProperty(assertThisInitialized(_this), "HeaderMapping", _objectSpread$3({}, TableHeaderMapping));
    defineProperty(assertThisInitialized(_this), "BodyMapping", _objectSpread$3({}, TableBodyMapping, {
      checkbox: {
        key: function key(data) {
          var idField = _this.props.idField;
          var _this$state = _this.state,
              selected = _this$state.selected,
              propsData = _this$state.data;
          var checked = !!find(selected, function (d) {
            return d[idField] === data[idField];
          });
          var checkedAll = selected.length === propsData.length;
          var checkedPartly = selected.length > 0 && !checkedAll;
          return data.total ? React.createElement(Checkbox, {
            className: checkedPartly ? '_dirty' : '',
            checked: checkedAll,
            name: "checkbox-id-".concat(data[idField]),
            onChange: _this.handleTableAllCampaignsSelection(data, checkedPartly)
          }) : React.createElement(Checkbox, {
            checked: checked,
            name: "checkbox-id-".concat(data[idField]),
            onChange: _this.handleTableCampaignSelection(data)
          });
        },
        className: '_checkbox'
      },
      campaignName: {
        key: function key(data) {
          return data.name;
        },
        hover: function hover(data) {
          return !data.total && React.createElement(EditableText, {
            value: data.name,
            confirm: function confirm(value) {
              _this.updateName(data, value);
            },
            Popup: {
              title: 'Change Campaign Name',
              remember: true,
              storageKey: STORAGE_NAME
            }
          }, React.createElement("div", null, "Campaign Name will be changed across all products. Are you sure?"));
        },
        className: '_campaign-name'
      }
    }));
    defineProperty(assertThisInitialized(_this), "getData", /*#__PURE__*/function () {
      var _ref = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _ref2,
            itemsCount,
            _this$props,
            dataPath,
            dataRequest,
            totalPath,
            countPath,
            transformRequestParams,
            _this$state2,
            itemsCountPerPage,
            currentPage,
            sorting,
            isNewArray,
            page,
            isGet,
            query,
            sortKey,
            request,
            _TableApiService$fetc,
            promise,
            source,
            _ref3,
            response,
            data,
            totalObj,
            totalData,
            totalItems,
            newData,
            hasMore,
            _args = arguments;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, itemsCount = _ref2.itemsCount;
                _context.prev = 1;

                if (!_this.state.loadingData) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this$props = _this.props, dataPath = _this$props.dataPath, dataRequest = _this$props.dataRequest, totalPath = _this$props.totalPath, countPath = _this$props.countPath, transformRequestParams = _this$props.transformRequestParams;
                _this$state2 = _this.state, itemsCountPerPage = _this$state2.itemsCountPerPage, currentPage = _this$state2.currentPage, sorting = _this$state2.sorting, isNewArray = _this$state2.isNewArray;

                _this.setState({
                  loadingData: true
                });

                page = isNewArray ? 1 : currentPage + 1;
                isGet = dataRequest.method.toLowerCase() === 'get';
                query = _objectSpread$3({
                  no_of_entries: itemsCountPerPage,
                  draw: 1,
                  pgno: page
                }, sorting.field ? {
                  sort_by: sorting.field,
                  sort_type: sorting.direction || 'asc'
                } : {}, {}, isGet ? dataRequest.params : dataRequest.data);

                if (itemsCount) {
                  query = _objectSpread$3({}, query, {
                    pgno: 1,
                    no_of_entries: itemsCount
                  });
                }

                if (transformRequestParams && isFunction(transformRequestParams)) {
                  query = transformRequestParams(query, _this.state);
                }

                sortKey = query.sort_by;

                if (sortKey && !_this.props.selectedColumns.some(function (c) {
                  return _this.headerMapping[c.value] && _this.headerMapping[c.value].sortingKey === sortKey;
                })) {
                  query.sort_by = _this.defaultSorting.field;
                  query.sort_type = _this.defaultSorting.direction;

                  _this.setState({
                    sorting: _this.defaultSorting
                  });
                }

                request = _objectSpread$3({}, dataRequest, {}, isGet ? {
                  params: query
                } : {
                  data: query
                });
                _TableApiService$fetc = TableApiService.fetchData(request), promise = _TableApiService$fetc.promise, source = _TableApiService$fetc.source;
                _this.prevSourceRequest = source;
                _context.next = 19;
                return promise;

              case 19:
                _ref3 = _context.sent;
                response = _ref3.data;
                _this.prevSourceRequest = null;

                if (_this.props.onDataLoaded) {
                  _this.props.onDataLoaded(response);
                }

                data = get(response, dataPath);
                totalObj = get(response, totalPath, []);
                totalData = (Array.isArray(totalObj) ? totalObj : [totalObj]).map(function (d) {
                  var _objectSpread2;

                  return _objectSpread$3({}, d, (_objectSpread2 = {
                    total: true
                  }, defineProperty(_objectSpread2, _this.props.idField, 'Total'), defineProperty(_objectSpread2, "rowClassName", '_aggregated'), _objectSpread2));
                });
                totalItems = get(response, countPath, 0);
                newData = isNewArray ? [] : _this.state.data;

                if (isArray(data)) {
                  newData = newData.concat(data);
                }

                hasMore = totalItems !== null && totalItems > newData.length;

                if (_this._mounted) {
                  _this.setState({
                    loading: false,
                    loadingData: false,
                    showProcessLoading: false,
                    isNewArray: false,
                    data: newData,
                    currentPage: page,
                    totalItems: totalItems,
                    hasMore: hasMore,
                    totalData: Array.isArray(totalData) ? totalData : [totalData]
                  }, function () {
                    return _this.handleOnChange(!!itemsCount);
                  });
                }

                _context.next = 39;
                break;

              case 33:
                _context.prev = 33;
                _context.t0 = _context["catch"](1);

                if (!axios.isCancel(_context.t0)) {
                  _context.next = 37;
                  break;
                }

                return _context.abrupt("return");

              case 37:
                if (_this._mounted) {
                  _this.setState({
                    loading: false,
                    loadingData: false
                  });
                }

                _this.props.onFetchDataError && _this.props.onFetchDataError(_context.t0);

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 33]]);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }());
    defineProperty(assertThisInitialized(_this), "handleOnChange", function (isAllSelected) {
      var data = _this.state.data;

      if (isAllSelected) {
        _this.setState({
          selected: toConsumableArray(data)
        }, _this.onSelect);
      }

      if (_this.props.onDataChanged) {
        _this.props.onDataChanged(_this.state.data, _this.state.totalData);
      }
    });
    defineProperty(assertThisInitialized(_this), "getNewData", /*#__PURE__*/function () {
      var _ref4 = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var _ref5,
            totalCount,
            _args2 = arguments;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref5 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, totalCount = _ref5.totalCount;

                _this.setState({
                  isNewArray: true,
                  showProcessLoading: true
                }, function () {
                  return _this.getData({
                    itemsCount: totalCount
                  });
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function () {
        return _ref4.apply(this, arguments);
      };
    }());
    defineProperty(assertThisInitialized(_this), "onSelect", function () {
      _this.props.onSelect(_this.state.selected);
    });
    defineProperty(assertThisInitialized(_this), "handleTableCampaignSelection", function (value) {
      return function (isSelected) {
        var idField = _this.props.idField;
        var _this$state3 = _this.state,
            selected = _this$state3.selected,
            data = _this$state3.data;

        if (isSelected) {
          selected.push(value);

          _this.setState({
            data: data.map(function (d) {
              return _objectSpread$3({}, d);
            }),
            selected: selected.map(function (d) {
              return _objectSpread$3({}, d);
            })
          }, _this.onSelect);
        } else {
          var found = find(data, function (d) {
            return d[idField] === value[idField];
          });

          if (found) {
            delete found.rowClassName;
          }

          var index = findIndex(selected, function (d) {
            return d[idField] === value[idField];
          });

          if (index !== -1) {
            selected.splice(index, 1);
          }

          _this.setState({
            selected: selected.map(function (d) {
              return _objectSpread$3({}, d);
            }),
            data: data.map(function (d) {
              return _objectSpread$3({}, d);
            })
          }, _this.onSelect);
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "_clearSelection", function () {
      _this.setState({
        selected: []
      }, _this.onSelect);
    });
    defineProperty(assertThisInitialized(_this), "handleTableAllCampaignsSelection", function (value, isCheckedPartly) {
      return function (isSelected) {
        if (isCheckedPartly || !isCheckedPartly && !isSelected) {
          _this._clearSelection();
        } else {
          var _this$state4 = _this.state,
              data = _this$state4.data,
              totalItems = _this$state4.totalItems;

          if (data.length === +totalItems) {
            _this.setState({
              selected: toConsumableArray(data)
            }, _this.onSelect);
          } else if (+totalItems <= 100) {
            _this.getNewData({
              totalCount: +totalItems
            });
          } else {
            _this.setState({
              showDialog: true
            });
          }
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "handleSort", function (_ref6) {
      var sorting = _ref6.sorting;
      var stateSorting = _this.state.sorting;

      if (sorting.field !== stateSorting.field || sorting.direction !== stateSorting.direction) {
        _this.setState({
          sorting: sorting,
          isNewArray: true,
          selected: [],
          showProcessLoading: true
        }, function () {
          _this.getData();
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "updateName", /*#__PURE__*/function () {
      var _ref7 = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(data, value) {
        var idField, id, done, _data;

        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                idField = _this.props.idField;
                id = data[idField];
                _context3.prev = 2;
                _context3.next = 5;
                return TableApiService.updateCampaignName(id, value);

              case 5:
                done = _context3.sent;

                if (done) {
                  _data = _this.state.data;

                  _this.setState({
                    data: _data.map(function (d) {
                      return d[idField] === id ? _objectSpread$3({}, d, {
                        name: value
                      }) : _objectSpread$3({}, d);
                    })
                  });
                }

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                console.log('Error update name', _context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 9]]);
      }));

      return function (_x, _x2) {
        return _ref7.apply(this, arguments);
      };
    }());
    defineProperty(assertThisInitialized(_this), "tableRef", void 0);
    defineProperty(assertThisInitialized(_this), "clearSelected", function () {
      _this._clearSelection();
    });
    defineProperty(assertThisInitialized(_this), "handleDragEnd", function (item, _ref8) {
      var start = _ref8.start,
          end = _ref8.end;
      var _this$props2 = _this.props,
          checkbox = _this$props2.checkbox,
          selectedColumns = _this$props2.selectedColumns;
      _this.props.onColumnsChanged && _this.props.onColumnsChanged(moveItem(selectedColumns, checkbox ? Math.max(start - 1, 0) : start, checkbox && end !== null ? Math.max(end - 1, 0) : end));
    });
    defineProperty(assertThisInitialized(_this), "closeDialog", function () {
      _this.setState({
        showDialog: false
      });
    });
    _this.defaultSorting = props.defaultSorting ? props.defaultSorting : defaultSorting;
    _this.skeletonRowsNumber = 5;
    _this.state = {
      currentPage: 1,
      itemsCountPerPage: 50,
      loading: true,
      loadingData: false,
      showProcessLoading: false,
      data: [],
      totalData: [],
      selected: [],
      totalItems: null,
      sorting: _this.defaultSorting,
      hasMore: true,
      isNewArray: true,
      dataRequest: props.dataRequest,
      showDialog: false
    };

    if (props.data) {
      _this.state.data = props.data;
      _this.state.totalItems = props.totalItems;
      _this.state.loading = false;
      _this.state.isNewArray = false;

      if (_this.state.totalItems === _this.state.data.length) {
        _this.state.hasMore = false;
      }

      _this.state.currentPage = Math.ceil(_this.state.data.length / _this.state.itemsCountPerPage);
    }

    _this.getData = debounce(_this.getData, 500);
    return _this;
  }

  createClass(TableComp, [{
    key: "cancelDataRequest",
    value: function cancelDataRequest() {
      if (this.prevSourceRequest) {
        this.prevSourceRequest.cancel();
      }
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      var _this$props3 = this.props,
          loadingComponent = _this$props3.loadingComponent,
          skeleton = _this$props3.skeleton,
          _this$props3$tablePar = _this$props3.tableParams,
          tableParams = _this$props3$tablePar === void 0 ? {} : _this$props3$tablePar;
      return loadingComponent || React.createElement(Skeleton, {
        colN: skeleton.columns,
        rowN: skeleton.rows,
        classes: skeleton.classes,
        theadRowHeight: tableParams.theadRowHeight,
        tbodyRowHeight: tableParams.tbodyRowHeight
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          offsetTop = _this$props4.offsetTop,
          total = _this$props4.total,
          _this$props4$scrollPa = _this$props4.scrollParams,
          scrollParams = _this$props4$scrollPa === void 0 ? {} : _this$props4$scrollPa,
          _this$props4$tablePar = _this$props4.tableParams,
          tableParams = _this$props4$tablePar === void 0 ? {} : _this$props4$tablePar,
          innerRef = _this$props4.innerRef,
          filter = _this$props4.filter,
          idField = _this$props4.idField,
          emptyTableLabel = _this$props4.emptyTableLabel;
      var _this$state5 = this.state,
          loadingData = _this$state5.loadingData,
          data = _this$state5.data,
          loading = _this$state5.loading,
          hasMore = _this$state5.hasMore,
          totalData = _this$state5.totalData,
          selected = _this$state5.selected,
          showProcessLoading = _this$state5.showProcessLoading,
          totalItems = _this$state5.totalItems;
      var selectedIds = selected.map(function (s) {
        return s[idField];
      });
      var formattedData = data.map(function (d) {
        return selectedIds.includes(d[idField]) ? _objectSpread$3({}, d, {
          rowClassName: SELECTED_CLASS_NAME
        }) : _objectSpread$3({}, d);
      });
      var filtered = formattedData;

      if (filter) {
        filtered = filter(formattedData);
      }

      return React.createElement("div", {
        className: "table-wrapper ".concat(className, " ").concat(loading || showProcessLoading ? '_show-skeleton' : ''),
        ref: function ref() {
          _this2.tableRef = _this2;

          if (innerRef) {
            innerRef(_this2);
          }
        }
      }, !loadingData && !loading && !data.length ? React.createElement("div", {
        className: "no-data-placeholder"
      }, React.createElement(Icon, {
        name: "NoData"
      }), React.createElement("h3", {
        className: "no-data-placeholder__subtitle"
      }, emptyTableLabel || 'No Data Available')) : React.createElement(React.Fragment, null, this.renderLoading(), React.createElement(Table, _extends_1({
        header: this.header,
        body: this.body,
        server: true,
        loading: loading,
        data: filtered,
        offsetTop: offsetTop,
        rowKeyExtractor: function rowKeyExtractor(data, rowIndex) {
          return "".concat(data[idField], "_").concat(rowIndex);
        },
        infiniteScroll: true,
        fixedXScroller: true,
        InfiniteScrollComponent: _objectSpread$3({
          loadMore: this.getData,
          hasMore: hasMore,
          useWindow: false,
          initialLoad: false,
          threshold: 700
        }, scrollParams),
        skeletonRowsNumber: this.skeletonRowsNumber,
        onChange: this.handleSort,
        unsortedData: total && data.length ? totalData : null,
        draggable: true,
        onDragEnd: this.handleDragEnd,
        sorting: this.state.sorting || this.defaultSorting,
        totalItemsCount: totalItems
      }, tableParams)), createPortal(this.dialog, document.body)));
    }
  }, {
    key: "headerMapping",
    get: function get() {
      return _objectSpread$3({}, this.HeaderMapping, {}, this.props.headerMapping);
    }
  }, {
    key: "bodyMapping",
    get: function get() {
      return _objectSpread$3({}, this.BodyMapping, {}, this.props.bodyMapping);
    }
  }, {
    key: "header",
    get: function get() {
      var _this3 = this;

      var _this$props5 = this.props,
          checkbox = _this$props5.checkbox,
          selectedColumns = _this$props5.selectedColumns;
      var header = [];

      if (checkbox) {
        header.push(this.headerMapping.checkbox);
      }

      selectedColumns.map(function (option) {
        return option.value;
      }).forEach(function (value) {
        var map = _this3.headerMapping[value];

        if (map) {
          header.push(map);
        }
      });
      return header;
    }
  }, {
    key: "body",
    get: function get() {
      var _this4 = this;

      var _this$props6 = this.props,
          checkbox = _this$props6.checkbox,
          selectedColumns = _this$props6.selectedColumns;
      var body = [];

      if (checkbox) {
        body.push(this.bodyMapping.checkbox);
      }

      selectedColumns.map(function (option) {
        return option.value;
      }).forEach(function (value) {
        var map = _this4.bodyMapping[value];

        if (map) {
          body.push(map);
        }
      });
      return body;
    }
  }, {
    key: "dialog",
    get: function get() {
      var _this5 = this;

      var _this$state6 = this.state,
          showDialog = _this$state6.showDialog,
          totalItems = _this$state6.totalItems;
      return React.createElement(Dialog, {
        open: showDialog,
        onClickOutside: this.closeDialog
      }, React.createElement(LoadAllDialogContent, {
        campaignCount: +totalItems,
        onClose: this.closeDialog,
        onLoad: function onLoad() {
          _this5.getNewData({
            totalCount: +totalItems
          });

          _this5.closeDialog();
        }
      }));
    }
  }]);
  return TableComp;
}(React.Component);

var TableComponent = function TableComponent(props) {
  return React.createElement(TableWithOptionsContext.Consumer, null, function (value) {
    return React.createElement(TableComp, _extends_1({}, props, value));
  });
};

TableComponent.defaultProps = {
  headerMapping: {},
  bodyMapping: {},
  className: '',
  offsetTop: 70,
  checkbox: true,
  dataPath: 'data',
  totalPath: 'total',
  countPath: 'recordsFiltered',
  onSelect: function onSelect() {},
  total: true,
  skeleton: {
    columns: 10,
    rows: 10,
    classes: []
  },
  idField: 'campaign_id'
};
var props$1 = {
  className: PropTypes.string,
  headerMapping: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  })),
  bodyMapping: PropTypes.objectOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  })),
  offsetTop: PropTypes.number,
  checkbox: PropTypes.bool,
  data: PropTypes.array,
  selectedColumns: PropTypes.array,
  emptyTableLabel: PropTypes.string,
  dataPath: PropTypes.string,
  totalPath: PropTypes.string,
  totalItems: PropTypes.number,
  countPath: PropTypes.string,
  onSelect: PropTypes.func,
  total: PropTypes.bool,
  scrollParams: PropTypes.object,
  defaultSorting: PropTypes.object,
  tableParams: PropTypes.object,
  innerRef: PropTypes.func,
  filter: PropTypes.func,
  onColumnsChanged: PropTypes.func,
  onDataChanged: PropTypes.func,
  onDataLoaded: PropTypes.func,
  onFetchDataError: PropTypes.func,
  onLoading: PropTypes.func,
  onDataLoading: PropTypes.func,
  skeleton: PropTypes.shape({
    columns: PropTypes.number,
    rows: PropTypes.number,
    classes: PropTypes.array
  }),
  loadingComponent: PropTypes.element,
  dataRequest: PropTypes.object,
  transformRequestParams: PropTypes.func,
  idField: PropTypes.string
};
TableComp.propTypes = props$1;
TableComponent.propTypes = props$1;

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var CSV_PAGE_URL = '#/download-csv';
var XLS_PAGE_URL = '#/download-xlsx';

var getColumns = function getColumns(value, mapper) {
  return value.map(function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    var obj = {
      value: value
    };
    var map = mapper[value];

    if (map) {
      obj = map;
    }

    return _objectSpread$4({
      label: label
    }, obj);
  });
};

function withDownloadHandler(Wrapper, url) {
  var WithDownload = /*#__PURE__*/function (_React$Component) {
    inherits(WithDownload, _React$Component);

    function WithDownload() {
      var _getPrototypeOf2;

      var _this;

      classCallCheck(this, WithDownload);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(WithDownload)).call.apply(_getPrototypeOf2, [this].concat(args)));
      defineProperty(assertThisInitialized(_this), "state", {
        loading: false
      });
      defineProperty(assertThisInitialized(_this), "handleDownload", /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _this$context, selectedColumns, csvDownloadRequest, transformCSVDownloadRequest, mapper, columns, baseCSVRequestParams, params, base64;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$context = _this.context, selectedColumns = _this$context.selectedColumns, csvDownloadRequest = _this$context.csvDownloadRequest, transformCSVDownloadRequest = _this$context.transformCSVDownloadRequest;
                mapper = _objectSpread$4({}, _this.props.columnsMapper);
                columns = getColumns(selectedColumns, mapper);
                baseCSVRequestParams = transformCSVDownloadRequest ? transformCSVDownloadRequest(csvDownloadRequest) : csvDownloadRequest;
                params = {
                  request: _objectSpread$4({}, baseCSVRequestParams, {
                    columns: columns
                  }),
                  component: {
                    fileName: _this.props.fileName
                  }
                }; // base64 doesn't work with unicode symbols, line below remove all unicode

                base64 = btoa(JSON.stringify(params).replace(/[\u00A0-\u2666]/g, ''));
                window.open("".concat(url, "?params=").concat(base64), '_blank');

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
      return _this;
    }

    createClass(WithDownload, [{
      key: "render",
      value: function render() {
        return React.createElement(Wrapper, {
          loading: this.state.loading,
          handleDownload: this.handleDownload
        });
      }
    }]);
    return WithDownload;
  }(React.Component);

  defineProperty(WithDownload, "contextType", TableWithOptionsContext);
  return WithDownload;
}

var TableCsv = /*#__PURE__*/function (_React$Component2) {
  inherits(TableCsv, _React$Component2);

  function TableCsv() {
    classCallCheck(this, TableCsv);
    return possibleConstructorReturn(this, getPrototypeOf(TableCsv).apply(this, arguments));
  }

  createClass(TableCsv, [{
    key: "render",
    value: function render() {
      return React.createElement(ButtonCircle, {
        iconName: "CSV",
        disabled: this.props.loading,
        className: "_size-20 _outline",
        onClick: this.props.handleDownload
      });
    }
  }]);
  return TableCsv;
}(React.Component);

var TableDownloadCsvButton = withDownloadHandler(TableCsv, CSV_PAGE_URL);

var TableXlsx = /*#__PURE__*/function (_React$Component3) {
  inherits(TableXlsx, _React$Component3);

  function TableXlsx() {
    classCallCheck(this, TableXlsx);
    return possibleConstructorReturn(this, getPrototypeOf(TableXlsx).apply(this, arguments));
  }

  createClass(TableXlsx, [{
    key: "render",
    value: function render() {
      return React.createElement(ButtonCircle, {
        iconName: "XLS",
        disabled: this.props.loading,
        className: "_size-20 _outline",
        onClick: this.props.handleDownload
      });
    }
  }]);
  return TableXlsx;
}(React.Component);

var TableDownloadXlsxButton = withDownloadHandler(TableXlsx, XLS_PAGE_URL);
TableDownloadCsvButton.defaultProps = {
  columnsMapper: {}
};
TableDownloadCsvButton.propTypes = {
  columnsMapper: PropTypes.objectOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    format: PropTypes.oneOf(['date'])
  })),
  fileName: PropTypes.string
};

var Timezones = function Timezones() {
  var _this = this;

  classCallCheck(this, Timezones);
  defineProperty(this, "fetchingTimezones", null);
  defineProperty(this, "getState", /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var state;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_this.state) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", _this.state);

          case 2:
            if (!_this.fetchingTimezones) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return _this.fetchingTimezones;

          case 5:
            _this.state = _context.sent;
            _context.next = 13;
            break;

          case 8:
            _this.fetchingTimezones = ApiService.fetchTimezones();
            _context.next = 11;
            return _this.fetchingTimezones;

          case 11:
            state = _context.sent;
            _this.state = state;

          case 13:
            return _context.abrupt("return", _this.state);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
};

var TimezonesService = new Timezones();
var TimezoneContext = React.createContext({
  timezone: null,
  onTimezoneChange: null,
  isChangedByTimezonePicker: true
});

var TimezoneProvider = /*#__PURE__*/function (_React$Component) {
  inherits(TimezoneProvider, _React$Component);

  function TimezoneProvider(props) {
    var _this;

    classCallCheck(this, TimezoneProvider);
    _this = possibleConstructorReturn(this, getPrototypeOf(TimezoneProvider).call(this, props));
    defineProperty(assertThisInitialized(_this), "updateTimezone", function (activeTimezone) {
      _this.setState({
        activeTimezone: activeTimezone,
        isChangedByTimezonePicker: true
      });
    });
    var user = AuthService.getUser();
    _this.state = {
      activeTimezone: props.timezone,
      isChangedByTimezonePicker: true
    };

    if (!_this.state.activeTimezone) {
      _this.state.activeTimezone = user && user.timezoneName ? {
        value: user.timezoneName,
        id: user.timezoneId
      } : {
        value: moment$1.tz.guess(),
        label: moment$1.tz.guess()
      };
    }

    return _this;
  }

  createClass(TimezoneProvider, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _ref, defaultUserTimezone;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return TimezonesService.getState();

              case 2:
                _ref = _context.sent;
                defaultUserTimezone = _ref.defaultUserTimezone;

                if (!this.state.activeTimezone || this.state.activeTimezone.value === defaultUserTimezone.value) {
                  this.setState({
                    activeTimezone: defaultUserTimezone
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(oldProps, oldState) {
        var _ref2, defaultUserTimezone;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(oldProps.timezone !== this.props.timezone && this.props.timezone !== this.state.activeTimezone)) {
                  _context2.next = 4;
                  break;
                }

                this.setState({
                  activeTimezone: this.props.timezone,
                  isChangedByTimezonePicker: false
                });
                _context2.next = 10;
                break;

              case 4:
                if (this.props.timezone) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 7;
                return TimezonesService.getState();

              case 7:
                _ref2 = _context2.sent;
                defaultUserTimezone = _ref2.defaultUserTimezone;

                if (!isEqual(this.state.activeTimezone, defaultUserTimezone)) {
                  this.setState({
                    activeTimezone: defaultUserTimezone,
                    isChangedByTimezonePicker: true
                  });
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x, _x2) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      return React.createElement(TimezoneContext.Provider, {
        value: {
          isChangedByTimezonePicker: this.state.isChangedByTimezonePicker,
          timezone: this.state.activeTimezone,
          onTimezoneChange: this.updateTimezone
        }
      }, this.props.children);
    }
  }]);
  return TimezoneProvider;
}(React.Component);

TimezoneProvider.propTypes = {
  timezone: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};
var css$7 = ".timezone-picker__option {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none; }\n  .timezone-picker__option:focus {\n    outline: none; }\n\n.timezone-picker {\n  position: relative;\n  width: auto;\n  min-width: 7.5rem;\n  height: 2.25rem;\n  background: #fff; }\n  .timezone-picker._opened {\n    width: auto; }\n  .timezone-picker:not(._opened) .timezone-picker__icon {\n    margin-right: 0.5rem;\n    flex-shrink: 0; }\n  .timezone-picker__wrapper {\n    border-radius: .25rem;\n    transition: box-shadow .25s, border .25s;\n    border: 1px solid transparent; }\n    .timezone-picker__wrapper:hover {\n      border: 1px solid #6075ff;\n      box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n  .timezone-picker._opened .timezone-picker__wrapper {\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53);\n    border: 1px solid #6075ff; }\n  .timezone-picker__title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    direction: rtl; }\n  .timezone-picker__btn {\n    display: flex;\n    align-items: center;\n    padding: 0 0.6875rem;\n    height: 2.125rem;\n    border: 0.0625rem solid transparent;\n    cursor: pointer;\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.25em;\n    color: #a2a2a2; }\n  .timezone-picker._opened .timezone-picker__btn {\n    color: #6075ff; }\n  .timezone-picker:not(._opened) .timezone-picker__btn {\n    justify-content: flex-end;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400; }\n  .timezone-picker__list-wrapper {\n    display: none;\n    max-height: 250px;\n    border: none;\n    border-radius: .25rem;\n    background: #fff;\n    transition: box-shadow .25s; }\n  .timezone-picker._opened .timezone-picker__list-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch; }\n  .timezone-picker__search {\n    flex: 0 0 auto; }\n  .timezone-picker__list {\n    flex: 1 1 auto;\n    display: block;\n    overflow: auto; }\n  .timezone-picker__option {\n    display: block;\n    padding: 0 0.6875rem;\n    width: 100%;\n    height: 1.75rem;\n    cursor: pointer;\n    font-family: 'Lato Light', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.75rem;\n    color: #000000;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n    .timezone-picker__option:hover {\n      background-color: #f2f5ff; }\n    .timezone-picker__option._active {\n      background-color: #dfe4ff; }\n  .timezone-picker__label {\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: -0.4375rem;\n    left: 0.375rem;\n    padding: 0 0.125rem;\n    max-width: calc(100% - 31rem/16);\n    background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0, #fff 0.125rem, #fff calc(100% - 2rem/16), rgba(255, 255, 255, 0.001));\n    overflow: hidden;\n    transition: opacity .25s, color .25s;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: .75rem;\n    line-height: 1.21429em;\n    color: #a2a2a2;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .timezone-picker__label:before {\n      content: '';\n      position: absolute;\n      z-index: -1;\n      top: 0.375rem;\n      left: 0.125rem;\n      right: 0.125rem;\n      height: 0.125rem;\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 0.001) 0, #fff 100%); }\n    .timezone-picker__label:after {\n      content: '';\n      position: absolute;\n      z-index: -1;\n      top: 0.5rem;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0, #fff 0.125rem, #fff calc(100% - 2rem/16), rgba(255, 255, 255, 0.001)); }\n  .timezone-picker:hover .timezone-picker__label,\n  .timezone-picker._opened .timezone-picker__label {\n    opacity: 1;\n    color: #6075ff; }\n  .timezone-picker__search {\n    padding: 0.25rem 0.6875rem; }\n";
styleInject(css$7);

var BtnWrapper = function BtnWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      tooltipParams = _ref.tooltipParams;
  return tooltipParams ? React.createElement(Tooltip, _extends_1({
    className: className
  }, tooltipParams), children) : React.createElement("div", {
    className: className
  }, children);
};

var TimezonePicker = /*#__PURE__*/function (_React$Component) {
  inherits(TimezonePicker, _React$Component);

  function TimezonePicker() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TimezonePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TimezonePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      isOpen: false,
      defaultUserTimezone: null,
      timezoneOptions: [],
      selectedTimezone: _this.context.timezone,
      search: ''
    });
    defineProperty(assertThisInitialized(_this), "toggleDropdown", function (_ref2) {
      var target = _ref2.target;

      if (target === _this.searchEl || _this.searchEl.contains(target)) {
        return;
      }

      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });
    defineProperty(assertThisInitialized(_this), "handleClickOutside", function () {
      if (_this.state.isOpen) {
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "onChange", function (value) {
      return function () {
        var timezoneOptions = _this.state.timezoneOptions;
        var timezoneOption = timezoneOptions.filter(function (i) {
          return i.value === value;
        })[0];

        if (_this.context.onTimezoneChange) {
          _this.context.onTimezoneChange(timezoneOption);
        }

        if (_this.props.onTimezoneChange) {
          _this.props.onTimezoneChange(timezoneOption);
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "onSearchChange", function (_ref3) {
      var target = _ref3.target;

      _this.setState({
        search: target.value
      });
    });
    return _this;
  }

  createClass(TimezonePicker, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, newState) {
      return newState.isOpen !== this.state.isOpen || newState.timezoneOptions !== this.state.timezoneOptions || newState.selectedTimezone !== this.state.selectedTimezone || newProps.selectedTimezone !== this.props.selectedTimezone || newState.search !== this.state.search;
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _ref4, defaultUserTimezone, timezoneOptions, newState;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return TimezonesService.getState();

              case 2:
                _ref4 = _context.sent;
                defaultUserTimezone = _ref4.defaultUserTimezone;
                timezoneOptions = _ref4.timezoneOptions;
                newState = {
                  timezoneOptions: timezoneOptions,
                  defaultUserTimezone: defaultUserTimezone
                };

                if (!this.state.selectedTimezone || this.state.selectedTimezone.value === defaultUserTimezone.value) {
                  newState.selectedTimezone = defaultUserTimezone;

                  if (this.context.onTimezoneChange) {
                    this.context.onTimezoneChange(defaultUserTimezone);
                  }

                  if (this.props.onTimezoneChange) {
                    this.props.onTimezoneChange(defaultUserTimezone);
                  }
                }

                this.setState(newState);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          placeholder = _this$props.placeholder,
          label = _this$props.label,
          tooltipParams = _this$props.tooltipParams;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          search = _this$state.search;
      var timezoneOptions = this.state.timezoneOptions;
      var selectedTimezone = this.context.timezone || this.props.selectedTimezone;
      var selectedTimezoneValue = get(selectedTimezone, 'value');
      var selectedTimezoneLabel = get(selectedTimezone, 'label');
      var timezoneOptionButtons;

      if (timezoneOptions) {
        if (search) {
          timezoneOptions = timezoneOptions.filter(function (i) {
            return new RegExp("".concat(search), 'i').test(i.label);
          });
        }

        timezoneOptionButtons = timezoneOptions.map(function (timezoneOption) {
          return React.createElement("button", {
            className: "timezone-picker__option ".concat(timezoneOption.value === selectedTimezoneValue ? '_active' : ''),
            key: timezoneOption.value,
            onClick: _this2.onChange(timezoneOption.value)
          }, timezoneOption.label);
        });
      }

      return React.createElement("div", {
        className: "timezone-picker ".concat(isOpen ? '_opened' : '', " ").concat(className || ''),
        onClick: this.toggleDropdown
      }, React.createElement("div", {
        className: "timezone-picker__label"
      }, label || 'Timezone'), React.createElement("div", {
        className: "timezone-picker__wrapper"
      }, React.createElement(BtnWrapper, {
        className: "timezone-picker__btn",
        tooltipParams: tooltipParams
      }, !isOpen && React.createElement(Icon, {
        className: "_size-20 timezone-picker__icon",
        fill: "#a2a2a2",
        name: "Globe"
      }), React.createElement("span", {
        className: "timezone-picker__title"
      }, selectedTimezoneLabel || placeholder || 'Select...')), React.createElement("div", {
        className: "timezone-picker__list-wrapper"
      }, React.createElement("div", {
        ref: function ref(el) {
          _this2.searchEl = el;
        },
        className: "timezone-picker__search"
      }, React.createElement(TextFieldWithIcon, {
        iconName: "Search",
        value: search,
        onChange: this.onSearchChange
      })), React.createElement("div", {
        className: "timezone-picker__list"
      }, timezoneOptionButtons))));
    }
  }]);
  return TimezonePicker;
}(React.Component);

defineProperty(TimezonePicker, "contextType", TimezoneContext);
var TimezonePicker$1 = withClickOutside(TimezonePicker);
BtnWrapper.propTypes = {
  className: PropTypes.string,
  tooltipParams: PropTypes.object
};
TimezonePicker.propTypes = {
  selectedTimezone: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  onTimezoneChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  tooltipParams: PropTypes.object
};

var _PRESELECTED_VALUES;

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getTimezoneCurrentDay = function getTimezoneCurrentDay(timezone) {
  return moment$1.tz(moment$1().utc(), 'UTC').tz(timezone);
};

var convertTimezoneDayToOSTimezone = function convertTimezoneDayToOSTimezone(date) {
  return moment$1.tz(date.format('YYYY-MM-DD HH:mm:ss'), moment$1.tz.guess());
};

var PRESELECT_KEYS = {
  TODAY: 'TODAY',
  YESTERDAY: 'YESTERDAY',
  LAST_WEEK: 'LAST_WEEK',
  LAST_MONTH: 'LAST_MONTH',
  LAST_THREE_MONTHS: 'LAST_THREE_MONTHS'
};
var PRESELECTED_VALUES = (_PRESELECTED_VALUES = {}, defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.TODAY, {
  key: PRESELECT_KEYS.TODAY,
  title: 'Today',
  start: function start(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day'));
  },
  end: function end(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
  }
}), defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.YESTERDAY, {
  key: PRESELECT_KEYS.YESTERDAY,
  title: 'Yesterday',
  start: function start(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-1, 'day'));
  },
  end: function end(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day').add(-1, 'day'));
  }
}), defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.LAST_WEEK, {
  key: PRESELECT_KEYS.LAST_WEEK,
  title: 'Week',
  start: function start(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-1, 'week'));
  },
  end: function end(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
  }
}), defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.LAST_MONTH, {
  key: PRESELECT_KEYS.LAST_MONTH,
  title: 'Month',
  start: function start(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-1, 'month'));
  },
  end: function end(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
  }
}), defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.LAST_THREE_MONTHS, {
  key: PRESELECT_KEYS.LAST_THREE_MONTHS,
  title: '3 Months',
  start: function start(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-3, 'month'));
  },
  end: function end(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
  }
}), _PRESELECTED_VALUES);

var EpochDateRangePicker = /*#__PURE__*/function (_React$Component) {
  inherits(EpochDateRangePicker, _React$Component);

  function EpochDateRangePicker() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, EpochDateRangePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(EpochDateRangePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {});
    defineProperty(assertThisInitialized(_this), "getActiveTimezone", function () {
      return _this.context.timezone || _this.state.activeTimezone;
    });
    defineProperty(assertThisInitialized(_this), "getCalendarMaximaAndMinima", function (timezone) {
      var activeTimezone = timezone || _this.getActiveTimezone();

      var activeTimezoneCurrentDate = moment$1.tz(moment$1().utc(), 'UTC').tz(activeTimezone.value);
      var activeTimezoneStartDate = activeTimezoneCurrentDate.clone().add(-1, 'year').startOf('day');
      var activeTimezoneEndDate = activeTimezoneCurrentDate.clone().endOf('day');
      var calendarMinimumDate = moment$1.tz(activeTimezoneStartDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      var calendarMaximumDate = moment$1.tz(activeTimezoneEndDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      return {
        calendarMinimumDate: calendarMinimumDate.toDate(),
        calendarMaximumDate: calendarMaximumDate.toDate()
      };
    });
    defineProperty(assertThisInitialized(_this), "getDateRangeState", function (props, activeTimezone) {
      var recievedThruPropsEpochDateRange = props.dateRange;
      var calendarStartDate;
      var calendarEndDate;
      var activeTimezoneStartDate;
      var activeTimezoneEndDate;

      if (!recievedThruPropsEpochDateRange) {
        if (props.defaultDateRange) {
          calendarStartDate = props.defaultDateRange.getStartDate(activeTimezone.value);
          calendarEndDate = props.defaultDateRange.getEndDate(activeTimezone.value);
        } else {
          throw new Error('A default date range getter [defaultDateRange] is required when no a date range is passed');
        }

        activeTimezoneStartDate = moment$1.tz(calendarStartDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        activeTimezoneEndDate = moment$1.tz(calendarEndDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
      } else {
        activeTimezoneStartDate = moment$1.tz(recievedThruPropsEpochDateRange.startDate, activeTimezone.value);
        activeTimezoneEndDate = moment$1.tz(recievedThruPropsEpochDateRange.endDate, activeTimezone.value);
        calendarStartDate = moment$1.tz(activeTimezoneStartDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
        calendarEndDate = moment$1.tz(activeTimezoneEndDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      }

      return {
        epochDateRange: {
          startDate: activeTimezoneStartDate.valueOf(),
          endDate: activeTimezoneEndDate.valueOf()
        },
        calendarDateRange: {
          start: calendarStartDate.startOf('day').toDate(),
          end: calendarEndDate.endOf('day').toDate()
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "getInitialState", function (props) {
      var activeTimezone = _this.context.timezone;
      return _objectSpread$5({
        activeTimezone: activeTimezone,
        preselectKey: null
      }, _this.getCalendarMaximaAndMinima(activeTimezone), {}, _this.getDateRangeState(props, activeTimezone));
    });
    defineProperty(assertThisInitialized(_this), "updateEpochForNewTimezone", function (activeTimezone) {
      var newState = _this.getCalendarMaximaAndMinima(activeTimezone);

      newState.activeTimezone = activeTimezone;

      if (_this.state.preselectKey) {
        Object.assign(newState, _this.getPreselectedDateRanges(_this.state.preselectKey, activeTimezone));
      } else {
        var calendarStartDate = moment$1.tz(_this.state.calendarDateRange.start, moment$1.tz.guess());
        var calendarEndDate = moment$1.tz(_this.state.calendarDateRange.end, moment$1.tz.guess());
        var activeTimezoneStartDate = moment$1.tz(calendarStartDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        var activeTimezoneEndDate = moment$1.tz(calendarEndDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        var epochStartDate = activeTimezoneStartDate.valueOf();
        var epochEndDate = activeTimezoneEndDate.valueOf();

        if (_this.sameDay(_this.state.calendarMaximumDate, _this.state.calendarDateRange.end) && !_this.sameDay(_this.state.calendarMaximumDate, newState.calendarMaximumDate)) {
          if (calendarEndDate.isAfter(moment$1(newState.calendarMaximumDate))) {
            calendarStartDate.add(-1, 'day');
            calendarEndDate.add(-1, 'day');
            epochStartDate = activeTimezoneStartDate.clone().add(-1, 'day').valueOf();
            epochEndDate = activeTimezoneEndDate.clone().add(-1, 'day').valueOf();
          } else {
            calendarStartDate.add(1, 'day');
            calendarEndDate.add(1, 'day');
            epochStartDate = activeTimezoneStartDate.clone().add(1, 'day').valueOf();
            epochEndDate = activeTimezoneEndDate.clone().add(1, 'day').valueOf();
          }
        }

        Object.assign(newState, {
          epochDateRange: {
            startDate: epochStartDate,
            endDate: epochEndDate
          },
          calendarDateRange: {
            start: calendarStartDate.toDate(),
            end: calendarEndDate.toDate()
          }
        });
      }

      _this.setState(newState);
    });
    defineProperty(assertThisInitialized(_this), "sameDay", function (d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    });
    defineProperty(assertThisInitialized(_this), "getPreselectedDateRanges", function (preselectKey, activeTimezone) {
      var preselect = _this.props.preselected.find(function (preselect) {
        return isObject(preselect) ? preselectKey === preselect.key : preselectKey === preselect;
      });

      if (!isObject(preselect)) {
        preselect = PRESELECTED_VALUES[preselect];
      }

      if (!preselect) {
        throw new Error('Cannot get a preselect object.');
      }

      var calendarStartDate = preselect.start(activeTimezone.value);
      var calendarEndDate = preselect.end(activeTimezone.value);
      var activeTimezoneStartDate = moment$1.tz(calendarStartDate.format(FULL_DAY_FORMAT), activeTimezone.value);
      var activeTimezoneEndDate = moment$1.tz(calendarEndDate.format(FULL_DAY_FORMAT), activeTimezone.value);
      var epochStartDate = activeTimezoneStartDate.valueOf();
      var epochEndDate = activeTimezoneEndDate.valueOf();
      return {
        epochDateRange: {
          startDate: epochStartDate,
          endDate: epochEndDate
        },
        calendarDateRange: {
          start: calendarStartDate.toDate(),
          end: calendarEndDate.toDate()
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "updateDateRange", function (startDate, endDate, preselectKey) {
      var activeTimezone = _this.getActiveTimezone();

      if (!moment$1.isMoment(startDate)) {
        startDate = moment$1(startDate);
      }

      if (!moment$1.isMoment(endDate)) {
        endDate = moment$1(endDate);
      }

      startDate = startDate.startOf('day');
      endDate = endDate.endOf('day');
      var stateUpdater = {
        preselectKey: preselectKey
      };

      if (preselectKey) {
        Object.assign(stateUpdater, _this.getPreselectedDateRanges(preselectKey, activeTimezone));
      } else {
        var activeTimezoneStartDate = moment$1.tz(startDate.format(FULL_DAY_FORMAT), activeTimezone.value);
        var activeTimezoneEndDate = moment$1.tz(endDate.format(FULL_DAY_FORMAT), activeTimezone.value);
        var epochStartDate = activeTimezoneStartDate.valueOf();
        var epochEndDate = activeTimezoneEndDate.valueOf();
        Object.assign(stateUpdater, {
          epochDateRange: {
            startDate: epochStartDate,
            endDate: epochEndDate
          },
          calendarDateRange: {
            start: startDate.toDate(),
            end: endDate.toDate()
          }
        });
      }

      _this.setState(stateUpdater);
    });
    defineProperty(assertThisInitialized(_this), "getPreselect", function (timezone) {
      var currentTimezone = timezone || _this.getActiveTimezone();

      return currentTimezone && _this.props.preselected.map(function (preselect) {
        if (!isObject(preselect)) {
          preselect = PRESELECTED_VALUES[preselect];
        }

        if (!preselect) {
          throw new Error('Cannot get a preselect object.');
        }

        var calendarStartDate = preselect.start(currentTimezone.value);
        var calendarEndDate = preselect.end(currentTimezone.value);
        return _objectSpread$5({}, preselect, {
          start: calendarStartDate.toDate(),
          end: calendarEndDate.toDate()
        });
      });
    });
    return _this;
  }

  createClass(EpochDateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState(this.getInitialState(this.props));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps, oldState) {
      if (this.context.timezone && this.context.timezone !== this.state.activeTimezone) {
        if (this.props.dateRange && !isEqual(this.props.dateRange, this.state.epochDateRange)) {
          return this.setState(this.getInitialState(this.props));
        }

        return this.state.activeTimezone && this.context.isChangedByTimezonePicker ? this.updateEpochForNewTimezone(this.context.timezone) : this.setState(this.getInitialState(this.props));
      }

      if (this.props.dateRange) {
        if (this.state.epochDateRange) {
          if (!isEqual(this.props.dateRange, oldProps.dateRange) && !isEqual(this.props.dateRange, this.state.epochDateRange)) {
            return this.setState(this.getInitialState(this.props));
          }
        } else {
          return this.setState(this.getInitialState(this.props));
        }
      } else {
        if (!this.state.epochDateRange || oldProps.dateRange) {
          return this.setState(this.getInitialState(this.props));
        }
      }

      if (!this.props.dateRange || !oldState.epochDateRange && this.state.epochDateRange || !isEqual(oldState.epochDateRange, this.state.epochDateRange)) {
        this.props.onDateRangeChange(this.state.epochDateRange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var datePickerProps = _objectSpread$5({
        maximumDate: this.state.calendarMaximumDate,
        minimumDate: this.state.calendarMinimumDate
      }, this.props.datePickerProps);

      return React.createElement(DatesPicker, _extends_1({}, this.props, {
        datePickerProps: datePickerProps,
        updateDateRange: this.updateDateRange,
        dateRange: this.state.calendarDateRange || this.props.dateRange,
        insidePreselectors: true,
        preselected: this.getPreselect()
      }));
    }
  }]);
  return EpochDateRangePicker;
}(React.Component);

defineProperty(EpochDateRangePicker, "contextType", TimezoneContext);
defineProperty(EpochDateRangePicker, "PRESELECT_KEYS", PRESELECT_KEYS);
EpochDateRangePicker.propTypes = {
  dateRange: PropTypes.object,
  datePickerProps: PropTypes.object,
  preselected: PropTypes.array,
  onDateRangeChange: PropTypes.func,
  label: PropTypes.string
};

function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$6(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$6(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var ERROR_MESSAGE = 'End time must be at least 15 min in the future and was corrected.';

var EpochDatePicker = /*#__PURE__*/function (_React$Component) {
  inherits(EpochDatePicker, _React$Component);

  function EpochDatePicker() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, EpochDatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(EpochDatePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {});
    defineProperty(assertThisInitialized(_this), "getSingleDateState", function (props, activeTimezone) {
      var recievedThruPropsEpochDate = props.singleDate;
      var calendarDate;
      var activeTimezoneDate;

      if (!recievedThruPropsEpochDate) {
        if (props.defaultDate) {
          calendarDate = props.defaultDate(activeTimezone.value);
          activeTimezoneDate = moment$1.tz(calendarDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        }
      } else {
        activeTimezoneDate = moment$1.tz(recievedThruPropsEpochDate, activeTimezone.value);
        calendarDate = moment$1.tz(activeTimezoneDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      }

      return _objectSpread$6({
        calendarDate: calendarDate && calendarDate.toDate(),
        epochDate: activeTimezoneDate && activeTimezoneDate.valueOf()
      }, _this.getCalendarMaximaAndMinima(activeTimezone));
    });
    defineProperty(assertThisInitialized(_this), "getCalendarMaximaAndMinima", function (timezone, shouldConvertDates) {
      var activeTimezone = timezone || _this.context.timezone;
      var calendarMinimumDate;
      var calendarMaximumDate;

      if (_this.props.calendarMinimumDate) {
        if (_this.props.calendarMinimumDate instanceof Date && !shouldConvertDates) {
          calendarMinimumDate = _this.props.calendarMinimumDate;
        } else {
          var activeTimezoneMinimumDate = moment$1.tz(moment$1(_this.props.calendarMinimumDate), 'UTC').tz(activeTimezone.value);
          calendarMinimumDate = moment$1.tz(activeTimezoneMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
        }
      }

      if (_this.props.calendarMaximumDate) {
        if (_this.props.calendarMaximumDate instanceof Date && !shouldConvertDates) {
          calendarMaximumDate = _this.props.calendarMaximumDate;
        } else {
          var activeTimezoneMaximumDate = moment$1.tz(moment$1(_this.props.calendarMaximumDate), 'UTC').tz(activeTimezone.value);
          calendarMaximumDate = moment$1.tz(activeTimezoneMaximumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
        }
      }

      return {
        calendarMinimumDate: calendarMinimumDate,
        calendarMaximumDate: calendarMaximumDate
      };
    });
    defineProperty(assertThisInitialized(_this), "sameDay", function (d1, d2) {
      if (!d1 || !d2) return false;
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    });
    defineProperty(assertThisInitialized(_this), "getInitialState", function (props) {
      var activeTimezone = _this.context.timezone;
      return _objectSpread$6({
        activeTimezone: activeTimezone
      }, _this.getSingleDateState(props, activeTimezone));
    });
    defineProperty(assertThisInitialized(_this), "updateEpochForNewTimezone", function (activeTimezone) {
      if (!_this.state.calendarDate) {
        return;
      }

      var newState = _this.getCalendarMaximaAndMinima(activeTimezone, true);

      var calendarDate = moment$1.tz(_this.state.calendarDate, moment$1.tz.guess());
      var selectedTimezoneDate = moment$1.tz(calendarDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
      var epochDate = selectedTimezoneDate.valueOf(); // old calendarMaximumDate and new calendarMaximumDate is different

      if (!_this.sameDay(_this.state.calendarMaximumDate, newState.calendarMaximumDate) // the calendar date date is the same as calendarMinimumDate or calendarMaximumDate
      && (_this.sameDay(_this.state.calendarMinimumDate, _this.state.calendarDate) || _this.sameDay(_this.state.calendarMaximumDate, _this.state.calendarDate))) {
        if (calendarDate.isAfter(moment$1(newState.calendarMaximumDate))) {
          if (newState.calendarMaximumDate) {
            calendarDate.add(-1, 'day');
            epochDate = selectedTimezoneDate.clone().add(-1, 'day').valueOf();
            _this.props.onError && _this.props.onError(ERROR_MESSAGE);
          }
        } else if (calendarDate.isBefore(moment$1(newState.calendarMinimumDate))) {
          calendarDate.add(1, 'day');
          epochDate = selectedTimezoneDate.clone().add(1, 'day').valueOf();
          _this.props.onError && _this.props.onError(ERROR_MESSAGE);
        }
      }

      newState.activeTimezone = activeTimezone;
      newState.epochDate = epochDate;
      newState.calendarDate = calendarDate.toDate();

      _this.setState(newState);
    });
    defineProperty(assertThisInitialized(_this), "updateDateRange", function (updatedDate) {
      if (!moment$1.isMoment(updatedDate)) {
        updatedDate = moment$1(updatedDate);
      }

      if (_this.state.calendarMaximumDate) {
        if (updatedDate.isAfter(_this.state.calendarMaximumDate)) {
          _this.props.onError && _this.props.onError(ERROR_MESSAGE);
          var _activeTimezone = _this.context.timezone;
          var calendarDate = moment$1(_this.state.calendarMaximumDate);

          var _activeTimezoneDate = moment$1.tz(calendarDate.format(FULL_DAY_FORMAT), _activeTimezone.value);

          var _epochDate = _activeTimezoneDate.valueOf();

          return _this.setState({
            epochDate: _epochDate,
            calendarDate: _this.state.calendarMaximumDate
          });
        }
      }

      if (_this.state.calendarMinimumDate) {
        if (updatedDate.isBefore(_this.state.calendarMinimumDate)) {
          _this.props.onError && _this.props.onError(ERROR_MESSAGE);
          var _activeTimezone2 = _this.context.timezone;

          var _calendarDate = moment$1(_this.state.calendarMinimumDate);

          var _activeTimezoneDate2 = moment$1.tz(_calendarDate.format(FULL_DAY_FORMAT), _activeTimezone2.value);

          var _epochDate2 = _activeTimezoneDate2.valueOf();

          return _this.setState({
            epochDate: _epochDate2,
            calendarDate: _this.state.calendarMinimumDate
          });
        }
      }

      var activeTimezone = _this.context.timezone;
      var activeTimezoneDate = moment$1.tz(updatedDate.format(FULL_DAY_FORMAT), activeTimezone.value);
      var epochDate = activeTimezoneDate.valueOf();

      _this.setState({
        epochDate: epochDate,
        calendarDate: updatedDate.toDate()
      });
    });
    return _this;
  }

  createClass(EpochDatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!(this.props.defaultDate && this.props.singleDate)) {
        if (this.props.calendarMaximumDate || this.props.calendarMinimumDate) {
          this.setState(this.getCalendarMaximaAndMinima(this.context.timezone));
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps, oldState) {
      if (this.context.timezone && (!this.state.activeTimezone || this.context.timezone.value !== this.state.activeTimezone.value)) {
        if (this.state.activeTimezone && this.context.isChangedByTimezonePicker) {
          return this.updateEpochForNewTimezone(this.context.timezone);
        } else {
          return this.setState(this.getInitialState(this.props));
        }
      }

      if (this.props.singleDate) {
        if (this.state.epochDate) {
          if (this.props.singleDate !== oldProps.singleDate && this.props.singleDate !== this.state.epochDate) {
            return this.setState(this.getInitialState(this.props));
          }
        } else {
          return this.setState(this.getInitialState(this.props));
        }
      } else {
        if (this.props.defaultDate && (!this.state.epochDate || oldProps.singleDate)) {
          return this.setState(this.getInitialState(this.props));
        }
      }

      if (oldProps.calendarMaximumDate !== this.props.calendarMaximumDate || oldProps.calendarMinimumDate !== this.props.calendarMinimumDate) {
        this.setState(this.getCalendarMaximaAndMinima());
      }

      if (oldState.epochDate !== this.state.epochDate && this.state.epochDate !== this.props.singleDate) {
        this.props.onDateChanged(this.state.epochDate, this.state.calendarDate);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, newState) {
      if (!newProps.singleDate && this.props.singleDate || newProps.singleDate && !this.props.singleDate) {
        return true;
      }

      return newState.epochDate !== this.state.epochDate || newState.calendarMinimumDate !== this.state.calendarMinimumDate || newState.calendarMaximumDate !== this.state.calendarMaximumDate || newProps.singleDate !== this.props.singleDate || newProps.calendarMinimumDate !== this.props.calendarMinimumDate || newProps.calendarMaximumDate !== this.props.calendarMaximumDate;
    }
  }, {
    key: "render",
    value: function render() {
      var datePickerProps = _objectSpread$6({
        maximumDate: this.state.calendarMaximumDate,
        minimumDate: this.state.calendarMinimumDate
      }, this.props.datePickerProps);

      return React.createElement(DatesPicker, _extends_1({}, this.props, {
        datePickerProps: datePickerProps,
        updateDateRange: this.updateDateRange,
        singleDate: this.state.calendarDate || this.props.singleDate
      }));
    }
  }]);
  return EpochDatePicker;
}(React.Component);

defineProperty(EpochDatePicker, "contextType", TimezoneContext);
EpochDatePicker.propTypes = {
  onError: PropTypes.func,
  singleDate: PropTypes.number,
  defaultDate: PropTypes.func,
  getSingleDateState: PropTypes.func,
  onDateChanged: PropTypes.func,
  datePickerProps: PropTypes.object,
  calendarMinimumDate: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(moment$1)]),
  calendarMaximumDate: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(moment$1)]),
  label: PropTypes.string,
  className: PropTypes.string
};
var css$8 = ".epoch-single-date-range-picker label {\n  font-family: \"Lato Regular\", sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  color: #787878;\n  margin-right: 0.5rem; }\n\n.epoch-single-date-range-picker__start-date, .epoch-single-date-range-picker__end-date {\n  align-items: center;\n  display: flex; }\n\n.epoch-single-date-range-picker .date-picker {\n  width: 12rem; }\n\n.epoch-single-date-range-picker__start-date {\n  margin-right: 1rem; }\n\n.epoch-single-date-range-picker__end-date {\n  position: relative; }\n";
styleInject(css$8);
var MILLISECONDS_15_MINUTES = 900000;

var getTimezoneCurrentDay$1 = function getTimezoneCurrentDay(timezone) {
  return moment$1.tz(moment$1().utc(), 'UTC').tz(timezone);
};

var EpochSingleDateRangePicker = /*#__PURE__*/function (_React$Component) {
  inherits(EpochSingleDateRangePicker, _React$Component);

  function EpochSingleDateRangePicker(props) {
    var _this;

    classCallCheck(this, EpochSingleDateRangePicker);
    _this = possibleConstructorReturn(this, getPrototypeOf(EpochSingleDateRangePicker).call(this, props));
    defineProperty(assertThisInitialized(_this), "datePickerProps", {
      numberOfCalendars: 1
    });
    defineProperty(assertThisInitialized(_this), "tryUpdateAbsoluteMaximaAndMinima", function () {
      if (_this.context.timezone) {
        var currentTimezone = get(_this.context, 'timezone.value');
        var stateUpdater = {
          currentTimezone: currentTimezone
        };
        var activeTimezoneCurrentDay = getTimezoneCurrentDay$1(currentTimezone);

        if (_this.props.calendarMinimumDate) {
          var calendarMinimumDate = _this.props.calendarMinimumDate(activeTimezoneCurrentDay).set('second', 0);

          var minimumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
          stateUpdater.absoluteMinimumDate = minimumDate;

          if (!_this.state.relativeMinimumDate) {
            stateUpdater.relativeMinimumDate = minimumDate;
          } else {
            stateUpdater.startDate = calendarMinimumDate.valueOf();

            if (_this.state.endDate) {
              if (stateUpdater.startDate > _this.state.startDate) {
                if (_this.state.endDate < stateUpdater.startDate) {
                  stateUpdater.endDate = stateUpdater.startDate + MILLISECONDS_15_MINUTES;
                  stateUpdater.relativeMaximumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).add(15, 'minutes').toDate();
                  stateUpdater.relativeMinimumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
                }
              } else {
                if (_this.state.endDate > stateUpdater.startDate) {
                  stateUpdater.endDate = stateUpdater.startDate + MILLISECONDS_15_MINUTES;
                  stateUpdater.relativeMaximumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).add(15, 'minutes').toDate();
                  stateUpdater.relativeMinimumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
                }
              }
            }
          }
        }

        if (_this.props.calendarMaximumDate) {
          var calendarMaximumDate = _this.props.calendarMaximumDate(activeTimezoneCurrentDay).set('second', 0);

          var maximumDate = moment$1.tz(calendarMaximumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
          stateUpdater.absoluteMaximumDate = maximumDate;

          if (!_this.state.relativeMaximumDate) {
            stateUpdater.relativeMaximumDate = maximumDate;
          }
        }

        _this.setState(stateUpdater);
      }
    });
    defineProperty(assertThisInitialized(_this), "getContextTimezone", function () {
      return get(_this.context, 'timezone.value', null);
    });
    defineProperty(assertThisInitialized(_this), "onStartDateChanged", function (startDate, calendarDate) {
      var momentCalendarDate = moment$1(calendarDate);

      if (_this.state.absoluteMinimumDate) {
        if (momentCalendarDate.valueOf() === +_this.state.absoluteMinimumDate) {
          _this.props.onError('Start time can’t be in the past and was corrected.'); // create a new date based on UTC passed as props to refresh the range extremum dates


          var utcCurrentDay = getTimezoneCurrentDay$1(_this.state.currentTimezone);

          var timezoneCurrentDateTime = _this.props.calendarMinimumDate(utcCurrentDay);

          var newAbosuluteMinimumDate = moment$1.tz(timezoneCurrentDateTime.format(FULL_DAY_FORMAT), moment$1.tz.guess());

          var _startDate = timezoneCurrentDateTime.valueOf();

          var shouldUpdateEndDate = _this.state.endDate && _this.state.endDate < _startDate + MILLISECONDS_15_MINUTES;
          return _this.setState({
            startDate: _startDate,
            endDate: shouldUpdateEndDate ? _startDate + MILLISECONDS_15_MINUTES : _this.state.endDate,
            relativeMaximumDate: shouldUpdateEndDate ? newAbosuluteMinimumDate.clone().toDate() : _this.state.relativeMaximumDate,
            absoluteMinimumDate: newAbosuluteMinimumDate.toDate(),
            relativeMinimumDate: newAbosuluteMinimumDate.clone().add(15, 'minutes').toDate()
          });
        }
      }

      if (_this.state.endDate && startDate > _this.state.endDate) {
        _this.props.onError('End time must be at least 15 min in the future and was corrected.');

        return _this.setState({
          startDate: startDate,
          endDate: startDate + MILLISECONDS_15_MINUTES,
          relativeMaximumDate: calendarDate,
          relativeMinimumDate: momentCalendarDate.add(15, 'minutes').toDate()
        });
      }

      _this.setState({
        startDate: startDate,
        relativeMinimumDate: calendarDate
      });
    });
    defineProperty(assertThisInitialized(_this), "onEndDateChanged", function (endDate, calendarDate) {
      var momentCalendarDate = moment$1(calendarDate);

      if (_this.state.absoluteMaximumDate) {
        if (momentCalendarDate.valueOf() === +_this.state.absoluteMaximumDate) {
          _this.props.onError('End time must be at least 15 min in the future and was corrected.'); // create a new date based on UTC passed as props to refresh the range extremum dates


          var utcCurrentDay = getTimezoneCurrentDay$1(_this.state.currentTimezone);

          var timezoneCurrentDateTime = _this.props.calendarMinimumDate(utcCurrentDay);

          var newAbsoluteMaximumDate = moment$1.tz(timezoneCurrentDateTime.format(FULL_DAY_FORMAT), moment$1.tz.guess());
          return _this.setState({
            endDate: timezoneCurrentDateTime.valueOf(),
            absoluteMaximumDate: newAbsoluteMaximumDate.toDate(),
            relativeMaximumDate: newAbsoluteMaximumDate.clone().add(-15, 'minutes').toDate()
          });
        }
      }

      if (_this.state.relativeMinimumDate) {
        var newCalendarDate = momentCalendarDate.valueOf();
        var relativeMinimumDate = +_this.state.relativeMinimumDate;

        if (newCalendarDate === relativeMinimumDate) {
          _this.props.onError('End time must be at least 15 min in the future and was corrected.');

          return _this.setState({
            endDate: _this.state.startDate + MILLISECONDS_15_MINUTES,
            relativeMinimumDate: momentCalendarDate.toDate(),
            relativeMaximumDate: momentCalendarDate.add(-15, 'minutes').toDate()
          });
        }
      }

      _this.setState({
        endDate: endDate,
        relativeMaximumDate: momentCalendarDate.add(-15, 'minutes').toDate()
      });
    });
    defineProperty(assertThisInitialized(_this), "getDefaultStartDateProps", function () {
      var _this$props$pickerCla = _this.props.pickerClassNames,
          pickerClassNames = _this$props$pickerCla === void 0 ? {} : _this$props$pickerCla;
      return {
        singleDate: _this.state.startDate,
        onDateChanged: _this.onStartDateChanged,
        defaultDate: _this.props.getDefaultDateStartDate,
        calendarMinimumDate: _this.state.absoluteMinimumDate,
        calendarMaximumDate: _this.state.relativeMaximumDate,
        label: _this.props.startLabel,
        tooltipParams: _this.props.startDateTooltipParams,
        className: pickerClassNames.start || ''
      };
    });
    defineProperty(assertThisInitialized(_this), "getDefaultEndDateProps", function () {
      var _this$props$pickerCla2 = _this.props.pickerClassNames,
          pickerClassNames = _this$props$pickerCla2 === void 0 ? {} : _this$props$pickerCla2;
      return {
        singleDate: _this.state.endDate,
        onDateChanged: _this.onEndDateChanged,
        defaultDate: _this.props.getDefaultDateEndDate,
        calendarMinimumDate: _this.state.relativeMinimumDate,
        calendarMaximumDate: _this.state.absoluteMaximumDate,
        label: _this.props.endLabel,
        tooltipParams: _this.props.endDateTooltipParams,
        className: pickerClassNames.end || ''
      };
    });
    defineProperty(assertThisInitialized(_this), "baseCalendarProps", {
      dateFormat: AM_PM_DATE_TIME_FORMAT,
      datePickerProps: {
        numberOfCalendars: 1
      },
      withTimePicker: true,
      singleDateMode: true,
      updateByDone: true
    });
    _this.state = {
      currentTimezone: get(_this.context, 'timezone.value'),
      startDate: props.startDate,
      endDate: props.endDate,
      absoluteMaximumDate: null,
      absoluteMinimumDate: null,
      relativeMaximumDate: null,
      relativeMinimumDate: null
    };
    return _this;
  }

  createClass(EpochSingleDateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount(newProps) {
      this.tryUpdateAbsoluteMaximaAndMinima();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps, newState) {
      if (newState.startDate !== this.state.startDate || newState.endDate !== this.state.endDate) {
        this.props.onDateRangeChanged({
          startDate: this.state.startDate,
          endDate: this.state.endDate
        });
      }

      var contextTimezone = this.getContextTimezone();

      if (contextTimezone !== this.state.currentTimezone) {
        this.tryUpdateAbsoluteMaximaAndMinima();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var wrapperClassName = "epoch-single-date-range-picker ".concat(get(this.props, 'className', ''));
      var startDateProps = this.getDefaultStartDateProps();
      var endDateProps = this.getDefaultEndDateProps();
      var startDateLabel = get(this.props.labelOptions, 'startDate');
      var endDateLabel = get(this.props.labelOptions, 'endDate');
      return React.createElement("div", {
        className: wrapperClassName
      }, React.createElement("div", {
        className: "epoch-single-date-range-picker__start-date"
      }, startDateLabel && React.createElement("label", null, startDateLabel), React.createElement(EpochDatePicker, _extends_1({}, this.baseCalendarProps, startDateProps))), React.createElement("div", {
        className: "epoch-single-date-range-picker__end-date"
      }, endDateLabel && React.createElement("label", null, endDateLabel), React.createElement(EpochDatePicker, _extends_1({}, this.baseCalendarProps, endDateProps))));
    }
  }]);
  return EpochSingleDateRangePicker;
}(React.Component);

defineProperty(EpochSingleDateRangePicker, "contextType", TimezoneContext);
EpochSingleDateRangePicker.propTypes = {
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  getDefaultDateEndDate: PropTypes.func,
  getDefaultDateStartDate: PropTypes.func,
  onDateRangeChanged: PropTypes.func,
  labelOptions: PropTypes.object,
  className: PropTypes.string,
  calendarMaximumDate: PropTypes.func,
  calendarMinimumDate: PropTypes.func,
  onError: PropTypes.func,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
  startDateTooltipParams: PropTypes.object,
  endDateTooltipParams: PropTypes.object,
  pickerClassNames: PropTypes.object
};

function _extends$i() {
  _extends$i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$i.apply(this, arguments);
}

var _ref$i = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "100.02%",
  y1: "50.061%",
  x2: "0%",
  y2: "50.061%",
  id: "u"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-22.111%",
  y1: "49.984%",
  x2: "77.908%",
  y2: "49.984%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.071%",
  y1: "49.952%",
  x2: "99.999%",
  y2: "49.952%",
  id: "c"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.019%",
  y1: "50.042%",
  x2: "99.857%",
  y2: "50.042%",
  id: "d"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "13.602%",
  y1: "50.315%",
  x2: "97.316%",
  y2: "48.678%",
  id: "e"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-22.111%",
  y1: "49.992%",
  x2: "77.908%",
  y2: "49.992%",
  id: "f"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.071%",
  y1: "49.989%",
  x2: "100.073%",
  y2: "49.989%",
  id: "g"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.019%",
  y1: "49.925%",
  x2: "99.857%",
  y2: "49.925%",
  id: "h"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "13.602%",
  y1: "50.315%",
  x2: "97.316%",
  y2: "48.678%",
  id: "i"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-22.111%",
  y1: "50%",
  x2: "77.908%",
  y2: "50%",
  id: "j"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.069%",
  x2: "100%",
  y2: "50.069%",
  id: "k"
}, React.createElement("stop", {
  stopColor: "#2F2E7A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.071%",
  y1: "50.004%",
  x2: "100.073%",
  y2: "50.004%",
  id: "l"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.019%",
  y1: "49.988%",
  x2: "99.857%",
  y2: "49.988%",
  id: "m"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "122.111%",
  y1: "50.008%",
  x2: "22.092%",
  y2: "50.008%",
  id: "n"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100%",
  y1: "50.016%",
  x2: "-.037%",
  y2: "50.016%",
  id: "o"
}, React.createElement("stop", {
  stopColor: "#2F2E7A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.071%",
  y1: "49.949%",
  x2: ".002%",
  y2: "49.949%",
  id: "p"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.163%",
  y1: "49.904%",
  x2: ".143%",
  y2: "49.904%",
  id: "q"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "86.398%",
  y1: "50.316%",
  x2: "2.684%",
  y2: "48.684%",
  id: "r"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "122.111%",
  y1: "50.086%",
  x2: "22.092%",
  y2: "50.086%",
  id: "s"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.071%",
  y1: "50.034%",
  x2: "-.071%",
  y2: "50.034%",
  id: "t"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.017%",
  x2: "100%",
  y2: "50.017%",
  id: "b"
}, React.createElement("stop", {
  stopColor: "#2F2E7A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "86.398%",
  y1: "50.315%",
  x2: "2.684%",
  y2: "48.679%",
  id: "v"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "122.111%",
  y1: "50.055%",
  x2: "22.092%",
  y2: "50.055%",
  id: "w"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100%",
  y1: "49.977%",
  x2: "-.037%",
  y2: "49.977%",
  id: "x"
}, React.createElement("stop", {
  stopColor: "#2F2E7A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.071%",
  y1: "50.005%",
  x2: "-.071%",
  y2: "50.005%",
  id: "y"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.02%",
  y1: "50.06%",
  x2: "0%",
  y2: "50.06%",
  id: "z"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "86.398%",
  y1: "50.312%",
  x2: "2.684%",
  y2: "48.681%",
  id: "A"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.003%",
  y1: "100%",
  x2: "50.003%",
  y2: "0%",
  id: "B"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5FAAB3",
  offset: "6%"
}), React.createElement("stop", {
  stopColor: "#4C8190",
  offset: "14%"
}), React.createElement("stop", {
  stopColor: "#3C5E73",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#2F415A",
  offset: "32%"
}), React.createElement("stop", {
  stopColor: "#252B48",
  offset: "42%"
}), React.createElement("stop", {
  stopColor: "#1E1B3A",
  offset: "53%"
}), React.createElement("stop", {
  stopColor: "#191232",
  offset: "65%"
}), React.createElement("stop", {
  stopColor: "#180F30",
  offset: "82%"
})), React.createElement("linearGradient", {
  x1: "50.005%",
  y1: "100%",
  x2: "50.005%",
  y2: ".013%",
  id: "C"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5FAAB3",
  offset: "6%"
}), React.createElement("stop", {
  stopColor: "#4C8190",
  offset: "14%"
}), React.createElement("stop", {
  stopColor: "#3C5E73",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#2F415A",
  offset: "32%"
}), React.createElement("stop", {
  stopColor: "#252B48",
  offset: "42%"
}), React.createElement("stop", {
  stopColor: "#1E1B3A",
  offset: "53%"
}), React.createElement("stop", {
  stopColor: "#191232",
  offset: "65%"
}), React.createElement("stop", {
  stopColor: "#180F30",
  offset: "82%"
})), React.createElement("linearGradient", {
  x1: "-22.105%",
  y1: "49.99%",
  x2: "77.898%",
  y2: "49.99%",
  id: "D"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.02%",
  x2: "100.054%",
  y2: "50.02%",
  id: "E"
}, React.createElement("stop", {
  stopColor: "#2F2E7A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.003%",
  y1: "49.999%",
  x2: "100.027%",
  y2: "49.999%",
  id: "F"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.006%",
  y1: "49.983%",
  x2: "100.072%",
  y2: "49.983%",
  id: "G"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "13.588%",
  y1: "50.32%",
  x2: "97.327%",
  y2: "48.656%",
  id: "H"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: ".002%",
  y1: "50.001%",
  x2: "100%",
  y2: "50.001%",
  id: "I"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-22.104%",
  y1: "50%",
  x2: "77.898%",
  y2: "50%",
  id: "J"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.008%",
  x2: "100.054%",
  y2: "50.008%",
  id: "K"
}, React.createElement("stop", {
  stopColor: "#2F2E7A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.003%",
  y1: "50%",
  x2: "100.027%",
  y2: "50%",
  id: "L"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.077%",
  y1: "50.027%",
  x2: "100%",
  y2: "50.027%",
  id: "M"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "13.588%",
  y1: "50.319%",
  x2: "97.327%",
  y2: "48.657%",
  id: "N"
}, React.createElement("stop", {
  stopColor: "#6ECACE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#5796AA",
  offset: "23%"
}), React.createElement("stop", {
  stopColor: "#406287",
  offset: "49%"
}), React.createElement("stop", {
  stopColor: "#2F3C6E",
  offset: "71%"
}), React.createElement("stop", {
  stopColor: "#25255E",
  offset: "89%"
}), React.createElement("stop", {
  stopColor: "#211C58",
  offset: "100%"
})));

var _ref2$e = /*#__PURE__*/React.createElement("path", {
  d: "M131.583 141H60.711c-16.399-.026-29.686-13.703-29.711-30.582 0-.231.182-.418.406-.418.224 0 .406.187.406.418.018 16.42 12.946 29.727 28.899 29.747h70.466V118.62a.42.42 0 01.412-.359.42.42 0 01.411.36v21.961a.434.434 0 01-.417.418z",
  fill: "#6ECACE"
});

var _ref3$b = /*#__PURE__*/React.createElement("path", {
  d: "M61 97.037v-4.811H48.637l-14.6-8.47a8.452 8.452 0 00-7.608.313l-14.066 8.157H0v5.09a2.238 2.238 0 001.303 2.048l25.616 14.882a8.419 8.419 0 007.607-.325L59.14 99.677a3.043 3.043 0 001.86-2.64z",
  fill: "#33308E"
});

var _ref4$a = /*#__PURE__*/React.createElement("path", {
  d: "M61 97.037v-4.811H48.637l-14.6-8.47a8.452 8.452 0 00-7.608.313l-14.066 8.157H0v5.09a2.238 2.238 0 001.303 2.048l25.616 14.882a8.419 8.419 0 007.607-.325L59.14 99.677a3.043 3.043 0 001.86-2.64z",
  fill: "url(#a)",
  opacity: 0.5
});

var _ref5$8 = /*#__PURE__*/React.createElement("path", {
  d: "M34.59 83.771a7.023 7.023 0 00-3.59-.76V115a8.937 8.937 0 004.144-1.119l24.965-14.193A3.045 3.045 0 0062 97.048v-4.81H49.432L34.59 83.771z",
  fill: "url(#b)"
});

var _ref6$7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.946 109.254L1.316 94.54c-1.95-1.106-1.705-3.064.546-4.359L26.4 76.067a8.513 8.513 0 017.61-.321l25.675 14.702c1.95 1.106 1.705 3.075-.557 4.37L34.612 108.9a8.501 8.501 0 01-7.666.354z",
  fill: "#33308E"
});

var _ref7$7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.946 109.254L1.316 94.54c-1.95-1.106-1.705-3.064.546-4.359L26.4 76.067a8.513 8.513 0 017.61-.321l25.675 14.702c1.95 1.106 1.705 3.075-.557 4.37L34.612 108.9a8.501 8.501 0 01-7.666.354z",
  fill: "url(#c)",
  opacity: 0.5
});

var _ref8$5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.114 107.357L8.077 95.191c-1.598-.935-1.394-2.552.453-3.623L28.66 79.88a6.91 6.91 0 016.231-.262L55.918 91.83c1.598.923 1.405 2.54-.441 3.623l-20.132 11.676a6.832 6.832 0 01-6.23.228z",
  fill: "#B7E2E8"
});

var _ref9$5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.527 92.79L28.665 81.4a7.076 7.076 0 016.234-.255l21.033 11.9c.35.184.646.452.862.777.232-.414.27-.906.105-1.35a1.66 1.66 0 00-.967-.97L34.9 79.602a7.076 7.076 0 00-6.234.255L8.527 91.247C7.133 92.035 6.68 93.123 7.224 94a3.259 3.259 0 011.303-1.21z",
  fill: "#6ECACE"
});

var _ref10$4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.57 109.27L2.28 94.537c-2.012-1.105-2.48-2.752.56-4.354L28 76.113a9.123 9.123 0 014-1.105 9.399 9.399 0 00-4.835 1.105L1.903 90.183c-2.286 1.293-2.56 3.238-.56 4.354l26.29 14.7a7.365 7.365 0 003.853.74 6.753 6.753 0 01-2.915-.707z",
  fill: "url(#d)",
  opacity: 0.5
});

var _ref11$3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.14 97.639L34.638 111.87a8.414 8.414 0 01-7.607.313L1.414 97.314A2.236 2.236 0 010 95.268v1.051c-.005.88.506 1.681 1.303 2.046l25.616 14.881a8.425 8.425 0 007.607-.324L59.14 98.689A3.052 3.052 0 0061 96.051V95a3.052 3.052 0 01-1.86 2.639z",
  fill: "url(#e)",
  opacity: 0.5
});

var _ref12$2 = /*#__PURE__*/React.createElement("path", {
  d: "M55.699 96.146c.401.2.401.508 0 .708a1.763 1.763 0 01-1.406 0c-.175-.052-.293-.194-.293-.354 0-.16.118-.302.293-.354a1.763 1.763 0 011.406 0zM57.706 95.146c.176.052.294.194.294.354 0 .16-.118.302-.294.354a1.777 1.777 0 01-1.412 0c-.176-.052-.294-.194-.294-.354 0-.16.118-.302.294-.354a1.777 1.777 0 011.412 0z",
  fill: "#6ECACE"
});

var _ref13$2 = /*#__PURE__*/React.createElement("circle", {
  fill: "#6ECACE",
  cx: 59,
  cy: 95.5,
  r: 1
});

var _ref14$2 = /*#__PURE__*/React.createElement("path", {
  d: "M61 78.04v-4.81H48.637l-14.6-8.47a8.409 8.409 0 00-7.608.314l-14.066 8.155H0v5.08a2.238 2.238 0 001.303 2.047l25.616 14.89a8.42 8.42 0 007.607-.325L59.14 80.68A3.053 3.053 0 0061 78.04z",
  fill: "#33308E"
});

var _ref15$2 = /*#__PURE__*/React.createElement("path", {
  d: "M61 78.04v-4.81H48.637l-14.6-8.47a8.409 8.409 0 00-7.608.314l-14.066 8.155H0v5.08a2.238 2.238 0 001.303 2.047l25.616 14.89a8.42 8.42 0 007.607-.325L59.14 80.68A3.053 3.053 0 0061 78.04z",
  fill: "url(#f)",
  opacity: 0.5
});

var _ref16$2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.59 64.771a7.023 7.023 0 00-3.59-.76V96a8.937 8.937 0 004.144-1.119l24.965-14.193A3.056 3.056 0 0062 78.048v-4.81H49.432L34.59 64.771z",
  fill: "url(#b)"
});

var _ref17$1 = /*#__PURE__*/React.createElement("path", {
  d: "M26.966 88.244L1.317 73.522c-1.951-1.107-1.706-3.078.547-4.362l24.555-14.103a8.553 8.553 0 017.617-.31L59.684 69.47c1.951 1.107 1.706 3.078-.558 4.362L34.593 87.935a8.508 8.508 0 01-7.627.31z",
  fill: "#33308E"
});

var _ref18$1 = /*#__PURE__*/React.createElement("path", {
  d: "M26.966 88.244L1.317 73.522c-1.951-1.107-1.706-3.078.547-4.362l24.555-14.103a8.553 8.553 0 017.617-.31L59.684 69.47c1.951 1.107 1.706 3.078-.558 4.362L34.593 87.935a8.508 8.508 0 01-7.627.31z",
  fill: "url(#g)",
  opacity: 0.5
});

var _ref19$1 = /*#__PURE__*/React.createElement("path", {
  d: "M29.123 86.403L8.092 74.165c-1.597-.933-1.439-2.548.453-3.617l20.125-11.67a6.916 6.916 0 016.229-.261l21.02 12.193c1.597.92 1.404 2.536-.442 3.605l-20.125 11.67a6.871 6.871 0 01-6.23.318z",
  fill: "#B7E2E8"
});

var _ref20$1 = /*#__PURE__*/React.createElement("path", {
  d: "M8.527 71.79L28.666 60.4a7.076 7.076 0 016.233-.255l21.034 11.9c.346.184.641.447.86.766.233-.413.27-.903.106-1.346a1.648 1.648 0 00-.966-.963l-21.034-11.9a7.076 7.076 0 00-6.233.255L8.527 70.247C7.133 71.035 6.68 72.123 7.224 73a3.259 3.259 0 011.303-1.21z",
  fill: "#6ECACE"
});

var _ref21$1 = /*#__PURE__*/React.createElement("path", {
  d: "M28.57 88.237L2.28 73.5c-2.012-1.108-2.48-2.759.56-4.365L28 55.02a9.257 9.257 0 014-1.008 9.384 9.384 0 00-4.835 1.052L1.903 69.135c-2.286 1.286-2.56 3.247-.56 4.366l26.29 14.736a7.467 7.467 0 003.853.742 6.737 6.737 0 01-2.915-.742z",
  fill: "url(#h)",
  opacity: 0.5
});

var _ref22$1 = /*#__PURE__*/React.createElement("path", {
  d: "M59.14 77.628L34.638 91.875a8.412 8.412 0 01-7.607.313L1.414 77.315A2.236 2.236 0 010 75.268v1.052a2.237 2.237 0 001.303 2.046L26.92 93.24a8.412 8.412 0 007.607-.314L59.14 78.69A3.052 3.052 0 0061 76.051V75a3.03 3.03 0 01-1.86 2.628z",
  fill: "url(#i)",
  opacity: 0.5
});

var _ref23$1 = /*#__PURE__*/React.createElement("path", {
  d: "M55.699 76.146c.401.2.401.508 0 .708a1.763 1.763 0 01-1.406 0c-.175-.052-.293-.194-.293-.354 0-.16.118-.302.293-.354a1.763 1.763 0 011.406 0zM57.706 74.146c.176.052.294.194.294.354 0 .16-.118.302-.294.354a1.777 1.777 0 01-1.412 0c-.176-.052-.294-.194-.294-.354 0-.16.118-.302.294-.354a1.777 1.777 0 011.412 0z",
  fill: "#6ECACE"
});

var _ref24$1 = /*#__PURE__*/React.createElement("circle", {
  fill: "#6ECACE",
  cx: 59,
  cy: 73.5,
  r: 1
});

var _ref25$1 = /*#__PURE__*/React.createElement("path", {
  d: "M61 57.064v-4.81H48.637l-14.6-8.493a8.408 8.408 0 00-7.608.313l-14.066 8.157H0v5.08a2.238 2.238 0 001.303 2.047L26.92 74.239a8.408 8.408 0 007.607-.313L59.14 59.683A3.054 3.054 0 0061 57.064z",
  fill: "#33308E"
});

var _ref26$1 = /*#__PURE__*/React.createElement("path", {
  d: "M61 57.064v-4.81H48.637l-14.6-8.493a8.408 8.408 0 00-7.608.313l-14.066 8.157H0v5.08a2.238 2.238 0 001.303 2.047L26.92 74.239a8.408 8.408 0 007.607-.313L59.14 59.683A3.054 3.054 0 0061 57.064z",
  fill: "url(#j)",
  opacity: 0.5
});

var _ref27$1 = /*#__PURE__*/React.createElement("path", {
  d: "M34.59 43.772a7.017 7.017 0 00-3.59-.761V75a8.93 8.93 0 004.144-1.12l24.965-14.175A3.059 3.059 0 0062 57.085V52.27H49.432L34.59 43.772z",
  fill: "url(#k)"
});

var _ref28$1 = /*#__PURE__*/React.createElement("path", {
  d: "M26.966 69.25L1.317 54.527c-1.951-1.107-1.706-3.077.547-4.361l24.555-14.103a8.508 8.508 0 017.617-.31l25.648 14.722c1.951 1.107 1.706 3.078-.558 4.362L34.593 68.94a8.553 8.553 0 01-7.627.31z",
  fill: "#33308E"
});

var _ref29$1 = /*#__PURE__*/React.createElement("path", {
  d: "M26.966 69.25L1.317 54.527c-1.951-1.107-1.706-3.077.547-4.361l24.555-14.103a8.508 8.508 0 017.617-.31l25.648 14.722c1.951 1.107 1.706 3.078-.558 4.362L34.593 68.94a8.553 8.553 0 01-7.627.31z",
  fill: "url(#l)",
  opacity: 0.5
});

var _ref30$1 = /*#__PURE__*/React.createElement("path", {
  d: "M29.123 66.382L8.092 54.176c-1.597-.922-1.439-2.539.453-3.586L28.67 38.885a6.865 6.865 0 016.229-.262l21.02 12.206c1.597.922 1.404 2.54-.442 3.61L35.352 66.12a6.91 6.91 0 01-6.23.262z",
  fill: "#B7E2E8"
});

var _ref31$1 = /*#__PURE__*/React.createElement("path", {
  d: "M8.527 51.77l20.139-11.369a7.041 7.041 0 016.233-.254l21.034 11.878c.348.18.644.443.86.764.233-.412.27-.902.106-1.343a1.647 1.647 0 00-.966-.961L34.899 38.606c-2-.89-4.316-.795-6.233.255L8.527 50.252C7.133 51.028 6.68 52.125 7.224 53c.308-.521.76-.947 1.303-1.23z",
  fill: "#6ECACE"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M28.57 69.238L2.28 54.52c-2.012-1.107-2.48-2.767.56-4.36L28 36.064a9.261 9.261 0 014-1.051 9.394 9.394 0 00-4.835 1.05L1.903 50.162c-2.286 1.284-2.56 3.242-.56 4.36l26.29 14.717a7.475 7.475 0 003.853.741 6.743 6.743 0 01-2.915-.741z",
  fill: "url(#m)",
  opacity: 0.5
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M59.14 55.628L34.638 69.875a8.456 8.456 0 01-7.607.313L1.414 55.315A2.236 2.236 0 010 53.268v1.052a2.237 2.237 0 001.303 2.046L26.92 71.24a8.412 8.412 0 007.607-.314L59.14 56.69A3.052 3.052 0 0061 54.051V53a3.03 3.03 0 01-1.86 2.628z",
  fill: "url(#i)",
  opacity: 0.5
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M55.7 55.148c.4.19.4.514 0 .704a1.722 1.722 0 01-1.397 0c-.18-.044-.303-.188-.303-.352 0-.164.124-.308.303-.352a1.722 1.722 0 011.398 0zM57.706 54.146c.176.052.294.194.294.354 0 .16-.118.302-.294.354a1.777 1.777 0 01-1.412 0c-.176-.052-.294-.194-.294-.354 0-.16.118-.302.294-.354a1.777 1.777 0 011.412 0z",
  fill: "#6ECACE"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  fill: "#6ECACE",
  cx: 59,
  cy: 53.5,
  r: 1
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M8.266 110a2.345 2.345 0 01-1.133-.308A2.282 2.282 0 016 107.675V73.741a7.233 7.233 0 013.546-6.268l5.822-3.418a.406.406 0 01.555.148.423.423 0 01-.147.57L9.954 68.19a6.423 6.423 0 00-3.183 5.55v33.957a1.506 1.506 0 00.754 1.317c.47.27 1.048.262 1.511-.018l6.355-3.68a.383.383 0 01.555.148.412.412 0 01-.148.558l-6.377 3.67c-.352.2-.75.306-1.155.307z",
  fill: "#6ECACE"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M6.378 91a.411.411 0 01-.33-.18.378.378 0 01.148-.515l9.237-5.256a.384.384 0 01.38.002.373.373 0 01-.005.648l-9.26 5.256a.38.38 0 01-.17.045zM54.686 110a2.35 2.35 0 01-1.134-.308l-6.35-3.693a.411.411 0 01-.148-.559.386.386 0 01.556-.148l6.35 3.682a1.49 1.49 0 001.513.017c.47-.27.759-.773.755-1.317V73.731a6.412 6.412 0 00-3.175-5.539l-5.829-3.42a.423.423 0 01-.147-.57.407.407 0 01.556-.147l5.829 3.419A7.222 7.222 0 0157 73.731v33.966a2.282 2.282 0 01-1.134 2.017 2.35 2.35 0 01-1.18.285z",
  fill: "#6ECACE"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M56.628 90.988a.4.4 0 01-.192 0l-9.194-5.253a.38.38 0 01-.03-.694.388.388 0 01.415.044l9.182 5.209a.37.37 0 01.136.515.386.386 0 01-.317.18zM217.241 141h-75.835a.412.412 0 01-.406-.417v-21.987c0-.23.182-.417.406-.417.225 0 .407.186.407.417v21.524h75.428c15.977-.013 28.928-13.302 28.946-29.703 0-.23.182-.417.407-.417.224 0 .406.187.406.417 0 16.877-13.318 30.564-29.759 30.583z",
  fill: "#6ECACE"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M217 97.045v-4.81h12.363l14.6-8.48a8.42 8.42 0 017.608.324l14.066 8.155H278v5.08a2.238 2.238 0 01-1.303 2.046l-25.616 14.88a8.409 8.409 0 01-7.607-.314l-24.625-14.252a3.031 3.031 0 01-1.849-2.63z",
  fill: "#33308E"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M217 97.045v-4.81h12.363l14.6-8.48a8.42 8.42 0 017.608.324l14.066 8.155H278v5.08a2.238 2.238 0 01-1.303 2.046l-25.616 14.88a8.409 8.409 0 01-7.607-.314l-24.625-14.252a3.031 3.031 0 01-1.849-2.63z",
  fill: "url(#n)",
  opacity: 0.5
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M244.41 83.76a7.138 7.138 0 013.59-.75V115a8.937 8.937 0 01-4.144-1.119L218.88 99.676A3.033 3.033 0 01217 97.048v-4.81h12.568l14.843-8.478z",
  fill: "url(#o)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M251.055 109.266l25.629-14.754c1.95-1.109 1.705-3.084-.546-4.381L251.6 76.065a8.48 8.48 0 00-7.611-.31l-25.674 14.73c-1.95 1.11-1.705 3.073.546 4.371l24.638 14.088a8.492 8.492 0 007.555.322z",
  fill: "#33308E"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M251.055 109.266l25.629-14.754c1.95-1.109 1.705-3.084-.546-4.381L251.6 76.065a8.48 8.48 0 00-7.611-.31l-25.674 14.73c-1.95 1.11-1.705 3.073.546 4.371l24.638 14.088a8.492 8.492 0 007.555.322z",
  fill: "url(#p)",
  opacity: 0.5
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M250.328 107.388l20.617-12.201c1.565-.922 1.365-2.55-.444-3.62l-19.729-11.689a6.614 6.614 0 00-6.106-.25l-20.606 12.19c-1.566.933-1.377 2.55.433 3.619l19.729 11.678a6.658 6.658 0 006.106.273z",
  fill: "#B7E2E8"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M270.504 92.79L250.768 81.4a6.766 6.766 0 00-6.109-.244l-20.613 11.89a2.31 2.31 0 00-.844.776 1.642 1.642 0 01.844-2.32l20.613-11.89a6.766 6.766 0 016.109.245l19.736 11.39c1.366.788 1.81 1.876 1.277 2.753-.31-.51-.75-.928-1.277-1.21z",
  fill: "#6ECACE"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M250.434 109.184l26.329-14.696c2.003-1.105 2.484-2.762-.561-4.364l-25.195-14.01A9.29 9.29 0 00247 75.009a9.354 9.354 0 014.842 1.105l25.253 14.065c2.289 1.293 2.564 3.249.56 4.365l-26.328 14.695a7.504 7.504 0 01-3.858.74 6.917 6.917 0 002.965-.795z",
  fill: "url(#q)",
  opacity: 0.5
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M218.849 97.686l24.625 14.201a8.48 8.48 0 007.607.313l25.616-14.826a2.23 2.23 0 001.303-2.04v1.048a2.23 2.23 0 01-1.303 2.04l-25.616 14.825a8.48 8.48 0 01-7.607-.312l-24.625-14.2a3.02 3.02 0 01-1.849-2.62V95a3.02 3.02 0 001.849 2.686z",
  fill: "url(#r)",
  opacity: 0.5
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M223.303 96.148c-.18.044-.303.188-.303.352 0 .164.124.308.303.352.439.197.959.197 1.398 0 .399-.19.399-.514 0-.704a1.722 1.722 0 00-1.398 0zM221.3 95.148c-.4.19-.4.514 0 .704.438.197.958.197 1.397 0 .18-.044.303-.188.303-.352 0-.164-.124-.308-.303-.352a1.722 1.722 0 00-1.398 0z",
  fill: "#6ECACE"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M220.294 95.146c-.176.052-.294.194-.294.354 0 .16.118.302.294.354.443.195.969.195 1.412 0 .176-.052.294-.194.294-.354 0-.16-.118-.302-.294-.354a1.777 1.777 0 00-1.412 0z",
  fill: "#6ECACE"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M217 78.047v-4.811h12.363l14.6-8.482a8.419 8.419 0 017.608.325l14.066 8.157H278v5.08a2.238 2.238 0 01-1.303 2.047L251.08 95.244a8.452 8.452 0 01-7.607-.313L218.849 80.7A3.032 3.032 0 01217 78.047z",
  fill: "#33308E"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M217 78.047v-4.811h12.363l14.6-8.482a8.419 8.419 0 017.608.325l14.066 8.157H278v5.08a2.238 2.238 0 01-1.303 2.047L251.08 95.244a8.452 8.452 0 01-7.607-.313L218.849 80.7A3.032 3.032 0 01217 78.047z",
  fill: "url(#s)",
  opacity: 0.5
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M244.41 64.76a7.138 7.138 0 013.59-.75V96a9.074 9.074 0 01-4.144-1.119L218.88 80.676a3.033 3.033 0 01-1.879-2.65v-4.81h12.568l14.843-8.456z",
  fill: "url(#o)"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M251.035 88.267l25.648-14.728c1.951-1.108 1.706-3.079-.547-4.375l-24.555-14.097a8.471 8.471 0 00-7.616-.31l-25.648 14.728c-1.951 1.108-1.706 3.068.547 4.364l24.61 14.097a8.516 8.516 0 007.56.321z",
  fill: "#33308E"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M251.035 88.267l25.648-14.728c1.951-1.108 1.706-3.079-.547-4.375l-24.555-14.097a8.471 8.471 0 00-7.616-.31l-25.648 14.728c-1.951 1.108-1.706 3.068.547 4.364l24.61 14.097a8.516 8.516 0 007.56.321z",
  fill: "url(#t)",
  opacity: 0.5
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M250.328 86.382l20.617-12.203c1.565-.922 1.365-2.55-.444-3.62l-19.729-11.68a6.613 6.613 0 00-6.106-.25L224.06 70.82c-1.566.934-1.377 2.55.433 3.62l19.729 11.68a6.656 6.656 0 006.106.262z",
  fill: "#B7E2E8"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M270.504 71.8l-19.736-11.398a6.762 6.762 0 00-6.109-.245l-20.613 11.899a2.31 2.31 0 00-.844.777 1.645 1.645 0 01.844-2.322l20.613-11.898a6.762 6.762 0 016.109.244l19.736 11.388c1.366.789 1.81 1.877 1.277 2.755a3.221 3.221 0 00-1.277-1.2z",
  fill: "#6ECACE"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M250.388 88.239l26.329-14.696c2.003-1.105 2.484-2.762-.561-4.364L250.96 55.113A9.147 9.147 0 00247 54.008a9.425 9.425 0 014.842 1.105l25.253 14.066c2.289 1.293 2.564 3.237.56 4.364L251.327 88.24a7.504 7.504 0 01-3.858.74 7.063 7.063 0 002.92-.74z",
  fill: "url(#u)",
  opacity: 0.5
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M218.849 77.638l24.625 14.232a8.425 8.425 0 007.607.324l25.616-14.869A2.236 2.236 0 00278 75.28v1.051c.005.88-.506 1.681-1.303 2.046l-25.616 14.87a8.458 8.458 0 01-7.607-.314L218.849 78.69A3.03 3.03 0 01217 76.051V75a3.04 3.04 0 001.849 2.638z",
  fill: "url(#v)",
  opacity: 0.5
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M223.303 76.148c-.18.044-.303.188-.303.352 0 .164.124.308.303.352.439.197.959.197 1.398 0 .399-.19.399-.514 0-.704a1.722 1.722 0 00-1.398 0z",
  fill: "#6ECACE"
});

var _ref60 = /*#__PURE__*/React.createElement("circle", {
  fill: "#6ECACE",
  cx: 222,
  cy: 74.5,
  r: 1
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M220.302 73.148c-.178.044-.302.188-.302.352 0 .164.124.308.302.352.439.197.957.197 1.396 0 .178-.044.302-.188.302-.352 0-.164-.124-.308-.302-.352a1.716 1.716 0 00-1.396 0z",
  fill: "#6ECACE"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M217 57.047v-4.815h12.363l14.6-8.476a8.447 8.447 0 017.608.314l14.066 8.162H278v5.095a2.24 2.24 0 01-1.314 2.038L251.07 74.257a8.447 8.447 0 01-7.596-.336l-24.625-14.232A3.034 3.034 0 01217 57.047z",
  fill: "#33308E"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M217 57.047v-4.815h12.363l14.6-8.476a8.447 8.447 0 017.608.314l14.066 8.162H278v5.095a2.24 2.24 0 01-1.314 2.038L251.07 74.257a8.447 8.447 0 01-7.596-.336l-24.625-14.232A3.034 3.034 0 01217 57.047z",
  fill: "url(#w)",
  opacity: 0.5
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M244.41 43.768a7.256 7.256 0 013.59-.76V75a9.215 9.215 0 01-4.087-1.118l-25.034-14.207A3.031 3.031 0 01217 57.037V52.23h12.568l14.843-8.462z",
  fill: "url(#x)"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M251.035 69.257l25.648-14.729c1.951-1.107 1.706-3.067-.547-4.363l-24.555-14.097a8.516 8.516 0 00-7.616-.321l-25.648 14.728c-1.951 1.108-1.706 3.079.547 4.43l24.61 14.042a8.471 8.471 0 007.56.31z",
  fill: "#33308E"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M251.035 69.257l25.648-14.729c1.951-1.107 1.706-3.067-.547-4.363l-24.555-14.097a8.516 8.516 0 00-7.616-.321l-25.648 14.728c-1.951 1.108-1.706 3.079.547 4.43l24.61 14.042a8.471 8.471 0 007.56.31z",
  fill: "url(#y)",
  opacity: 0.5
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M250.328 66.372l20.617-12.192c1.565-.934 1.365-2.55-.444-3.62l-19.729-11.68a6.656 6.656 0 00-6.106-.262L224.06 50.82c-1.566.922-1.377 2.55.433 3.62l19.729 11.68a6.613 6.613 0 006.106.25z",
  fill: "#B7E2E8"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M270.504 50.79L250.768 39.4a6.811 6.811 0 00-6.109-.255l-20.613 11.9a2.31 2.31 0 00-.844.777 1.642 1.642 0 01.844-2.32l20.613-11.9a6.811 6.811 0 016.109.255l19.736 11.39c1.366.788 1.81 1.876 1.277 2.753a3.22 3.22 0 00-1.277-1.21z",
  fill: "#6ECACE"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M250.388 69.227l26.329-14.695c2.003-1.105 2.484-2.751-.561-4.353L250.96 36.113A9.147 9.147 0 00247 35.008a9.425 9.425 0 014.842 1.105l25.253 14.066c2.289 1.292 2.564 3.237.56 4.353l-26.328 14.695a7.385 7.385 0 01-3.858.751 6.92 6.92 0 002.92-.75z",
  fill: "url(#z)",
  opacity: 0.5
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M218.849 55.63l24.625 14.191a8.447 8.447 0 007.607.324l25.616-14.837a2.23 2.23 0 001.303-2.04v1.114a2.23 2.23 0 01-1.303 2.04L251.08 71.248a8.447 8.447 0 01-7.607-.323l-24.625-14.246A3.032 3.032 0 01217 54.048V53a3.032 3.032 0 001.849 2.63z",
  fill: "url(#A)",
  opacity: 0.5
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M223.293 55.146c-.175.052-.293.194-.293.354 0 .16.118.302.293.354.441.195.964.195 1.406 0 .401-.2.401-.508 0-.708a1.763 1.763 0 00-1.406 0z",
  fill: "#6ECACE"
});

var _ref72 = /*#__PURE__*/React.createElement("circle", {
  fill: "#6ECACE",
  cx: 222,
  cy: 54.5,
  r: 1
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M220.302 53.148c-.178.044-.302.188-.302.352 0 .164.124.308.302.352.439.197.957.197 1.396 0 .178-.044.302-.188.302-.352 0-.164-.124-.308-.302-.352a1.716 1.716 0 00-1.396 0zM270.654 109.998a2.22 2.22 0 01-1.123-.32l-6.297-3.692a.411.411 0 01-.02-.734.399.399 0 01.424.027l6.297 3.693c.46.29 1.04.3 1.508.026.47-.274.752-.788.737-1.337V73.693a6.425 6.425 0 00-3.143-5.529l-5.77-3.42a.414.414 0 01-.114-.54.4.4 0 01.519-.166l5.77 3.42c2.194 1.292 3.549 3.67 3.558 6.246v33.969a2.287 2.287 0 01-1.123 2.017c-.37.22-.795.326-1.223.308z",
  fill: "#6ECACE"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M272.622 90.988a.39.39 0 01-.193 0l-9.23-5.287a.361.361 0 01-.147-.507.388.388 0 01.523-.146l9.23 5.286c.183.104.25.335.147.519a.4.4 0 01-.33.135zM224.255 110a2.238 2.238 0 01-1.127-.319 2.282 2.282 0 01-1.128-2.015V73.732a7.244 7.244 0 013.563-6.24l5.796-3.416c.125-.09.29-.1.426-.028a.41.41 0 01-.02.734l-5.796 3.416a6.411 6.411 0 00-3.157 5.523v33.933c-.003.54.281 1.04.744 1.31a1.51 1.51 0 001.489 0l6.314-3.69c.125-.09.29-.1.426-.027a.41.41 0 01-.02.733l-6.314 3.69c-.36.22-.774.335-1.196.33z",
  fill: "#6ECACE"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M222.385 91a.365.365 0 01-.33-.19.364.364 0 01.137-.515l9.235-5.248a.39.39 0 01.523.146.366.366 0 01-.137.503l-9.235 5.248a.472.472 0 01-.193.056z",
  fill: "#6ECACE"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M83.109 60.705c-22.08 0-42.841-3.133-58.45-8.817-7.877-2.876-14.01-6.222-18.174-9.96C2.322 38.192.42 34.499.42 30.583c0-3.916 2.037-7.732 6.065-11.347 4.03-3.614 10.275-7.083 18.163-9.959C40.268 3.592 61.03.46 83.098.46c22.078 0 42.84 3.133 58.449 8.817 7.877 2.876 14.01 6.222 18.174 9.96 4.163 3.737 6.065 7.43 6.065 11.346 0 3.917-2.037 7.732-6.065 11.347-4.029 3.614-10.275 7.083-18.163 9.959-15.62 5.684-36.325 8.817-58.45 8.817zm0-60.134c-21.134 0-42.279 2.931-58.37 8.795C9.151 15.028.576 22.57.576 30.582s8.575 15.554 24.15 21.261c32.195 11.727 84.568 11.727 116.752 0 15.575-5.662 24.15-13.204 24.15-21.26 0-8.058-8.575-15.555-24.15-21.262-16.103-5.819-37.237-8.75-58.382-8.75h.012z",
  fill: "url(#B)",
  transform: "translate(55 89)"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M83.109 52.123c-15.147 0-30.294-2.093-41.817-6.289-11.186-4.073-17.342-9.49-17.342-15.252 0-5.763 6.156-11.19 17.342-15.252 23.058-8.392 60.565-8.392 83.622 0 11.186 4.073 17.342 9.49 17.342 15.252 0 5.763-6.156 11.19-17.342 15.252-11.523 4.196-26.67 6.289-41.805 6.289zm0-42.992c-15.113 0-30.227 2.093-41.727 6.289-11.141 4.05-17.274 9.433-17.274 15.162 0 5.73 6.133 11.112 17.274 15.162 23.013 8.382 60.452 8.382 83.465 0 11.14-4.05 17.274-9.433 17.274-15.162 0-5.73-6.133-11.112-17.274-15.162-11.512-4.23-26.625-6.289-41.75-6.289h.012z",
  fill: "url(#C)",
  transform: "translate(55 89)"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M183.991 107.083v-7.238H165.36l-22.03-12.704c-2.94-1.692-8.077-1.479-11.476.482l-21.2 12.222H92v7.63a3.36 3.36 0 001.963 3.07l38.721 22.305c2.94 1.702 8.077 1.49 11.475-.471l37.017-21.364c1.985-1.132 2.927-2.588 2.815-3.932z",
  fill: "#33308E"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M183.991 107.083v-7.238H165.36l-22.03-12.704c-2.94-1.692-8.077-1.479-11.476.482l-21.2 12.222H92v7.63a3.36 3.36 0 001.963 3.07l38.721 22.305c2.94 1.702 8.077 1.49 11.475-.471l37.017-21.364c1.985-1.132 2.927-2.588 2.815-3.932z",
  fill: "url(#D)",
  opacity: 0.5
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M143.33 87.14a10.29 10.29 0 00-5.33-1.121V134a13.333 13.333 0 006.161-1.614l37.036-21.379c1.964-1.12 2.906-2.59 2.794-3.957v-7.197h-18.619L143.331 87.14z",
  fill: "url(#E)"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M132.688 123.86l-38.705-22.294c-2.94-1.69-2.569-4.656.83-6.603l37.022-21.342c3.366-1.958 8.538-2.171 11.477-.481l38.705 22.293c2.94 1.701 2.569 4.656-.83 6.614l-37.022 21.342c-3.4 1.947-8.538 2.16-11.477.47z",
  fill: "#33308E"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M132.688 123.86l-38.705-22.294c-2.94-1.69-2.569-4.656.83-6.603l37.022-21.342c3.366-1.958 8.538-2.171 11.477-.481l38.705 22.293c2.94 1.701 2.569 4.656-.83 6.614l-37.022 21.342c-3.4 1.947-8.538 2.16-11.477.47z",
  fill: "url(#F)",
  opacity: 0.5
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M133.164 120.087l-31.54-18.036c-2.407-1.376-2.1-3.777.669-5.366l30.19-17.372c2.77-1.59 6.958-1.759 9.353-.383l31.54 18.037c2.407 1.375 2.1 3.776-.669 5.365l-30.202 17.327c-2.77 1.623-6.957 1.781-9.34.428z",
  fill: "#86D1D7"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M102.292 98.222l30.2-16.65c2.769-1.529 6.957-1.691 9.351-.369l31.539 17.344c.52.252.964.625 1.294 1.084.692-1.225.283-2.514-1.294-3.393l-31.539-17.344c-2.394-1.322-6.582-1.16-9.351.369l-30.2 16.715c-2.088 1.15-2.769 2.743-1.963 4.022a5.017 5.017 0 011.963-1.778z",
  fill: "#6ECACE"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M133.94 123.845L94.36 101.557c-3.006-1.69-3.729-4.174.837-6.602l37.861-21.337a13.697 13.697 0 015.943-1.6c-2.53-.129-5.046.425-7.274 1.6l-37.86 21.337c-3.442 1.947-3.855 4.912-.85 6.602l39.582 22.288a10.96 10.96 0 005.794 1.119 10.03 10.03 0 01-4.452-1.12z",
  fill: "url(#G)",
  opacity: 0.5
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M181.216 106.021l-37.033 21.723c-3.367 1.993-8.54 2.21-11.48.49l-38.74-22.691A3.421 3.421 0 0192 102.42v1.607a3.421 3.421 0 001.964 3.12l38.716 22.692c2.94 1.72 8.08 1.503 11.48-.49l37.033-21.723c1.964-1.139 2.907-2.631 2.794-4.02V102c.135 1.39-.808 2.87-2.771 4.021z",
  fill: "url(#H)",
  opacity: 0.8
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M173.71 104.141c.174.054.29.196.29.355 0 .16-.116.301-.29.355a1.77 1.77 0 01-1.42 0c-.174-.054-.29-.196-.29-.355 0-.159.116-.3.29-.355a1.857 1.857 0 011.42 0zM176.712 103.149c.173.054.288.196.288.355 0 .159-.115.3-.288.355-.45.188-.974.188-1.424 0-.173-.054-.288-.196-.288-.355 0-.16.115-.301.288-.355a1.778 1.778 0 011.424 0zM178.71 101.141c.174.054.29.196.29.355 0 .16-.116.301-.29.355a1.77 1.77 0 01-1.42 0c-.174-.054-.29-.196-.29-.355 0-.159.116-.3.29-.355a1.857 1.857 0 011.42 0z",
  fill: "#FCCC6D"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M135.464 108.57l-14.701-8.414c-1.131-.639-.984-1.748.305-2.487l14.068-8.044a4.87 4.87 0 014.4-.19l14.701 8.402c1.131.639.984 1.759-.305 2.487l-14.068 8.055a4.904 4.904 0 01-4.4.19z",
  fill: "#140E43",
  opacity: 0.1
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M144 53h-13v46.355a.447.447 0 00.277.425l5.457 3.065a1.855 1.855 0 001.624-.067l5.239-2.909a.674.674 0 00.391-.492L144 53z",
  fill: "url(#I)"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M155 44h-35v54.844c0 .497.295.946.748 1.142l14.73 8.58a4.836 4.836 0 004.362-.182l14.095-8.215c.552-.25.946-.759 1.054-1.36L155 44z",
  fill: "#86D1D7",
  opacity: 0.5
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M183.991 35.064v-7.216H165.36l-22.03-12.706c-2.94-1.692-8.077-1.479-11.476.47l-21.2 12.236H92.001v7.62a3.294 3.294 0 001.962 3.07l38.7 22.32c2.938 1.692 8.075 1.479 11.474-.47l37.016-21.368c2.008-1.132 2.95-2.6 2.838-3.956z",
  fill: "#33308E"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M183.991 35.064v-7.216H165.36l-22.03-12.706c-2.94-1.692-8.077-1.479-11.476.47l-21.2 12.236H92.001v7.62a3.294 3.294 0 001.962 3.07l38.7 22.32c2.938 1.692 8.075 1.479 11.474-.47l37.016-21.368c2.008-1.132 2.95-2.6 2.838-3.956z",
  fill: "url(#J)",
  opacity: 0.5
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M143.33 15.14a10.292 10.292 0 00-5.33-1.121V62a13.19 13.19 0 006.161-1.603l37.036-21.373c1.964-1.121 2.906-2.6 2.794-3.957V27.85h-18.619l-22.041-12.71z",
  fill: "url(#K)"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M132.688 51.86L93.983 29.566c-2.94-1.69-2.569-4.655.83-6.614l37.022-21.33c3.366-1.96 8.538-2.172 11.477-.482l38.705 22.294c2.94 1.69 2.569 4.655-.83 6.603l-37.022 21.342c-3.4 1.958-8.538 2.171-11.477.481z",
  fill: "#33308E"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M132.688 51.86L93.983 29.566c-2.94-1.69-2.569-4.655.83-6.614l37.022-21.33c3.366-1.96 8.538-2.172 11.477-.482l38.705 22.294c2.94 1.69 2.569 4.655-.83 6.603l-37.022 21.342c-3.4 1.958-8.538 2.171-11.477.481z",
  fill: "url(#L)",
  opacity: 0.5
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M133.164 49.07l-31.54-18.031c-2.407-1.375-2.1-3.775.669-5.364l30.19-17.356c2.77-1.589 6.958-1.77 9.353-.394l31.54 18.031c2.407 1.375 2.1 3.776-.669 5.365l-30.202 17.366c-2.77 1.59-6.957 1.758-9.34.383z",
  fill: "#B7E2E8"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M102.292 26.227l30.2-16.703c2.769-1.533 6.957-1.697 9.351-.37l31.539 17.4c.526.268.97.661 1.294 1.142.692-1.23.283-2.534-1.294-3.404l-31.539-17.4c-2.394-1.326-6.582-1.152-9.351.38l-30.2 16.693c-2.088 1.153-2.769 2.752-1.963 4.035a5.024 5.024 0 011.963-1.773z",
  fill: "#6ECACE"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M133.906 51.87L94.324 29.58c-3.005-1.69-3.728-4.184.838-6.612l37.86-21.327A13.695 13.695 0 01139 .018c-2.53-.129-5.046.425-7.274 1.6l-37.86 21.327c-3.442 1.958-3.855 4.923-.85 6.613l39.582 22.289a11.077 11.077 0 005.794 1.119 10.184 10.184 0 01-4.486-1.097z",
  fill: "url(#M)",
  opacity: 0.5
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M181.216 34.017l-37.033 21.698c-3.367 1.991-8.54 2.208-11.48.478L93.962 33.54A3.417 3.417 0 0192 30.42v1.638a3.417 3.417 0 001.964 3.118l38.716 22.655c2.94 1.73 8.08 1.513 11.48-.478l37.033-21.699c1.964-1.138 2.907-2.628 2.794-4.017V30c.135 1.388-.808 2.867-2.771 4.017z",
  fill: "url(#N)",
  opacity: 0.8
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M173.71 32.148c.174.053.29.194.29.352 0 .158-.116.299-.29.352a1.783 1.783 0 01-1.42 0c-.174-.053-.29-.194-.29-.352 0-.158.116-.299.29-.352a1.783 1.783 0 011.42 0zM176.707 31.149c.175.05.293.191.293.351 0 .16-.118.302-.293.351-.444.199-.97.199-1.414 0-.175-.05-.293-.191-.293-.351 0-.16.118-.302.293-.351.444-.199.97-.199 1.414 0zM178.71 29.149c.174.054.29.196.29.355 0 .159-.116.3-.29.355a1.857 1.857 0 01-1.42 0c-.174-.054-.29-.196-.29-.355 0-.16.116-.301.29-.355a1.77 1.77 0 011.42 0z",
  fill: "#FCCC6D"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M183.997 34c.067 1.335-.864 2.772-2.794 3.882l-37.018 21.399c-3.365 1.963-8.537 2.177-11.476.471L93.964 37.4A3.299 3.299 0 0192 34.325v64.24a3.366 3.366 0 001.951 2.94l38.713 22.352c2.939 1.694 8.076 1.481 11.475-.482l37.019-21.399c1.884-1.122 2.804-2.48 2.782-3.792V34h.056z",
  fill: "#86D1D7",
  opacity: 0.5
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.5,
  d: "M72 24h11v2H72zM77 28h5v2h-5zM77 33h5v2h-5zM77 38h5v2h-5zM72 43h11v2H72zM77 47h5v2h-5zM77 52h5v2h-5zM77 57h5v2h-5zM77 61h5v2h-5zM77 67h5v2h-5zM77 71h5v2h-5zM77 77h5v2h-5zM77 81h5v2h-5zM72 86h11v2H72zM77 90h5v2h-5z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.4,
  d: "M77 96h5v2h-5z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.3,
  d: "M77 100h5v2h-5z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.2,
  d: "M77 105h5v2h-5z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.1,
  d: "M77 110h5v2h-5z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.8,
  d: "M72 24h11v2H72zM77 38h5v2h-5zM77 47h5v2h-5zM77 71h5v2h-5z"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.4,
  d: "M190 29h4v4h-4zM190 35h4v4h-4zM190 42h4v4h-4zM190 48h4v4h-4zM190 54h4v4h-4zM195 29h4v4h-4zM195 35h4v4h-4zM195 42h4v4h-4zM195 48h4v4h-4zM195 54h4v4h-4zM201 29h4v4h-4zM201 35h4v4h-4zM201 42h4v4h-4zM201 48h4v4h-4zM201 54h4v4h-4z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.8,
  d: "M195 29h4v4h-4zM195 48h4v4h-4zM201 35h4v4h-4z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M211.611 98h-9.234c-.208 0-.377-.155-.377-.345 0-.191.169-.346.377-.346h8.858V49.691h-8.858c-.208 0-.377-.155-.377-.346 0-.19.169-.345.377-.345h9.234c.21 0 .382.153.389.345v48.31c-.007.192-.179.345-.389.345z",
  fill: "#86D1D7"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.4,
  d: "M190 84h4v4h-4zM190 90h4v4h-4zM190 96h4v4h-4zM195 84h4v4h-4zM195 90h4v4h-4zM195 96h4v4h-4zM201 84h4v4h-4zM201 90h4v4h-4zM201 96h4v4h-4z"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  fill: "#86D1D7",
  opacity: 0.8,
  d: "M195 84h4v4h-4zM201 90h4v4h-4z"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M74.291 126.933a9.564 9.564 0 01-5.958-.668c-1.158 0-6.344-2.617-7.205-.323-.75 2.004 1.975 3.863 3.443 4.22 3.188.78 5.517 2.382 6.83 2.66a3.285 3.285 0 002.957-.422c.904-.869.827-4.276-.067-5.467z",
  fill: "#3C2415"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M61.156 125.888c.571-1.235 2.779-.96 4.844-.496-1.692.71-2.826 2.068-3.013 3.608-1.312-.78-2.403-1.93-1.831-3.112z",
  fill: "#3C2415"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M71.578 131.339c-1.301-.251-3.702-1.696-6.944-2.399-1.245-.27-3.366-1.485-3.612-2.94-.28 1.666 2.243 3.14 3.612 3.442 3.242.702 5.61 2.147 6.944 2.398a3.701 3.701 0 003.007-.381c.198-.198.34-.435.415-.692-.977.66-2.244.871-3.422.572z",
  fill: "#232E62"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M64.307 125.037c-.629.338-1.099.932-1.3 1.644-.066.325.402.453.467.138.193-.781.78-1.387 1.526-1.576a.608.608 0 00-.693-.206z",
  fill: "#232E62"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M65.326 125.028a2.799 2.799 0 00-1.32 1.657c-.065.316.403.454.459.129.2-.78.789-1.383 1.535-1.569a.617.617 0 00-.674-.217zM67.345 125.037a2.656 2.656 0 00-1.339 1.645c-.065.317.403.456.468.139.193-.787.78-1.396 1.526-1.586a.561.561 0 00-.655-.198z",
  fill: "#232E62"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M75.963 77c-1.162.134-11.963.802-11.963.802.233 3.977 1.814 21.388 2.476 26.345.628 4.712 2.151 21.578 2.151 21.578 2.326 2.406 6.278.668 6.278.668s1.163-19.171.477-24.708c-1.22-10.47.919-17.834.581-24.685z",
  fill: "#25336C"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M67.293 129.931a9.559 9.559 0 01-5.954-.667c-1.169 0-6.351-2.615-7.211-.323-.75 2.003 1.984 3.86 3.44 4.217 3.198.779 5.513 2.38 6.836 2.659.992.35 2.09.192 2.945-.423.915-.912.838-4.272-.056-5.463z",
  fill: "#3C2415"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M54.111 129.016c.496-1.165 2.138-1.165 3.889-.804-1.545.676-2.234 2.331-2.593 3.788-1.133-.664-1.652-1.858-1.296-2.984z",
  fill: "#3C2415"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M64.579 135.334c-1.313-.251-3.702-1.695-6.955-2.397-1.245-.27-3.365-1.483-3.6-2.937-.293 1.664 2.243 3.138 3.6 3.439 3.253.702 5.609 2.145 6.955 2.396a3.615 3.615 0 002.995-.381c.201-.197.347-.434.426-.692-.978.658-2.244.87-3.421.572zM59.32 129.044a2.661 2.661 0 00-1.314 1.64c-.066.317.397.456.463.128.183-.8.773-1.426 1.531-1.629a.637.637 0 00-.68-.139z",
  fill: "#232E62"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M59.288 129.042a2.77 2.77 0 00-1.283 1.646c-.056.313.403.45.468.127.2-.771.785-1.368 1.527-1.558a.602.602 0 00-.712-.215zM60.345 130.035a2.626 2.626 0 00-1.339 1.644c-.065.327.403.456.468.139.193-.786.78-1.395 1.526-1.585a.57.57 0 00-.655-.198z",
  fill: "#232E62"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M69.976 82c-1.15.133-12.976.933-12.976.933.23 3.955 1.795 21.331 2.45 26.275.621 4.7 2.128 21.52 2.128 21.52 2.3 2.4 6.212.667 6.212.667s1.15-19.12.472-24.642C67.088 96.299 70.309 88.822 69.976 82z",
  fill: "#25336C"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M35.26 57.27a.68.68 0 01-.254-.363.462.462 0 01.195-.45c.231-.187.68-.132.946-.21a8.792 8.792 0 014.242-.164c0-.253-.138-.67.08-.9a.705.705 0 01.731-.135.65.65 0 01.422.585c.02.38.209.736.519.977.231.119.454.251.669.396l1.152.79c.784.528 7.69 5.492 8.07 5.712.415-1.098 1.256-2.955 1.683-4.02.922.846 3.285 3.987 3.285 4.68-.634 1.998-2.363 4.766-4.369 4.832-.957 0-8.945-7.183-10.582-8.787a2.93 2.93 0 01-2.006-.494 12.094 12.094 0 00-1.787-.066c-.645 0-1.464.153-1.833-.473a.548.548 0 01-.057-.494 2.89 2.89 0 01-.969-.34.62.62 0 01-.322-.55v-.11a.75.75 0 01.184-.417z",
  fill: "#FDDBCA"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M55.998 65.608c-1.895.37-4.356-1.706-4.998-3.895 0 0 1.023-3.739 1.568-5.355a14.884 14.884 0 013.343-5.916 25.456 25.456 0 018.296-5.614A8.956 8.956 0 0170 44.233c1.993.555 3.415 2.366 3.527 4.491.414 7.084 1.536 26.808 1.47 31.108 0 1.763-8.776 6.95-18.77 2.245-.23-.696-.502-9.138.402-19.084-.207.572-.207 1.583-.631 2.615z",
  fill: "#FEC233"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M69.753 32.037c-1.154-1.989-3.463-3.171-5.906-3.025-2.303.109-4.724 1.208-5.55 3.34-1.017 2.774-2.044 6.19-.532 8.9 4.807 8.8 13.842-6.071 11.988-9.215z",
  fill: "#FDDBCA"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M67.827 41.266a.27.27 0 00-.14-.231.279.279 0 00-.272.001c-1.45.855-4.582.615-4.582.814 0 0-.603 4.243-.825 5.577a.28.28 0 00.19.334 4.933 4.933 0 004.73-.949c.564-.385.946-.98 1.058-1.647a26.825 26.825 0 00-.159-3.9z",
  fill: "#FDDBCA"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M62.59 28.029c.378 0 .907.447 1.318.535a7.49 7.49 0 001.481.13 18.41 18.41 0 013.243 0 5.216 5.216 0 013.87 3.387 8.536 8.536 0 01-.422 6.73c-.649 1.365-2.886 4.959-4.778 4.041a6.89 6.89 0 01-2.82-2.862 2.153 2.153 0 002.593-1.092c.086-.333.01-.688-.202-.956a1.076 1.076 0 00-.879-.41 1.917 1.917 0 00-1.567.754c0-1.267 0-2.458-.054-2.458-2.356-.218-4.832-1.628-5.33-4.096a3.223 3.223 0 01.848-2.757 3.148 3.148 0 012.698-.946z",
  fill: "#050C3C"
});

var SvgComponent$i = function SvgComponent(props) {
  return React.createElement("svg", _extends$i({
    viewBox: "0 0 279 150"
  }, props), _ref$i, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2$e, _ref3$b, _ref4$a, _ref5$8, _ref6$7, _ref7$7, _ref8$5, _ref9$5, _ref10$4, _ref11$3, _ref12$2, _ref13$2, _ref14$2, _ref15$2, _ref16$2, _ref17$1, _ref18$1, _ref19$1, _ref20$1, _ref21$1, _ref22$1, _ref23$1, _ref24$1, _ref25$1, _ref26$1, _ref27$1, _ref28$1, _ref29$1, _ref30$1, _ref31$1, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    fillRule: "nonzero"
  }, _ref76, _ref77), _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, React.createElement("path", {
    d: "M181.211 37.883l-37.048 21.4A13.184 13.184 0 01138 60.888V125a13.33 13.33 0 006.163-1.616l37.048-21.4c1.886-1.123 2.807-2.48 2.784-3.794V34c.079 1.335-.853 2.772-2.784 3.883z",
    fill: "#6ECACE",
    opacity: 0.7,
    style: {
      mixBlendMode: "lighten"
    }
  }), _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128));
};

var css$9 = ".generate-progress-page {\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  align-items: center; }\n\n.generate-progress {\n  width: 605px;\n  margin: 0 auto;\n  color: #242424;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center; }\n  .generate-progress__image {\n    width: 50%; }\n    .generate-progress__image svg {\n      position: relative; }\n  .generate-progress__bar {\n    margin-top: 2.5rem;\n    width: 100%;\n    height: 0.8125rem;\n    border-radius: 20px;\n    background-color: #b7e2e8;\n    overflow: hidden;\n    position: relative; }\n    .generate-progress__bar-stripped {\n      width: 100%;\n      background-color: #303c79;\n      background-image: linear-gradient(135deg, rgba(183, 226, 232, 0.75) 25%, transparent 25%, transparent 50%, rgba(183, 226, 232, 0.75) 50%, rgba(183, 226, 232, 0.75) 75%, transparent 75%);\n      background-size: 40px 40px;\n      width: 100%;\n      height: 100%;\n      border-radius: 20px; }\n    .generate-progress__bar._animated .generate-progress__bar-stripped {\n      animation: progress-stripes 0.8s linear infinite; }\n  .generate-progress__value {\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 1.15;\n    text-align: center;\n    margin-top: 20px; }\n    .generate-progress__value._warn {\n      color: #ff5859; }\n      .generate-progress__value._warn a {\n        color: #ff5859;\n        text-decoration: underline; }\n    .generate-progress__value-dotted:after {\n      content: \"...\";\n      display: inline-block;\n      width: 20px;\n      text-align: left;\n      animation: dotted 1.5s linear infinite; }\n\n@keyframes progress-stripes {\n  from {\n    background-position-x: 0; }\n  to {\n    background-position-x: 40px; } }\n\n@keyframes dotted {\n  0% {\n    content: \"...\"; }\n  25% {\n    content: \"\"; }\n  50% {\n    content: \".\"; }\n  75% {\n    content: \"..\"; } }\n";
styleInject(css$9);

var GeneratingFileProgress = /*#__PURE__*/function (_React$Component) {
  inherits(GeneratingFileProgress, _React$Component);

  function GeneratingFileProgress() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, GeneratingFileProgress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(GeneratingFileProgress)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      inProgress: true,
      isError: false
    });
    return _this;
  }

  createClass(GeneratingFileProgress, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var base64, params, fileURL;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                base64 = window.location.hash.split('?params=')[1];
                if (!base64) window.close();
                params = JSON.parse(atob(base64));
                _context.next = 6;
                return this.props.getFileURL(params.request);

              case 6:
                fileURL = _context.sent;
                this.setState({
                  inProgress: false
                });
                window.location.href = fileURL;
                setTimeout(function () {
                  window.close();
                }, 2500);
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
                this.setState({
                  isError: true,
                  inProgress: false
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          inProgress = _this$state.inProgress,
          isError = _this$state.isError;
      return React.createElement("div", {
        className: "generate-progress-page"
      }, React.createElement("div", {
        className: "generate-progress"
      }, React.createElement("div", {
        className: "generate-progress__image"
      }, React.createElement(SvgComponent$i, null)), React.createElement("div", {
        className: "generate-progress__bar ".concat(inProgress ? '_animated' : '')
      }, React.createElement("div", {
        className: "generate-progress__bar-stripped"
      })), !inProgress && isError && React.createElement("div", {
        className: "generate-progress__value _warn"
      }, "File generation failed. Please try again or contact support at ", React.createElement("a", {
        href: "https://help.iqm.com/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "help.iqm.com"), " if problem persists."), inProgress && React.createElement("div", {
        className: "generate-progress__value"
      }, this.props.title, React.createElement("span", {
        className: "generate-progress__value-dotted"
      })), !inProgress && !isError && React.createElement("div", {
        className: "generate-progress__value"
      }, "Succesfully generated.")));
    }
  }]);
  return GeneratingFileProgress;
}(React.Component);

GeneratingFileProgress.propTypes = {
  title: PropTypes.string,
  getFileURL: PropTypes.func
};

function CSVDownloadingProgress() {
  var getFileURL = function getFileURL(params) {
    return TableApiService.downloadCSV(params);
  };

  return React.createElement(GeneratingFileProgress, {
    title: "Generating CSV. Please wait",
    getFileURL: getFileURL
  });
}

function XLSXDownloadingProgress() {
  var getFileURL = function getFileURL(params) {
    return TableApiService.downloadXLSX(params);
  };

  return React.createElement(GeneratingFileProgress, {
    title: "Generating XLSX. Please wait",
    getFileURL: getFileURL
  });
}

var LazySelect = /*#__PURE__*/function (_React$Component) {
  inherits(LazySelect, _React$Component);

  function LazySelect(props) {
    var _this;

    classCallCheck(this, LazySelect);
    _this = possibleConstructorReturn(this, getPrototypeOf(LazySelect).call(this, props));
    defineProperty(assertThisInitialized(_this), "onChange", function (value, selectedItem, deselectedAll) {
      if (deselectedAll) {
        _this.props.onChange([]);

        return;
      }

      if (_this.state.searchField) {
        var newSelectedValueMap = value.reduce(function (newSelectedValueMap, option) {
          newSelectedValueMap[option.value] = true;
          return newSelectedValueMap;
        }, {});

        if (_this.props.value && _this.props.value.length) {
          var isActiveSelectedItem = selectedItem && selectedItem.isActive;

          _this.props.value.forEach(function (option) {
            if (!(isActiveSelectedItem && selectedItem.value === option.value)) {
              if (!newSelectedValueMap[option.value]) {
                value.push(option);
              }
            }
          });
        }
      }

      _this.props.onChange(value);
    });
    defineProperty(assertThisInitialized(_this), "onScroll", function (event) {
      if (_this.state.isFetching || _this.state.totalRecords === _this.state.options.length || _this.state.filteredRecords === _this.state.options.length || event.target.offsetHeight + event.target.scrollTop !== event.target.scrollHeight) {
        return;
      }

      _this.setState({
        isFetching: true,
        pageNo: _this.state.pageNo + 1
      });
    });
    defineProperty(assertThisInitialized(_this), "loadData", /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var user, source, _ref2, data;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.prevSourceRequest) {
                _this.prevSourceRequest.cancel();
              }

              _context.prev = 1;
              user = AuthService.getUser();
              source = axios.CancelToken.source();
              _this.prevSourceRequest = source;
              _context.next = 7;
              return axios({
                cancelToken: source.token,
                url: _this.state.url,
                method: _this.state.httpMethod,
                headers: {
                  'x-iaa-api-token': user.apiToken
                },
                params: _this.props.transformPagingParameters(_this.state)
              });

            case 7:
              _ref2 = _context.sent;
              data = _ref2.data;
              _this.prevSourceRequest = null;
              return _context.abrupt("return", _this.props.mapServerReposponseData(data));

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              _this.prevSourceRequest = null;
              return _context.abrupt("return", {
                totalRecords: 0,
                filteredRecords: 0,
                data: []
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13]]);
    })));
    defineProperty(assertThisInitialized(_this), "componentDidUpdate", /*#__PURE__*/function () {
      var _ref3 = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(oldProps, oldState) {
        var currentUser, shoudlReplaceOptions, loadedOptions, map, options;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.props.apiPath !== oldProps.apiPath)) {
                  _context2.next = 5;
                  break;
                }

                currentUser = AuthService.getUser();

                if (_this.prevSourceRequest) {
                  _this.prevSourceRequest.cancel();
                }

                _this.selectedValueMap = _this.props.value && _this.props.value.reduce(function (selectedValueMap, selectedValue) {
                  selectedValueMap[selectedValue.value] = selectedValue;
                  return selectedValueMap;
                }, {});
                return _context2.abrupt("return", _this.setState({
                  url: "https://".concat(currentUser.domainURL, "/").concat(_this.props.apiPath),
                  isFetching: true,
                  pageNo: 1,
                  searchField: '',
                  totalRecords: 0,
                  filteredRecords: 0,
                  options: []
                }));

              case 5:
                if (!(oldState.pageNo !== _this.state.pageNo || oldState.searchField !== _this.state.searchField || oldState.url !== _this.state.url)) {
                  _context2.next = 17;
                  break;
                }

                if (!(oldState.searchField !== _this.state.searchField)) {
                  _context2.next = 10;
                  break;
                }

                if (!(oldState.searchField.length < _this.state.searchField.length)) {
                  _context2.next = 10;
                  break;
                }

                if (!(_this.state.totalRecords && !_this.state.filteredRecords)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return");

              case 10:
                shoudlReplaceOptions = oldState.searchField !== _this.state.searchField || oldState.url !== _this.state.url;
                _context2.next = 13;
                return _this.loadData();

              case 13:
                loadedOptions = _context2.sent;

                if (oldState.searchField !== _this.state.searchField) {
                  if (!_this.state.searchField && _this.props.value) {
                    _this.selectedValueMap = _this.selectedValueMap || {};
                    map = loadedOptions.data.reduce(function (res, option) {
                      res[option.value] = option;
                      return res;
                    }, {});

                    _this.props.value.forEach(function (option) {
                      if (!map[option.value]) {
                        _this.selectedValueMap[option.value] = option;
                      }
                    });
                  }
                } else {
                  _this.selectedValueMap && loadedOptions.data.map(function (option) {
                    if (_this.selectedValueMap[option.value]) {
                      delete _this.selectedValueMap[option.value];
                    }

                    return option;
                  });
                }

                options = shoudlReplaceOptions ? loadedOptions.data : [].concat(toConsumableArray(_this.state.options), toConsumableArray(loadedOptions.data));
                !_this.isUnmounted && _this.setState({
                  options: options,
                  totalRecords: loadedOptions.totalRecords,
                  filteredRecords: loadedOptions.filteredRecords,
                  isFetching: false
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    defineProperty(assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var config, observer, loadedOptions, selectedValueMap;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              config = {
                attributes: true
              };
              observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                  if (mutation.attributeName === 'class') {
                    var target = mutation.target;
                    var isOpenedMenu = ~target.className.indexOf('_opened');

                    if (isOpenedMenu) {
                      if (_this.state.searchField) {
                        var inputElement = target.querySelector('.select__list-input');
                        inputElement.value = _this.state.searchField;
                      }

                      var listElement = target.querySelector('.select__list');

                      if (listElement) {
                        listElement.onscroll = _this.onScroll;

                        _this.forceUpdate();
                      }
                    }
                  }
                });
              });
              observer.observe(_this.selectRef.current.select, config);
              _context3.next = 5;
              return _this.loadData();

            case 5:
              loadedOptions = _context3.sent;
              selectedValueMap = _this.props.value && _this.props.value.reduce(function (selectedValueMap, selectedValue) {
                selectedValueMap[selectedValue.value] = selectedValue;
                return selectedValueMap;
              }, {});

              if (selectedValueMap) {
                _this.selectedValueMap = selectedValueMap;
                loadedOptions.data.map(function (option) {
                  if (selectedValueMap[option.value]) {
                    delete selectedValueMap[option.value];
                  }

                  return option;
                });
              }

              !_this.isUnmounted && _this.setState({
                options: loadedOptions.data,
                totalRecords: loadedOptions.totalRecords,
                filteredRecords: loadedOptions.filteredRecords,
                isFetching: false
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    defineProperty(assertThisInitialized(_this), "tryRenderPortal", function () {
      if (!_this.state.isFetching) {
        return null;
      }

      var listElement = _this.selectRef.current && _this.selectRef.current.select.querySelector('.select__list');

      if (!listElement) {
        return null;
      }

      if (_this.state.totalRecords && !_this.state.filteredRecords) {
        return;
      }

      var total = _this.state.totalRecords > _this.state.filteredRecords ? _this.state.filteredRecords : _this.state.totalRecords;

      if (total === _this.state.options.length) {
        return;
      }

      var leftRecords = total - _this.state.options.length;
      var skeletonCount = leftRecords ? Math.min(_this.state.noOfEntries, leftRecords) : _this.state.noOfEntries;
      var style = {
        width: '100%',
        height: '18px'
      };
      return ReactDOM.createPortal(React.createElement(React.Fragment, null, times(skeletonCount, function (index) {
        return React.createElement("div", {
          key: "".concat(index, "-select-skeleton"),
          className: "select__option"
        }, React.createElement("div", {
          className: "select__option-label"
        }, React.createElement("div", {
          className: "skeleton-block",
          style: style
        })));
      })), listElement);
    });
    defineProperty(assertThisInitialized(_this), "handleSearchField", function (event) {
      _this.debouncedUpdateSearchField(event.target.value);
    });
    defineProperty(assertThisInitialized(_this), "updateSearchField", function (value) {
      _this.setState({
        searchField: value,
        pageNo: 1,
        isFetching: true
      });
    });
    _this.selectRef = React.createRef();

    var _currentUser = AuthService.getUser();

    _this.state = {
      isFetching: true,
      options: props.value || [],
      httpMethod: props.httpMethod || 'get',
      dspId: _currentUser.dspId,
      advertiserId: _currentUser.userId,
      url: "https://".concat(_currentUser.domainURL, "/").concat(props.apiPath),
      pageNo: 1,
      noOfEntries: props.numberOfEntries || 100,
      searchField: ''
    };
    _this.debouncedUpdateSearchField = throttle(_this.updateSearchField, 300);
    return _this;
  }

  createClass(LazySelect, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.prevSourceRequest) {
        this.isUnmounted = true;
        this.prevSourceRequest.cancel();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedValues = this.selectedValueMap && !this.state.searchField ? Object.keys(this.selectedValueMap).map(function (key) {
        return _this2.selectedValueMap[key];
      }) : [];
      return React.createElement(React.Fragment, null, React.createElement(Select, _extends_1({
        ref: this.selectRef,
        onChange: this.onChange,
        value: this.props.value,
        options: [].concat(toConsumableArray(selectedValues), toConsumableArray(this.state.options)),
        totalRecords: this.state.filteredRecords || this.state.totalRecords,
        searchString: this.state.searchField,
        changeSearchHandler: this.handleSearchField,
        placeholder: "Include All",
        isMulti: true,
        isSearchable: true,
        searchByValue: true,
        isClearable: true,
        allSelectable: true
      }, this.props.selectSpecificProps)), this.tryRenderPortal());
    }
  }]);
  return LazySelect;
}(React.Component);

LazySelect.propTypes = {
  transformPagingParameters: PropTypes.func,
  mapServerReposponseData: PropTypes.func,
  onChange: PropTypes.func,
  httpMethod: PropTypes.string,
  apiPath: PropTypes.string,
  numberOfEntries: PropTypes.number,
  selectSpecificProps: PropTypes.object,
  value: PropTypes.array
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

function Dropdown(props) {
  var dropdownIsOpened = props.dropdownIsOpened,
      toggleOpeningEl = props.toggleOpeningEl,
      toggleDropdownVisilitiy = props.toggleDropdownVisilitiy,
      hasSelectedItems = props.hasSelectedItems,
      allowsToSelectAll = props.allowsToSelectAll,
      handleClearSelection = props.handleClearSelection,
      handleSelectAllItems = props.handleSelectAllItems,
      label = props.label,
      placeholder = props.placeholder,
      selectedLabel = props.selectedLabel,
      style = props.style,
      className = props.className,
      children = props.children;
  var wrapperClassName = "select-with-creating ".concat(className || '');
  var selectClassName = "select js-select ".concat(dropdownIsOpened ? '_opened' : '');
  var upperLabel = hasSelectedItems ? label : placeholder;
  var mainLabel = hasSelectedItems ? selectedLabel : '';
  var onClearSelection = useCallback(function (event) {
    event.stopPropagation();
    handleClearSelection();
  }, []);
  var onSelectAll = useCallback(function (event) {
    event.stopPropagation();
    handleSelectAllItems();
  }, []);
  var clearSelectionElement = hasSelectedItems && React.createElement("div", {
    className: "select__clear",
    onClick: onClearSelection
  }, React.createElement(Icon, {
    name: "Close"
  }));
  var selectAllElement = allowsToSelectAll && React.createElement("div", {
    className: "select__btn-secondary",
    onClick: onSelectAll
  }, "Select All");
  return React.createElement("div", {
    style: style,
    className: wrapperClassName,
    ref: toggleOpeningEl
  }, React.createElement("div", {
    className: selectClassName
  }, React.createElement("div", {
    className: "select__outer-wrapper"
  }, React.createElement("div", {
    className: "select__wrapper"
  }, React.createElement("div", {
    className: "select__btn",
    onClick: toggleDropdownVisilitiy
  }, React.createElement("div", {
    className: "select__label ".concat(hasSelectedItems ? '_up' : '')
  }, upperLabel), React.createElement("div", {
    className: "select__value ".concat(hasSelectedItems ? '_selected' : '')
  }, mainLabel), selectAllElement, clearSelectionElement, React.createElement("div", {
    className: "select__indicator"
  })), dropdownIsOpened && children))));
}

Dropdown.propTypes = {
  dropdownIsOpened: PropTypes.bool,
  toggleOpeningEl: PropTypes.object,
  toggleDropdownVisilitiy: PropTypes.func,
  hasSelectedItems: PropTypes.bool,
  allowsToSelectAll: PropTypes.bool,
  handleClearSelection: PropTypes.func,
  handleSelectAllItems: PropTypes.func,
  selectedLabel: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
};

function DropdownActionButtons(props) {
  var onApply = props.onApply,
      onCancel = props.onCancel,
      applyButtonIsDisabled = props.applyButtonIsDisabled;
  return React.createElement("div", {
    className: "select__list-wrapper _action-buttons"
  }, React.createElement(Button, {
    className: "btn-square _conflower-blue mr-2",
    onClick: onCancel
  }, "Cancel"), React.createElement(Button, {
    className: "btn-square _filled _conflower-blue",
    disabled: applyButtonIsDisabled,
    onClick: onApply
  }, "Apply"));
}

DropdownActionButtons.propTypes = {
  applyButtonIsDisabled: PropTypes.bool,
  onCancel: PropTypes.func,
  onApply: PropTypes.func
};

function CreatingForm(props) {
  var createNewItem = props.createNewItem,
      cancelCreating = props.cancelCreating,
      newItemPlaceholder = props.newItemPlaceholder,
      buttonLabel = props.buttonLabel,
      newItemName = props.newItemName,
      changeNewItemName = props.changeNewItemName;
  return React.createElement("div", {
    className: "select__list-wrapper _header"
  }, React.createElement(TextField, {
    name: "newItemNameInput",
    label: newItemPlaceholder,
    onChange: changeNewItemName,
    value: newItemName,
    inputRef: function inputRef(v) {
      return v.select();
    },
    autofocus: true
  }), React.createElement("div", {
    className: "select__buttons d-flex mt-3 mb-3"
  }, React.createElement(Button, {
    className: "create-group-container__button btn-square _conflower-blue _sm mr-2",
    onClick: cancelCreating
  }, "Cancel"), React.createElement(Button, {
    className: "create-group-container__button btn-square _filled _conflower-blue _sm",
    onClick: createNewItem
  }, buttonLabel)));
}

CreatingForm.propTypes = {
  buttonLabel: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  createNewItem: PropTypes.func,
  cancelCreating: PropTypes.func,
  newItemName: PropTypes.string,
  changeNewItemName: PropTypes.func
};

function SelectListHeader(props) {
  var switchToCreateMode = props.switchToCreateMode,
      buttonLabel = props.buttonLabel,
      changeSearchString = props.changeSearchString,
      searchString = props.searchString;
  var handeChangeSearchString = useCallback(function (event) {
    return changeSearchString(event.target.value);
  });
  return React.createElement("div", {
    className: "select__list-wrapper _header"
  }, React.createElement("div", {
    className: "select__search btn-select__search"
  }, React.createElement(TextFieldWithIcon, {
    iconName: "Search",
    onChange: handeChangeSearchString,
    value: searchString,
    placeholder: "Search"
  })), React.createElement("div", {
    className: "select__buttons d-flex mt-3 mb-3"
  }, React.createElement(Button, {
    className: "create-group-container__button btn-round _conflower-blue _sm",
    onClick: switchToCreateMode
  }, buttonLabel)));
}

SelectListHeader.propTypes = {
  buttonLabel: PropTypes.string,
  searchString: PropTypes.string,
  switchToCreateMode: PropTypes.func,
  changeSearchString: PropTypes.func
};

function DropdownHeader(props) {
  var allowsToCreateNewItem = props.allowsToCreateNewItem,
      buttonLabel = props.buttonLabel,
      newItemPlaceholder = props.newItemPlaceholder,
      newItemName = props.newItemName,
      searchString = props.searchString,
      createNewItem = props.createNewItem,
      doInvertAllowingToCreateNewItem = props.doInvertAllowingToCreateNewItem,
      doChangeSearchString = props.doChangeSearchString,
      doChangeNewItemName = props.doChangeNewItemName;
  return allowsToCreateNewItem ? React.createElement(CreatingForm, {
    newItemPlaceholder: newItemPlaceholder,
    buttonLabel: buttonLabel,
    cancelCreating: doInvertAllowingToCreateNewItem,
    newItemName: newItemName,
    changeNewItemName: doChangeNewItemName,
    createNewItem: createNewItem
  }) : React.createElement(SelectListHeader, {
    switchToCreateMode: doInvertAllowingToCreateNewItem,
    buttonLabel: buttonLabel,
    searchString: searchString,
    changeSearchString: doChangeSearchString
  });
}

DropdownHeader.propTypes = {
  allowsToCreateNewItem: PropTypes.bool,
  buttonLabel: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  newItemName: PropTypes.string,
  searchString: PropTypes.string,
  createNewItem: PropTypes.func,
  doInvertAllowingToCreateNewItem: PropTypes.func,
  doChangeSearchString: PropTypes.func,
  doChangeNewItemName: PropTypes.func
};

function DropdownItem(props) {
  var deleteItem = props.deleteItem,
      selectItem = props.selectItem,
      item = props.item,
      isSelected = props.isSelected;
  var className = "select__option ".concat(isSelected ? '_active' : '');
  var onSelectItem = useCallback(function () {
    selectItem(item, !isSelected);
  }, [isSelected]);
  var onDeleteItem = useCallback(function (event) {
    event.stopPropagation();
    deleteItem(item);
  }, []);
  return React.createElement("div", {
    key: item.value,
    className: className,
    onClick: onSelectItem
  }, React.createElement("div", {
    className: "select__option-label"
  }, item.label), React.createElement(Icon, {
    name: "Delete",
    onClick: onDeleteItem
  }));
}

DropdownItem.propTypes = {
  item: PropTypes.object,
  isSelected: PropTypes.any,
  deleteItem: PropTypes.func,
  selectItem: PropTypes.func
};

function DropdownItems(props) {
  var selectListItems = props.selectListItems,
      selectionMap = props.selectionMap,
      deleteItem = props.deleteItem,
      selectItem = props.selectItem;
  var selectListRef = useRef(null);

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      isScrollable = _useState2[0],
      setIsScrollable = _useState2[1];

  var changeScrollability = useCallback(function () {
    var isScrollable = selectListRef.current && selectListRef.current.clientHeight < selectListRef.current.scrollHeight;
    setIsScrollable(isScrollable);
  }, []);
  useEffect(function () {
    changeScrollability();
  }, [selectListItems]);
  useEffect(function () {
    changeScrollability();
  }, []);
  var selectListItemsComponents = selectListItems.map(function (selectListItem) {
    var item = selectionMap[selectListItem.value];
    return React.createElement(DropdownItem, {
      key: selectListItem.value,
      item: selectListItem,
      isSelected: item && item.itemIsSelected,
      selectItem: selectItem,
      deleteItem: deleteItem
    });
  });
  return React.createElement("div", {
    className: "select__list-container ".concat(isScrollable ? '_scrollable' : '')
  }, React.createElement("div", {
    className: "select__list",
    ref: selectListRef
  }, selectListItemsComponents));
}

DropdownItems.propTypes = {
  selectListItems: PropTypes.array,
  selectionMap: PropTypes.object,
  deleteItem: PropTypes.func,
  selectItem: PropTypes.func
};
var TOGGLE_SELECT_VISIBILITY = 'TOGGLE_SELECT_VISIBILITY';
var ALLOWS_TO_CREATE_NEW_ITEM = 'ALLOWS_TO_CREATE_NEW_ITEM';
var CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING';
var CHANGE_NEW_ITEM_NAME = 'CHANGE_NEW_ITEM_NAME';
var HANDLE_SELECT_ITEM = 'HANDLE_SELECT_ITEM';
var HANDLE_DELETE_ITEM = 'HANDLE_DELETE_ITEM';
var HANDLE_SELECT_ALL_ITEMS = 'HANDLE_SELECT_ALL_ITEMS';
var HANDLE_DESELECT_ALL_ITEMS = 'HANDLE_DESELECT_ALL_ITEMS';
var ADD_NEW_ITEM = 'ADD_NEW_ITEM';
var ADD_NEW_ITEMS = 'ADD_NEW_ITEMS';
var CLEAR_STATE = 'CLEAR_STATE';

function getIntialState(props) {
  var shouldApplyChanges = props.shouldApplyChanges,
      items = props.items,
      value = props.value;
  var intialState = {
    selectListIsOpened: false,
    allowsToCreateNewItem: false,
    selectionMap: {},
    defaultDataSnapshot: {},
    searchString: '',
    newItemName: '',
    changesCount: 0,
    selectedItemsCount: value.length,
    shouldApplyChanges: shouldApplyChanges
  };
  var map = value.reduce(function (map, selectedItem) {
    map[selectedItem.value] = selectedItem;
    return map;
  }, {});
  items.forEach(function (item) {
    if (map[item.value]) {
      intialState.selectionMap[item.value] = {
        itemIsSelected: true,
        item: item
      };
    }

    intialState.defaultDataSnapshot[item.value] = !!map[item.value];
  });
  return intialState;
}

var _reducer;

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$7(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$7(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var reducer = (_reducer = {}, defineProperty(_reducer, TOGGLE_SELECT_VISIBILITY, function (state, action) {
  return state.shouldApplyChanges && state.selectListIsOpened ? getIntialState(action.props) : _objectSpread$7({}, state, {
    selectListIsOpened: !state.selectListIsOpened
  });
}), defineProperty(_reducer, ALLOWS_TO_CREATE_NEW_ITEM, function (state, action) {
  var allowsToCreateNewItem = !state.allowsToCreateNewItem;

  var updatedState = _objectSpread$7({}, state, {
    allowsToCreateNewItem: allowsToCreateNewItem
  });

  if (!state.allowsToCreateNewItem) {
    updatedState.newItemName = state.searchString;
    updatedState.searchString = '';
  }

  return updatedState;
}), defineProperty(_reducer, CHANGE_SEARCH_STRING, function (state, action) {
  return _objectSpread$7({}, state, {
    searchString: action.searchString
  });
}), defineProperty(_reducer, CHANGE_NEW_ITEM_NAME, function (state, action) {
  return _objectSpread$7({}, state, {
    newItemName: action.newItemName
  });
}), defineProperty(_reducer, HANDLE_DELETE_ITEM, function (state, action) {
  var newState = _objectSpread$7({}, state);

  if (newState.selectionMap[action.item.value]) {
    if (newState.selectionMap[action.item.value].itemIsSelected) {
      newState.selectedItemsCount--;
    }

    if (newState.selectionMap[action.item.value].itemIsSelected !== newState.defaultDataSnapshot[action.item.value]) {
      newState.changesCount--;
    }
  }

  if (newState.selectionMap[action.item.value]) {
    newState.selectionMap = _objectSpread$7({}, newState.selectionMap);
    delete newState.selectionMap[action.item.value];
    newState.defaultDataSnapshot = _objectSpread$7({}, newState.defaultDataSnapshot);
    delete newState.defaultDataSnapshot[action.item.value];
  }

  return newState;
}), defineProperty(_reducer, HANDLE_SELECT_ALL_ITEMS, function (state, action) {
  var changesCount = 0;
  var selectionMap = action.items.reduce(function (selectionMap, item) {
    if (!state.defaultDataSnapshot[item.value]) {
      changesCount++;
    }

    selectionMap[item.value] = {
      itemIsSelected: true,
      item: item
    };
    return selectionMap;
  }, {});
  return _objectSpread$7({}, state, {
    changesCount: changesCount,
    selectedItemsCount: action.items.length,
    selectionMap: selectionMap
  });
}), defineProperty(_reducer, HANDLE_DESELECT_ALL_ITEMS, function (state, action) {
  var changesCount = 0;
  var selectionMap = action.items.reduce(function (selectionMap, item) {
    if (state.defaultDataSnapshot[item.value]) {
      changesCount++;
    }

    selectionMap[item.value] = {
      itemIsSelected: false,
      item: item
    };
    return selectionMap;
  }, {});
  return _objectSpread$7({}, state, {
    changesCount: changesCount,
    selectedItemsCount: 0,
    selectionMap: selectionMap
  });
}), defineProperty(_reducer, HANDLE_SELECT_ITEM, function (state, action) {
  var item = action.item,
      itemIsSelected = action.itemIsSelected;

  var _selectionMap = !action.isMulti ? Object.keys(state.selectionMap).reduce(function (selectionMap, itemValue) {
    selectionMap[itemValue] = _objectSpread$7({}, state.selectionMap[itemValue]);

    if (selectionMap[itemValue].item.value === item.value) {
      selectionMap[itemValue].itemIsSelected = itemIsSelected;
    } else {
      selectionMap[itemValue].itemIsSelected = false;
    }

    return selectionMap;
  }, defineProperty({}, item.value, {
    item: item,
    itemIsSelected: itemIsSelected
  })) : _objectSpread$7({}, state.selectionMap, defineProperty({}, item.value, {
    item: item,
    itemIsSelected: itemIsSelected
  }));

  var changesCount = state.changesCount;

  if (state.shouldApplyChanges) {
    if (state.defaultDataSnapshot[item.value] === itemIsSelected) {
      changesCount--;
    } else {
      changesCount++;
    }
  }

  return _objectSpread$7({}, state, {
    changesCount: changesCount,
    selectedItemsCount: itemIsSelected ? state.selectedItemsCount + 1 : state.selectedItemsCount - 1,
    selectionMap: _selectionMap
  });
}), defineProperty(_reducer, ADD_NEW_ITEMS, function (state, action) {
  var defaultDataSnapshot = _objectSpread$7({}, state.defaultDataSnapshot);

  action.items.forEach(function (item) {
    defaultDataSnapshot[item.value] = false;
  });
  return _objectSpread$7({}, state, {
    defaultDataSnapshot: defaultDataSnapshot
  });
}), defineProperty(_reducer, ADD_NEW_ITEM, function (state, action) {
  return _objectSpread$7({}, state, {
    defaultDataSnapshot: _objectSpread$7({}, state.defaultDataSnapshot, defineProperty({}, action.item.value, false))
  });
}), defineProperty(_reducer, CLEAR_STATE, function (state, action) {
  return _objectSpread$7({}, state, {
    allowsToCreateNewItem: false,
    newItemName: ''
  });
}), _reducer);

var selectWithCreatingBlockReducer = function selectWithCreatingBlockReducer(state, action) {
  return reducer[action.type] && reducer[action.type](state, action);
};

var invertAllowingToCreateNewItem = function invertAllowingToCreateNewItem(allowsToCreateNewItem) {
  return {
    type: ALLOWS_TO_CREATE_NEW_ITEM,
    allowsToCreateNewItem: allowsToCreateNewItem
  };
};

var toggleSelectListVisibility = function toggleSelectListVisibility(props) {
  return {
    type: TOGGLE_SELECT_VISIBILITY,
    props: props
  };
};

var changeSearchString = function changeSearchString(searchString) {
  return {
    type: CHANGE_SEARCH_STRING,
    searchString: searchString
  };
};

var changeNewItemName = function changeNewItemName(newItemName) {
  return {
    type: CHANGE_NEW_ITEM_NAME,
    newItemName: newItemName
  };
};

var handleSelectItem = function handleSelectItem(item, itemIsSelected, isMulti) {
  return {
    type: HANDLE_SELECT_ITEM,
    item: item,
    itemIsSelected: itemIsSelected,
    isMulti: isMulti
  };
};

var handleSelectAllItems = function handleSelectAllItems(items) {
  return {
    type: HANDLE_SELECT_ALL_ITEMS,
    items: items
  };
};

var handleDeselectAllItems = function handleDeselectAllItems(items) {
  return {
    type: HANDLE_DESELECT_ALL_ITEMS,
    items: items
  };
};

var handleDeleteItem = function handleDeleteItem(item) {
  return {
    type: HANDLE_DELETE_ITEM,
    item: item
  };
};

var addNewItem = function addNewItem(item) {
  return {
    type: ADD_NEW_ITEM,
    item: item
  };
};

var addNewItems = function addNewItems(items) {
  return {
    type: ADD_NEW_ITEMS,
    items: items
  };
};

var clearState = function clearState() {
  return {
    type: CLEAR_STATE
  };
};

var css$a = ".select__list-input {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.21429em; }\n\n.title-main {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 3rem;\n  text-transform: capitalize;\n  color: #787878; }\n\n.title-main-subtitle {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 2.25rem;\n  text-transform: uppercase;\n  color: #ff5859; }\n\n.title-form {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 1.25rem;\n  text-transform: uppercase;\n  color: #3fd4ad; }\n\n.title-form-subtitle {\n  font-family: 'Lato Light', sans-serif;\n  font-weight: 400;\n  font-size: 2rem;\n  color: #000000; }\n\n.title-card {\n  font-family: 'Lato Medium', sans-serif;\n  font-weight: 400;\n  font-size: 1.5rem;\n  line-height: 1.375em;\n  color: #000000; }\n\n.title-card-subtitle {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  color: #787878; }\n\n.paragraph {\n  margin-bottom: 1.5rem;\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.78947em;\n  color: #787878; }\n  .paragraph_large {\n    font-size: 1.5rem; }\n\n.select {\n  position: relative;\n  z-index: 1;\n  width: 15.625rem; }\n  .select:hover {\n    z-index: 2; }\n  .select._opened {\n    z-index: 3; }\n  .select__label {\n    position: absolute;\n    padding: 0;\n    max-width: calc(100% - 31rem/16);\n    background: transparent;\n    overflow: hidden;\n    transition: padding .25s, transform .25s, font-size .25s, color .25s;\n    font-family: 'Lato Light Italic', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .select__label._up {\n      transform: translate(-0.375rem, -1.125rem);\n      padding: 0 0.125rem;\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      font-size: .75rem;\n      color: #a2a2a2; }\n      .select__label._up:before {\n        content: '';\n        position: absolute;\n        z-index: -1;\n        top: 0.3125rem;\n        left: 0.125rem;\n        right: 0.125rem;\n        height: 0.125rem;\n        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.001) 0, #fff 100%); }\n      .select__label._up:after {\n        content: '';\n        position: absolute;\n        z-index: -1;\n        top: 0.4375rem;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0, #fff 0.125rem, #fff calc(100% - 2rem/16), rgba(255, 255, 255, 0.001)); }\n  .select__value {\n    margin-right: auto;\n    overflow: hidden;\n    font-family: 'Lato Light', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .select__value:not(._selected) {\n      font-family: 'Lato Light Italic', sans-serif;\n      font-weight: 400; }\n    .select__value._selected {\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      color: black; }\n  .select._opened .select__value, .select._opened .select__label:not(._up) {\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400; }\n    .select._opened .select__value:not(._selected), .select._opened .select__label:not(._up):not(._selected) {\n      font-family: 'Lato Bold Italic', sans-serif;\n      font-weight: 400; }\n  .select._opened .select__label._up {\n    color: #6075ff; }\n  .select__outer-wrapper {\n    position: relative;\n    height: 2.25rem; }\n  .select__wrapper {\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    width: 100%;\n    border-radius: .25rem;\n    transition: box-shadow .25s; }\n  .select:hover .select__btn {\n    border-color: #6075ff; }\n  .select:hover .select__label._up {\n    color: #6075ff; }\n  .select:hover .select__indicator {\n    border-top-color: #505050; }\n  .select:hover .select__wrapper {\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n  .select__btn {\n    display: flex;\n    position: relative;\n    font-family: 'Lato Light', sans-serif;\n    font-weight: 400;\n    border: 0.0625rem solid #e0e0e0;\n    border-radius: .25rem;\n    height: 2.25rem;\n    padding: 0 1.125rem 0 0.8125rem;\n    align-items: center;\n    cursor: pointer;\n    width: 100%;\n    background-color: white;\n    white-space: nowrap; }\n    .select__btn-secondary {\n      margin-right: .5rem;\n      padding-left: .5rem;\n      font-family: 'Lato Bold', sans-serif;\n      font-weight: 400;\n      font-size: 0.875rem;\n      color: #8293ff; }\n      .select__btn-secondary:hover {\n        color: #4f67ff; }\n  .select__clear {\n    margin-right: .5rem; }\n    .select__clear svg {\n      width: 12px;\n      height: 12px; }\n    .select__clear:hover svg {\n      fill: black; }\n  .select__indicator {\n    position: absolute;\n    top: 50%;\n    right: 0.625rem;\n    transform: translateY(-50%);\n    border-style: solid;\n    border-width: 0.3125rem 0.25rem 0 0.25rem;\n    border-color: #787878 transparent transparent transparent;\n    cursor: pointer;\n    width: 0;\n    height: 0;\n    transition: border .25s; }\n  .select__list-wrapper {\n    display: none;\n    position: relative;\n    z-index: 1;\n    padding: 0 0.4375rem;\n    border-top: 0.0625rem solid #d8d8d8;\n    border-radius: 0 0 0.1875rem 0.1875rem;\n    width: 100%;\n    background-color: white;\n    overflow: hidden; }\n  .select__list-input-wrapper {\n    position: relative;\n    margin: 0.25rem 0;\n    width: 100%; }\n    .select__list-input-wrapper svg {\n      position: absolute;\n      width: 1.125rem;\n      height: auto;\n      top: 50%;\n      transform: translateY(-50%);\n      left: 0.5625rem; }\n  .select__list {\n    margin: 0 -0.4375rem;\n    max-height: 15.625rem;\n    overflow-y: auto; }\n  .select__option {\n    position: relative; }\n    .select__option:not(._header):hover {\n      background-color: #f2f5ff; }\n      .select__option:not(._header):hover .select__option-icon._dnd {\n        opacity: 1; }\n    .select__option:not(._header)._active {\n      background-color: #dfe4ff; }\n    .select__option-label {\n      display: flex;\n      align-items: center;\n      padding: 0.3125rem 0.8125rem;\n      font-family: 'Lato Light', sans-serif;\n      font-weight: 400;\n      font-size: 0.875rem;\n      line-height: 1.125rem;\n      cursor: pointer; }\n    .select__option._header .select__option-label {\n      font-family: 'Lato Bold', sans-serif;\n      font-weight: 400;\n      cursor: initial; }\n    .select__option-icon {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      pointer-events: none;\n      line-height: 0; }\n      .select__option-icon._dnd {\n        right: 0.6875rem;\n        width: 1rem;\n        height: auto;\n        cursor: pointer;\n        opacity: 0; }\n        .select__option-icon._dnd svg {\n          width: auto;\n          height: auto; }\n    .select__option._active {\n      position: relative; }\n      .select__option._active:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: .25rem;\n        background: #6075ff; }\n    .select__option-image {\n      flex: 0 0 auto;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-right: .5rem; }\n      .select__option-image img {\n        max-width: 8.4375rem;\n        max-height: 5rem; }\n  .select._dnd .select__option:not(._active) {\n    background-color: white; }\n  .select._dnd .select__option:hover {\n    background-color: #f2f5ff; }\n  .select._dnd .select__option-label {\n    padding-right: 1.875rem; }\n  .select._dnd .select__option._active svg {\n    fill: #798eff; }\n  .select._dnd .select__option._active:hover {\n    background: #f2f5ff; }\n  .select._dnd .select__option._enabled {\n    background-color: #dfe4ff; }\n    .select._dnd .select__option._enabled svg {\n      fill: #798eff; }\n  .select._dnd .select__option._last-enabled {\n    position: relative; }\n    .select._dnd .select__option._last-enabled ~ ._separator {\n      display: block;\n      opacity: 1;\n      height: 1px;\n      width: 100%;\n      background-color: #6075ff; }\n  .select._dnd .select__option._hide {\n    opacity: .3; }\n  .select._dnd .select__option._separator:before {\n    content: '';\n    position: absolute;\n    left: -0.5rem;\n    right: -0.5rem;\n    height: 2px;\n    background-color: #798eff; }\n  .select._dnd .select__option._separator._top:before {\n    top: 0; }\n  .select._dnd .select__option._separator._bottom:before {\n    bottom: 0; }\n  .select._dnd .select__list {\n    margin: 0; }\n    .select._dnd .select__list-wrapper {\n      padding: 0; }\n  .select._sorting .select__list {\n    cursor: pointer; }\n  .select._sorting .select__option:hover {\n    background-color: white; }\n    .select._sorting .select__option:hover .select__option-icon._dnd {\n      opacity: 0; }\n  .select._sorting .select__option._active:hover {\n    background-color: #dfe4ff; }\n  .select._sorting .select__option._active:not(._enabled):hover {\n    background-color: #dfe4ff; }\n  .select._with-groups .select__option-label {\n    align-items: center;\n    min-height: 1.75rem;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400; }\n  .select._with-groups .select__option._header .select__option-label {\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400; }\n  .select__list-input {\n    padding: 0 0.625rem 0 1.9375rem;\n    width: 100%;\n    height: 2.25rem;\n    border-radius: .25rem;\n    border: 0.0625rem solid #dddddd;\n    outline: 0;\n    color: #000; }\n    .select__list-input::-moz-placeholder {\n      color: #a2a2a2;\n      opacity: 1;\n      font-family: inherit; }\n    .select__list-input:-ms-input-placeholder {\n      color: #a2a2a2;\n      opacity: 1;\n      font-family: inherit; }\n    .select__list-input::-webkit-input-placeholder {\n      color: #a2a2a2;\n      opacity: 1;\n      font-family: inherit; }\n  .select._opened .select__value._bold {\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400; }\n  .select._opened .select__wrapper {\n    border: 1px solid #6075ff;\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n  .select._opened .select__btn {\n    height: 2.125rem;\n    border: none;\n    border-radius: .25rem .25rem 0 0; }\n  .select._opened .select__list-wrapper {\n    display: block; }\n  .select._opened .select__indicator {\n    transform: rotateX(180deg) translateY(60%); }\n  .select__tumbler {\n    display: flex;\n    margin: 10px 0;\n    align-items: center;\n    cursor: pointer; }\n    .select__tumbler-slide {\n      position: relative;\n      width: 1.625rem;\n      height: 0.6875rem;\n      background-color: #707070;\n      border-radius: 100px;\n      opacity: 0.5; }\n    .select__tumbler-btn {\n      position: absolute;\n      background: #6075ff;\n      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);\n      height: 0.8125rem;\n      width: 0.8125rem;\n      border-radius: 100%;\n      top: 50%;\n      transform: translateY(-50%) translateX(0);\n      transition: transform .3s; }\n    .select__tumbler-label {\n      margin-left: 0.625rem;\n      color: #a2a2a2; }\n    .select__tumbler._active .select__tumbler-slide {\n      opacity: 1; }\n    .select__tumbler._active .select__tumbler-btn {\n      transform: translateY(-50%) translateX(100%); }\n  .select__dragged {\n    z-index: 10000;\n    box-shadow: 0 0 0.25em 0.0625rem rgba(162, 162, 162, 0.5); }\n    .select__dragged .select__option-icon .svg-icon {\n      fill: #798eff; }\n    .select__dragged .select__option-icon._dnd {\n      opacity: 1; }\n    .select__dragged .select__option-label {\n      padding-left: 2.1875rem;\n      padding-right: 1.875rem; }\n  .select._opened .tooltip__label {\n    opacity: 0; }\n\n/*!\n * Bootstrap Grid v4.4.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 The Bootstrap Authors\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\nhtml {\n  box-sizing: border-box;\n  -ms-overflow-style: scrollbar; }\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit; }\n\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n  @media (min-width: 576px) {\n    .container {\n      max-width: 540px; } }\n  @media (min-width: 768px) {\n    .container {\n      max-width: 720px; } }\n  @media (min-width: 992px) {\n    .container {\n      max-width: 960px; } }\n  @media (min-width: 1200px) {\n    .container {\n      max-width: 1140px; } }\n\n.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n\n@media (min-width: 576px) {\n  .container, .container-sm {\n    max-width: 540px; } }\n\n@media (min-width: 768px) {\n  .container, .container-sm, .container-md {\n    max-width: 720px; } }\n\n@media (min-width: 992px) {\n  .container, .container-sm, .container-md, .container-lg {\n    max-width: 960px; } }\n\n@media (min-width: 1200px) {\n  .container, .container-sm, .container-md, .container-lg, .container-xl {\n    max-width: 1140px; } }\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px; }\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0; }\n  .no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0; }\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px; }\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%; }\n\n.row-cols-1 > * {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.row-cols-2 > * {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.row-cols-3 > * {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.row-cols-4 > * {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.row-cols-5 > * {\n  flex: 0 0 20%;\n  max-width: 20%; }\n\n.row-cols-6 > * {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; }\n\n.col-1 {\n  flex: 0 0 8.33333%;\n  max-width: 8.33333%; }\n\n.col-2 {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.col-4 {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.col-5 {\n  flex: 0 0 41.66667%;\n  max-width: 41.66667%; }\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.col-7 {\n  flex: 0 0 58.33333%;\n  max-width: 58.33333%; }\n\n.col-8 {\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%; }\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%; }\n\n.col-10 {\n  flex: 0 0 83.33333%;\n  max-width: 83.33333%; }\n\n.col-11 {\n  flex: 0 0 91.66667%;\n  max-width: 91.66667%; }\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.order-first {\n  order: -1; }\n\n.order-last {\n  order: 13; }\n\n.order-0 {\n  order: 0; }\n\n.order-1 {\n  order: 1; }\n\n.order-2 {\n  order: 2; }\n\n.order-3 {\n  order: 3; }\n\n.order-4 {\n  order: 4; }\n\n.order-5 {\n  order: 5; }\n\n.order-6 {\n  order: 6; }\n\n.order-7 {\n  order: 7; }\n\n.order-8 {\n  order: 8; }\n\n.order-9 {\n  order: 9; }\n\n.order-10 {\n  order: 10; }\n\n.order-11 {\n  order: 11; }\n\n.order-12 {\n  order: 12; }\n\n.offset-1 {\n  margin-left: 8.33333%; }\n\n.offset-2 {\n  margin-left: 16.66667%; }\n\n.offset-3 {\n  margin-left: 25%; }\n\n.offset-4 {\n  margin-left: 33.33333%; }\n\n.offset-5 {\n  margin-left: 41.66667%; }\n\n.offset-6 {\n  margin-left: 50%; }\n\n.offset-7 {\n  margin-left: 58.33333%; }\n\n.offset-8 {\n  margin-left: 66.66667%; }\n\n.offset-9 {\n  margin-left: 75%; }\n\n.offset-10 {\n  margin-left: 83.33333%; }\n\n.offset-11 {\n  margin-left: 91.66667%; }\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-sm-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-sm-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-sm-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-sm-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-sm-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-sm-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-sm-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-sm-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-sm-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-sm-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-sm-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-sm-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-sm-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-sm-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-sm-first {\n    order: -1; }\n  .order-sm-last {\n    order: 13; }\n  .order-sm-0 {\n    order: 0; }\n  .order-sm-1 {\n    order: 1; }\n  .order-sm-2 {\n    order: 2; }\n  .order-sm-3 {\n    order: 3; }\n  .order-sm-4 {\n    order: 4; }\n  .order-sm-5 {\n    order: 5; }\n  .order-sm-6 {\n    order: 6; }\n  .order-sm-7 {\n    order: 7; }\n  .order-sm-8 {\n    order: 8; }\n  .order-sm-9 {\n    order: 9; }\n  .order-sm-10 {\n    order: 10; }\n  .order-sm-11 {\n    order: 11; }\n  .order-sm-12 {\n    order: 12; }\n  .offset-sm-0 {\n    margin-left: 0; }\n  .offset-sm-1 {\n    margin-left: 8.33333%; }\n  .offset-sm-2 {\n    margin-left: 16.66667%; }\n  .offset-sm-3 {\n    margin-left: 25%; }\n  .offset-sm-4 {\n    margin-left: 33.33333%; }\n  .offset-sm-5 {\n    margin-left: 41.66667%; }\n  .offset-sm-6 {\n    margin-left: 50%; }\n  .offset-sm-7 {\n    margin-left: 58.33333%; }\n  .offset-sm-8 {\n    margin-left: 66.66667%; }\n  .offset-sm-9 {\n    margin-left: 75%; }\n  .offset-sm-10 {\n    margin-left: 83.33333%; }\n  .offset-sm-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-md-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-md-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-md-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-md-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-md-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-md-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-md-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-md-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-md-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-md-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-md-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-md-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-md-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-md-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-md-first {\n    order: -1; }\n  .order-md-last {\n    order: 13; }\n  .order-md-0 {\n    order: 0; }\n  .order-md-1 {\n    order: 1; }\n  .order-md-2 {\n    order: 2; }\n  .order-md-3 {\n    order: 3; }\n  .order-md-4 {\n    order: 4; }\n  .order-md-5 {\n    order: 5; }\n  .order-md-6 {\n    order: 6; }\n  .order-md-7 {\n    order: 7; }\n  .order-md-8 {\n    order: 8; }\n  .order-md-9 {\n    order: 9; }\n  .order-md-10 {\n    order: 10; }\n  .order-md-11 {\n    order: 11; }\n  .order-md-12 {\n    order: 12; }\n  .offset-md-0 {\n    margin-left: 0; }\n  .offset-md-1 {\n    margin-left: 8.33333%; }\n  .offset-md-2 {\n    margin-left: 16.66667%; }\n  .offset-md-3 {\n    margin-left: 25%; }\n  .offset-md-4 {\n    margin-left: 33.33333%; }\n  .offset-md-5 {\n    margin-left: 41.66667%; }\n  .offset-md-6 {\n    margin-left: 50%; }\n  .offset-md-7 {\n    margin-left: 58.33333%; }\n  .offset-md-8 {\n    margin-left: 66.66667%; }\n  .offset-md-9 {\n    margin-left: 75%; }\n  .offset-md-10 {\n    margin-left: 83.33333%; }\n  .offset-md-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-lg-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-lg-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-lg-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-lg-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-lg-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-lg-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-lg-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-lg-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-lg-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-lg-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-lg-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-lg-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-lg-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-lg-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-lg-first {\n    order: -1; }\n  .order-lg-last {\n    order: 13; }\n  .order-lg-0 {\n    order: 0; }\n  .order-lg-1 {\n    order: 1; }\n  .order-lg-2 {\n    order: 2; }\n  .order-lg-3 {\n    order: 3; }\n  .order-lg-4 {\n    order: 4; }\n  .order-lg-5 {\n    order: 5; }\n  .order-lg-6 {\n    order: 6; }\n  .order-lg-7 {\n    order: 7; }\n  .order-lg-8 {\n    order: 8; }\n  .order-lg-9 {\n    order: 9; }\n  .order-lg-10 {\n    order: 10; }\n  .order-lg-11 {\n    order: 11; }\n  .order-lg-12 {\n    order: 12; }\n  .offset-lg-0 {\n    margin-left: 0; }\n  .offset-lg-1 {\n    margin-left: 8.33333%; }\n  .offset-lg-2 {\n    margin-left: 16.66667%; }\n  .offset-lg-3 {\n    margin-left: 25%; }\n  .offset-lg-4 {\n    margin-left: 33.33333%; }\n  .offset-lg-5 {\n    margin-left: 41.66667%; }\n  .offset-lg-6 {\n    margin-left: 50%; }\n  .offset-lg-7 {\n    margin-left: 58.33333%; }\n  .offset-lg-8 {\n    margin-left: 66.66667%; }\n  .offset-lg-9 {\n    margin-left: 75%; }\n  .offset-lg-10 {\n    margin-left: 83.33333%; }\n  .offset-lg-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-xl-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-xl-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-xl-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-xl-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-xl-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-xl-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-xl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-xl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-xl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-xl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-xl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-xl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-xl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-xl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-xl-first {\n    order: -1; }\n  .order-xl-last {\n    order: 13; }\n  .order-xl-0 {\n    order: 0; }\n  .order-xl-1 {\n    order: 1; }\n  .order-xl-2 {\n    order: 2; }\n  .order-xl-3 {\n    order: 3; }\n  .order-xl-4 {\n    order: 4; }\n  .order-xl-5 {\n    order: 5; }\n  .order-xl-6 {\n    order: 6; }\n  .order-xl-7 {\n    order: 7; }\n  .order-xl-8 {\n    order: 8; }\n  .order-xl-9 {\n    order: 9; }\n  .order-xl-10 {\n    order: 10; }\n  .order-xl-11 {\n    order: 11; }\n  .order-xl-12 {\n    order: 12; }\n  .offset-xl-0 {\n    margin-left: 0; }\n  .offset-xl-1 {\n    margin-left: 8.33333%; }\n  .offset-xl-2 {\n    margin-left: 16.66667%; }\n  .offset-xl-3 {\n    margin-left: 25%; }\n  .offset-xl-4 {\n    margin-left: 33.33333%; }\n  .offset-xl-5 {\n    margin-left: 41.66667%; }\n  .offset-xl-6 {\n    margin-left: 50%; }\n  .offset-xl-7 {\n    margin-left: 58.33333%; }\n  .offset-xl-8 {\n    margin-left: 66.66667%; }\n  .offset-xl-9 {\n    margin-left: 75%; }\n  .offset-xl-10 {\n    margin-left: 83.33333%; }\n  .offset-xl-11 {\n    margin-left: 91.66667%; } }\n\n.d-none {\n  display: none !important; }\n\n.d-inline {\n  display: inline !important; }\n\n.d-inline-block {\n  display: inline-block !important; }\n\n.d-block {\n  display: block !important; }\n\n.d-table {\n  display: table !important; }\n\n.d-table-row {\n  display: table-row !important; }\n\n.d-table-cell {\n  display: table-cell !important; }\n\n.d-flex {\n  display: flex !important; }\n\n.d-inline-flex {\n  display: inline-flex !important; }\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important; }\n  .d-sm-inline {\n    display: inline !important; }\n  .d-sm-inline-block {\n    display: inline-block !important; }\n  .d-sm-block {\n    display: block !important; }\n  .d-sm-table {\n    display: table !important; }\n  .d-sm-table-row {\n    display: table-row !important; }\n  .d-sm-table-cell {\n    display: table-cell !important; }\n  .d-sm-flex {\n    display: flex !important; }\n  .d-sm-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important; }\n  .d-md-inline {\n    display: inline !important; }\n  .d-md-inline-block {\n    display: inline-block !important; }\n  .d-md-block {\n    display: block !important; }\n  .d-md-table {\n    display: table !important; }\n  .d-md-table-row {\n    display: table-row !important; }\n  .d-md-table-cell {\n    display: table-cell !important; }\n  .d-md-flex {\n    display: flex !important; }\n  .d-md-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important; }\n  .d-lg-inline {\n    display: inline !important; }\n  .d-lg-inline-block {\n    display: inline-block !important; }\n  .d-lg-block {\n    display: block !important; }\n  .d-lg-table {\n    display: table !important; }\n  .d-lg-table-row {\n    display: table-row !important; }\n  .d-lg-table-cell {\n    display: table-cell !important; }\n  .d-lg-flex {\n    display: flex !important; }\n  .d-lg-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important; }\n  .d-xl-inline {\n    display: inline !important; }\n  .d-xl-inline-block {\n    display: inline-block !important; }\n  .d-xl-block {\n    display: block !important; }\n  .d-xl-table {\n    display: table !important; }\n  .d-xl-table-row {\n    display: table-row !important; }\n  .d-xl-table-cell {\n    display: table-cell !important; }\n  .d-xl-flex {\n    display: flex !important; }\n  .d-xl-inline-flex {\n    display: inline-flex !important; } }\n\n@media print {\n  .d-print-none {\n    display: none !important; }\n  .d-print-inline {\n    display: inline !important; }\n  .d-print-inline-block {\n    display: inline-block !important; }\n  .d-print-block {\n    display: block !important; }\n  .d-print-table {\n    display: table !important; }\n  .d-print-table-row {\n    display: table-row !important; }\n  .d-print-table-cell {\n    display: table-cell !important; }\n  .d-print-flex {\n    display: flex !important; }\n  .d-print-inline-flex {\n    display: inline-flex !important; } }\n\n.flex-row {\n  flex-direction: row !important; }\n\n.flex-column {\n  flex-direction: column !important; }\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important; }\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important; }\n\n.flex-wrap {\n  flex-wrap: wrap !important; }\n\n.flex-nowrap {\n  flex-wrap: nowrap !important; }\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important; }\n\n.flex-fill {\n  flex: 1 1 auto !important; }\n\n.flex-grow-0 {\n  flex-grow: 0 !important; }\n\n.flex-grow-1 {\n  flex-grow: 1 !important; }\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important; }\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important; }\n\n.justify-content-start {\n  justify-content: flex-start !important; }\n\n.justify-content-end {\n  justify-content: flex-end !important; }\n\n.justify-content-center {\n  justify-content: center !important; }\n\n.justify-content-between {\n  justify-content: space-between !important; }\n\n.justify-content-around {\n  justify-content: space-around !important; }\n\n.align-items-start {\n  align-items: flex-start !important; }\n\n.align-items-end {\n  align-items: flex-end !important; }\n\n.align-items-center {\n  align-items: center !important; }\n\n.align-items-baseline {\n  align-items: baseline !important; }\n\n.align-items-stretch {\n  align-items: stretch !important; }\n\n.align-content-start {\n  align-content: flex-start !important; }\n\n.align-content-end {\n  align-content: flex-end !important; }\n\n.align-content-center {\n  align-content: center !important; }\n\n.align-content-between {\n  align-content: space-between !important; }\n\n.align-content-around {\n  align-content: space-around !important; }\n\n.align-content-stretch {\n  align-content: stretch !important; }\n\n.align-self-auto {\n  align-self: auto !important; }\n\n.align-self-start {\n  align-self: flex-start !important; }\n\n.align-self-end {\n  align-self: flex-end !important; }\n\n.align-self-center {\n  align-self: center !important; }\n\n.align-self-baseline {\n  align-self: baseline !important; }\n\n.align-self-stretch {\n  align-self: stretch !important; }\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important; }\n  .flex-sm-column {\n    flex-direction: column !important; }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important; }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-sm-fill {\n    flex: 1 1 auto !important; }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-sm-start {\n    justify-content: flex-start !important; }\n  .justify-content-sm-end {\n    justify-content: flex-end !important; }\n  .justify-content-sm-center {\n    justify-content: center !important; }\n  .justify-content-sm-between {\n    justify-content: space-between !important; }\n  .justify-content-sm-around {\n    justify-content: space-around !important; }\n  .align-items-sm-start {\n    align-items: flex-start !important; }\n  .align-items-sm-end {\n    align-items: flex-end !important; }\n  .align-items-sm-center {\n    align-items: center !important; }\n  .align-items-sm-baseline {\n    align-items: baseline !important; }\n  .align-items-sm-stretch {\n    align-items: stretch !important; }\n  .align-content-sm-start {\n    align-content: flex-start !important; }\n  .align-content-sm-end {\n    align-content: flex-end !important; }\n  .align-content-sm-center {\n    align-content: center !important; }\n  .align-content-sm-between {\n    align-content: space-between !important; }\n  .align-content-sm-around {\n    align-content: space-around !important; }\n  .align-content-sm-stretch {\n    align-content: stretch !important; }\n  .align-self-sm-auto {\n    align-self: auto !important; }\n  .align-self-sm-start {\n    align-self: flex-start !important; }\n  .align-self-sm-end {\n    align-self: flex-end !important; }\n  .align-self-sm-center {\n    align-self: center !important; }\n  .align-self-sm-baseline {\n    align-self: baseline !important; }\n  .align-self-sm-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important; }\n  .flex-md-column {\n    flex-direction: column !important; }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-md-wrap {\n    flex-wrap: wrap !important; }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-md-fill {\n    flex: 1 1 auto !important; }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-md-start {\n    justify-content: flex-start !important; }\n  .justify-content-md-end {\n    justify-content: flex-end !important; }\n  .justify-content-md-center {\n    justify-content: center !important; }\n  .justify-content-md-between {\n    justify-content: space-between !important; }\n  .justify-content-md-around {\n    justify-content: space-around !important; }\n  .align-items-md-start {\n    align-items: flex-start !important; }\n  .align-items-md-end {\n    align-items: flex-end !important; }\n  .align-items-md-center {\n    align-items: center !important; }\n  .align-items-md-baseline {\n    align-items: baseline !important; }\n  .align-items-md-stretch {\n    align-items: stretch !important; }\n  .align-content-md-start {\n    align-content: flex-start !important; }\n  .align-content-md-end {\n    align-content: flex-end !important; }\n  .align-content-md-center {\n    align-content: center !important; }\n  .align-content-md-between {\n    align-content: space-between !important; }\n  .align-content-md-around {\n    align-content: space-around !important; }\n  .align-content-md-stretch {\n    align-content: stretch !important; }\n  .align-self-md-auto {\n    align-self: auto !important; }\n  .align-self-md-start {\n    align-self: flex-start !important; }\n  .align-self-md-end {\n    align-self: flex-end !important; }\n  .align-self-md-center {\n    align-self: center !important; }\n  .align-self-md-baseline {\n    align-self: baseline !important; }\n  .align-self-md-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important; }\n  .flex-lg-column {\n    flex-direction: column !important; }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important; }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-lg-fill {\n    flex: 1 1 auto !important; }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-lg-start {\n    justify-content: flex-start !important; }\n  .justify-content-lg-end {\n    justify-content: flex-end !important; }\n  .justify-content-lg-center {\n    justify-content: center !important; }\n  .justify-content-lg-between {\n    justify-content: space-between !important; }\n  .justify-content-lg-around {\n    justify-content: space-around !important; }\n  .align-items-lg-start {\n    align-items: flex-start !important; }\n  .align-items-lg-end {\n    align-items: flex-end !important; }\n  .align-items-lg-center {\n    align-items: center !important; }\n  .align-items-lg-baseline {\n    align-items: baseline !important; }\n  .align-items-lg-stretch {\n    align-items: stretch !important; }\n  .align-content-lg-start {\n    align-content: flex-start !important; }\n  .align-content-lg-end {\n    align-content: flex-end !important; }\n  .align-content-lg-center {\n    align-content: center !important; }\n  .align-content-lg-between {\n    align-content: space-between !important; }\n  .align-content-lg-around {\n    align-content: space-around !important; }\n  .align-content-lg-stretch {\n    align-content: stretch !important; }\n  .align-self-lg-auto {\n    align-self: auto !important; }\n  .align-self-lg-start {\n    align-self: flex-start !important; }\n  .align-self-lg-end {\n    align-self: flex-end !important; }\n  .align-self-lg-center {\n    align-self: center !important; }\n  .align-self-lg-baseline {\n    align-self: baseline !important; }\n  .align-self-lg-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important; }\n  .flex-xl-column {\n    flex-direction: column !important; }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important; }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-xl-fill {\n    flex: 1 1 auto !important; }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-xl-start {\n    justify-content: flex-start !important; }\n  .justify-content-xl-end {\n    justify-content: flex-end !important; }\n  .justify-content-xl-center {\n    justify-content: center !important; }\n  .justify-content-xl-between {\n    justify-content: space-between !important; }\n  .justify-content-xl-around {\n    justify-content: space-around !important; }\n  .align-items-xl-start {\n    align-items: flex-start !important; }\n  .align-items-xl-end {\n    align-items: flex-end !important; }\n  .align-items-xl-center {\n    align-items: center !important; }\n  .align-items-xl-baseline {\n    align-items: baseline !important; }\n  .align-items-xl-stretch {\n    align-items: stretch !important; }\n  .align-content-xl-start {\n    align-content: flex-start !important; }\n  .align-content-xl-end {\n    align-content: flex-end !important; }\n  .align-content-xl-center {\n    align-content: center !important; }\n  .align-content-xl-between {\n    align-content: space-between !important; }\n  .align-content-xl-around {\n    align-content: space-around !important; }\n  .align-content-xl-stretch {\n    align-content: stretch !important; }\n  .align-self-xl-auto {\n    align-self: auto !important; }\n  .align-self-xl-start {\n    align-self: flex-start !important; }\n  .align-self-xl-end {\n    align-self: flex-end !important; }\n  .align-self-xl-center {\n    align-self: center !important; }\n  .align-self-xl-baseline {\n    align-self: baseline !important; }\n  .align-self-xl-stretch {\n    align-self: stretch !important; } }\n\n.m-0 {\n  margin: 0 !important; }\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important; }\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important; }\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important; }\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important; }\n\n.m-1 {\n  margin: 0.25rem !important; }\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important; }\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important; }\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important; }\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important; }\n\n.m-2 {\n  margin: 0.5rem !important; }\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important; }\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important; }\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important; }\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important; }\n\n.m-3 {\n  margin: 1rem !important; }\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important; }\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important; }\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important; }\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important; }\n\n.m-4 {\n  margin: 1.5rem !important; }\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important; }\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important; }\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important; }\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important; }\n\n.m-5 {\n  margin: 3rem !important; }\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important; }\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important; }\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important; }\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important; }\n\n.p-0 {\n  padding: 0 !important; }\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important; }\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important; }\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important; }\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important; }\n\n.p-1 {\n  padding: 0.25rem !important; }\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important; }\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important; }\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important; }\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important; }\n\n.p-2 {\n  padding: 0.5rem !important; }\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important; }\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important; }\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important; }\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important; }\n\n.p-3 {\n  padding: 1rem !important; }\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important; }\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important; }\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important; }\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important; }\n\n.p-4 {\n  padding: 1.5rem !important; }\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important; }\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important; }\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important; }\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important; }\n\n.p-5 {\n  padding: 3rem !important; }\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important; }\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important; }\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important; }\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important; }\n\n.m-n1 {\n  margin: -0.25rem !important; }\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important; }\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important; }\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important; }\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important; }\n\n.m-n2 {\n  margin: -0.5rem !important; }\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important; }\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important; }\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important; }\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important; }\n\n.m-n3 {\n  margin: -1rem !important; }\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important; }\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important; }\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important; }\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important; }\n\n.m-n4 {\n  margin: -1.5rem !important; }\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important; }\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important; }\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important; }\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important; }\n\n.m-n5 {\n  margin: -3rem !important; }\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important; }\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important; }\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important; }\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important; }\n\n.m-auto {\n  margin: auto !important; }\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important; }\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important; }\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important; }\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important; }\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important; }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important; }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important; }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important; }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important; }\n  .m-sm-1 {\n    margin: 0.25rem !important; }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important; }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important; }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important; }\n  .m-sm-2 {\n    margin: 0.5rem !important; }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important; }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important; }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important; }\n  .m-sm-3 {\n    margin: 1rem !important; }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important; }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important; }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important; }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important; }\n  .m-sm-4 {\n    margin: 1.5rem !important; }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important; }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important; }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important; }\n  .m-sm-5 {\n    margin: 3rem !important; }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important; }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important; }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important; }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important; }\n  .p-sm-0 {\n    padding: 0 !important; }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important; }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important; }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important; }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important; }\n  .p-sm-1 {\n    padding: 0.25rem !important; }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important; }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important; }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important; }\n  .p-sm-2 {\n    padding: 0.5rem !important; }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important; }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important; }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important; }\n  .p-sm-3 {\n    padding: 1rem !important; }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important; }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important; }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important; }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important; }\n  .p-sm-4 {\n    padding: 1.5rem !important; }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important; }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important; }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important; }\n  .p-sm-5 {\n    padding: 3rem !important; }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important; }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important; }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important; }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important; }\n  .m-sm-n1 {\n    margin: -0.25rem !important; }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important; }\n  .m-sm-n2 {\n    margin: -0.5rem !important; }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important; }\n  .m-sm-n3 {\n    margin: -1rem !important; }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important; }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important; }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important; }\n  .m-sm-n4 {\n    margin: -1.5rem !important; }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important; }\n  .m-sm-n5 {\n    margin: -3rem !important; }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important; }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important; }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important; }\n  .m-sm-auto {\n    margin: auto !important; }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important; }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important; }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important; }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important; }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important; }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important; }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important; }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important; }\n  .m-md-1 {\n    margin: 0.25rem !important; }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important; }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important; }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important; }\n  .m-md-2 {\n    margin: 0.5rem !important; }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important; }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important; }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important; }\n  .m-md-3 {\n    margin: 1rem !important; }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important; }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important; }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important; }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important; }\n  .m-md-4 {\n    margin: 1.5rem !important; }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important; }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important; }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important; }\n  .m-md-5 {\n    margin: 3rem !important; }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important; }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important; }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important; }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important; }\n  .p-md-0 {\n    padding: 0 !important; }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important; }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important; }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important; }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important; }\n  .p-md-1 {\n    padding: 0.25rem !important; }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important; }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important; }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important; }\n  .p-md-2 {\n    padding: 0.5rem !important; }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important; }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important; }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important; }\n  .p-md-3 {\n    padding: 1rem !important; }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important; }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important; }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important; }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important; }\n  .p-md-4 {\n    padding: 1.5rem !important; }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important; }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important; }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important; }\n  .p-md-5 {\n    padding: 3rem !important; }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important; }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important; }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important; }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important; }\n  .m-md-n1 {\n    margin: -0.25rem !important; }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important; }\n  .m-md-n2 {\n    margin: -0.5rem !important; }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important; }\n  .m-md-n3 {\n    margin: -1rem !important; }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important; }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important; }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important; }\n  .m-md-n4 {\n    margin: -1.5rem !important; }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important; }\n  .m-md-n5 {\n    margin: -3rem !important; }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important; }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important; }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important; }\n  .m-md-auto {\n    margin: auto !important; }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important; }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important; }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important; }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important; }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important; }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important; }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important; }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important; }\n  .m-lg-1 {\n    margin: 0.25rem !important; }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important; }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important; }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important; }\n  .m-lg-2 {\n    margin: 0.5rem !important; }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important; }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important; }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important; }\n  .m-lg-3 {\n    margin: 1rem !important; }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important; }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important; }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important; }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important; }\n  .m-lg-4 {\n    margin: 1.5rem !important; }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important; }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important; }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important; }\n  .m-lg-5 {\n    margin: 3rem !important; }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important; }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important; }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important; }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important; }\n  .p-lg-0 {\n    padding: 0 !important; }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important; }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important; }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important; }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important; }\n  .p-lg-1 {\n    padding: 0.25rem !important; }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important; }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important; }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important; }\n  .p-lg-2 {\n    padding: 0.5rem !important; }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important; }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important; }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important; }\n  .p-lg-3 {\n    padding: 1rem !important; }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important; }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important; }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important; }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important; }\n  .p-lg-4 {\n    padding: 1.5rem !important; }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important; }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important; }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important; }\n  .p-lg-5 {\n    padding: 3rem !important; }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important; }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important; }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important; }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important; }\n  .m-lg-n1 {\n    margin: -0.25rem !important; }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important; }\n  .m-lg-n2 {\n    margin: -0.5rem !important; }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important; }\n  .m-lg-n3 {\n    margin: -1rem !important; }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important; }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important; }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important; }\n  .m-lg-n4 {\n    margin: -1.5rem !important; }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important; }\n  .m-lg-n5 {\n    margin: -3rem !important; }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important; }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important; }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important; }\n  .m-lg-auto {\n    margin: auto !important; }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important; }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important; }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important; }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important; }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important; }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important; }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important; }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important; }\n  .m-xl-1 {\n    margin: 0.25rem !important; }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important; }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important; }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important; }\n  .m-xl-2 {\n    margin: 0.5rem !important; }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important; }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important; }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important; }\n  .m-xl-3 {\n    margin: 1rem !important; }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important; }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important; }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important; }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important; }\n  .m-xl-4 {\n    margin: 1.5rem !important; }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important; }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important; }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important; }\n  .m-xl-5 {\n    margin: 3rem !important; }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important; }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important; }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important; }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important; }\n  .p-xl-0 {\n    padding: 0 !important; }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important; }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important; }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important; }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important; }\n  .p-xl-1 {\n    padding: 0.25rem !important; }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important; }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important; }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important; }\n  .p-xl-2 {\n    padding: 0.5rem !important; }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important; }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important; }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important; }\n  .p-xl-3 {\n    padding: 1rem !important; }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important; }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important; }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important; }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important; }\n  .p-xl-4 {\n    padding: 1.5rem !important; }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important; }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important; }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important; }\n  .p-xl-5 {\n    padding: 3rem !important; }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important; }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important; }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important; }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important; }\n  .m-xl-n1 {\n    margin: -0.25rem !important; }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important; }\n  .m-xl-n2 {\n    margin: -0.5rem !important; }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important; }\n  .m-xl-n3 {\n    margin: -1rem !important; }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important; }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important; }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important; }\n  .m-xl-n4 {\n    margin: -1.5rem !important; }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important; }\n  .m-xl-n5 {\n    margin: -3rem !important; }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important; }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important; }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important; }\n  .m-xl-auto {\n    margin: auto !important; }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important; }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important; }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important; }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important; } }\n\n.m-0 {\n  margin: 0 !important; }\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important; }\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important; }\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important; }\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important; }\n\n.m-1 {\n  margin: 0.25rem !important; }\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important; }\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important; }\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important; }\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important; }\n\n.m-2 {\n  margin: 0.5rem !important; }\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important; }\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important; }\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important; }\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important; }\n\n.m-3 {\n  margin: 1rem !important; }\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important; }\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important; }\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important; }\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important; }\n\n.m-4 {\n  margin: 1.5rem !important; }\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important; }\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important; }\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important; }\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important; }\n\n.m-5 {\n  margin: 3rem !important; }\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important; }\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important; }\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important; }\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important; }\n\n.p-0 {\n  padding: 0 !important; }\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important; }\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important; }\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important; }\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important; }\n\n.p-1 {\n  padding: 0.25rem !important; }\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important; }\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important; }\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important; }\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important; }\n\n.p-2 {\n  padding: 0.5rem !important; }\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important; }\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important; }\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important; }\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important; }\n\n.p-3 {\n  padding: 1rem !important; }\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important; }\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important; }\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important; }\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important; }\n\n.p-4 {\n  padding: 1.5rem !important; }\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important; }\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important; }\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important; }\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important; }\n\n.p-5 {\n  padding: 3rem !important; }\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important; }\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important; }\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important; }\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important; }\n\n.m-n1 {\n  margin: -0.25rem !important; }\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important; }\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important; }\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important; }\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important; }\n\n.m-n2 {\n  margin: -0.5rem !important; }\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important; }\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important; }\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important; }\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important; }\n\n.m-n3 {\n  margin: -1rem !important; }\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important; }\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important; }\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important; }\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important; }\n\n.m-n4 {\n  margin: -1.5rem !important; }\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important; }\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important; }\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important; }\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important; }\n\n.m-n5 {\n  margin: -3rem !important; }\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important; }\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important; }\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important; }\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important; }\n\n.m-auto {\n  margin: auto !important; }\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important; }\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important; }\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important; }\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important; }\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important; }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important; }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important; }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important; }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important; }\n  .m-sm-1 {\n    margin: 0.25rem !important; }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important; }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important; }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important; }\n  .m-sm-2 {\n    margin: 0.5rem !important; }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important; }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important; }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important; }\n  .m-sm-3 {\n    margin: 1rem !important; }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important; }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important; }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important; }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important; }\n  .m-sm-4 {\n    margin: 1.5rem !important; }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important; }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important; }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important; }\n  .m-sm-5 {\n    margin: 3rem !important; }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important; }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important; }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important; }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important; }\n  .p-sm-0 {\n    padding: 0 !important; }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important; }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important; }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important; }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important; }\n  .p-sm-1 {\n    padding: 0.25rem !important; }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important; }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important; }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important; }\n  .p-sm-2 {\n    padding: 0.5rem !important; }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important; }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important; }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important; }\n  .p-sm-3 {\n    padding: 1rem !important; }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important; }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important; }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important; }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important; }\n  .p-sm-4 {\n    padding: 1.5rem !important; }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important; }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important; }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important; }\n  .p-sm-5 {\n    padding: 3rem !important; }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important; }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important; }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important; }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important; }\n  .m-sm-n1 {\n    margin: -0.25rem !important; }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important; }\n  .m-sm-n2 {\n    margin: -0.5rem !important; }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important; }\n  .m-sm-n3 {\n    margin: -1rem !important; }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important; }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important; }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important; }\n  .m-sm-n4 {\n    margin: -1.5rem !important; }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important; }\n  .m-sm-n5 {\n    margin: -3rem !important; }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important; }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important; }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important; }\n  .m-sm-auto {\n    margin: auto !important; }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important; }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important; }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important; }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important; }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important; }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important; }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important; }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important; }\n  .m-md-1 {\n    margin: 0.25rem !important; }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important; }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important; }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important; }\n  .m-md-2 {\n    margin: 0.5rem !important; }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important; }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important; }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important; }\n  .m-md-3 {\n    margin: 1rem !important; }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important; }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important; }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important; }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important; }\n  .m-md-4 {\n    margin: 1.5rem !important; }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important; }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important; }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important; }\n  .m-md-5 {\n    margin: 3rem !important; }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important; }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important; }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important; }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important; }\n  .p-md-0 {\n    padding: 0 !important; }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important; }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important; }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important; }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important; }\n  .p-md-1 {\n    padding: 0.25rem !important; }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important; }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important; }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important; }\n  .p-md-2 {\n    padding: 0.5rem !important; }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important; }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important; }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important; }\n  .p-md-3 {\n    padding: 1rem !important; }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important; }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important; }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important; }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important; }\n  .p-md-4 {\n    padding: 1.5rem !important; }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important; }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important; }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important; }\n  .p-md-5 {\n    padding: 3rem !important; }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important; }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important; }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important; }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important; }\n  .m-md-n1 {\n    margin: -0.25rem !important; }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important; }\n  .m-md-n2 {\n    margin: -0.5rem !important; }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important; }\n  .m-md-n3 {\n    margin: -1rem !important; }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important; }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important; }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important; }\n  .m-md-n4 {\n    margin: -1.5rem !important; }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important; }\n  .m-md-n5 {\n    margin: -3rem !important; }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important; }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important; }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important; }\n  .m-md-auto {\n    margin: auto !important; }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important; }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important; }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important; }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important; }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important; }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important; }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important; }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important; }\n  .m-lg-1 {\n    margin: 0.25rem !important; }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important; }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important; }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important; }\n  .m-lg-2 {\n    margin: 0.5rem !important; }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important; }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important; }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important; }\n  .m-lg-3 {\n    margin: 1rem !important; }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important; }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important; }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important; }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important; }\n  .m-lg-4 {\n    margin: 1.5rem !important; }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important; }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important; }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important; }\n  .m-lg-5 {\n    margin: 3rem !important; }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important; }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important; }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important; }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important; }\n  .p-lg-0 {\n    padding: 0 !important; }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important; }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important; }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important; }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important; }\n  .p-lg-1 {\n    padding: 0.25rem !important; }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important; }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important; }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important; }\n  .p-lg-2 {\n    padding: 0.5rem !important; }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important; }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important; }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important; }\n  .p-lg-3 {\n    padding: 1rem !important; }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important; }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important; }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important; }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important; }\n  .p-lg-4 {\n    padding: 1.5rem !important; }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important; }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important; }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important; }\n  .p-lg-5 {\n    padding: 3rem !important; }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important; }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important; }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important; }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important; }\n  .m-lg-n1 {\n    margin: -0.25rem !important; }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important; }\n  .m-lg-n2 {\n    margin: -0.5rem !important; }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important; }\n  .m-lg-n3 {\n    margin: -1rem !important; }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important; }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important; }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important; }\n  .m-lg-n4 {\n    margin: -1.5rem !important; }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important; }\n  .m-lg-n5 {\n    margin: -3rem !important; }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important; }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important; }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important; }\n  .m-lg-auto {\n    margin: auto !important; }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important; }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important; }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important; }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important; }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important; }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important; }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important; }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important; }\n  .m-xl-1 {\n    margin: 0.25rem !important; }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important; }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important; }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important; }\n  .m-xl-2 {\n    margin: 0.5rem !important; }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important; }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important; }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important; }\n  .m-xl-3 {\n    margin: 1rem !important; }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important; }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important; }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important; }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important; }\n  .m-xl-4 {\n    margin: 1.5rem !important; }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important; }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important; }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important; }\n  .m-xl-5 {\n    margin: 3rem !important; }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important; }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important; }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important; }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important; }\n  .p-xl-0 {\n    padding: 0 !important; }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important; }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important; }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important; }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important; }\n  .p-xl-1 {\n    padding: 0.25rem !important; }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important; }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important; }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important; }\n  .p-xl-2 {\n    padding: 0.5rem !important; }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important; }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important; }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important; }\n  .p-xl-3 {\n    padding: 1rem !important; }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important; }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important; }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important; }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important; }\n  .p-xl-4 {\n    padding: 1.5rem !important; }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important; }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important; }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important; }\n  .p-xl-5 {\n    padding: 3rem !important; }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important; }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important; }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important; }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important; }\n  .m-xl-n1 {\n    margin: -0.25rem !important; }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important; }\n  .m-xl-n2 {\n    margin: -0.5rem !important; }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important; }\n  .m-xl-n3 {\n    margin: -1rem !important; }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important; }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important; }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important; }\n  .m-xl-n4 {\n    margin: -1.5rem !important; }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important; }\n  .m-xl-n5 {\n    margin: -3rem !important; }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important; }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important; }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important; }\n  .m-xl-auto {\n    margin: auto !important; }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important; }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important; }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important; }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important; } }\n\n.select-with-creating {\n  box-sizing: border-box;\n  position: relative;\n  width: 200px; }\n  .select-with-creating * {\n    box-sizing: border-box; }\n  .select-with-creating ._action-buttons {\n    display: flex !important;\n    padding: 15px 0;\n    justify-content: center;\n    border-top: none !important; }\n  .select-with-creating ._header {\n    padding: 8px 12px 0 !important; }\n  .select-with-creating .select__clear {\n    margin-left: 0; }\n  .select-with-creating .select__list {\n    margin: 0; }\n    .select-with-creating .select__list-wrapper .btn-select__button {\n      margin-left: auto;\n      margin-right: auto; }\n    .select-with-creating .select__list-container {\n      background-color: white; }\n      .select-with-creating .select__list-container._scrollable {\n        position: relative;\n        overflow: hidden; }\n        .select-with-creating .select__list-container._scrollable:before {\n          content: \"\";\n          display: block;\n          position: absolute;\n          width: 100%;\n          height: 0;\n          top: 0;\n          left: 0;\n          box-shadow: 0 -0.75rem 0.5rem 0.625rem #dddddd;\n          z-index: 1; }\n        .select-with-creating .select__list-container._scrollable:after {\n          content: \"\";\n          display: block;\n          position: absolute;\n          width: 100%;\n          height: 0;\n          bottom: 0;\n          left: 0;\n          box-shadow: 0 0.75rem 0.5rem 0.625rem #e0e0e0;\n          z-index: 1; }\n  .select-with-creating .select__option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer; }\n    .select-with-creating .select__option:hover .svg-icon {\n      visibility: visible; }\n    .select-with-creating .select__option-label {\n      flex-grow: 1; }\n    .select-with-creating .select__option .svg-icon {\n      margin-right: 0.8125rem;\n      flex-shrink: 0;\n      width: 1rem;\n      height: 1rem;\n      cursor: pointer;\n      transition: fill 0.3s;\n      visibility: hidden; }\n      .select-with-creating .select__option .svg-icon:hover {\n        fill: #f44336; }\n  .select-with-creating .select__search {\n    padding: 0; }\n  .select-with-creating .select__input {\n    margin-top: 0.375rem; }\n  .select-with-creating .select._opened {\n    min-width: 18.75rem;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 4; }\n  .select-with-creating .create-group-container__title {\n    text-align: center; }\n  .select-with-creating .create-group-container__text-field {\n    margin: 0 auto 1rem; }\n  .select-with-creating .create-group-container__button {\n    margin-left: auto;\n    margin-right: auto; }\n  .select-with-creating .create-group-container__divider {\n    margin: 0 -1rem 0.75rem;\n    height: 1px;\n    background-color: #ededed; }\n";
styleInject(css$a);

function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var SelectWithCreatingBlockComponent = function SelectWithCreatingBlockComponent(props) {
  var isMulti = props.isMulti,
      shouldApplyChanges = props.shouldApplyChanges,
      toggleOpeningElement = props.toggleOpeningElement,
      selectedLabel = props.selectedLabel,
      newItemPlaceholder = props.newItemPlaceholder,
      buttonLabel = props.buttonLabel,
      placeholder = props.placeholder,
      className = props.className,
      items = props.items,
      value = props.value,
      onCreate = props.onCreate,
      onSelect = props.onSelect,
      onDelete = props.onDelete;
  var wrapperMainStyles = useRef(null);
  var toggleOpeningEl = useRef(null);

  var _useReducer = useReducer(selectWithCreatingBlockReducer, getIntialState(props)),
      _useReducer2 = slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var doToggleSelectListVisibility = function doToggleSelectListVisibility() {
    dispatch(toggleSelectListVisibility(props));
  };

  var doInvertAllowingToCreateNewItem = function doInvertAllowingToCreateNewItem() {
    return dispatch(invertAllowingToCreateNewItem());
  };

  var doChangeNewItemName = function doChangeNewItemName(newItemName) {
    return dispatch(changeNewItemName(newItemName));
  };

  var doChangeSearchString = function doChangeSearchString(searchString) {
    return dispatch(changeSearchString(searchString));
  };

  var doAddNewItem = function doAddNewItem(item) {
    return dispatch(addNewItem(item));
  };

  var doAddNewItems = function doAddNewItems(items) {
    return dispatch(addNewItems(items));
  };

  var doHandleSelectAllItems = function doHandleSelectAllItems() {
    return dispatch(handleSelectAllItems(items));
  };

  var doHandleDeselectAllItems = function doHandleDeselectAllItems() {
    return dispatch(handleDeselectAllItems(items));
  };

  var doApplyChanges = function doApplyChanges() {
    var allSelectedItems = [];
    var result = Object.keys(state.defaultDataSnapshot).reduce(function (result, itemValue) {
      var itemSelection = state.selectionMap[itemValue];

      if (itemSelection) {
        if (itemSelection.itemIsSelected) {
          allSelectedItems.push(itemSelection.item);
        }

        if (itemSelection.itemIsSelected !== state.defaultDataSnapshot[itemValue]) {
          if (itemSelection.itemIsSelected) {
            result.selectedItems.push(itemSelection.item);
          } else {
            result.deselectedItems.push(itemSelection.item);
          }
        }
      }

      return result;
    }, {
      selectedItems: [],
      deselectedItems: []
    });
    onSelect(allSelectedItems, {
      selectedItems: result.selectedItems,
      deselectedItems: result.deselectedItems
    });
    dispatch(toggleSelectListVisibility(_objectSpread$8({}, props, {
      value: allSelectedItems
    })));
  };

  var doHandleSelectItem = function doHandleSelectItem(item, isSelected) {
    dispatch(handleSelectItem(item, isSelected, isMulti));

    if (!isMulti) {
      onSelect([item]);
      doToggleSelectListVisibility();
    }
  };

  var doCreateNewItem = function doCreateNewItem() {
    onCreate(state.newItemName);
    dispatch(clearState());

    if (!isMulti) {
      doToggleSelectListVisibility();
    }
  };

  var doHandeDeleteItem = function doHandeDeleteItem(item) {
    onDelete(item);
    dispatch(handleDeleteItem(item));
  };

  useEffect(function () {
    if (toggleOpeningEl.current) {
      var openingButtonStyle = getComputedStyle(toggleOpeningEl.current);
      wrapperMainStyles.current = {
        width: toggleOpeningElement && openingButtonStyle.width,
        height: openingButtonStyle.height,
        left: openingButtonStyle.marginLeft
      };
    }

    return function () {
      document.removeEventListener('mousedown', clickOutsideHandler);
    };
  }, []);
  var doOpenDropdawn = useCallback(function (event) {
    event.stopPropagation();
    doToggleSelectListVisibility();
  }, []);
  var clickOutsideHandler = useCallback(function (event) {
    if (!toggleOpeningEl.current.contains(event.target)) {
      doToggleSelectListVisibility();
    }
  }, []);
  useEffect(function () {
    if (!state.selectListIsOpened) {
      document.removeEventListener('mousedown', clickOutsideHandler);
    } else {
      document.addEventListener('mousedown', clickOutsideHandler);
    }
  }, [state.selectListIsOpened]);
  var ref = useRef();
  useEffect(function () {
    if (!ref.current) {
      ref.current = items;
    } else {
      if (ref.current.length < items.length) {
        if (ref.current.length && items.length === ref.current.length + 1) {
          var firstItemOfOldItems = first(ref.current);
          var firstItemOfNewItems = first(items);

          if (firstItemOfNewItems.value !== firstItemOfOldItems.value) {
            doAddNewItem(firstItemOfNewItems);
          } else {
            var lastItemOfOldItems = last(ref.current);
            var lastItemOfNewItems = last(items);

            if (lastItemOfOldItems.value !== lastItemOfNewItems.value) {
              doAddNewItem(lastItemOfNewItems);
            }
          }
        } else {
          doAddNewItems(items);
        }
      }
    }
  }, [items]);

  if (!shouldApplyChanges && isMulti) {
    useEffect(function () {
      var selectionMapKeys = Object.keys(state.selectionMap);

      if (!selectionMapKeys.length) {
        return;
      }

      var selectedItems = selectionMapKeys.reduce(function (selectedItems, itemKey) {
        if (state.selectionMap[itemKey].itemIsSelected) {
          selectedItems.push(state.selectionMap[itemKey].item);
        }

        return selectedItems;
      }, []);
      onSelect(selectedItems);
    }, [state.selectionMap]);
  }

  var filteredItems = useMemo(function () {
    if (!state.searchString) {
      return items;
    }

    var lowerCaseSearchString = state.searchString.toLowerCase();
    return items.filter(function (item) {
      var lowerCasedLabel = item.label.toLowerCase();
      return lowerCasedLabel.includes(lowerCaseSearchString);
    });
  }, [state.searchString, items]);

  if (!state.selectListIsOpened && toggleOpeningElement) {
    return React.createElement("div", {
      ref: toggleOpeningEl,
      onClick: doOpenDropdawn
    }, props.toggleOpeningElement);
  }

  var formattedSelectedLabel;

  if (state.selectedItemsCount) {
    formattedSelectedLabel = selectedLabel || isMulti ? "".concat(state.selectedItemsCount, " selected") : get(value, '[0].label');
  }

  var allowsToSelectAll = state.selectedItemsCount !== items.length && isMulti && state.selectListIsOpened;
  return React.createElement(Dropdown, {
    style: wrapperMainStyles.current,
    className: className,
    dropdownIsOpened: state.selectListIsOpened,
    toggleDropdownVisilitiy: doToggleSelectListVisibility,
    handleClearSelection: doHandleDeselectAllItems,
    handleSelectAllItems: doHandleSelectAllItems,
    hasSelectedItems: !!state.selectedItemsCount,
    allowsToSelectAll: allowsToSelectAll,
    selectedLabel: formattedSelectedLabel,
    placeholder: placeholder,
    label: props.label,
    toggleOpeningEl: toggleOpeningEl
  }, React.createElement(DropdownHeader, {
    allowsToCreateNewItem: state.allowsToCreateNewItem,
    buttonLabel: buttonLabel,
    newItemPlaceholder: newItemPlaceholder,
    newItemName: state.newItemName,
    searchString: state.searchString,
    createNewItem: doCreateNewItem,
    doInvertAllowingToCreateNewItem: doInvertAllowingToCreateNewItem,
    doChangeSearchString: doChangeSearchString,
    doChangeNewItemName: doChangeNewItemName
  }), React.createElement(DropdownItems, {
    selectListItems: filteredItems,
    selectionMap: state.selectionMap,
    deleteItem: doHandeDeleteItem,
    selectItem: doHandleSelectItem
  }), shouldApplyChanges && React.createElement(DropdownActionButtons, {
    onApply: doApplyChanges,
    onCancel: doToggleSelectListVisibility,
    applyButtonIsDisabled: !state.changesCount
  }));
};

SelectWithCreatingBlockComponent.defaultProps = {
  isMulti: false,
  newItemPlaceholder: ''
};
SelectWithCreatingBlockComponent.propTypes = {
  toggleOpeningElement: PropTypes.element,
  items: PropTypes.array,
  value: PropTypes.array,
  selectedLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  label: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  shouldApplyChanges: PropTypes.bool,
  className: PropTypes.string,
  onSelect: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func
};
var SelectWithCreatingBlock = SelectWithCreatingBlockComponent;
export { ApiService, AuthService, ColumnOptions, CSVDownloadingProgress as DownloadCsvProgress, XLSXDownloadingProgress as DownloadXlsxProgress, EpochDatePicker, EpochDateRangePicker, EpochSingleDateRangePicker, Header, IQMRouter, LazySelect, LoginForm, LoginRoute, SelectWithCreatingBlock, TableBaseRoot, TableBodyMapping, TableComponent, TableDownloadCsvButton, TableDownloadXlsxButton, TableHeaderMapping, TableSortedOptions, TimezonePicker$1 as TimezonePicker, TimezoneProvider, enableLogRocket, identifyLogRocket };